"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[340],{

/***/ 18321:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var CHEVRON_DOWN = 'M7 10.1456L12 15L17 10.1456L15.82 9L12 12.7282L8.18 9L7 10.1456Z';
var IconChevronDown = lib.variant('IconChevronDown', icon.Icon, {
    path: CHEVRON_DOWN,
});

exports.IconChevronDown = IconChevronDown;
//# sourceMappingURL=_icon-chevrondown.js.map


/***/ }),

/***/ 77133:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var DOUBLE_CHEVRON_LEFT = 'M6.66602 11.9998L11.2687 16.6665L12.3549 15.5652L8.82006 11.9998L12.3549 8.4345L11.2687 7.33317L6.66602 11.9998ZM11.6444 11.9998L16.247 16.6665L17.3333 15.5652L13.7984 11.9998L17.3333 8.4345L16.247 7.33317L11.6444 11.9998Z';
var IconDoubleChevronLeft = lib.variant('IconDoubleChevronLeft', icon.Icon, {
    path: DOUBLE_CHEVRON_LEFT,
});

exports.IconDoubleChevronLeft = IconDoubleChevronLeft;
//# sourceMappingURL=_icon-doublechevronleft.js.map


/***/ }),

/***/ 19386:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var QUESTION_OUTLINED = 'M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z';
var IconQuestionOutlined = lib.variant('IconQuestionOutlined', icon.Icon, {
    path: QUESTION_OUTLINED,
});

exports.IconQuestionOutlined = IconQuestionOutlined;
//# sourceMappingURL=_icon-questionoutlined.js.map


/***/ }),

/***/ 1572:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var SHOPPING_CART = 'M17.4173 17.4087C17.9065 17.4087 18.3237 17.5889 18.6691 17.9495C19.0144 18.3101 19.187 18.7356 19.187 19.226C19.187 19.7163 19.0144 20.1346 18.6691 20.4808C18.3237 20.8269 17.9065 21 17.4173 21C16.9281 21 16.5036 20.8269 16.1439 20.4808C15.7842 20.1346 15.6043 19.7163 15.6043 19.226C15.6043 18.7356 15.7842 18.3101 16.1439 17.9495C16.5036 17.5889 16.9281 17.4087 17.4173 17.4087ZM3 3H5.95683L6.79856 4.77404H20.1151C20.3597 4.77404 20.5683 4.86418 20.741 5.04447C20.9137 5.22476 21 5.44471 21 5.70433C21 5.86298 20.9568 6 20.8705 6.11538L17.6763 11.9567C17.518 12.2308 17.2986 12.4543 17.018 12.6274C16.7374 12.8005 16.4317 12.887 16.1007 12.887H9.41007L8.61151 14.3582L8.56835 14.488C8.56835 14.5457 8.58993 14.5962 8.63309 14.6394C8.67626 14.6827 8.72662 14.7043 8.78417 14.7043H19.187V16.5216H8.39568C7.90647 16.5216 7.48921 16.3413 7.14388 15.9808C6.79856 15.6202 6.6259 15.1947 6.6259 14.7043C6.6259 14.4303 6.69784 14.149 6.84173 13.8606L8.05036 11.6106L4.81295 4.77404H3V3ZM8.39568 17.4087C8.88489 17.4087 9.30935 17.5889 9.66906 17.9495C10.0288 18.3101 10.2086 18.7356 10.2086 19.226C10.2086 19.7163 10.0288 20.1346 9.66906 20.4808C9.30935 20.8269 8.88489 21 8.39568 21C7.90647 21 7.48921 20.8269 7.14388 20.4808C6.79856 20.1346 6.6259 19.7163 6.6259 19.226C6.6259 18.7356 6.79856 18.3101 7.14388 17.9495C7.48921 17.5889 7.90647 17.4087 8.39568 17.4087Z';
var IconShoppingCart = lib.variant('IconShoppingCart', icon.Icon, {
    path: SHOPPING_CART,
});

exports.IconShoppingCart = IconShoppingCart;
//# sourceMappingURL=_icon-shoppingcart.js.map


/***/ }),

/***/ 83276:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var lib = __webpack_require__(93212);
var icon = __webpack_require__(59213);

var TRASH = 'M8.58008 2H15.4441L16.5714 3.10257H20V5.3077H4V3.10257H7.42857L8.58008 2ZM18.8891 6.41027H5.14286V19.3538C5.14286 20.8153 6.32759 22 7.78902 22H16.243C17.7044 22 18.8891 20.8153 18.8891 19.3538V6.41027Z';
var IconTrash = lib.variant('IconTrash', icon.Icon, {
    path: TRASH,
});

exports.IconTrash = IconTrash;
//# sourceMappingURL=_icon-trash.js.map


/***/ }),

/***/ 26578:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var React = __webpack_require__(93236);
var cn = __webpack_require__(19803);
var index$5 = __webpack_require__(2739);
var index$4 = __webpack_require__(58181);
var tslib = __webpack_require__(80677);
var styled = __webpack_require__(10297);
var lightThemeColors = __webpack_require__(24774);
var measurements = __webpack_require__(70416);
var variants = __webpack_require__(81594);
var utils = __webpack_require__(62315);
var index$1 = __webpack_require__(50477);
var index$2 = __webpack_require__(158);
var index$3 = __webpack_require__(22590);
var index = __webpack_require__(39467);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var mediumUp = 'screen and (min-width: 39.9376em)';
styled__default["default"](index.Badge).withConfig({ displayName: "StyledBadge", componentId: "-1qnu7b4" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  width: 16px;\n  height: auto;\n"], ["\n  width: 16px;\n  height: auto;\n"])));
var IconButton = styled__default["default"].button.withConfig({ displayName: "IconButton", componentId: "-jtm6ad" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  display: flex;\n  border: none;\n  background-color: transparent;\n  opacity: 0.72;\n  padding: 0;\n  padding-left: ", ";\n  cursor: pointer;\n  height: 16px;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  display: flex;\n  border: none;\n  background-color: transparent;\n  opacity: 0.72;\n  padding: 0;\n  padding-left: ", ";\n  cursor: pointer;\n  height: 16px;\n\n  &:focus {\n    outline: none;\n  }\n"])), measurements.spacing025);
var PasswordVisibilityButton = styled__default["default"](IconButton).withConfig({ displayName: "PasswordVisibilityButton", componentId: "-tttnjd" })(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject([""], [""])));
var iconSize = styled.css(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  width: 16px;\n  height: 16px;\n"], ["\n  width: 16px;\n  height: 16px;\n"])));
var ClearIcon = styled__default["default"](index$1.IconClose).withConfig({ displayName: "ClearIcon", componentId: "-1jl13tr" })(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), function (p) { var _a; return utils.setRgba((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base800, 0.72) || utils.setRgba(lightThemeColors.base800, 0.72); }, iconSize);
var PasswordEyeIcon = styled__default["default"](index$2.IconEyeHidden).withConfig({ displayName: "PasswordEyeIcon", componentId: "-1y9ejrl" })(templateObject_6 || (templateObject_6 = tslib.__makeTemplateObject(["\n  ", "\n  padding-left: ", ";\n"], ["\n  ", "\n  padding-left: ", ";\n"])), iconSize, measurements.spacing025);
var VisiblePasswordEyeIcon = styled__default["default"](index$3.IconEye).withConfig({ displayName: "VisiblePasswordEyeIcon", componentId: "-7i9edh" })(templateObject_7 || (templateObject_7 = tslib.__makeTemplateObject(["\n  ", "\n  padding-left: ", ";\n"], ["\n  ", "\n  padding-left: ", ";\n"])), iconSize, measurements.spacing025);
var StyledInput = styled__default["default"].div.withConfig({ displayName: "StyledInput", componentId: "-118kl9q" })(templateObject_8 || (templateObject_8 = tslib.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 10px 8px 10px 12px;\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  transition: all 0.3s;\n  border-color: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n    ", "\n  }\n\n  &:focus-within {\n    border-color: ", ";\n    ", ";\n    box-shadow: ", ",\n      inset 0 0 0 1px ", ";\n    ", "\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 10px 8px 10px 12px;\n  background-color: ", ";\n  border-width: 1px;\n  border-style: solid;\n  border-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  transition: all 0.3s;\n  border-color: ", ";\n\n  &:hover {\n    box-shadow: ", ";\n    ", "\n  }\n\n  &:focus-within {\n    border-color: ", ";\n    ", ";\n    box-shadow: ", ",\n      inset 0 0 0 1px ", ";\n    ", "\n  }\n"])), function (p) {
    var _a, _b;
    return p.disabled || p.readOnly
        ? ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base100) || lightThemeColors.base100
        : ((_b = p.theme.colors) === null || _b === void 0 ? void 0 : _b.base0) || lightThemeColors.base0;
}, function (p) { var _a; return ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base300) || lightThemeColors.base300; }, function (p) { var _a; return utils.setRgba((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base800, 0.48) || utils.setRgba(lightThemeColors.base800, 0.48); }, function (p) {
    var _a, _b;
    return (p.disabled && 'transparent') ||
        (p.status === 'error' && "".concat(((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.redio500) || lightThemeColors.redio500)) ||
        (p.status === 'success' &&
            "".concat(((_b = p.theme.colors) === null || _b === void 0 ? void 0 : _b.positive500) || lightThemeColors.positive500));
}, function (p) {
    var _a;
    var color = utils.setRgba((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.maybeBlue300, 0.48) ||
        utils.setRgba(lightThemeColors.maybeBlue300, 0.48);
    return "0 0 0 4px ".concat(color);
}, function (p) {
    return (p.disabled && "box-shadow: none") || (p.readOnly && "box-shadow: none");
}, function (p) { var _a; return ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.maybeBlue500) || lightThemeColors.maybeBlue500; }, function (p) {
    var _a, _b;
    return (p.status === 'error' &&
        "border-color:".concat(((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.redio500) || lightThemeColors.redio500)) ||
        (p.status === 'success' &&
            "border-color:".concat(((_b = p.theme.colors) === null || _b === void 0 ? void 0 : _b.positive500) || lightThemeColors.positive500));
}, function (p) {
    var _a;
    var color = utils.setRgba((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.maybeBlue300, 0.48) ||
        utils.setRgba(lightThemeColors.maybeBlue300, 0.48);
    return "0 0 0 4px ".concat(color);
}, function (p) { var _a; return ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.maybeBlue500) || lightThemeColors.maybeBlue500; }, function (p) { return p.readOnly && "box-shadow: none"; });
var TextInput = styled__default["default"].input.withConfig({ displayName: "TextInput", componentId: "-1v40hph" })(templateObject_9 || (templateObject_9 = tslib.__makeTemplateObject(["\n  flex-grow: 1;\n  border: none;\n  background-color: transparent;\n  ", ";\n  ", "\n  ::placeholder {\n    color: ", ";\n  }\n  &:focus {\n    outline: none;\n  }\n"], ["\n  flex-grow: 1;\n  border: none;\n  background-color: transparent;\n  ", ";\n  ", "\n  ::placeholder {\n    color: ", ";\n  }\n  &:focus {\n    outline: none;\n  }\n"])), function (p) {
    var _a, _b;
    return (p.status === 'success' &&
        "color: ".concat(((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.positive700) || lightThemeColors.positive700)) ||
        (p.status === 'error' && "color: ".concat(((_b = p.theme.colors) === null || _b === void 0 ? void 0 : _b.redio700) || lightThemeColors.redio700));
}, function (p) { return p.readOnly && "cursor: default; caret-color: transparent;"; }, function (p) { var _a; return utils.setRgba((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.base800, 0.48) || utils.setRgba(lightThemeColors.base800, 0.48); });
var StyledHelperText = styled__default["default"](variants.CaptionText).withConfig({ displayName: "StyledHelperText", componentId: "-1fu1p49" })(templateObject_10 || (templateObject_10 = tslib.__makeTemplateObject(["\n  display: block;\n  margin-top: ", ";\n"], ["\n  display: block;\n  margin-top: ", ";\n"])), measurements.spacing025);
var StyledErrorText = styled__default["default"](variants.CaptionText).withConfig({ displayName: "StyledErrorText", componentId: "-1yakdv6" })(templateObject_11 || (templateObject_11 = tslib.__makeTemplateObject(["\n  display: block;\n  margin-top: ", ";\n  color: ", ";\n  opacity: 1;\n  @media ", " {\n    min-width: 250px;\n  }\n"], ["\n  display: block;\n  margin-top: ", ";\n  color: ", ";\n  opacity: 1;\n  @media ", " {\n    min-width: 250px;\n  }\n"])), measurements.spacing025, function (p) { var _a; return ((_a = p.theme.colors) === null || _a === void 0 ? void 0 : _a.redio700) || lightThemeColors.redio700; }, mediumUp);
var InputContainer = styled__default["default"].div.withConfig({ displayName: "InputContainer", componentId: "-1raaxde" })(templateObject_12 || (templateObject_12 = tslib.__makeTemplateObject(["\n  display: block;\n  width: 100%;\n  height: 100%;\n  input {\n    padding: 0;\n  }\n  @media ", " {\n    display: inline-block;\n    ", "\n  }\n\n  &:focus-within ", " {\n    display: inline-block;\n  }\n  ", " {\n    display: none;\n  }\n  &:focus-within ", " {\n    display: inline-block;\n  }\n  ", " {\n    display: none;\n  }\n"], ["\n  display: block;\n  width: 100%;\n  height: 100%;\n  input {\n    padding: 0;\n  }\n  @media ", " {\n    display: inline-block;\n    ", "\n  }\n\n  &:focus-within ", " {\n    display: inline-block;\n  }\n  ", " {\n    display: none;\n  }\n  &:focus-within ", " {\n    display: inline-block;\n  }\n  ", " {\n    display: none;\n  }\n"])), mediumUp, function (p) { return !p.fullWidth && "width: 250px"; }, ClearIcon, ClearIcon, PasswordVisibilityButton, PasswordVisibilityButton);
var IconContainer = styled__default["default"].div.withConfig({ displayName: "IconContainer", componentId: "-1g6s60x" })(templateObject_13 || (templateObject_13 = tslib.__makeTemplateObject(["\n  display: flex;\n  opacity: 0.48;\n  margin-right: ", ";\n"], ["\n  display: flex;\n  opacity: 0.48;\n  margin-right: ", ";\n"])), measurements.spacing025);
var StatusContainer = styled__default["default"].div.withConfig({ displayName: "StatusContainer", componentId: "-x2jsie" })(templateObject_14 || (templateObject_14 = tslib.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;

var getInputValidationStatus = function (errorValue, errorMessages) {
    var hasErrors = errorMessages.length > 0;
    var hasSuccess = errorValue.filter(function (err) { return err.success === true; }).length > 0;
    var status;
    if (hasErrors) {
        status = 'error';
    }
    if (!hasErrors && hasSuccess) {
        status = 'success';
    }
    return errorMessages && status;
};

function BaseInput(props) {
    var id = React.useState(function () { return props.id || "uniqueId_".concat(Math.random()); })[0];
    var _a = React.useState([]), error = _a[0], setError = _a[1];
    var _b = React.useState(false), isFocus = _b[0], setIsFocus = _b[1];
    var _c = React.useState(false), isPasswordVisible = _c[0], setIsPasswordVisible = _c[1];
    var _d = props.type, type = _d === void 0 ? 'text' : _d, placeHolder = props.placeHolder, Icon = props.icon, required = props.required, validate = props.validate, helperText = props.helperText, name = props.name, variant = props.variant, className = props.className, _e = props.fullWidth, fullWidth = _e === void 0 ? false : _e;
    var valueToString = function (val, useExternal) {
        if (val === undefined) {
            return '';
        }
        if (useExternal && props.valueToString) {
            return props.valueToString(val);
        }
        if (typeof val === 'string') {
            return val;
        }
        if (typeof val === 'number') {
            return val.toString();
        }
        if (typeof val === 'object') {
            return val === null || val === void 0 ? void 0 : val.toString();
        }
        throw new Error("Unable to convert value of type ".concat(typeof val, " to string"));
    };
    var _f = React.useState(function () {
        return valueToString(props.value, true);
    }), inputValue = _f[0], setInputValue = _f[1];
    var _g = React.useState(function () {
        return valueToString(props.value, true);
    }), stringValue = _g[0], setStringValue = _g[1];
    React.useEffect(function () {
        if (props.value === stringValue) {
            return;
        }
        setStringValue(props.value || '');
        setInputValue(valueToString(props.value, false));
    }, [props.value]);
    var disabled = Boolean(props.disabled);
    var readOnly = Boolean(props.readOnly);
    var clearable = Boolean(props.clearable) && !(readOnly || disabled);
    var handleOnChange = function (e) {
        var inpValue = e.target.value;
        if (!disabled && !readOnly) {
            setInputValue(inpValue);
            setStringValue(inpValue);
            props.onChangeHandler(inpValue);
        }
    };
    var handleFocusEvent = function (e) {
        if (!disabled) {
            setIsFocus(!isFocus);
        }
        else {
            setIsFocus(false);
        }
        if (props.onFocus) {
            props.onFocus(e);
        }
    };
    var handleReset = function (e) {
        setStringValue('');
        setInputValue(undefined);
        props.onChangeHandler(undefined);
    };
    var errorMessages = error.filter(function (err) { return err.success === false; });
    var inputStatus = getInputValidationStatus(error, errorMessages);
    var handleOnBlur = function (e) {
        var validationResult = [];
        var val = props.formatValue
            ? props.formatValue(inputValue)
            : inputValue;
        if (required) {
            appendValidation(val, required, validationResult);
        }
        if (validate) {
            appendValidation(val, validate, validationResult);
        }
        setError(validationResult);
        setIsFocus(!isFocus);
        if (props.onBlur) {
            props.onBlur(e);
        }
    };
    var togglePasswordVisibility = function (e) {
        setIsPasswordVisible(!isPasswordVisible);
    };
    return (React__default["default"].createElement(InputContainer, { className: cn__default["default"](variant, className), fullWidth: fullWidth },
        React__default["default"].createElement(StyledInput, { disabled: disabled, readOnly: readOnly, status: inputStatus },
            Icon && (React__default["default"].createElement(IconContainer, null,
                React__default["default"].createElement(Icon, { color: "base800", size: 16 }))),
            React__default["default"].createElement(TextInput, { type: isPasswordVisible ? 'text' : type, id: id, onChange: handleOnChange, onFocus: handleFocusEvent, onBlur: handleOnBlur, disabled: disabled, placeholder: isFocus ? undefined : placeHolder, value: stringValue, status: inputStatus, name: name, readOnly: readOnly }),
            React__default["default"].createElement(StatusContainer, null,
                (inputStatus === 'error' && (React__default["default"].createElement(index$4.IconCloseFilled, { color: "redio500", size: 16 }))) ||
                    (inputStatus === 'success' && (React__default["default"].createElement(index$5.IconCheckFilled, { color: "positive500", size: 16 }))),
                type === 'password' && (React__default["default"].createElement(PasswordVisibilityButton, { onClick: togglePasswordVisibility }, isPasswordVisible ? (React__default["default"].createElement(VisiblePasswordEyeIcon, null)) : (React__default["default"].createElement(PasswordEyeIcon, null)))),
                clearable && (stringValue === null || stringValue === void 0 ? void 0 : stringValue.length) > 0 && (React__default["default"].createElement(IconButton, { onClick: handleReset },
                    React__default["default"].createElement(ClearIcon, null))))),
        helperText && React__default["default"].createElement(StyledHelperText, null, helperText),
        errorMessages
            .filter(function (status) { return status.success === false; })
            .map(function (err) {
            return (React__default["default"].createElement(StyledErrorText, { key: err.message }, err.message));
        })));
}
function appendValidation(val, func, errors) {
    var result = func(val);
    if (Array.isArray(result)) {
        result.forEach(function (err) {
            errors.push(err);
        });
    }
    else {
        errors.push(result);
    }
}

exports.BaseInput = BaseInput;
//# sourceMappingURL=_input-index.js.map


/***/ }),

/***/ 46503:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(18321);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.C = index.IconChevronDown;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 37961:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(77133);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.E = index.IconDoubleChevronLeft;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 73005:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(19386);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.n = index.IconQuestionOutlined;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 31615:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(1572);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.w = index.IconShoppingCart;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 27042:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(83276);
__webpack_require__(93212);
__webpack_require__(80677);
__webpack_require__(59213);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(10297);
__webpack_require__(24774);



exports.I = index.IconTrash;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 40236:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var index = __webpack_require__(26578);
var lib = __webpack_require__(93212);
__webpack_require__(93236);
__webpack_require__(19803);
__webpack_require__(2739);
__webpack_require__(59213);
__webpack_require__(80677);
__webpack_require__(10297);
__webpack_require__(24774);
__webpack_require__(58181);
__webpack_require__(70416);
__webpack_require__(81594);
__webpack_require__(90540);
__webpack_require__(62315);
__webpack_require__(53851);
__webpack_require__(50477);
__webpack_require__(158);
__webpack_require__(22590);
__webpack_require__(39467);

var Input = lib.variant('Input', index.BaseInput, {
    type: 'text',
    clearable: false,
});
var ClearableInput = lib.variant('ClearableInput', index.BaseInput, {
    type: 'text',
    clearable: true,
});
var PasswordInput = lib.variant('PasswordInput', index.BaseInput, {
    type: 'password',
    isPasswordVisible: true,
});
var EmailInput = lib.variant('EmailInput', index.BaseInput, {
    type: 'email',
    clearable: true,
});
var NumberInput = lib.variant('NumberInput', index.BaseInput, {
    type: 'number',
});
var DateInput = lib.variant('DateInput', index.BaseInput);

__webpack_unused_export__ = ClearableInput;
__webpack_unused_export__ = DateInput;
__webpack_unused_export__ = EmailInput;
exports.II = Input;
__webpack_unused_export__ = NumberInput;
__webpack_unused_export__ = PasswordInput;
//# sourceMappingURL=variants.js.map


/***/ }),

/***/ 46469:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(93236);
var reactCompoundSlider = __webpack_require__(89583);
var tslib = __webpack_require__(80677);
var styled = __webpack_require__(10297);
var designTokens = __webpack_require__(43220);
var lightThemeColors = __webpack_require__(24774);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var thumbHeight = 24;
var trackHeight = 4;
var StyledRangeWrapper = styled__default["default"].div.withConfig({ displayName: "StyledRangeWrapper", componentId: "-1lswugg" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  ", "\n"])), "".concat(thumbHeight * 2, "px"), function (p) { return p.$ticks && "margin-bottom: ".concat(thumbHeight / 2, "px;"); });
var StyledRangeSlider = styled__default["default"].div.withConfig({ displayName: "StyledRangeSlider", componentId: "-38bxx5" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  position: relative;\n  width: calc(100% - ", "px);\n"], ["\n  position: relative;\n  width: calc(100% - ", "px);\n"])), thumbHeight);
var StyledSliderHandle = styled__default["default"].div.withConfig({ displayName: "StyledSliderHandle", componentId: "-8l6zic" })(templateObject_3 || (templateObject_3 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  height: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  white-space: nowrap;\n  position: absolute;\n  z-index: 2;\n  cursor: pointer;\n  box-sizing: border-box;\n"], ["\n  background-color: ", ";\n  margin-left: ", ";\n  margin-top: ", ";\n  width: ", ";\n  height: ", ";\n  border: 2px solid ", ";\n  border-radius: 50%;\n  white-space: nowrap;\n  position: absolute;\n  z-index: 2;\n  cursor: pointer;\n  box-sizing: border-box;\n"])), lightThemeColors.staticBase0, "".concat((thumbHeight - 3) * -0.5, "px"), "".concat((thumbHeight - 3) * -0.5, "px"), "".concat(thumbHeight, "px"), "".concat(thumbHeight, "px"), lightThemeColors.staticBase900);
var StyledSliderRail = styled__default["default"].div.withConfig({ displayName: "StyledSliderRail", componentId: "-zik09y" })(templateObject_4 || (templateObject_4 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  width: 100%;\n  height: ", ";\n  position: absolute;\n  pointer-events: none;\n"], ["\n  background-color: ", ";\n  width: 100%;\n  height: ", ";\n  position: absolute;\n  pointer-events: none;\n"])), lightThemeColors.staticBase300, "".concat(trackHeight, "px"));
var StyledRailHotSpot = styled__default["default"].div.withConfig({ displayName: "StyledRailHotSpot", componentId: "-zni2up" })(templateObject_5 || (templateObject_5 = tslib.__makeTemplateObject(["\n  width: 100%;\n  height: ", ";\n  top: ", ";\n  position: absolute;\n  cursor: pointer;\n"], ["\n  width: 100%;\n  height: ", ";\n  top: ", ";\n  position: absolute;\n  cursor: pointer;\n"])), "".concat(thumbHeight * 2, "px"), "".concat(thumbHeight * -1, "px"));
var StyledTrack = styled__default["default"].div.withConfig({ displayName: "StyledTrack", componentId: "-181soti" })(templateObject_6 || (templateObject_6 = tslib.__makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n  left: ", ";\n  width: ", ";\n"], ["\n  background-color: ", ";\n  height: ", ";\n  position: absolute;\n  z-index: 1;\n  pointer-events: none;\n  left: ", ";\n  width: ", ";\n"])), lightThemeColors.staticBase900, "".concat(trackHeight, "px"), function (props) { return props.left; }, function (props) { return props.width; });
var StyledTrackHotSpot = styled__default["default"].div.withConfig({ displayName: "StyledTrackHotSpot", componentId: "-1t7wwg9" })(templateObject_7 || (templateObject_7 = tslib.__makeTemplateObject(["\n  height: ", "px;\n  top: ", ";\n  position: absolute;\n  cursor: pointer;\n  left: ", ";\n  width: ", ";\n"], ["\n  height: ", "px;\n  top: ", ";\n  position: absolute;\n  cursor: pointer;\n  left: ", ";\n  width: ", ";\n"])), thumbHeight, "".concat(thumbHeight * -0.5, "px"), function (props) { return props.left; }, function (props) { return props.width; });
styled__default["default"].div.withConfig({ displayName: "SliderRow", componentId: "-ceqnqt" })(templateObject_8 || (templateObject_8 = tslib.__makeTemplateObject(["\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  margin-bottom: ", ";\n"])), designTokens.measurements.spacing100);
styled__default["default"].div.withConfig({ displayName: "SliderContainer", componentId: "-pp94sj" })(templateObject_9 || (templateObject_9 = tslib.__makeTemplateObject(["\n  padding: ", ";\n  flex-grow: 1;\n"], ["\n  padding: ", ";\n  flex-grow: 1;\n"])), designTokens.measurements.spacing100);
var StyledTick = styled__default["default"].div.withConfig({ displayName: "StyledTick", componentId: "-171yz4w" })(templateObject_10 || (templateObject_10 = tslib.__makeTemplateObject(["\n  position: absolute;\n  margin-top: 16px;\n  font-size: 12xp;\n  text-align: center;\n  margin-left: ", "%;\n  width: ", "%;\n  left: ", "%;\n"], ["\n  position: absolute;\n  margin-top: 16px;\n  font-size: 12xp;\n  text-align: center;\n  margin-left: ", "%;\n  width: ", "%;\n  left: ", "%;\n"])), function (p) { return p.$marginLeft; }, function (p) { return p.$width; }, function (p) { return p.$left; });
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var SliderRail$1 = function (_a) {
    var getRailProps = _a.getRailProps;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StyledRailHotSpot, tslib.__assign({}, getRailProps())),
        React__default["default"].createElement(StyledSliderRail, null)));
};

var SliderHandle = function (_a) {
    var _b = _a.domain, min = _b[0], max = _b[1], _c = _a.handle, id = _c.id, value = _c.value, percent = _c.percent, getHandleProps = _a.getHandleProps;
    return (React__default["default"].createElement(StyledSliderHandle, tslib.__assign({ role: "slider", "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, style: { left: "".concat(percent, "%") } }, getHandleProps(id))));
};

var SliderRail = function (_a) {
    var source = _a.source, target = _a.target, getTrackProps = _a.getTrackProps;
    var left = "".concat(source.percent, "%");
    var width = "".concat(target.percent - source.percent, "%");
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(StyledTrack, { left: left, width: width }),
        React__default["default"].createElement(StyledTrackHotSpot, tslib.__assign({ left: left, width: width }, getTrackProps()))));
};

var RangeSlider = function (_a) {
    var domain = _a.domain, values = _a.values, step = _a.step, onChange = _a.onChange, onBlur = _a.onBlur, tickValues = _a.tickValues, logarithmicMax = _a.logarithmicMax, shortenUnits = _a.shortenUnits;
    var _b = React.useState(values), currentValues = _b[0], setCurrentValues = _b[1];
    var handleUpdate = function (data) {
        var newValue = [
            roundNumberToDecimal(data[0], 2),
            roundNumberToDecimal(data[1], 2),
        ];
        if (JSON.stringify(currentValues) === JSON.stringify(newValue)) {
            return;
        }
        setCurrentValues(newValue);
        onChange(newValue);
    };
    var handleOnBlur = function (data) {
        if (!onBlur) {
            return;
        }
        var newValue = [
            roundNumberToDecimal(data[0], 2),
            roundNumberToDecimal(data[1], 2),
        ];
        onBlur(newValue);
    };
    var roundNumberToDecimal = function (number, decimal) {
        var factor = Math.pow(10, decimal);
        return Math.round(number * factor) / factor;
    };
    return (React__default["default"].createElement(StyledRangeWrapper, { "$ticks": tickValues.length > 0 },
        React__default["default"].createElement(StyledRangeSlider, null,
            React__default["default"].createElement(reactCompoundSlider.Slider, { mode: 2, step: step, domain: domain, onUpdate: handleUpdate, onSlideEnd: handleOnBlur, values: values },
                React__default["default"].createElement(reactCompoundSlider.Rail, null, function (_a) {
                    var getRailProps = _a.getRailProps;
                    return React__default["default"].createElement(SliderRail$1, { getRailProps: getRailProps });
                }),
                React__default["default"].createElement(reactCompoundSlider.Handles, null, function (_a) {
                    var handles = _a.handles, getHandleProps = _a.getHandleProps;
                    return (React__default["default"].createElement(React__default["default"].Fragment, null, handles.map(function (handle) { return (React__default["default"].createElement(SliderHandle, { key: handle.id, handle: handle, domain: domain, getHandleProps: getHandleProps })); })));
                }),
                React__default["default"].createElement(reactCompoundSlider.Tracks, { left: false, right: false }, function (_a) {
                    var tracks = _a.tracks, getTrackProps = _a.getTrackProps;
                    return (React__default["default"].createElement(React__default["default"].Fragment, null, tracks.map(function (_a) {
                        var id = _a.id, source = _a.source, target = _a.target;
                        return (React__default["default"].createElement(SliderRail, { key: id, source: source, target: target, getTrackProps: getTrackProps }));
                    })));
                }),
                React__default["default"].createElement(reactCompoundSlider.Ticks, { values: tickValues }, function (_a) {
                    var ticks = _a.ticks;
                    return (React__default["default"].createElement("div", { className: "slider-ticks" }, ticks.map(function (tick) { return (React__default["default"].createElement(Tick, { key: tick.id, tick: tick, count: ticks.length, logarithmicMax: logarithmicMax, domain: domain, shortenUnits: shortenUnits })); })));
                })))));
};
var Tick = function (_a) {
    var tick = _a.tick, count = _a.count, logarithmicMax = _a.logarithmicMax, domain = _a.domain, shortenUnits = _a.shortenUnits;
    var percent = logarithmicMax
        ? domain[1] * (Math.log(tick.value) / Math.log(logarithmicMax))
        : tick.percent;
    return (React__default["default"].createElement("div", null,
        React__default["default"].createElement(StyledTick, { "$marginLeft": -(100 / count) / 2, "$left": percent, "$width": 100 / count }, tick.value >= 1000 && shortenUnits
            ? "".concat(Math.floor(tick.value / 1000), "k")
            : tick.value)));
};

exports.U = RangeSlider;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 91897:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "j2": () => (/* reexport */ src_ascending),
  "b4": () => (/* reexport */ src_bisect),
  "YF": () => (/* reexport */ bisector),
  "VR": () => (/* reexport */ quantile_quantile),
  "s7": () => (/* reexport */ quantileSorted),
  "w6": () => (/* reexport */ range),
  "G9": () => (/* reexport */ ticks_tickIncrement),
  "ly": () => (/* reexport */ tickStep),
  "sd": () => (/* reexport */ src_ticks)
});

// UNUSED EXPORTS: Adder, InternMap, InternSet, bin, bisectCenter, bisectLeft, bisectRight, count, cross, cumsum, descending, deviation, difference, disjoint, every, extent, fcumsum, filter, fsum, greatest, greatestIndex, group, groupSort, groups, histogram, index, indexes, intersection, least, leastIndex, map, max, maxIndex, mean, median, merge, min, minIndex, nice, pairs, permute, quickselect, reduce, reverse, rollup, rollups, scan, shuffle, shuffler, some, sort, subset, sum, superset, thresholdFreedmanDiaconis, thresholdScott, thresholdSturges, transpose, union, variance, zip

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/ascending.js
/* harmony default export */ function src_ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/bisector.js


/* harmony default export */ function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => src_ascending(f(d), x);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/number.js
/* harmony default export */ function number(x) {
  return x === null ? NaN : +x;
}

function* numbers(values, valueof) {
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        yield value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        yield value;
      }
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/bisect.js




const ascendingBisect = bisector(src_ascending);
const bisectRight = ascendingBisect.right;
const bisectLeft = ascendingBisect.left;
const bisectCenter = bisector(number).center;
/* harmony default export */ const src_bisect = (bisectRight);

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/count.js
function count_count(values, valueof) {
  let count = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count;
      }
    }
  }
  return count;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/cross.js
function cross_length(array) {
  return array.length | 0;
}

function empty(length) {
  return !(length > 0);
}

function arrayify(values) {
  return typeof values !== "object" || "length" in values ? values : Array.from(values);
}

function reducer(reduce) {
  return values => reduce(...values);
}

function cross(...values) {
  const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
  values = values.map(arrayify);
  const lengths = values.map(cross_length);
  const j = values.length - 1;
  const index = new Array(j + 1).fill(0);
  const product = [];
  if (j < 0 || lengths.some(empty)) return product;
  while (true) {
    product.push(index.map((j, i) => values[i][j]));
    let i = j;
    while (++index[i] === lengths[i]) {
      if (i === 0) return reduce ? product.map(reduce) : product;
      index[i--] = 0;
    }
  }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/cumsum.js
function cumsum(values, valueof) {
  var sum = 0, index = 0;
  return Float64Array.from(values, valueof === undefined
    ? v => (sum += +v || 0)
    : v => (sum += +valueof(v, index++, values) || 0));
}
;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/descending.js
/* harmony default export */ function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/variance.js
function variance_variance(values, valueof) {
  let count = 0;
  let delta;
  let mean = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        delta = value - mean;
        mean += delta / ++count;
        sum += delta * (value - mean);
      }
    }
  }
  if (count > 1) return sum / (count - 1);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/deviation.js


function deviation_deviation(values, valueof) {
  const v = variance(values, valueof);
  return v ? Math.sqrt(v) : v;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/extent.js
/* harmony default export */ function src_extent(values, valueof) {
  let min;
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null) {
        if (min === undefined) {
          if (value >= value) min = max = value;
        } else {
          if (min > value) min = value;
          if (max < value) max = value;
        }
      }
    }
  }
  return [min, max];
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/fsum.js
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
  constructor() {
    this._partials = new Float64Array(32);
    this._n = 0;
  }
  add(x) {
    const p = this._partials;
    let i = 0;
    for (let j = 0; j < this._n && j < 32; j++) {
      const y = p[j],
        hi = x + y,
        lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
      if (lo) p[i++] = lo;
      x = hi;
    }
    p[i] = x;
    this._n = i + 1;
    return this;
  }
  valueOf() {
    const p = this._partials;
    let n = this._n, x, y, lo, hi = 0;
    if (n > 0) {
      hi = p[--n];
      while (n > 0) {
        x = hi;
        y = p[--n];
        hi = x + y;
        lo = y - (hi - x);
        if (lo) break;
      }
      if (n > 0 && ((lo < 0 && p[n - 1] < 0) || (lo > 0 && p[n - 1] > 0))) {
        y = lo * 2;
        x = hi + y;
        if (y == x - hi) hi = x;
      }
    }
    return hi;
  }
}

function fsum(values, valueof) {
  const adder = new Adder();
  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        adder.add(value);
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        adder.add(value);
      }
    }
  }
  return +adder;
}

function fcumsum(values, valueof) {
  const adder = new Adder();
  let index = -1;
  return Float64Array.from(values, valueof === undefined
      ? v => adder.add(+v || 0)
      : v => adder.add(+valueof(v, ++index, values) || 0)
  );
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/internmap@1.0.1/node_modules/internmap/src/index.js
class src_InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, {_intern: {value: new Map()}, _key: {value: key}});
    if (entries != null) for (const [key, value] of entries) this.set(key, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}

class InternSet extends Set {
  constructor(values, key = keyof) {
    super();
    Object.defineProperties(this, {_intern: {value: new Map()}, _key: {value: key}});
    if (values != null) for (const value of values) this.add(value);
  }
  has(value) {
    return super.has(intern_get(this, value));
  }
  add(value) {
    return super.add(intern_set(this, value));
  }
  delete(value) {
    return super.delete(intern_delete(this, value));
  }
}

function intern_get({_intern, _key}, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}

function intern_set({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}

function intern_delete({_intern, _key}, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(value);
    _intern.delete(key);
  }
  return value;
}

function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/identity.js
/* harmony default export */ function src_identity(x) {
  return x;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/group.js



function group_group(values, ...keys) {
  return nest(values, identity, identity, keys);
}

function groups(values, ...keys) {
  return nest(values, Array.from, identity, keys);
}

function group_rollup(values, reduce, ...keys) {
  return nest(values, identity, reduce, keys);
}

function rollups(values, reduce, ...keys) {
  return nest(values, Array.from, reduce, keys);
}

function index(values, ...keys) {
  return nest(values, identity, unique, keys);
}

function indexes(values, ...keys) {
  return nest(values, Array.from, unique, keys);
}

function unique(values) {
  if (values.length !== 1) throw new Error("duplicate key");
  return values[0];
}

function nest(values, map, reduce, keys) {
  return (function regroup(values, i) {
    if (i >= keys.length) return reduce(values);
    const groups = new InternMap();
    const keyof = keys[i++];
    let index = -1;
    for (const value of values) {
      const key = keyof(value, ++index, values);
      const group = groups.get(key);
      if (group) group.push(value);
      else groups.set(key, [value]);
    }
    for (const [key, values] of groups) {
      groups.set(key, regroup(values, i));
    }
    return map(groups);
  })(values, 0);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/permute.js
/* harmony default export */ function src_permute(source, keys) {
  return Array.from(keys, key => source[key]);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/sort.js



function sort_sort(values, ...F) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  values = Array.from(values);
  let [f = ascending] = F;
  if (f.length === 1 || F.length > 1) {
    const index = Uint32Array.from(values, (d, i) => i);
    if (F.length > 1) {
      F = F.map(f => values.map(f));
      index.sort((i, j) => {
        for (const f of F) {
          const c = ascending(f[i], f[j]);
          if (c) return c;
        }
      });
    } else {
      f = values.map(f);
      index.sort((i, j) => ascending(f[i], f[j]));
    }
    return permute(values, index);
  }
  return values.sort(f);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/groupSort.js




function groupSort(values, reduce, key) {
  return (reduce.length === 1
    ? sort(rollup(values, reduce, key), (([ak, av], [bk, bv]) => ascending(av, bv) || ascending(ak, bk)))
    : sort(group(values, key), (([ak, av], [bk, bv]) => reduce(av, bv) || ascending(ak, bk))))
    .map(([key]) => key);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/array.js
var array = Array.prototype;

var array_slice = array.slice;
var map = array.map;

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/constant.js
/* harmony default export */ function src_constant(x) {
  return function() {
    return x;
  };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/ticks.js
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ function src_ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = ticks_tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function ticks_tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/nice.js


function nice_nice(start, stop, count) {
  let prestep;
  while (true) {
    const step = tickIncrement(start, stop, count);
    if (step === prestep || step === 0 || !isFinite(step)) {
      return [start, stop];
    } else if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
    }
    prestep = step;
  }
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/threshold/sturges.js


/* harmony default export */ function threshold_sturges(values) {
  return Math.ceil(Math.log(count(values)) / Math.LN2) + 1;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/bin.js









/* harmony default export */ function bin() {
  var value = identity,
      domain = extent,
      threshold = sturges;

  function histogram(data) {
    if (!Array.isArray(data)) data = Array.from(data);

    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds, and nice the
    // default domain accordingly.
    if (!Array.isArray(tz)) {
      const max = x1, tn = +tz;
      if (domain === extent) [x0, x1] = nice(x0, x1, tn);
      tz = ticks(x0, x1, tn);

      // If the last threshold is coincident with the domain’s upper bound, the
      // last bin will be zero-width. If the default domain is used, and this
      // last threshold is coincident with the maximum input value, we can
      // extend the niced upper bound by one tick to ensure uniform bin widths;
      // otherwise, we simply remove the last threshold. Note that we don’t
      // coerce values or the domain to numbers, and thus must be careful to
      // compare order (>=) rather than strict equality (===)!
      if (tz[tz.length - 1] >= x1) {
        if (max >= x1 && domain === extent) {
          const step = tickIncrement(x0, x1, tn);
          if (isFinite(step)) {
            if (step > 0) {
              x1 = (Math.floor(x1 / step) + 1) * step;
            } else if (step < 0) {
              x1 = (Math.ceil(x1 * -step) + 1) / -step;
            }
          }
        } else {
          tz.pop();
        }
      }
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[bisect(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
  };

  return histogram;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/max.js
function max(values, valueof) {
  let max;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value;
      }
    }
  }
  return max;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/min.js
function min_min(values, valueof) {
  let min;
  if (valueof === undefined) {
    for (const value of values) {
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value;
      }
    }
  }
  return min;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/quickselect.js


// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare = src_ascending) {
  while (right > left) {
    if (right - left > 600) {
      const n = right - left + 1;
      const m = k - left + 1;
      const z = Math.log(n);
      const s = 0.5 * Math.exp(2 * z / 3);
      const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
      const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
      const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
      quickselect(array, k, newLeft, newRight, compare);
    }

    const t = array[k];
    let i = left;
    let j = right;

    swap(array, left, k);
    if (compare(array[right], t) > 0) swap(array, left, right);

    while (i < j) {
      swap(array, i, j), ++i, --j;
      while (compare(array[i], t) < 0) ++i;
      while (compare(array[j], t) > 0) --j;
    }

    if (compare(array[left], t) === 0) swap(array, left, j);
    else ++j, swap(array, j, right);

    if (j <= k) left = j + 1;
    if (k <= j) right = j - 1;
  }
  return array;
}

function swap(array, i, j) {
  const t = array[i];
  array[i] = array[j];
  array[j] = t;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/quantile.js





function quantile_quantile(values, p, valueof) {
  values = Float64Array.from(numbers(values, valueof));
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return min_min(values);
  if (p >= 1) return max(values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = max(quickselect(values, i0).subarray(0, i0 + 1)),
      value1 = min_min(values.subarray(i0 + 1));
  return value0 + (value1 - value0) * (i - i0);
}

function quantileSorted(values, p, valueof = number) {
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/threshold/freedmanDiaconis.js



/* harmony default export */ function freedmanDiaconis(values, min, max) {
  return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(count(values), -1 / 3)));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/threshold/scott.js



/* harmony default export */ function scott(values, min, max) {
  return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(count(values), -1 / 3)));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/maxIndex.js
function maxIndex_maxIndex(values, valueof) {
  let max;
  let maxIndex = -1;
  let index = -1;
  if (valueof === undefined) {
    for (const value of values) {
      ++index;
      if (value != null
          && (max < value || (max === undefined && value >= value))) {
        max = value, maxIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (max < value || (max === undefined && value >= value))) {
        max = value, maxIndex = index;
      }
    }
  }
  return maxIndex;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/mean.js
function mean(values, valueof) {
  let count = 0;
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
        ++count, sum += value;
      }
    }
  }
  if (count) return sum / count;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/median.js


/* harmony default export */ function median(values, valueof) {
  return quantile(values, 0.5, valueof);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/merge.js
function* flatten(arrays) {
  for (const array of arrays) {
    yield* array;
  }
}

function merge(arrays) {
  return Array.from(flatten(arrays));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/minIndex.js
function minIndex_minIndex(values, valueof) {
  let min;
  let minIndex = -1;
  let index = -1;
  if (valueof === undefined) {
    for (const value of values) {
      ++index;
      if (value != null
          && (min > value || (min === undefined && value >= value))) {
        min = value, minIndex = index;
      }
    }
  } else {
    for (let value of values) {
      if ((value = valueof(value, ++index, values)) != null
          && (min > value || (min === undefined && value >= value))) {
        min = value, minIndex = index;
      }
    }
  }
  return minIndex;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/pairs.js
function pairs(values, pairof = pair) {
  const pairs = [];
  let previous;
  let first = false;
  for (const value of values) {
    if (first) pairs.push(pairof(previous, value));
    previous = value;
    first = true;
  }
  return pairs;
}

function pair(a, b) {
  return [a, b];
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/range.js
/* harmony default export */ function range(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/least.js


function least(values, compare = ascending) {
  let min;
  let defined = false;
  if (compare.length === 1) {
    let minValue;
    for (const element of values) {
      const value = compare(element);
      if (defined
          ? ascending(value, minValue) < 0
          : ascending(value, value) === 0) {
        min = element;
        minValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined
          ? compare(value, min) < 0
          : compare(value, value) === 0) {
        min = value;
        defined = true;
      }
    }
  }
  return min;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/leastIndex.js



function leastIndex_leastIndex(values, compare = ascending) {
  if (compare.length === 1) return minIndex(values, compare);
  let minValue;
  let min = -1;
  let index = -1;
  for (const value of values) {
    ++index;
    if (min < 0
        ? compare(value, value) === 0
        : compare(value, minValue) < 0) {
      minValue = value;
      min = index;
    }
  }
  return min;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/greatest.js


function greatest(values, compare = ascending) {
  let max;
  let defined = false;
  if (compare.length === 1) {
    let maxValue;
    for (const element of values) {
      const value = compare(element);
      if (defined
          ? ascending(value, maxValue) > 0
          : ascending(value, value) === 0) {
        max = element;
        maxValue = value;
        defined = true;
      }
    }
  } else {
    for (const value of values) {
      if (defined
          ? compare(value, max) > 0
          : compare(value, value) === 0) {
        max = value;
        defined = true;
      }
    }
  }
  return max;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/greatestIndex.js



function greatestIndex(values, compare = ascending) {
  if (compare.length === 1) return maxIndex(values, compare);
  let maxValue;
  let max = -1;
  let index = -1;
  for (const value of values) {
    ++index;
    if (max < 0
        ? compare(value, value) === 0
        : compare(value, maxValue) > 0) {
      maxValue = value;
      max = index;
    }
  }
  return max;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/scan.js


function scan(values, compare) {
  const index = leastIndex(values, compare);
  return index < 0 ? undefined : index;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/shuffle.js
/* harmony default export */ const shuffle = (shuffler(Math.random));

function shuffler(random) {
  return function shuffle(array, i0 = 0, i1 = array.length) {
    let m = i1 - (i0 = +i0);
    while (m) {
      const i = random() * m-- | 0, t = array[m + i0];
      array[m + i0] = array[i + i0];
      array[i + i0] = t;
    }
    return array;
  };
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/sum.js
function sum(values, valueof) {
  let sum = 0;
  if (valueof === undefined) {
    for (let value of values) {
      if (value = +value) {
        sum += value;
      }
    }
  } else {
    let index = -1;
    for (let value of values) {
      if (value = +valueof(value, ++index, values)) {
        sum += value;
      }
    }
  }
  return sum;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/transpose.js


/* harmony default export */ function src_transpose(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = min(matrix, transpose_length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
}

function transpose_length(d) {
  return d.length;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/zip.js


/* harmony default export */ function zip() {
  return transpose(arguments);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/every.js
function every(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;
  for (const value of values) {
    if (!test(value, ++index, values)) {
      return false;
    }
  }
  return true;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/some.js
function some(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  let index = -1;
  for (const value of values) {
    if (test(value, ++index, values)) {
      return true;
    }
  }
  return false;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/filter.js
function filter(values, test) {
  if (typeof test !== "function") throw new TypeError("test is not a function");
  const array = [];
  let index = -1;
  for (const value of values) {
    if (test(value, ++index, values)) {
      array.push(value);
    }
  }
  return array;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/map.js
function map_map(values, mapper) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
  return Array.from(values, (value, index) => mapper(value, index, values));
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/reduce.js
function reduce(values, reducer, value) {
  if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
  const iterator = values[Symbol.iterator]();
  let done, next, index = -1;
  if (arguments.length < 3) {
    ({done, value} = iterator.next());
    if (done) return;
    ++index;
  }
  while (({done, value: next} = iterator.next()), !done) {
    value = reducer(value, next, ++index, values);
  }
  return value;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/reverse.js
function reverse(values) {
  if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
  return Array.from(values).reverse();
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/difference.js
function difference(values, ...others) {
  values = new Set(values);
  for (const other of others) {
    for (const value of other) {
      values.delete(value);
    }
  }
  return values;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/disjoint.js
function disjoint(values, other) {
  const iterator = other[Symbol.iterator](), set = new Set();
  for (const v of values) {
    if (set.has(v)) return false;
    let value, done;
    while (({value, done} = iterator.next())) {
      if (done) break;
      if (Object.is(v, value)) return false;
      set.add(value);
    }
  }
  return true;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/set.js
function set_set(values) {
  return values instanceof Set ? values : new Set(values);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/intersection.js


function intersection(values, ...others) {
  values = new Set(values);
  others = others.map(set);
  out: for (const value of values) {
    for (const other of others) {
      if (!other.has(value)) {
        values.delete(value);
        continue out;
      }
    }
  }
  return values;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/superset.js
function superset_superset(values, other) {
  const iterator = values[Symbol.iterator](), set = new Set();
  for (const o of other) {
    if (set.has(o)) continue;
    let value, done;
    while (({value, done} = iterator.next())) {
      if (done) return false;
      set.add(value);
      if (Object.is(o, value)) break;
    }
  }
  return true;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/subset.js


function subset(values, other) {
  return superset(other, values);
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/union.js
function union(...others) {
  const set = new Set();
  for (const other of others) {
    for (const o of other) {
      set.add(o);
    }
  }
  return set;
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/d3-array@2.12.1/node_modules/d3-array/src/index.js












 // Deprecated; use bin.




















 // Deprecated; use leastIndex.






















/***/ }),

/***/ 89583:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Handles": () => (/* binding */ Handles),
/* harmony export */   "Rail": () => (/* binding */ Rail),
/* harmony export */   "Slider": () => (/* binding */ Slider),
/* harmony export */   "Ticks": () => (/* binding */ Ticks),
/* harmony export */   "Tracks": () => (/* binding */ Tracks),
/* harmony export */   "mode1": () => (/* binding */ mode1),
/* harmony export */   "mode2": () => (/* binding */ mode2),
/* harmony export */   "mode3": () => (/* binding */ mode3)
/* harmony export */ });
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91190);
/* harmony import */ var warning__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(warning__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);
/* harmony import */ var d3_array__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91897);




function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var prfx = 'react-compound-slider:';
function getSortByVal() {
  var reversed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return function sortByVal(a, b) {
    if (a.val > b.val) {
      return reversed ? -1 : 1;
    }

    if (b.val > a.val) {
      return reversed ? 1 : -1;
    }

    return 0;
  };
}
function getUpdatedHandles(handles, updateKey, updateValue) {
  var reversed = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var index = handles.findIndex(function (v) {
    return v.key === updateKey;
  });

  if (index !== -1) {
    var _handles$index = handles[index],
        key = _handles$index.key,
        val = _handles$index.val;

    if (val === updateValue) {
      return handles;
    }

    return [].concat(_toConsumableArray(handles.slice(0, index)), [{
      key: key,
      val: updateValue
    }], _toConsumableArray(handles.slice(index + 1))).sort(getSortByVal(reversed));
  }

  return handles;
}
function getSliderDomain(slider, vertical) {
  if (!slider) {
    return [0, 0];
  }

  var s = slider.getBoundingClientRect();
  var d0 = vertical ? s.top : s.left;
  var d1 = vertical ? s.bottom : s.right;
  return [d0, d1];
}
function isNotValidTouch(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? '' : _ref$type,
      touches = _ref.touches;
  return !touches || touches.length > 1 || type.toLowerCase() === 'touchend' && touches.length > 0;
}
function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandles() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var reversed = arguments.length > 1 ? arguments[1] : undefined;
  var valueToStep = arguments.length > 2 ? arguments[2] : undefined;
  var warn = arguments.length > 3 ? arguments[3] : undefined;
  var changes = 0;
  var handles = values.map(function (x) {
    var val = valueToStep.getValue(x);

    if (x !== val) {
      changes += 1;
      warning__WEBPACK_IMPORTED_MODULE_0___default()(!warn, "".concat(prfx, " Invalid value encountered. Changing ").concat(x, " to ").concat(val, "."));
    }

    return val;
  }).map(function (val, i) {
    return {
      key: "$$-".concat(i),
      val: val
    };
  }).sort(getSortByVal(reversed));
  return {
    handles: handles,
    changes: changes
  };
}

// default mode
function mode1(_, next) {
  return next;
} // prevent duplicate values and crossing

function mode2(curr, next) {
  for (var i = 0; i < curr.length; i++) {
    if (curr[i].key !== next[i].key) {
      return curr;
    }

    if (next[i + 1] && next[i].val === next[i + 1].val) {
      return curr;
    }
  }

  return next;
} // pushable mode

function mode3(curr, next, step, reversed, getValue) {
  var indexForMovingHandle = -1;
  var handleMoveIsPositive = true;

  for (var i = 0; i < curr.length; i++) {
    var c = curr[i];
    var n = next[i]; // make sure keys are in same order if not return curr

    if (!n || n.key !== c.key) {
      return curr;
    } else if (n.val !== c.val) {
      indexForMovingHandle = i;
      handleMoveIsPositive = n.val - c.val > 0;
    }
  } // nothing has changed (shouldn't happen but just in case).


  if (indexForMovingHandle === -1) {
    return curr;
  } else {
    var increment = handleMoveIsPositive ? step : -step;

    for (var _i = 0; _i < next.length; _i++) {
      var n0 = next[_i];
      var n1 = next[_i + 1];

      if (n1 && n0.val === n1.val) {
        if (_i === indexForMovingHandle) {
          var newStep = n1.val + increment;

          if (getValue(newStep) === newStep) {
            var clone = getUpdatedHandles(next, n1.key, n1.val + increment, reversed);
            var check = mode3(next, clone, step, reversed, getValue);

            if (check === next) {
              return curr;
            } else {
              return check;
            }
          } else {
            return curr;
          }
        } else {
          var _newStep = n0.val + increment;

          if (getValue(_newStep) === _newStep) {
            var _clone = getUpdatedHandles(next, n0.key, n0.val + increment, reversed);

            var _check = mode3(next, _clone, step, reversed, getValue);

            if (_check === next) {
              return curr;
            } else {
              return _check;
            }
          } else {
            return curr;
          }
        }
      }
    }
  }

  return next;
}

function callAll() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (e) {
    return fns.forEach(function (fn) {
      return fn && fn(e);
    });
  };
}

var NOOP = function NOOP() {
  return {
    value: 0,
    percent: 0
  };
};

var Rail = /*#__PURE__*/function (_Component) {
  _inherits(Rail, _Component);

  var _super = _createSuper(Rail);

  function Rail() {
    var _this;

    _classCallCheck(this, Rail);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getRailProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = _this.props,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return _objectSpread2(_objectSpread2({}, props), {}, {
        onMouseDown: callAll(props && props.onMouseDown, emitMouse),
        onTouchStart: callAll(props && props.onTouchStart, emitTouch)
      });
    };

    return _this;
  }

  _createClass(Rail, [{
    key: "render",
    value: function render() {
      var getRailProps = this.getRailProps,
          _this$props2 = this.props,
          getEventData = _this$props2.getEventData,
          _this$props2$activeHa = _this$props2.activeHandleID,
          activeHandleID = _this$props2$activeHa === void 0 ? '' : _this$props2$activeHa,
          children = _this$props2.children;
      var renderedChildren = children({
        getEventData: getEventData || NOOP,
        activeHandleID: activeHandleID,
        getRailProps: getRailProps
      });
      return renderedChildren && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(renderedChildren);
    }
  }]);

  return Rail;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

var Handles = /*#__PURE__*/function (_Component) {
  _inherits(Handles, _Component);

  var _super = _createSuper(Handles);

  function Handles() {
    var _this;

    _classCallCheck(this, Handles);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.autofocus = function (e) {
      if (e.target instanceof HTMLElement) {
        e.target.focus();
      }
    };

    _this.getHandleProps = function (id) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this$props = _this.props,
          emitKeyboard = _this$props.emitKeyboard,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return _objectSpread2(_objectSpread2({}, props), {}, {
        onKeyDown: callAll(props && props.onKeyDown, function (e) {
          return emitKeyboard && emitKeyboard(e, id);
        }),
        onMouseDown: callAll(props && props.onMouseDown, _this.autofocus, function (e) {
          return emitMouse && emitMouse(e, id);
        }),
        onTouchStart: callAll(props && props.onTouchStart, function (e) {
          return emitTouch && emitTouch(e, id);
        })
      });
    };

    return _this;
  }

  _createClass(Handles, [{
    key: "render",
    value: function render() {
      var getHandleProps = this.getHandleProps,
          _this$props2 = this.props,
          _this$props2$activeHa = _this$props2.activeHandleID,
          activeHandleID = _this$props2$activeHa === void 0 ? '' : _this$props2$activeHa,
          children = _this$props2.children,
          _this$props2$handles = _this$props2.handles,
          handles = _this$props2$handles === void 0 ? [] : _this$props2$handles;
      var renderedChildren = children({
        handles: handles,
        activeHandleID: activeHandleID,
        getHandleProps: getHandleProps
      });
      return renderedChildren && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(renderedChildren);
    }
  }]);

  return Handles;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

var LinearScale = /*#__PURE__*/function () {
  function LinearScale() {
    _classCallCheck(this, LinearScale);

    this.interpolator = void 0;
    this.domain = [0, 1];
    this.range = [0, 1];
    this.domain = [0, 1];
    this.range = [0, 1];
    this.interpolator = null;
  }

  _createClass(LinearScale, [{
    key: "createInterpolator",
    value: function createInterpolator(domain, range) {
      var _this = this;

      var d0 = domain[0];
      var d1 = domain[1];
      var r0 = range[0];
      var r1 = range[1];

      if (d1 < d0) {
        return function (x) {
          return _this.interpolateValue(r1, r0)(_this.deinterpolateValue(d1, d0)(x));
        };
      } else {
        return function (x) {
          return _this.interpolateValue(r0, r1)(_this.deinterpolateValue(d0, d1)(x));
        };
      }
    }
  }, {
    key: "interpolateValue",
    value: function interpolateValue(a, b) {
      return a = +a, b -= a, function i(t) {
        return a + b * t;
      };
    }
  }, {
    key: "deinterpolateValue",
    value: function deinterpolateValue(a, b) {
      return (b -= a = +a) ? function (x) {
        return (x - a) / b;
      } : function () {
        return b;
      };
    }
  }, {
    key: "rescale",
    value: function rescale() {
      this.interpolator = null;
      return this;
    }
  }, {
    key: "getValue",
    value: function getValue(x) {
      var domain = this.domain,
          range = this.range;
      return (this.interpolator || (this.interpolator = this.createInterpolator(domain, range)))(+x);
    }
  }, {
    key: "setDomain",
    value: function setDomain(val) {
      this.domain = [val[0], val[1]];
      this.rescale();
      return this;
    }
  }, {
    key: "getDomain",
    value: function getDomain() {
      return this.domain;
    }
  }, {
    key: "setRange",
    value: function setRange(val) {
      this.range = [val[0], val[1]];
      return this;
    }
  }, {
    key: "getRange",
    value: function getRange() {
      return this.range;
    }
  }, {
    key: "getTicks",
    value: function getTicks(count) {
      var d = this.domain;
      return (0,d3_array__WEBPACK_IMPORTED_MODULE_2__/* .ticks */ .sd)(d[0], d[d.length - 1], count ? count : 10);
    }
  }]);

  return LinearScale;
}();

var defaultGetEventData$1 = function defaultGetEventData() {
  return {
    value: 0,
    percent: 0
  };
};

var Ticks = /*#__PURE__*/function (_Component) {
  _inherits(Ticks, _Component);

  var _super = _createSuper(Ticks);

  function Ticks() {
    _classCallCheck(this, Ticks);

    return _super.apply(this, arguments);
  }

  _createClass(Ticks, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          values = _this$props.values,
          _this$props$scale = _this$props.scale,
          scale = _this$props$scale === void 0 ? new LinearScale() : _this$props$scale,
          _this$props$count = _this$props.count,
          count = _this$props$count === void 0 ? 10 : _this$props$count,
          _this$props$getEventD = _this$props.getEventData,
          getEventData = _this$props$getEventD === void 0 ? defaultGetEventData$1 : _this$props$getEventD,
          _this$props$activeHan = _this$props.activeHandleID,
          activeHandleID = _this$props$activeHan === void 0 ? '' : _this$props$activeHan;
      var ticks = (values ? values : scale.getTicks(count)).map(function (value) {
        return {
          id: "$$-".concat(value),
          value: value,
          percent: scale.getValue(value)
        };
      });
      var renderedChildren = children({
        getEventData: getEventData,
        activeHandleID: activeHandleID,
        ticks: ticks
      });
      return renderedChildren && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(renderedChildren);
    }
  }]);

  return Ticks;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

var defaultGetEventData = function defaultGetEventData() {
  return {
    value: 0,
    percent: 0
  };
};

var Tracks = /*#__PURE__*/function (_Component) {
  _inherits(Tracks, _Component);

  var _super = _createSuper(Tracks);

  function Tracks() {
    var _this;

    _classCallCheck(this, Tracks);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getTrackProps = function (props) {
      var _this$props = _this.props,
          emitMouse = _this$props.emitMouse,
          emitTouch = _this$props.emitTouch;
      return _objectSpread2(_objectSpread2({}, props || {}), {}, {
        onMouseDown: callAll(props && props.onMouseDown, emitMouse),
        onTouchStart: callAll(props && props.onTouchStart, emitTouch)
      });
    };

    return _this;
  }

  _createClass(Tracks, [{
    key: "render",
    value: function render() {
      var getTrackProps = this.getTrackProps,
          _this$props2 = this.props,
          children = _this$props2.children,
          _this$props2$left = _this$props2.left,
          left = _this$props2$left === void 0 ? true : _this$props2$left,
          _this$props2$right = _this$props2.right,
          right = _this$props2$right === void 0 ? true : _this$props2$right,
          _this$props2$scale = _this$props2.scale,
          scale = _this$props2$scale === void 0 ? new LinearScale() : _this$props2$scale,
          _this$props2$handles = _this$props2.handles,
          handles = _this$props2$handles === void 0 ? [] : _this$props2$handles,
          _this$props2$getEvent = _this$props2.getEventData,
          getEventData = _this$props2$getEvent === void 0 ? defaultGetEventData : _this$props2$getEvent,
          _this$props2$activeHa = _this$props2.activeHandleID,
          activeHandleID = _this$props2$activeHa === void 0 ? '' : _this$props2$activeHa;
      var domain = scale.getDomain();
      var tracks = [];

      for (var i = 0; i < handles.length + 1; i++) {
        var source = handles[i - 1];
        var target = handles[i];

        if (i === 0 && left === true) {
          source = {
            id: '$',
            value: domain[0],
            percent: 0
          };
        } else if (i === handles.length && right === true) {
          target = {
            id: '$',
            value: domain[1],
            percent: 100
          };
        }

        if (source && target) {
          tracks.push({
            id: "".concat(source.id, "-").concat(target.id),
            source: source,
            target: target
          });
        }
      }

      var renderedChildren = children({
        getEventData: getEventData,
        activeHandleID: activeHandleID,
        tracks: tracks,
        getTrackProps: getTrackProps
      });
      return renderedChildren && react__WEBPACK_IMPORTED_MODULE_1__.Children.only(renderedChildren);
    }
  }]);

  return Tracks;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

var DiscreteScale = /*#__PURE__*/_createClass(function DiscreteScale() {
  var _this = this;

  _classCallCheck(this, DiscreteScale);

  this.step = 1;
  this.domain = [0, 1];
  this.range = [0, 1];

  this.setDomain = function (val) {
    _this.domain = [val[0], val[1]];
    return _this;
  };

  this.setRange = function (val) {
    _this.range = [val[0], val[1]];
    return _this;
  };

  this.setStep = function (val) {
    _this.step = val;
    return _this;
  };

  this.getValue = function (x) {
    var _this$domain = _slicedToArray(_this.domain, 2),
        d0 = _this$domain[0],
        d1 = _this$domain[1],
        _this$range = _slicedToArray(_this.range, 2),
        r0 = _this$range[0],
        r1 = _this$range[1],
        step = _this.step;

    var p = (clamp(x, d0, d1) - d0) / (d1 - d0);
    var b = step * Math.round(p * (r1 - r0) / step) + r0;
    return clamp(b, r0 < r1 ? r0 : r1, r1 > r0 ? r1 : r0);
  };
});

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var noop = function noop() {};

var compare = function compare(b) {
  return function (m, d, i) {
    return m && b[i] === d;
  };
};

var equal = function equal(a, b) {
  return a === b || a.length === b.length && a.reduce(compare(b), true);
};

var isRCSComponent = function isRCSComponent(item) {
  if (! /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.isValidElement)(item)) {
    return false;
  }

  var type = item.type;
  var name = type ? type.name : '';
  return name === Handles.name || name === Rail.name || name === Ticks.name || name === Tracks.name;
};

var getNextValue = function getNextValue(curr, step, domain, reversed) {
  var newVal = reversed ? curr - step : curr + step;
  return reversed ? Math.max(domain[0], newVal) : Math.min(domain[1], newVal);
};

var getPrevValue = function getPrevValue(curr, step, domain, reversed) {
  var newVal = reversed ? curr + step : curr - step;
  return reversed ? Math.min(domain[1], newVal) : Math.max(domain[0], newVal);
};

var defaultDomain = [0, 100];
var Slider = /*#__PURE__*/function (_PureComponent) {
  _inherits(Slider, _PureComponent);

  var _super = _createSuper(Slider);

  function Slider() {
    var _this;

    _classCallCheck(this, Slider);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      step: 0.1,
      values: [],
      domain: defaultDomain,
      handles: [],
      reversed: false,
      activeHandleID: '',
      valueToPerc: null,
      valueToStep: null,
      pixelToStep: null
    };
    _this.slider = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createRef();

    _this.onKeyDown = function (e, handleID) {
      var validUpKeys = ['ArrowRight', 'ArrowUp'];
      var validDownKeys = ['ArrowDown', 'ArrowLeft'];

      var _assertThisInitialize = _assertThisInitialized(_this),
          handles = _assertThisInitialize.state.handles,
          _assertThisInitialize2 = _assertThisInitialize.props,
          _assertThisInitialize3 = _assertThisInitialize2.step,
          step = _assertThisInitialize3 === void 0 ? 0.1 : _assertThisInitialize3,
          _assertThisInitialize4 = _assertThisInitialize2.reversed,
          reversed = _assertThisInitialize4 === void 0 ? false : _assertThisInitialize4,
          _assertThisInitialize5 = _assertThisInitialize2.vertical,
          vertical = _assertThisInitialize5 === void 0 ? false : _assertThisInitialize5,
          _assertThisInitialize6 = _assertThisInitialize2.domain,
          domain = _assertThisInitialize6 === void 0 ? [0, 100] : _assertThisInitialize6;

      var key = e.key || "".concat(e.keyCode);

      if (!validUpKeys.concat(validDownKeys).includes(key)) {
        return;
      }

      if (vertical) {
        var _ref = [validDownKeys, validUpKeys];
        validUpKeys = _ref[0];
        validDownKeys = _ref[1];
      }

      e.stopPropagation && e.stopPropagation();
      e.preventDefault && e.preventDefault();
      var found = handles.find(function (value) {
        return value.key === handleID;
      });

      if (!found) {
        return;
      }

      var currVal = found.val;
      var newVal = currVal;

      if (validUpKeys.includes(key)) {
        newVal = getNextValue(currVal, step, domain, reversed);
      } else if (validDownKeys.includes(key)) {
        newVal = getPrevValue(currVal, step, domain, reversed);
      }

      var nextHandles = handles.map(function (v) {
        return v.key === handleID ? {
          key: v.key,
          val: newVal
        } : v;
      });

      _this.submitUpdate(nextHandles, true);
    };

    _this.onMouseDown = function (e, handleID) {
      _this.onStart(e, handleID, false);
    };

    _this.onTouchStart = function (e, handleID) {
      if (isNotValidTouch(e)) {
        return;
      }

      _this.onStart(e, handleID, true);
    };

    _this.getEventData = function (e, isTouch) {
      var _assertThisInitialize7 = _assertThisInitialized(_this),
          _assertThisInitialize8 = _assertThisInitialize7.state,
          pixelToStep = _assertThisInitialize8.pixelToStep,
          valueToPerc = _assertThisInitialize8.valueToPerc,
          vertical = _assertThisInitialize7.props.vertical; // double check the dimensions of the slider
      // @ts-ignore


      pixelToStep.setDomain(getSliderDomain(_this.slider.current, vertical));
      var value;

      if (isTouch && e instanceof TouchEvent) {
        // @ts-ignore
        value = pixelToStep.getValue(getTouchPosition(vertical, e));
      } else if (e instanceof MouseEvent) {
        // @ts-ignore
        value = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
      }

      return {
        value: value,
        // @ts-ignore
        percent: valueToPerc.getValue(value)
      };
    };

    _this.onMouseMove = function (e) {
      var _assertThisInitialize9 = _assertThisInitialized(_this),
          _assertThisInitialize10 = _assertThisInitialize9.state,
          curr = _assertThisInitialize10.handles,
          pixelToStep = _assertThisInitialize10.pixelToStep,
          _assertThisInitialize11 = _assertThisInitialize10.activeHandleID,
          activeHandleID = _assertThisInitialize11 === void 0 ? '' : _assertThisInitialize11,
          _assertThisInitialize12 = _assertThisInitialize9.props,
          vertical = _assertThisInitialize12.vertical,
          _assertThisInitialize13 = _assertThisInitialize12.reversed,
          reversed = _assertThisInitialize13 === void 0 ? false : _assertThisInitialize13; // double check the dimensions of the slider
      // @ts-ignore


      pixelToStep.setDomain(getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
      // @ts-ignore

      var updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX); // generate a "candidate" set of values - a suggestion of what to do

      var nextHandles = getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values

      _this.submitUpdate(nextHandles);
    };

    _this.onTouchMove = function (e) {
      var _assertThisInitialize14 = _assertThisInitialized(_this),
          _assertThisInitialize15 = _assertThisInitialize14.state,
          curr = _assertThisInitialize15.handles,
          pixelToStep = _assertThisInitialize15.pixelToStep,
          activeHandleID = _assertThisInitialize15.activeHandleID,
          _assertThisInitialize16 = _assertThisInitialize14.props,
          vertical = _assertThisInitialize16.vertical,
          reversed = _assertThisInitialize16.reversed;

      if (pixelToStep === null || isNotValidTouch(e)) {
        return;
      } // double check the dimensions of the slider
      // @ts-ignore


      pixelToStep.setDomain(getSliderDomain(_this.slider.current, vertical)); // find the closest value (aka step) to the event location
      // @ts-ignore

      var updateValue = pixelToStep.getValue(getTouchPosition(vertical, e)); // generate a "candidate" set of values - a suggestion of what to do

      var nextHandles = getUpdatedHandles(curr, activeHandleID, updateValue, reversed); // submit the candidate values

      _this.submitUpdate(nextHandles);
    };

    _this.onMouseUp = function () {
      var _assertThisInitialize17 = _assertThisInitialized(_this),
          _assertThisInitialize18 = _assertThisInitialize17.state,
          _assertThisInitialize19 = _assertThisInitialize18.handles,
          handles = _assertThisInitialize19 === void 0 ? [] : _assertThisInitialize19,
          activeHandleID = _assertThisInitialize18.activeHandleID,
          _assertThisInitialize20 = _assertThisInitialize17.props,
          _assertThisInitialize21 = _assertThisInitialize20.onChange,
          onChange = _assertThisInitialize21 === void 0 ? noop : _assertThisInitialize21,
          _assertThisInitialize22 = _assertThisInitialize20.onSlideEnd,
          onSlideEnd = _assertThisInitialize22 === void 0 ? noop : _assertThisInitialize22;

      onChange(handles.map(function (d) {
        return d.val;
      }));
      onSlideEnd(handles.map(function (d) {
        return d.val;
      }), {
        activeHandleID: activeHandleID
      });

      _this.setState({
        activeHandleID: ''
      });

      if (isBrowser) {
        document.removeEventListener('mousemove', _this.onMouseMove);
        document.removeEventListener('mouseup', _this.onMouseUp);
      }
    };

    _this.onTouchEnd = function () {
      var _assertThisInitialize23 = _assertThisInitialized(_this),
          _assertThisInitialize24 = _assertThisInitialize23.state,
          handles = _assertThisInitialize24.handles,
          activeHandleID = _assertThisInitialize24.activeHandleID,
          _assertThisInitialize25 = _assertThisInitialize23.props,
          _assertThisInitialize26 = _assertThisInitialize25.onChange,
          onChange = _assertThisInitialize26 === void 0 ? noop : _assertThisInitialize26,
          _assertThisInitialize27 = _assertThisInitialize25.onSlideEnd,
          onSlideEnd = _assertThisInitialize27 === void 0 ? noop : _assertThisInitialize27;

      onChange(handles.map(function (d) {
        return d.val;
      }));
      onSlideEnd(handles.map(function (d) {
        return d.val;
      }), {
        activeHandleID: activeHandleID
      });

      _this.setState({
        activeHandleID: ''
      });

      if (isBrowser) {
        document.removeEventListener('touchmove', _this.onTouchMove);
        document.removeEventListener('touchend', _this.onTouchEnd);
      }
    };

    return _this;
  }

  _createClass(Slider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var pixelToStep = this.state.pixelToStep;
      var vertical = this.props.vertical; // @ts-ignore

      pixelToStep.setDomain(getSliderDomain(this.slider.current, vertical));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListeners();
    }
  }, {
    key: "removeListeners",
    value: function removeListeners() {
      if (isBrowser) {
        document.removeEventListener('mousemove', this.onMouseMove);
        document.removeEventListener('mouseup', this.onMouseUp);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "onStart",
    value: function onStart(e, handleID, isTouch) {
      var handles = this.state.handles,
          _this$props$onSlideSt = this.props.onSlideStart,
          onSlideStart = _this$props$onSlideSt === void 0 ? noop : _this$props$onSlideSt;

      if (!isTouch) {
        e.preventDefault && e.preventDefault();
      }

      e.stopPropagation && e.stopPropagation();
      var found = handles.find(function (value) {
        return value.key === handleID;
      });

      if (found) {
        this.setState({
          activeHandleID: handleID
        });
        onSlideStart(handles.map(function (d) {
          return d.val;
        }), {
          activeHandleID: handleID
        });
        isTouch ? this.addTouchEvents() : this.addMouseEvents();
      } else {
        this.setState({
          activeHandleID: ''
        });
        this.handleRailAndTrackClicks(e, isTouch);
      }
    }
  }, {
    key: "handleRailAndTrackClicks",
    value: function handleRailAndTrackClicks(e, isTouch) {
      var _this2 = this;

      var _this$state = this.state,
          curr = _this$state.handles,
          pixelToStep = _this$state.pixelToStep,
          _this$props = this.props,
          vertical = _this$props.vertical,
          _this$props$reversed = _this$props.reversed,
          reversed = _this$props$reversed === void 0 ? false : _this$props$reversed;
      var slider = this.slider; // double check the dimensions of the slider
      // @ts-ignore

      pixelToStep.setDomain(getSliderDomain(slider.current, vertical)); // find the closest value (aka step) to the event location

      var updateValue;

      if (isTouch) {
        // @ts-ignore
        updateValue = pixelToStep.getValue(getTouchPosition(vertical, e));
      } else {
        // @ts-ignore
        updateValue = pixelToStep.getValue(vertical ? e.clientY : e.pageX);
      } // find the closest handle key


      var updateKey = '';
      var minDiff = Infinity;

      for (var i = 0; i < curr.length; i++) {
        var _curr$i = curr[i],
            key = _curr$i.key,
            val = _curr$i.val;
        var diff = Math.abs(val - updateValue);

        if (diff < minDiff) {
          updateKey = key;
          minDiff = diff;
        }
      } // generate a "candidate" set of values - a suggestion of what to do


      var nextHandles = getUpdatedHandles(curr, updateKey, updateValue, reversed); // submit the candidate values

      this.setState({
        activeHandleID: updateKey
      }, function () {
        _this2.submitUpdate(nextHandles, true);

        isTouch ? _this2.addTouchEvents() : _this2.addMouseEvents();
      });
    }
  }, {
    key: "addMouseEvents",
    value: function addMouseEvents() {
      if (isBrowser) {
        document.addEventListener('mousemove', this.onMouseMove);
        document.addEventListener('mouseup', this.onMouseUp);
      }
    }
  }, {
    key: "addTouchEvents",
    value: function addTouchEvents() {
      if (isBrowser) {
        document.addEventListener('touchmove', this.onTouchMove);
        document.addEventListener('touchend', this.onTouchEnd);
      }
    }
  }, {
    key: "submitUpdate",
    value: function submitUpdate(next) {
      var callOnChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props2 = this.props,
          _this$props2$mode = _this$props2.mode,
          mode = _this$props2$mode === void 0 ? 1 : _this$props2$mode,
          _this$props2$step = _this$props2.step,
          step = _this$props2$step === void 0 ? 0.1 : _this$props2$step,
          _this$props2$onUpdate = _this$props2.onUpdate,
          onUpdate = _this$props2$onUpdate === void 0 ? noop : _this$props2$onUpdate,
          _this$props2$onChange = _this$props2.onChange,
          onChange = _this$props2$onChange === void 0 ? noop : _this$props2$onChange,
          _this$props2$reversed = _this$props2.reversed,
          reversed = _this$props2$reversed === void 0 ? false : _this$props2$reversed; //@ts-ignore

      var getValue = this.state.valueToStep.getValue;
      this.setState(function (_ref2) {
        var curr = _ref2.handles;
        var handles = []; // given the current handles and a candidate set, decide what to do

        if (typeof mode === 'function') {
          handles = mode(curr, next, step, reversed, getValue);
          warning__WEBPACK_IMPORTED_MODULE_0___default()(Array.isArray(handles), 'Custom mode function did not return an array.');
        } else {
          switch (mode) {
            case 1:
              handles = mode1(curr, next);
              break;

            case 2:
              handles = mode2(curr, next);
              break;

            case 3:
              handles = mode3(curr, next, step, reversed, getValue);
              break;

            default:
              handles = next;
              warning__WEBPACK_IMPORTED_MODULE_0___default()(false, "".concat(prfx, " Invalid mode value."));
          }
        }

        onUpdate(handles.map(function (d) {
          return d.val;
        }));

        if (callOnChange) {
          onChange(handles.map(function (d) {
            return d.val;
          }));
        }

        return {
          handles: handles
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state2 = this.state,
          handles = _this$state2.handles,
          valueToPerc = _this$state2.valueToPerc,
          activeHandleID = _this$state2.activeHandleID,
          _this$props3 = this.props,
          className = _this$props3.className,
          _this$props3$rootStyl = _this$props3.rootStyle,
          rootStyle = _this$props3$rootStyl === void 0 ? {} : _this$props3$rootStyl,
          _this$props3$rootProp = _this$props3.rootProps,
          rootProps = _this$props3$rootProp === void 0 ? {} : _this$props3$rootProp,
          _this$props3$componen = _this$props3.component,
          Comp = _this$props3$componen === void 0 ? 'div' : _this$props3$componen,
          _this$props3$disabled = _this$props3.disabled,
          disabled = _this$props3$disabled === void 0 ? false : _this$props3$disabled,
          _this$props3$flatten = _this$props3.flatten,
          flatten = _this$props3$flatten === void 0 ? false : _this$props3$flatten;
      var mappedHandles = handles.map(function (_ref3) {
        var key = _ref3.key,
            val = _ref3.val;
        // @ts-ignore
        return {
          id: key,
          value: val,
          percent: valueToPerc.getValue(val)
        };
      });
      var children = react__WEBPACK_IMPORTED_MODULE_1__.Children.map(this.props.children, function (child) {
        if (isRCSComponent(child) === true) {
          return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.cloneElement(child, {
            scale: valueToPerc,
            handles: mappedHandles,
            activeHandleID: activeHandleID,
            getEventData: _this3.getEventData,
            emitKeyboard: disabled ? noop : _this3.onKeyDown,
            emitMouse: disabled ? noop : _this3.onMouseDown,
            emitTouch: disabled ? noop : _this3.onTouchStart
          });
        } else {
          return child;
        }
      });
      return flatten ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Comp, _objectSpread2(_objectSpread2({}, rootProps), {}, {
        style: rootStyle,
        className: className,
        ref: this.slider
      })), children) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(Comp, _objectSpread2(_objectSpread2({}, rootProps), {}, {
        style: rootStyle,
        className: className,
        ref: this.slider
      }), children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var _nextProps$step = nextProps.step,
          step = _nextProps$step === void 0 ? 0.1 : _nextProps$step,
          values = nextProps.values,
          _nextProps$domain = nextProps.domain,
          domain = _nextProps$domain === void 0 ? defaultDomain : _nextProps$domain,
          _nextProps$reversed = nextProps.reversed,
          reversed = _nextProps$reversed === void 0 ? false : _nextProps$reversed,
          _nextProps$onUpdate = nextProps.onUpdate,
          onUpdate = _nextProps$onUpdate === void 0 ? noop : _nextProps$onUpdate,
          _nextProps$onChange = nextProps.onChange,
          onChange = _nextProps$onChange === void 0 ? noop : _nextProps$onChange,
          _nextProps$warnOnChan = nextProps.warnOnChanges,
          warnOnChanges = _nextProps$warnOnChan === void 0 ? false : _nextProps$warnOnChan;
      var valueToPerc = prevState.valueToPerc;
      var valueToStep = prevState.valueToStep;
      var pixelToStep = prevState.pixelToStep;
      var nextState = {};

      if (!valueToPerc || !valueToStep || !pixelToStep) {
        valueToPerc = new LinearScale();
        valueToStep = new DiscreteScale();
        pixelToStep = new DiscreteScale();
        nextState.valueToPerc = valueToPerc;
        nextState.valueToStep = valueToStep;
        nextState.pixelToStep = pixelToStep;
      }

      if (prevState.domain === defaultDomain || prevState.step === null || prevState.domain === null || prevState.reversed === null || step !== prevState.step || domain[0] !== prevState.domain[0] || domain[1] !== prevState.domain[1] || reversed !== prevState.reversed) {
        var _domain = _slicedToArray(domain, 2),
            min = _domain[0],
            max = _domain[1];

        valueToStep.setStep(step).setRange([min, max]).setDomain([min, max]);

        if (reversed === true) {
          valueToPerc.setDomain([min, max]).setRange([100, 0]);
          pixelToStep.setStep(step).setRange([max, min]);
        } else {
          valueToPerc.setDomain([min, max]).setRange([0, 100]);
          pixelToStep.setStep(step).setRange([min, max]);
        }

        warning__WEBPACK_IMPORTED_MODULE_0___default()(max > min, "".concat(prfx, " Max must be greater than min (even if reversed). Max is ").concat(max, ". Min is ").concat(min, "."));

        var _getHandles = getHandles(values || prevState.values, reversed, valueToStep, warnOnChanges),
            handles = _getHandles.handles,
            changes = _getHandles.changes;

        if (changes || values === undefined || values === prevState.values) {
          onUpdate(handles.map(function (d) {
            return d.val;
          }));
          onChange(handles.map(function (d) {
            return d.val;
          }));
        }

        nextState.step = step;
        nextState.values = values;
        nextState.domain = domain === defaultDomain ? _toConsumableArray(domain) : domain;
        nextState.handles = handles;
        nextState.reversed = reversed;
      } else if (!equal(values, prevState.values)) {
        var _getHandles2 = getHandles(values, reversed, valueToStep, warnOnChanges),
            _handles = _getHandles2.handles,
            _changes = _getHandles2.changes;

        if (_changes) {
          onUpdate(_handles.map(function (d) {
            return d.val;
          }));
          onChange(_handles.map(function (d) {
            return d.val;
          }));
        }

        nextState.values = values;
        nextState.handles = _handles;
      }

      if (Object.keys(nextState).length) {
        return nextState;
      }

      return null;
    }
  }]);

  return Slider;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


//# sourceMappingURL=rcs.esm.js.map


/***/ }),

/***/ 1793:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93236);


var Banner = function(param) {
    var banners = param.banners, type = param.type, alt = param.alt;
    if (!banners || !banners.length > 0) {
        return null;
    }
    var banner = banners.find(function(b) {
        return b.type.toUpperCase() === type.toUpperCase();
    });
    if (!banner) {
        return null;
    }
    var imageUrl = banner.imageUrl, targetUrl = banner.url;
    return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement("img", {
        src: imageUrl,
        alt: alt,
        role: "link" // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
        ,
        onClick: function() {
            if (targetUrl) {
                window.open(targetUrl);
            }
        }
    }));
};
var string = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().string), shape = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().shape), arrayOf = (prop_types__WEBPACK_IMPORTED_MODULE_0___default().arrayOf);
Banner.propTypes = {
    type: string.isRequired,
    alt: string,
    banners: arrayOf(shape({
        type: string,
        url: string,
        imageUrl: string
    }))
};
Banner.defaultProps = {
    alt: ""
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Banner);


/***/ }),

/***/ 27774:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_articles)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/featured-article/index.tsx + 5 modules
var featured_article = __webpack_require__(66103);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/areas/campaign/styles.ts
var styles = __webpack_require__(63593);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-articles/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Articles = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Articles",
    componentId: "sc-0-0"
})(_templateObject(), styles/* flexStyle */.XX, styles/* dividerStyle */.hg, styles/* gutterStyle */.W2);

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-articles/index.js






var CampaignArticles = function(param) {
    var featuredArticle = param.featuredArticle, articles = param.articles, campaignName = param.campaignName;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Articles, null, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("campaigns", "article.related-articles", {
        campaignName: campaignName
    })), /*#__PURE__*/ react.createElement(featured_article/* FeaturedArticle */.h, {
        // If no featured article was found show first article
        article: featuredArticle || articles[0],
        related: articles
    })));
};
var string = (prop_types_default()).string, number = (prop_types_default()).number, shape = (prop_types_default()).shape, arrayOf = (prop_types_default()).arrayOf;
var articleShape = shape({
    id: number,
    publishedAt: string,
    title: string,
    preamble: string,
    imageUrl: string,
    imageCaption: string,
    pathName: string
});
CampaignArticles.propTypes = {
    featuredArticle: articleShape,
    articles: arrayOf(articleShape),
    campaignName: string
};
CampaignArticles.defaultProps = {
    featuredArticle: null,
    articles: [],
    campaignName: ""
};
/* harmony default export */ const campaign_articles = (CampaignArticles);


/***/ }),

/***/ 1603:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_group)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(93927);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  border-color: ",
        ";\n  border-style: solid;\n  border-width: 1px;\n  border-radius: ",
        ";\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n  gap: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CampaignListItem = (0,styled_components_browser_esm["default"])(list_variants/* GridColumn */.C4).withConfig({
    displayName: "CampaignListItem",
    componentId: "sc-0-0"
})(_templateObject(), base/* colors.borderLightGray */.O9.borderLightGray, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants/* GridRow */.Jn).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing400 */.bK.measurements.spacing400);

// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-group/index.js








var CampaignGroup = function(param) {
    var campaigns = param.campaigns, title = param.title, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, {
        className: className
    }, title && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, title), /*#__PURE__*/ react.createElement(RowWithWrap, null, campaigns.map(function(campaign) {
        return /*#__PURE__*/ react.createElement(CampaignListItem, {
            key: campaign.id
        }, /*#__PURE__*/ react.createElement(variants/* H4Text */.Ml, null, campaign.title.short), /*#__PURE__*/ react.createElement(variants/* BodySmallText */.oI, {
            container: "p"
        }, campaign.description.short), /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
            campaign: campaign,
            linkContent: t("campaigns", "link.visit-campaign"),
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                    nextPage: campaign.web_uri.responsive
                });
            }
        }));
    })));
};
var arrayOf = (prop_types_default()).arrayOf, number = (prop_types_default()).number, shape = (prop_types_default()).shape, string = (prop_types_default()).string;
CampaignGroup.propTypes = {
    title: string,
    campaigns: arrayOf(shape({
        id: number.isRequired,
        slug: string,
        title: shape({
            short: string,
            long: string
        }),
        description: shape({
            short: string,
            long: string
        })
    }).isRequired).isRequired,
    className: string
};
CampaignGroup.defaultProps = {
    title: undefined,
    className: undefined
};
/* harmony default export */ const campaign_group = (CampaignGroup);


/***/ }),

/***/ 76291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ campaign_inactive)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.1.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(86177);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/components/flip-clock/index.js
var flip_clock = __webpack_require__(23672);
// EXTERNAL MODULE: ./src/components/newsletter-signup/index.ts + 2 modules
var newsletter_signup = __webpack_require__(26285);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.js
var campaign_ids = __webpack_require__(59827);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(51558);
// EXTERNAL MODULE: ./src/components/campaign-deals/index.ts
var campaign_deals = __webpack_require__(85222);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/cdn-image/index.tsx
var cdn_image = __webpack_require__(8219);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
;// CONCATENATED MODULE: ./src/areas/campaign/components/shop-card/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  height: 100%;\n  padding: 15px;\n  text-align: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  flex: 0 0 auto;\n  font-weight: 600;\n  padding: 10px;\n  background: #f5f9fb;\n  color: ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  box-shadow: 0 0 5px 0 ",
        ";\n  transition: box-shadow 0.1s linear;\n  &:hover {\n    box-shadow: 0 0 5px 0 ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n  &:focus {\n    box-shadow: 0 0 0 2px ",
        ";\n    ",
        " {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  flex: 0 0 auto;\n  padding: 15px;\n  margin: auto 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var StyledShopCard = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledShopCard",
    componentId: "sc-0-0"
})(_templateObject());
var CallToActionText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CallToActionText",
    componentId: "sc-0-1"
})(_templateObject1(), function(p) {
    return p.theme.text.callToAction;
});
var ShopButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ShopButton",
    componentId: "sc-0-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.base200;
}, function(p) {
    return p.theme.colors.base300;
}, CallToActionText, function(p) {
    return p.theme.text.callToActionHover;
}, function(p) {
    return p.theme.colors.positive500;
}, CallToActionText, function(p) {
    return p.theme.text.callToActionHover;
});
var LogoWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "LogoWrapper",
    componentId: "sc-0-3"
})(_templateObject3());

;// CONCATENATED MODULE: ./src/areas/campaign/components/shop-card/index.tsx



// eslint-disable-next-line @typescript-eslint/no-empty-function
var noop = function() {};
var ShopCard = function(param) {
    var id = param.id, name = param.name, width = param.width, height = param.height, logo = param.logo, _hasLogo = param.hasLogo, hasLogo = _hasLogo === void 0 ? false : _hasLogo, _featured = param.featured, featured = _featured === void 0 ? false : _featured, _onClick = param.onClick, onClick = _onClick === void 0 ? noop : _onClick, callToActionText = param.callToActionText;
    return /*#__PURE__*/ react.createElement(StyledShopCard, null, /*#__PURE__*/ react.createElement(ShopButton, {
        type: "button",
        onClick: onClick,
        style: {
            width: width,
            height: height
        }
    }, hasLogo && id ? /*#__PURE__*/ react.createElement(cdn_image/* CdnImage */.l, {
        name: id,
        width: width
    }) : /*#__PURE__*/ react.createElement(LogoWrapper, null, logo && featured ? /*#__PURE__*/ react.createElement("img", {
        alt: name,
        src: logo
    }) : name), callToActionText && /*#__PURE__*/ react.createElement(CallToActionText, null, callToActionText)));
};

// EXTERNAL MODULE: ./src/components/flexible-grid/index.ts + 2 modules
var flexible_grid = __webpack_require__(59857);
// EXTERNAL MODULE: ./src/areas/campaign/components/data/use-with-elastic.tsx
var use_with_elastic = __webpack_require__(24405);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/areas/campaign/components/deals/index.tsx + 2 modules
var deals = __webpack_require__(35014);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(93927);
// EXTERNAL MODULE: ./src/areas/store/actions/index.js
var actions = __webpack_require__(96833);
// EXTERNAL MODULE: ./src/components/modal/modal.tsx + 1 modules
var modal = __webpack_require__(30407);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-store-popup/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 90% !important;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 90% !important;\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 60% !important;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: auto;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var StorePopupModal = (0,styled_components_browser_esm["default"])(modal["default"]).withConfig({
    displayName: "StorePopupModal",
    componentId: "sc-0-0"
})(styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(styles_templateObject()), base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject1()), base/* media.largeUp */.BC.largeUp(styles_templateObject2()));
var StyledOutlineButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledOutlineButton",
    componentId: "sc-0-1"
})(_templateObject4());

// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(77660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(71406);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-store-popup/index.tsx











var CampaignStorePopup = function(param) {
    var router = param.router, shop = param.shop, _onRequestClose = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onRequestClose, onRequestClose = _onRequestClose === void 0 ? function() {} : _onRequestClose, campaign = param.campaign, _dealCount = param.dealCount, dealCount = _dealCount === void 0 ? 8 : _dealCount;
    var dispatch = (0,es/* useDispatch */.I0)();
    var t = (0,app_context/* useAppContext */.bp)().t;
    var onClick = (0,react.useCallback)(function() {
        dispatch((0,actions/* storeLinkClick */.P)(shop));
        (0,conversion/* trackShopClickWithRevenue */.Yn)({
            shopId: shop.id,
            scope: conversion/* TrackClickScope.CAMPAIGN_SHOP_POPUP */.b8.CAMPAIGN_SHOP_POPUP
        });
    }, [
        dispatch,
        shop
    ]);
    return /*#__PURE__*/ react.createElement(StorePopupModal, {
        isOpen: true,
        shouldShowCloseIcon: true,
        onRequestClose: onRequestClose
    }, /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, shop.featured ? /*#__PURE__*/ react.createElement(variants/* BodyMediumText */.J$, {
        container: "a",
        containerProps: {
            target: "_blank",
            rel: "nofollow noopener",
            onClick: onClick,
            href: shop.external_uri
        }
    }, /*#__PURE__*/ react.createElement("img", {
        width: 176,
        alt: shop.name,
        src: shop.logo && (shop.logo["176"] || shop.logo["96"]),
        style: {
            display: "block"
        }
    }), "".concat(shop.name, " - ").concat(t("search", "raw-search.go-to-shop"))) : /*#__PURE__*/ react.createElement(variants/* H3Text */.I7, null, shop.name), campaign.id && campaign.name && /*#__PURE__*/ react.createElement(deals/* Deals */.Y, {
        campaignId: campaign.id,
        campaignName: campaign.name,
        router: router,
        rangeOptions: [],
        size: dealCount,
        stores: [
            String(shop.id)
        ],
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: function() {},
        showPagination: false,
        showProductsHeader: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClear: function() {}
    }), /*#__PURE__*/ react.createElement(StyledOutlineButton, {
        style: {
            textAlign: "center"
        }
    }, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        queryString: "?stores=".concat(shop.id),
        linkContent: /*#__PURE__*/ react.createElement(button_variants/* OutlinedButton */.Uc, null, t("campaigns", "link.view-all"))
    }))));
};
/* harmony default export */ const campaign_store_popup = (CampaignStorePopup);

// EXTERNAL MODULE: ./src/areas/campaign/styles.ts
var styles = __webpack_require__(63593);
;// CONCATENATED MODULE: ./src/areas/campaign/components/popular-stores/styles.ts
function popular_stores_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function popular_stores_styles_templateObject() {
    var data = popular_stores_styles_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n\n  && {\n    min-width: 100%;\n  }\n"
    ]);
    popular_stores_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-0"
})(popular_stores_styles_templateObject(), styles/* flexStyle */.XX, styles/* gutterStyle */.W2);

// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(70477);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
;// CONCATENATED MODULE: ./src/areas/campaign/components/popular-stores/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}












var buildQuery = function() {
    return {
        size: 0,
        aggs: {
            stores: {
                terms: {
                    field: "store.id",
                    size: 20,
                    order: {
                        total_rank: "desc"
                    }
                },
                aggs: {
                    total_rank: {
                        sum: {
                            field: "rank"
                        }
                    },
                    top_hits: {
                        top_hits: {
                            _source: {
                                includes: [
                                    "id",
                                    "store.id",
                                    "store.featured",
                                    "store.logo",
                                    "store.name",
                                    "store.external_uri"
                                ]
                            },
                            size: 1
                        }
                    }
                }
            }
        }
    };
};
var PopularStores = function(props) {
    var toggleStoreCampaignItemsPopup = function toggleStoreCampaignItemsPopup(shop) {
        setCurrentShop(shop);
    };
    var ref, ref1;
    var ref2 = _slicedToArray(react.useState(undefined), 2), currentShop = ref2[0], setCurrentShop = ref2[1];
    var data = (0,use_with_elastic/* useElasticFetch */.Z)({
        query: buildQuery(),
        campaignId: props.campaignId,
        timeout: 1500
    }).data;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var dailyDeals = props.dailyDeals, router = props.router;
    var vp = (0,context/* useViewportContext */.Ak)();
    var ref3 = vp.isDesktop ? {
        numberOfStores: 20,
        dealCount: 8
    } : {
        numberOfStores: 4,
        dealCount: 4
    }, numberOfStores = ref3.numberOfStores, dealCount = ref3.dealCount;
    return /*#__PURE__*/ react.createElement(Wrapper, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, {
        style: {
            flexWrap: "wrap"
        }
    }, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("campaigns", "inactive-campaign.popular-stores")), /*#__PURE__*/ react.createElement(variants/* BodyMediumText */.J$, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: dailyDeals.web_uri.responsive,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.CAMPAIGN_HEADER */.U.CAMPAIGN_HEADER,
                    nextPage: dailyDeals.web_uri.responsive
                });
            }
        }
    }, t("campaigns", "link.view-all"))), /*#__PURE__*/ react.createElement(flexible_grid/* Grid */.r, {
        columnTemplate: "repeat(auto-fit, minmax(min(100%/2, max(143px, 100%/5)), 1fr))"
    }, (data === null || data === void 0 ? void 0 : (ref = data.aggregations) === null || ref === void 0 ? void 0 : (ref1 = ref.stores) === null || ref1 === void 0 ? void 0 : ref1.buckets) && data.aggregations.stores.buckets.slice(0, numberOfStores).map(function(hit) {
        var shop = hit.top_hits.hits.hits[0]._source.store;
        return /*#__PURE__*/ react.createElement(ShopCard, {
            key: hit.key,
            name: shop.name,
            featured: shop.featured,
            logo: shop.logo && (shop.logo["176"] || shop.logo["96"]),
            onClick: function() {
                return toggleStoreCampaignItemsPopup(shop);
            }
        });
    })), currentShop && dailyDeals && /*#__PURE__*/ react.createElement(campaign_store_popup, {
        router: router,
        campaign: dailyDeals,
        shop: currentShop,
        dealCount: dealCount,
        onRequestClose: function() {
            return toggleStoreCampaignItemsPopup();
        }
    }));
};

// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(69919);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(23354);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx + 1 modules
var product_alert_form = __webpack_require__(32851);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(84130);
// EXTERNAL MODULE: ./src/components/product-search/index.tsx + 3 modules
var product_search = __webpack_require__(29014);
;// CONCATENATED MODULE: ./src/areas/campaign/components/product-alert-box/styles.ts
function product_alert_box_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function product_alert_box_styles_templateObject() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n  border-radius: ",
        ";\n  background: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    product_alert_box_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject1() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n    min-width: 100%;\n  "
    ]);
    product_alert_box_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject2() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  & > * {\n    flex: none;\n  }\n\n  max-width: 33%;\n\n  ",
        "\n"
    ]);
    product_alert_box_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function product_alert_box_styles_templateObject3() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  background: ",
        ";\n  border-radius: 5px 5px 0 0;\n"
    ]);
    product_alert_box_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = product_alert_box_styles_taggedTemplateLiteral([
        "\n  & > * {\n    min-width: 100%;\n  }\n\n  background: ",
        ";\n  padding: 0 ",
        " ",
        ";\n  border-radius: 0 0 5px 5px;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var RoundedBluePanel = (0,styled_components_browser_esm["default"])(list_variants/* Row */.X2).withConfig({
    displayName: "RoundedBluePanel",
    componentId: "sc-0-0"
})(product_alert_box_styles_templateObject(), base/* layout.measurements.spacing150 */.bK.measurements.spacing150, base/* layout.measurements.spacing250 */.bK.measurements.spacing250, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.maybeBlue700;
});
var TextColumn = (0,styled_components_browser_esm["default"])(list_variants/* Column */.sg).withConfig({
    displayName: "TextColumn",
    componentId: "sc-0-1"
})(product_alert_box_styles_templateObject2(), base/* media.smallOnly */.BC.smallOnly(product_alert_box_styles_templateObject1()));
var SelectedProductRow = (0,styled_components_browser_esm["default"])(list_variants/* Row */.X2).withConfig({
    displayName: "SelectedProductRow",
    componentId: "sc-0-2"
})(product_alert_box_styles_templateObject3(), function(p) {
    return p.theme.colors.base0;
});
var AlertFormWrapper = (0,styled_components_browser_esm["default"])(list_variants/* Row */.X2).withConfig({
    displayName: "AlertFormWrapper",
    componentId: "sc-0-3"
})(styles_templateObject4(), function(p) {
    return p.theme.colors.base0;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);

;// CONCATENATED MODULE: ./src/areas/campaign/components/product-alert-box/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}














var ProductAlertBox = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(ProductAlertBox, _PureComponent);
    var _super = _createSuper(ProductAlertBox);
    function ProductAlertBox(props) {
        _classCallCheck(this, ProductAlertBox);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            item: undefined
        };
        return _this;
    }
    _createClass(ProductAlertBox, [
        {
            key: "getPrivacyUrl",
            value: function getPrivacyUrl() {
                var _context = this.context, market = _context.market, renderMode = _context.renderMode;
                return (market.privacySettings[renderMode] || market.privacySettings.responsive).privacyUrl;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, sending = _props.sending, error = _props.error, createAlertRequest = _props.createAlertRequest, removeAlertRequest = _props.removeAlertRequest, campaignName = _props.campaignName;
                var _context = this.context, t = _context.t, linkTo = _context.linkTo;
                var item = this.state.item;
                if (item) {
                    item.stockStatus = "in_stock";
                }
                return /*#__PURE__*/ react.createElement(RoundedBluePanel, {
                    gap: 1
                }, /*#__PURE__*/ react.createElement(TextColumn, null, /*#__PURE__*/ react.createElement(variants/* BodyLargeText */.oZ, {
                    color: "light"
                }, t("campaigns", "inactive-campaign.alert-box-title")), /*#__PURE__*/ react.createElement(variants/* BodySmallText */.oI, {
                    color: "light"
                }, t("campaigns", "inactive-campaign.alert-box-description", {
                    campaignName: campaignName
                }))), /*#__PURE__*/ react.createElement(list_variants/* Column */.sg, {
                    style: {
                        position: "relative"
                    }
                }, item ? /*#__PURE__*/ react.createElement(SelectedProductRow, null, /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                    key: item.id,
                    id: item.id,
                    link: linkTo("product", item),
                    name: item.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    price: item.price
                }), /*#__PURE__*/ react.createElement(button_variants/* IconButton */.hU, {
                    onlyIcon: true,
                    onClick: function() {
                        return _this.setState({
                            item: undefined
                        });
                    }
                }, /*#__PURE__*/ react.createElement(button_variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null)))) : /*#__PURE__*/ react.createElement(product_search/* default */.Z, {
                    onSelect: function(selectedItem) {
                        return _this.setState({
                            item: selectedItem
                        });
                    },
                    showFloatingResult: true,
                    placeholder: t("campaigns", "inactive-campaign.alert-box-search-placeholder")
                }), item && /*#__PURE__*/ react.createElement(AlertFormWrapper, null, /*#__PURE__*/ react.createElement(product_alert_form/* ProductAlertForm */.u, {
                    productAlertFormData: {
                        product: _objectSpreadProps(_objectSpread({}, item), {
                            priceSummary: {
                                regular: item.priceRaw
                            }
                        })
                    },
                    disabled: sending,
                    error: error,
                    showTypeSelect: false,
                    onCreate: function(alert) {
                        return createAlertRequest(alert, item.pathName);
                    },
                    onRemove: function(alertId) {
                        return removeAlertRequest(alertId, item.id, item.pathName);
                    },
                    privacyPolicyUri: this.getPrivacyUrl(),
                    showCancel: false,
                    alertType: "PRICE_DROPS",
                    showRemoveButton: false
                }))));
            }
        }
    ]);
    return ProductAlertBox;
}(react.PureComponent);
var func = (prop_types_default()).func, bool = (prop_types_default()).bool, string = (prop_types_default()).string, oneOfType = (prop_types_default()).oneOfType;
ProductAlertBox.contextType = app_context/* AppContext */.Il;
ProductAlertBox.propTypes = {
    createAlertRequest: func.isRequired,
    removeAlertRequest: func.isRequired,
    sending: bool.isRequired,
    success: bool.isRequired,
    error: oneOfType([
        bool,
        string
    ]).isRequired,
    campaignName: string.isRequired
};
var dispatchActions = {
    createAlertRequest: actions_alert/* createAlertRequest */.$b,
    removeAlertRequest: actions_alert/* removeAlertRequest */.s$
};
/* harmony default export */ const product_alert_box = ((0,es/* connect */.$j)(function(state) {
    return {
        sending: state.areas.productAlert.sending,
        success: state.areas.productAlert.success,
        error: state.areas.productAlert.error
    };
}, dispatchActions)(ProductAlertBox));

// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-articles/index.js + 1 modules
var campaign_articles = __webpack_require__(27774);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-inactive/styles.ts
function campaign_inactive_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_inactive_styles_templateObject() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    campaign_inactive_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject1() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  flex-wrap: wrap;\n"
    ]);
    campaign_inactive_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject2() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n    scale: 0.75;\n  "
    ]);
    campaign_inactive_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function campaign_inactive_styles_templateObject3() {
    var data = campaign_inactive_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    campaign_inactive_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var PanelWithGutter = (0,styled_components_browser_esm["default"])(panel/* Panel */.s_).withConfig({
    displayName: "PanelWithGutter",
    componentId: "sc-0-0"
})(campaign_inactive_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RowWithWrap = (0,styled_components_browser_esm["default"])(list_variants/* GridRow */.Jn).withConfig({
    displayName: "RowWithWrap",
    componentId: "sc-0-1"
})(campaign_inactive_styles_templateObject1());
var FlipClockWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FlipClockWrapper",
    componentId: "sc-0-2"
})(campaign_inactive_styles_templateObject3(), base/* media.smallOnly */.BC.smallOnly(campaign_inactive_styles_templateObject2()));

;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-inactive/index.js
function campaign_inactive_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function campaign_inactive_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function campaign_inactive_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function campaign_inactive_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) campaign_inactive_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) campaign_inactive_defineProperties(Constructor, staticProps);
    return Constructor;
}
function campaign_inactive_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function campaign_inactive_getPrototypeOf(o) {
    campaign_inactive_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return campaign_inactive_getPrototypeOf(o);
}
function campaign_inactive_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) campaign_inactive_setPrototypeOf(subClass, superClass);
}
function campaign_inactive_possibleConstructorReturn(self, call) {
    if (call && (campaign_inactive_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return campaign_inactive_assertThisInitialized(self);
}
function campaign_inactive_setPrototypeOf(o, p) {
    campaign_inactive_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return campaign_inactive_setPrototypeOf(o, p);
}
var campaign_inactive_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function campaign_inactive_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function campaign_inactive_createSuper(Derived) {
    var hasNativeReflectConstruct = campaign_inactive_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = campaign_inactive_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = campaign_inactive_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return campaign_inactive_possibleConstructorReturn(this, result);
    };
}














var CampaignInactive = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    campaign_inactive_inherits(CampaignInactive, _PureComponent);
    var _super = campaign_inactive_createSuper(CampaignInactive);
    function CampaignInactive(props) {
        campaign_inactive_classCallCheck(this, CampaignInactive);
        var _this;
        _this = _super.call(this, props);
        _this.handleChange = _this.handleChange.bind(campaign_inactive_assertThisInitialized(_this));
        return _this;
    }
    campaign_inactive_createClass(CampaignInactive, [
        {
            key: "handleChange",
            value: function handleChange(e) {
                this.setState(campaign_inactive_defineProperty({}, e.target.name, e.target.value));
            }
        },
        {
            key: "render",
            value: function render() {
                var _context = this.context, t = _context.t, renderMode = _context.renderMode;
                var _props = this.props, campaign = _props.campaign, targetDate = _props.targetDate, dailyDeals = _props.dailyDeals, router = _props.router, campaignDeals = _props.campaignDeals;
                var articles = campaign.articles;
                var featuredArticle = articles ? articles.find(function(item) {
                    return item.featured;
                }) : null;
                var upcoming = campaign.state === "UPCOMING";
                var legacyRenderMode = [
                    "desktop",
                    "mobile",
                    "native"
                ].includes(renderMode);
                return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(PanelWithGutter, null, !legacyRenderMode && /*#__PURE__*/ react.createElement(product_alert_box, {
                    campaignName: campaign.name
                }), upcoming && /*#__PURE__*/ react.createElement(RowWithWrap, null, /*#__PURE__*/ react.createElement(FlipClockWrapper, null, /*#__PURE__*/ react.createElement(flip_clock/* FlipClock */.d, {
                    suppressHydrationWarning: true,
                    targetDate: targetDate,
                    daysLabel: t("common", "time.day", {
                        n: 0
                    }),
                    hoursLabel: t("common", "time.hour", {
                        n: 0
                    }),
                    minutesLabel: t("common", "time.minute", {
                        n: 0
                    }),
                    secondsLabel: t("common", "time.second", {
                        n: 0
                    })
                })), /*#__PURE__*/ react.createElement(newsletter_signup/* NewsletterSignup */.o, {
                    title: t("campaigns", "newsletter.sign-up-title", {
                        campaignName: campaign.name
                    }),
                    description: t("campaigns", "newsletter.sign-up-description")
                })), /*#__PURE__*/ react.createElement(campaign_deals/* default */.Z, {
                    deals: campaignDeals
                })), /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
                    onError: function() {
                        return null;
                    }
                }, /*#__PURE__*/ react.createElement(campaign_articles/* default */.Z, {
                    featuredArticle: featuredArticle,
                    articles: articles,
                    campaignName: campaign.name
                })), /*#__PURE__*/ react.createElement(PopularStores, {
                    dailyDeals: dailyDeals,
                    campaignId: campaign_ids/* DAILY_DEALS_ID */.Wf,
                    router: router
                }), !upcoming && /*#__PURE__*/ react.createElement(PanelWithGutter, null, /*#__PURE__*/ react.createElement(variants/* H2Text */.H$, null, t("campaigns", "ended.title", {
                    campaign: campaign.name
                })), /*#__PURE__*/ react.createElement(variants/* H3Text */.I7, null, t("campaigns", "ended.subtitle"))));
            }
        }
    ]);
    return CampaignInactive;
}(react.PureComponent);
var campaign_inactive_string = (prop_types_default()).string, number = (prop_types_default()).number, shape = (prop_types_default()).shape, object = (prop_types_default()).object;
CampaignInactive.propTypes = {
    targetDate: number.isRequired,
    campaign: shape({
        title: shape({
            short: campaign_inactive_string,
            long: campaign_inactive_string
        }),
        description: shape({
            short: campaign_inactive_string,
            long: campaign_inactive_string
        })
    }).isRequired,
    history: shape({
        location: shape({
            pathname: campaign_inactive_string,
            search: campaign_inactive_string
        })
    }).isRequired,
    router: shape({
        id: number
    }).isRequired,
    dailyDeals: object
};
CampaignInactive.defaultProps = {
    dailyDeals: undefined
};
CampaignInactive.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const campaign_inactive = ((0,react_router/* withRouter */.EN)(CampaignInactive));


/***/ }),

/***/ 93927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ components_link)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
;// CONCATENATED MODULE: ./src/areas/campaign/components/link/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var TitleMediumTextLink = (0,styled_components_browser_esm["default"])(variants/* TitleMediumText */.tC).withConfig({
    displayName: "TitleMediumTextLink",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/areas/campaign/components/link/index.js





var CampaignLink = function(props) {
    var renderMode = (0,react.useContext)(app_context/* AppContext */.Il).renderMode;
    var campaign = props.campaign, linkContent = props.linkContent, onClick = props.onClick;
    if (!linkContent) {
        return null;
    }
    if (renderMode === "native") {
        return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
            container: "a",
            containerProps: {
                href: campaign.web_uri.mobile,
                "data-test": props["data-test"],
                onClick: onClick
            }
        }, linkContent);
    }
    return /*#__PURE__*/ react.createElement(TitleMediumTextLink, {
        container: react_router_dom/* Link */.rU,
        containerProps: {
            to: "".concat(campaign.web_uri.responsive).concat(props.queryString || ""),
            "data-test": props["data-test"],
            onClick: onClick
        }
    }, linkContent);
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string, node = (prop_types_default()).node, func = (prop_types_default()).func;
CampaignLink.propTypes = {
    linkContent: node,
    queryString: string,
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        }),
        web_uri: shape({
            desktop: string,
            mobile: string
        })
    }).isRequired,
    className: string,
    "data-test": string,
    onClick: func
};
CampaignLink.defaultProps = {
    linkContent: "",
    className: null,
    queryString: null,
    "data-test": undefined,
    onClick: undefined
};
/* harmony default export */ const components_link = (CampaignLink);


/***/ }),

/***/ 82346:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ search)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var actions = __webpack_require__(46205);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(58676);
;// CONCATENATED MODULE: ./src/areas/campaign/components/search/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  right: 10px;\n  top: 10px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: 0;\n  display: block;\n  outline: none;\n  cursor: text;\n  padding: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 5px;\n\n  &:focus {\n    border-color: ",
        ";\n    box-shadow: inset 0 0 0 1px ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var SearchIcon = (0,styled_components_browser_esm["default"])(magnifier/* IconMagnifier */.j).attrs(function() {
    return {
        color: "base300"
    };
}).withConfig({
    displayName: "SearchIcon",
    componentId: "sc-0-0"
})(_templateObject());
var IconButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "IconButton",
    componentId: "sc-0-1"
})(_templateObject1());
var SearchInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-2"
})(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.colors.base300;
}, function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue700;
});

;// CONCATENATED MODULE: ./src/areas/campaign/components/search/index.js
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}








var Search = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(Search, _PureComponent);
    var _super = _createSuper(Search);
    function Search() {
        _classCallCheck(this, Search);
        return _super.apply(this, arguments);
    }
    _createClass(Search, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var t = this.context.t;
                // Clear the search input if no query is given
                if (!this.props.query && this.searchInput) {
                    this.searchInput.value = "";
                }
                return /*#__PURE__*/ react.createElement(variants/* Row */.X2, {
                    style: {
                        position: "relative"
                    }
                }, /*#__PURE__*/ react.createElement(SearchInput, {
                    onBlur: function(e) {
                        if (e.currentTarget.value) {
                            _this.props.campaignSearchDone();
                        }
                    },
                    defaultValue: this.props.query,
                    placeholder: t("campaigns", "search.placeholder"),
                    type: "search",
                    onChange: function(e) {
                        return _this.props.onSearch({
                            id: "query",
                            value: e.currentTarget.value
                        });
                    },
                    ref: function(input) {
                        _this.searchInput = input;
                        if (_this.searchInput) {
                            _this.searchInput.value = _this.props.query || "";
                        }
                    }
                }), this.searchInput && this.searchInput.value.length || this.props.query ? /*#__PURE__*/ react.createElement(IconButton, {
                    type: "button",
                    onClick: function() {
                        _this.props.onSearch({
                            id: "query",
                            value: ""
                        });
                        _this.searchInput.value = "";
                        _this.searchInput.focus();
                    }
                }, /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, {
                    size: 12
                })) : /*#__PURE__*/ react.createElement(IconButton, {
                    type: "button",
                    onClick: function() {
                        _this.searchInput.focus();
                    }
                }, /*#__PURE__*/ react.createElement(SearchIcon, {
                    size: 20
                })));
            }
        }
    ]);
    return Search;
}(react.PureComponent);
var func = (prop_types_default()).func, string = (prop_types_default()).string;
Search.propTypes = {
    query: string,
    onSearch: func,
    campaignSearchDone: func.isRequired
};
Search.defaultProps = {
    query: undefined
};
Search.contextType = app_context/* AppContext */.Il;
/* harmony default export */ const search = ((0,es/* connect */.$j)(null, actions/* default */.ZP)(Search));


/***/ }),

/***/ 83151:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var FIELDS = [
    "product.category.path.name",
    "product.category.name",
    "product.brand.name",
    "store.name"
];
var FILTER_TERM_MAP = {
    category: "product.category.path.id",
    brand: "product.brand.name.keyword",
    store: "store.name.keyword"
};
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
    var query = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", filter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _instance, _instance1;
    var terms = query ? query.trim().split(/\s/) : []; // Split up terms for a broader match
    return {
        bool: {
            minimum_should_match: terms.length,
            should: (_instance1 = (_instance = []).concat.apply(_instance, _toConsumableArray(terms.map(function(term) {
                return FIELDS.map(function(field) {
                    return {
                        match_phrase_prefix: _defineProperty({}, field, {
                            query: term
                        })
                    };
                });
            })))).concat.apply(_instance1, _toConsumableArray(terms.map(function(term) {
                return FIELDS.map(function(field) {
                    return {
                        match_phrase: _defineProperty({}, field, {
                            query: term,
                            boost: 3
                        })
                    };
                });
            }))).concat(terms.map(function(term) {
                return {
                    match_phrase_prefix: {
                        "product.name": {
                            slop: 10,
                            query: term,
                            boost: 2
                        }
                    }
                };
            })).concat(terms.map(function(term) {
                return {
                    match_phrase: {
                        "product.name": {
                            query: term,
                            boost: 3
                        }
                    }
                };
            })),
            must: Object.keys(filter).filter(function(term) {
                return filter[term].length > 0;
            }).map(function(term) {
                return {
                    bool: {
                        should: [].concat(filter[term].map(function(value) {
                            return {
                                term: _defineProperty({}, FILTER_TERM_MAP[term], value)
                            };
                        }))
                    }
                };
            })
        }
    };
};


/***/ }),

/***/ 72862:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Od": () => (/* binding */ trackSortOrderChange),
/* harmony export */   "ms": () => (/* binding */ trackCampaignItemClick),
/* harmony export */   "sJ": () => (/* binding */ trackCampaignLinkClick)
/* harmony export */ });
/* harmony import */ var _client_data_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81384);

/**
 * Tracks a change in the campaign sort order.
 */ var trackSortOrderChange = function(order) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("campaignSortOrderChange", {
        order: order
    });
};
/**
 * Tracks a click on any link to a campaign.
 */ var trackCampaignLinkClick = function(campaignId, linkType) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("campaignLinkClick", {
        campaignId: campaignId,
        linkType: linkType
    });
};
/**
 * Tracks a click on a campaign item (that is, a product in the campaign).
 * The structure matches the Redux action CAMPAIGN_ITEM_CLICK.
 */ var trackCampaignItemClick = function(item) {
    (0,_client_data_layer__WEBPACK_IMPORTED_MODULE_0__/* .pushEvent */ .A)("campaignItemClick", {
        item: item
    });
};


/***/ }),

/***/ 64217:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ campaign_banner)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex-direction: row;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  border-radius: 10px;\n  padding: ",
        ";\n  background-position: center center;\n  background-size: cover;\n  color: white;\n  text-align: center;\n\n  flex-direction: column;\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n    padding-right: calc(",
        " * 2);\n    border-right: 1px solid white;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  flex: 0 0 auto;\n\n  padding: ",
        ";\n  padding-bottom: 0;\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    max-width: 300px;\n    min-width: 200px;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 200px;\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: calc(",
        " * 2);\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  max-width: 600px;\n  margin: 0 auto;\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  border: 1px solid currentColor;\n  border-radius: ",
        ";\n  display: inline-block;\n  font-weight: 600;\n  outline: none;\n  padding: 10px 20px;\n  transition: box-shadow 0.1s linear;\n\n  :hover,\n  :focus {\n    color: ",
        ";\n  }\n\n  :focus {\n    box-shadow: 0 0 0 2px currentColor;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var basePadding = "20px";
var Banner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Banner",
    componentId: "sc-0-0"
})(_templateObject1(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject()));
var BadgeSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BadgeSection",
    componentId: "sc-0-1"
})(_templateObject3(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject2(), basePadding, basePadding));
var BadgeImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "BadgeImage",
    componentId: "sc-0-2"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject4()));
var MainSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "MainSection",
    componentId: "sc-0-3"
})(_templateObject7(), basePadding, base/* media.mediumUp */.BC.mediumUp(_templateObject6(), basePadding));
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Description",
    componentId: "sc-0-4"
})(_templateObject8(), basePadding);
var Button = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "Button",
    componentId: "sc-0-5"
})(_templateObject9(), function(p) {
    return p.theme.colors.base0;
}, base/* layout.borderRadius */.bK.borderRadius, function(p) {
    return p.theme.colors.base200;
});

;// CONCATENATED MODULE: ./src/areas/landing-page/components/campaign-banner/campaign-banner.js




var CampaignBanner = function(param) {
    var url = param.url, imageUrl = param.imageUrl, badgeUrl = param.badgeUrl, badgeAltText = param.badgeAltText, description = param.description, linkText = param.linkText;
    return /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(Banner, {
        style: {
            backgroundImage: "url(".concat(imageUrl, ")")
        }
    }, badgeUrl && /*#__PURE__*/ react.createElement(BadgeSection, null, /*#__PURE__*/ react.createElement(BadgeImage, {
        src: badgeUrl,
        alt: badgeAltText
    })), /*#__PURE__*/ react.createElement(MainSection, null, /*#__PURE__*/ react.createElement(Description, null, description), /*#__PURE__*/ react.createElement(Button, {
        to: url
    }, linkText))));
};
var string = (prop_types_default()).string;
CampaignBanner.propTypes = {
    url: string,
    imageUrl: string,
    badgeUrl: string,
    badgeAltText: string,
    description: string,
    linkText: string
};
CampaignBanner.defaultProps = {
    url: undefined,
    imageUrl: undefined,
    badgeUrl: undefined,
    badgeAltText: undefined,
    description: undefined,
    linkText: undefined
};
/* harmony default export */ const campaign_banner = (CampaignBanner);


/***/ }),

/***/ 96833:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": () => (/* binding */ storeLinkClick)
/* harmony export */ });
var storeLinkClick = function(store) {
    return {
        type: "STORE_LINK_CLICK",
        store: store
    };
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    storeLinkClick: storeLinkClick
});


/***/ }),

/***/ 23672:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": () => (/* binding */ FlipClock)
/* harmony export */ });
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13923);

var FlipClock = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "flip-clock";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | flip-clock */ 831).then(__webpack_require__.bind(__webpack_require__, 53124));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(53124);
        }
        return eval("require.resolve")("./flip-clock");
    }
});


/***/ }),

/***/ 80939:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": () => (/* binding */ ProductCard)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40507);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_components_product_of_the_year_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97901);
/* harmony import */ var src_components_badges_image_badges__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33627);
/* harmony import */ var src_components_offer_price_price_label__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14596);
/* harmony import */ var src_components_store_logo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90243);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77344);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}







var ProductCard = function(param) {
    var id = param.id, onClick = param.onClick, category = param.category, linkAttributes = param.linkAttributes, link = param.link, campaignBadge = param.campaignBadge, image = param.image, brandLogo = param.brandLogo, productCoreProps = param.productCoreProps, rating = param.rating, ratingCount = param.ratingCount, ratingCountTranslation = param.ratingCountTranslation, name = param.name, highlightedName = param.highlightedName, subtitle = param.subtitle, price = param.price, diffPercentage = param.diffPercentage, isCampaignItem = param.isCampaignItem, hasDivider = param.hasDivider, store = param.store, className = param.className, children = param.children, footer = param.footer, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect, externalLink = param.externalLink, onCategoryLinkClick = param.onCategoryLinkClick;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle();
            return;
        }
        if (externalLink) {
            e.preventDefault();
            window.location.href = e.currentTarget.href;
        }
        onClick(e);
    }, [
        selectable,
        onToggle,
        externalLink,
        onClick
    ]);
    var productProperties = productCoreProps ? productCoreProps.map(function(p, i, arr) {
        if (p.pretty === null) return "";
        if (arr.length - 1 === i) {
            return p.pretty;
        }
        return "".concat(p.pretty, ", ");
    }) : null;
    var productOfTheYearAward = (0,src_components_product_of_the_year_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useIsProductOfTheYear */ .q)(id || undefined);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Card */ .Zb, {
        className: className,
        hasDivider: hasDivider
    }, productOfTheYearAward && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_badges_image_badges__WEBPACK_IMPORTED_MODULE_3__/* .GridCardImageBadge */ .ni, {
        badgeUrl: productOfTheYearAward.awardLogo,
        title: "".concat(productOfTheYearAward.awardName, " ").concat(productOfTheYearAward.year)
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ProductLink */ .oe, _extends({
        onClick: clickHandler
    }, linkAttributes, {
        to: link,
        "aria-label": name,
        selected: selected
    }), diffPercentage && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .DiffPercentage */ .rE, null, "-", Math.round(diffPercentage), "%"), campaignBadge && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .CampaignBadge */ .xV, null, campaignBadge), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ProductImage */ .qN, null, image, brandLogo && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .BrandLogo */ .Oc, null, brandLogo)), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ProductDetails */ .f4, {
        stretch: isCampaignItem
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ProductName */ .rZ, null, highlightedName || name), subtitle && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Subtitle */ .QE, null, subtitle), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Subtitle */ .QE, null, productProperties), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Rating */ .iG, {
        hide: rating === null || rating === undefined,
        rate: rating,
        centerAlign: true,
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true,
        size: "small"
    })), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .PriceInfo */ .a8, null, price && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_offer_price_price_label__WEBPACK_IMPORTED_MODULE_4__/* .PriceLabel */ .l, {
        value: price
    })), store && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_store_logo__WEBPACK_IMPORTED_MODULE_5__/* .StoreLogo */ .Xv, {
        variant: src_components_store_logo__WEBPACK_IMPORTED_MODULE_5__/* .StoreLogoVariant.CAMPAIGN */ .mA.CAMPAIGN,
        name: store.name,
        storeId: store.id,
        featured: true,
        hasImage: store.hasLogo
    })), children && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .ExtraFooter */ .Qq, null, children)), category && category.pathName && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .CategoryArea */ .p2, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .CategoryLink */ .Ij, {
        size: "small",
        color: "secondary",
        variant: "outlined",
        href: category.pathName,
        truncate: true,
        onClick: function() {
            if (onCategoryLinkClick) {
                onCategoryLinkClick({
                    url: category.pathName
                });
            }
        }
    }, category.name)), footer && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Footer */ .$_, null, footer), selectable && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_6__/* .Checkbox */ .XZ, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
var func = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().func), string = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string), number = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().number), oneOfType = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType), arrayOf = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().arrayOf), element = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().element), node = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().node), shape = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().shape), bool = (prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool);
ProductCard.propTypes = {
    onClick: func,
    link: string.isRequired,
    image: node,
    name: oneOfType([
        string.isRequired,
        node.isRequired
    ]),
    highlightedName: node,
    rating: number,
    ratingCount: number,
    ratingCountTranslation: shape({
        domain: string,
        key: string
    }),
    price: oneOfType([
        string,
        number,
        element
    ]),
    diffPercentage: number,
    isCampaignItem: bool,
    children: node,
    campaignBadge: element,
    subtitle: node,
    brandLogo: node,
    productCoreProps: arrayOf(shape({
        id: string,
        isCore: bool,
        name: string,
        pretty: string,
        prettyTable: string,
        type: string,
        unit: string,
        value: string
    })),
    linkAttributes: shape({
        target: string,
        rel: string
    }),
    category: shape({
        name: string.isRequired,
        pathName: string
    }),
    store: shape({
        name: string.isRequired,
        id: number.isRequired,
        hasLogo: bool.isRequired
    }),
    hasDivider: bool,
    className: string,
    footer: node,
    selectable: bool,
    selected: bool,
    onSelect: func,
    onDeselect: func,
    externalLink: bool,
    onCategoryLinkClick: func
};
var noop = function() {};
ProductCard.defaultProps = {
    onClick: noop,
    image: undefined,
    highlightedName: undefined,
    rating: undefined,
    ratingCount: undefined,
    ratingCountTranslation: {
        domain: "product",
        key: "product-card.n-ratings"
    },
    price: undefined,
    diffPercentage: undefined,
    isCampaignItem: false,
    children: undefined,
    campaignBadge: undefined,
    subtitle: undefined,
    brandLogo: undefined,
    productCoreProps: undefined,
    linkAttributes: undefined,
    category: undefined,
    store: undefined,
    hasDivider: false,
    className: undefined,
    footer: undefined,
    selectable: false,
    selected: false,
    onSelect: noop,
    onDeselect: noop,
    externalLink: false,
    onCategoryLinkClick: noop
};


/***/ }),

/***/ 431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ search)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(66292);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/search/container.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}



var DEFAULT_QUERY_OPTIONS = {
    groups: [
        {
            limit: 10,
            name: "categories",
            modes: [
                {
                    name: "brand_category",
                    params: {
                        fq: "row_type:category OR row_type:virtual_category OR row_type:brand_virtual_category"
                    }
                }
            ]
        },
        {
            limit: 15,
            name: "products",
            modes: [
                "product",
                "raw_sorted",
                "raw"
            ]
        },
        {
            limit: 10,
            name: "brands",
            modes: [
                "brand"
            ]
        },
        {
            limit: 10,
            name: "stores",
            modes: [
                "store"
            ]
        }
    ]
};
var SearchContainer = function(param) {
    var query = param.query, _queryOptions = param.queryOptions, queryOptions = _queryOptions === void 0 ? DEFAULT_QUERY_OPTIONS : _queryOptions, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, render = param.render, renderLoader = param.renderLoader;
    var ref = _slicedToArray((0,react.useState)([]), 2), results = ref[0], setResults = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(false), 2), error = ref1[0], setError = ref1[1];
    var market = (0,app_context/* useAppContext */.bp)().market;
    var selectionId = (0,react.useRef)(0);
    var retrySearch = (0,react.useRef)(-1);
    var mounted = (0,react.useRef)(false);
    var search = (0,react.useCallback)(debounce_default()(function() {
        setError(false);
        if (!market || !market.superSearchEndpoint || !market.code) {
            // eslint-disable-next-line no-console
            console.error("No superSearchEndpoint is configured in <MarketContext>");
            return;
        }
        var url = market.superSearchEndpoint;
        var body = {
            market: market.code,
            query: query,
            groups: queryOptions.groups
        };
        fetch(url, {
            method: "POST",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        }).then(function(resp) {
            if (resp.status >= 400 && resp.status < 600) {
                throw new Error(resp.message);
            }
            return resp.json();
        }).then(function(json) {
            if (json.error) {
                throw new Error("Error in search container");
            }
            var groups = json.results.map(function(group) {
                return Object.assign(group, {
                    hits: group.hits.map(function(item) {
                        selectionId.current += 1;
                        return _objectSpreadProps(_objectSpread({}, item), {
                            selectionId: "sc".concat(selectionId.current)
                        });
                    }),
                    offset: 0
                });
            });
            clearTimeout(retrySearch.current);
            if (mounted.current) {
                setResults(function(prev) {
                    return body.query === query ? groups : prev;
                });
            }
            if (!disableScrollToTop) {
                // Reset scroll position for small devices
                if ( true && window.innerWidth <= 620) {
                    window.scrollTo(0, 0);
                }
            }
        }).catch(function(e) {
            // eslint-disable-next-line no-console
            console.error(e);
            clearTimeout(retrySearch.current);
            setError(true);
            if (mounted.current) {
                // If error occurs, retry search after 1000s
                retrySearch.current = setTimeout(function() {
                    search();
                }, 1000);
            }
        });
    }, 300), [
        query,
        queryOptions,
        disableScrollToTop,
        market
    ]);
    (0,react.useEffect)(function() {
        search();
        return function() {
            search.cancel();
        };
    }, [
        search
    ]);
    (0,react.useEffect)(function() {
        onSearchResultFound === null || onSearchResultFound === void 0 ? void 0 : onSearchResultFound(results);
    }, [
        results,
        onSearchResultFound
    ]);
    (0,react.useEffect)(function() {
        mounted.current = true;
    }, []);
    if (!results.length) {
        var ref2;
        return (ref2 = renderLoader === null || renderLoader === void 0 ? void 0 : renderLoader()) !== null && ref2 !== void 0 ? ref2 : null;
    }
    if (error) {
        return null;
    }
    return render(results);
};
/* harmony default export */ const container = (SearchContainer);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.1.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(86177);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/search/components/selectable/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      border-radius: 5px;\n\n      > a {\n        background: none;\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var SearchSelectable = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchSelectable",
    componentId: "sc-0-0"
})(_templateObject1(), function(p) {
    return p.selected && (0,styled_components_browser_esm.css)(_templateObject(), base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, 0.2));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/search/components/selectable/selectable.js



var Selectable = function(props) {
    var isSelected = String(props.selected) === String(props.id);
    return /*#__PURE__*/ react.createElement(SearchSelectable, {
        selected: isSelected,
        role: "option",
        "aria-selected": isSelected,
        "data-selected": isSelected,
        "data-query": props.query,
        "data-selection-id": props.id,
        id: "selection".concat(props.id)
    }, props.children);
};
Selectable.propTypes = {
    selected: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    id: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]).isRequired,
    query: (prop_types_default()).string,
    children: (prop_types_default()).node.isRequired
};
Selectable.defaultProps = {
    selected: undefined,
    query: undefined
};
/* harmony default export */ const selectable = (Selectable);

// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/components/search/components/show-all/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n        margin-bottom: 30px;\n      "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n      margin-bottom: 20px;\n      ",
        "\n    "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  min-height: 40px;\n  justify-content: space-between;\n  background-color: ",
        ";\n  border-radius: 5px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ShowAllLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ShowAllLink",
    componentId: "sc-0-0"
})(_templateObject2(), function(p) {
    return p.richText && (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* media.mediumUp */.BC.mediumUp(styles_templateObject()));
}, function(p) {
    return p.theme.colors.base100;
});

;// CONCATENATED MODULE: ./src/components/search/components/show-all/show-all.js







var getQueryString = function(history) {
    return querystring.decode(history.location.search.substr(1));
};
var getLink = function(query, history) {
    var qs = getQueryString(history);
    qs.q = query;
    delete qs.search;
    var qsEncoded = querystring.encode(qs);
    return "/search?".concat(qsEncoded);
};
var ShowAll = function(param) {
    var onClick = param.onClick, styling = param.styling, query = param.query, history = param.history;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(ShowAllLink, {
        onClick: onClick,
        richText: styling === "rich",
        to: getLink(query, history)
    }, /*#__PURE__*/ react.createElement("span", null, t("search", "results.show-all-button")), /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, null));
};
var string = (prop_types_default()).string, func = (prop_types_default()).func, object = (prop_types_default()).object;
ShowAll.propTypes = {
    query: string.isRequired,
    styling: string.isRequired,
    history: object.isRequired,
    onClick: func
};
ShowAll.defaultProps = {
    onClick: function() {}
};
/* harmony default export */ const show_all = (/*#__PURE__*/(0,react.memo)((0,react_router/* withRouter */.EN)(ShowAll)));

// EXTERNAL MODULE: ./src/components/product-card/index.js
var product_card = __webpack_require__(80939);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(69919);
// EXTERNAL MODULE: ./src/components/list-item/index.tsx
var list_item = __webpack_require__(94957);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(23354);
// EXTERNAL MODULE: ./src/components/store-logo/index.tsx
var store_logo = __webpack_require__(90243);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/outgoing-link/index.js
var outgoing_link = __webpack_require__(75708);
;// CONCATENATED MODULE: ./src/components/search/components/item/styles.ts
function item_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function item_styles_templateObject() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  height: 24px;\n  img {\n    height: 16px;\n    width: auto;\n  }\n"
    ]);
    item_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function item_styles_templateObject1() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  color: ",
        ";\n\n  .pj-ui-product-list-item--grid:hover &,\n  .pj-ui-product-row:hover & {\n    color: ",
        ";\n  }\n"
    ]);
    item_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = item_styles_taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  vertical-align: -2px;\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledListItem = (0,styled_components_browser_esm["default"])(list_item/* ListItem */.H).withConfig({
    displayName: "StyledListItem",
    componentId: "sc-0-0"
})({
    "&&": {
        img: {
            marginRight: "10px"
        }
    }
});
var StoreLogo = (0,styled_components_browser_esm["default"])(store_logo/* StoreLogo */.Xv).withConfig({
    displayName: "StoreLogo",
    componentId: "sc-0-1"
})(item_styles_templateObject());
var OutlinkCallToAction = styled_components_browser_esm["default"].span.withConfig({
    displayName: "OutlinkCallToAction",
    componentId: "sc-0-2"
})(item_styles_templateObject1(), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.theme.colors.maybeBlue500;
});
var OutlinkIcon = (0,styled_components_browser_esm["default"])(outgoing_link/* IconOutgoingLink */.v).withConfig({
    displayName: "OutlinkIcon",
    componentId: "sc-0-3"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/components/search/components/item/item.js








var SearchItem = function(param) {
    var item = param.item, onClick = param.onClick, onRawClick = param.onRawClick, type = param.type, mode = param.mode, query = param.query, onSelect = param.onSelect, styling = param.styling, callToActionText = param.callToActionText, showStoreLogo = param.showStoreLogo;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), t = ref.t, linkTo = ref.linkTo;
    var qs = {
        q: query
    };
    var externalLinkAttributes = {
        target: "_blank",
        rel: "nofollow"
    };
    var onClickHandler = function(e) {
        if (onSelect) {
            e.preventDefault();
            onSelect(item);
        }
        onClick(type, item, e);
        if (onRawClick && type === "raw") {
            onRawClick(item);
        }
    };
    var link = linkTo(type, item, qs);
    switch(type){
        case "product":
        case "raw_sorted":
            {
                if (styling === "simple") {
                    return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                        name: item.name,
                        link: link,
                        onClick: onClickHandler
                    });
                }
                return mode === "row" ? /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                    onClick: onClickHandler,
                    name: item.name,
                    link: link,
                    price: item.priceRaw ? item.priceRaw : null,
                    subtitle: item.category && item.category.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    ratingCount: item.ratingCount,
                    storesCount: item.priceCount,
                    storesCountText: t("campaigns", "item.sold-by-n-stores", {
                        n: item.priceCount
                    }),
                    showDivider: true
                }) : /*#__PURE__*/ react.createElement(product_card/* ProductCard */.I, {
                    id: item.id,
                    onClick: onClickHandler,
                    name: item.name,
                    link: link,
                    price: item.price ? item.price : null,
                    subtitle: item.category && item.category.name,
                    image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                        name: item.name,
                        src: item.image
                    }),
                    rating: item.rating,
                    ratingCount: item.ratingCount
                });
            }
        case "raw":
            if (styling === "simple") {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    linkAttributes: externalLinkAttributes
                });
            }
            return mode === "row" ? /*#__PURE__*/ react.createElement(product_row/* default */.Z, {
                onClick: onClickHandler,
                name: item.name,
                price: item.price ? item.price : null,
                link: link,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name
                }),
                subtitle: /*#__PURE__*/ react.createElement(Outlink, {
                    store: item.store
                }),
                linkAttributes: externalLinkAttributes,
                showDivider: true
            }) : /*#__PURE__*/ react.createElement(product_card/* ProductCard */.I, {
                onClick: onClickHandler,
                name: item.name,
                price: item.price ? item.price : null,
                link: link,
                image: /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                    name: item.name
                }),
                subtitle: /*#__PURE__*/ react.createElement(Outlink, {
                    store: item.store
                }),
                linkAttributes: externalLinkAttributes
            });
        case "brand":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    showArrow: true
                });
            }
        case "store":
            {
                return /*#__PURE__*/ react.createElement(list_item/* ListItem */.H, {
                    name: item.name,
                    link: link,
                    onClick: onClickHandler,
                    image: showStoreLogo && item.logo && /*#__PURE__*/ react.createElement(StoreLogo, {
                        storeId: item.id,
                        name: item.name,
                        hasImage: true,
                        featured: true
                    }),
                    showArrow: true
                });
            }
        case "brand_category":
        case "brand_virtual_category":
        case "virtual_category":
        case "category":
            {
                return /*#__PURE__*/ react.createElement(StyledListItem, {
                    name: item.name,
                    link: link,
                    image: styling !== "simple" && item.logo ? /*#__PURE__*/ react.createElement("img", {
                        height: "28",
                        width: "28",
                        src: item.logo,
                        alt: ""
                    }) : null,
                    callToActionText: callToActionText,
                    showArrow: true,
                    onClick: onClickHandler
                });
            }
        default:
            return null;
    }
};
var item_object = (prop_types_default()).object, item_func = (prop_types_default()).func, oneOf = (prop_types_default()).oneOf, item_string = (prop_types_default()).string;
SearchItem.propTypes = {
    item: item_object.isRequired,
    type: oneOf([
        "product",
        "raw",
        "raw_sorted",
        "category",
        "brand_category",
        "virtual_category",
        "brand_virtual_category",
        "store",
        "brand"
    ]).isRequired,
    styling: oneOf([
        "simple",
        "rich"
    ]),
    mode: oneOf([
        "row",
        "grid"
    ]),
    onRawClick: item_func,
    onClick: item_func,
    onSelect: item_func,
    query: item_string.isRequired,
    callToActionText: item_string
};
SearchItem.defaultProps = {
    mode: "row",
    styling: "rich",
    onRawClick: function() {},
    onClick: function() {},
    onSelect: undefined,
    callToActionText: undefined
};
var Outlink = function(param) {
    var store = param.store;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement("span", null, store, " - ", /*#__PURE__*/ react.createElement(OutlinkCallToAction, null, t("search", "raw-search.go-to-shop"), /*#__PURE__*/ react.createElement(OutlinkIcon, {
        size: 14
    })));
};
Outlink.contextType = app_context/* AppContext */.Il;
Outlink.propTypes = {
    store: item_string.isRequired
};
/* harmony default export */ const item = (/*#__PURE__*/(0,react.memo)(SearchItem));

;// CONCATENATED MODULE: ./src/components/search/styles.ts
function search_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function search_styles_templateObject() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: ",
        " 10px;\n"
    ]);
    search_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function search_styles_templateObject1() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: 10px;\n"
    ]);
    search_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function search_styles_templateObject2() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    search_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n  background: white;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = search_styles_taggedTemplateLiteral([
        "\n  padding-top: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}



var NoResults = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResults",
    componentId: "sc-0-0"
})(search_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShowAllSelectable = (0,styled_components_browser_esm["default"])(selectable).withConfig({
    displayName: "ShowAllSelectable",
    componentId: "sc-0-1"
})(search_styles_templateObject1());
var ProductListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductListBox",
    componentId: "sc-0-2"
})(search_styles_templateObject2(), function(p) {
    return p.simple ? "0" : "10px";
});
var CategoryListBox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CategoryListBox",
    componentId: "sc-0-3"
})(_templateObject3(), function(p) {
    return p.simple ? "0" : "10px";
});
var NoResultContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NoResultContainer",
    componentId: "sc-0-4"
})(_templateObject4(), (0,base/* remCalc */.vR)(15));

;// CONCATENATED MODULE: ./src/components/search/render.js
function render_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return render_arrayLikeToArray(arr);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || render_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function render_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return render_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return render_arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}









var triggerSelection = function() {
    var a = document.querySelector('*[data-selected="true"] a');
    a.click();
};
var SearchPage = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    _inherits(SearchPage, _PureComponent);
    var _super = _createSuper(SearchPage);
    function SearchPage(props) {
        _classCallCheck(this, SearchPage);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            selected: undefined
        };
        _this.spy = _this.spy.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(SearchPage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                window.addEventListener("keydown", this.spy);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("keydown", this.spy);
            }
        },
        {
            key: "handleEnter",
            value: function handleEnter() {
                var push = this.props.history.push;
                var activeElement = document.activeElement;
                var selected = document.querySelector('*[data-selected="true"]');
                if (selected) {
                    triggerSelection();
                } else if (activeElement && activeElement.tagName === "INPUT") {
                    var query = activeElement.value.trim();
                    if (query.length === 0) {
                        return;
                    }
                    push("/search?q=".concat(encodeURIComponent(query)));
                }
            }
        },
        {
            key: "handleSideMove",
            value: function handleSideMove() {
                var activeElement = document.activeElement;
                var push = this.props.history.push;
                if (activeElement.tagName !== "INPUT") {
                    return;
                }
                var query = this.props.query;
                var value = activeElement.value;
                if (query !== value) {
                    push("/search?q=".concat(encodeURIComponent(value)));
                }
            }
        },
        {
            key: "changeSearchInput",
            value: function changeSearchInput(selected) {
                var activeElement = document.activeElement;
                if (activeElement.tagName !== "INPUT") {
                    return;
                }
                var currentValue = this.props.query;
                if (!selected || !selected.query) {
                    activeElement.value = currentValue;
                } else {
                    var newValue = "".concat(selected.query, " ");
                    activeElement.value = newValue;
                    activeElement.setSelectionRange(currentValue.length, newValue.length);
                }
            }
        },
        {
            key: "handleKeyMove",
            value: function handleKeyMove(direction, e) {
                e.preventDefault();
                var selectable = _toConsumableArray(document.querySelectorAll("*[data-selected]")).map(function(n) {
                    return {
                        id: n.dataset.selectionId,
                        query: n.dataset.query,
                        selected: n.dataset.selected === "true"
                    };
                });
                if (selectable.length === 0) {
                    return;
                }
                var selected = selectable.findIndex(function(n) {
                    return n.selected;
                });
                var newIndex;
                if (direction === "down") {
                    newIndex = selected + 1 === selectable.length ? -1 : selected + 1;
                }
                if (direction === "up") {
                    newIndex = selected >= 0 ? selected - 1 : selectable.length - 1;
                }
                if (newIndex === -1) {
                    this.setState({
                        selected: false
                    });
                } else {
                    this.setState({
                        selected: selectable[newIndex].id
                    });
                }
                this.changeSearchInput(selectable[newIndex]);
            }
        },
        {
            key: "spy",
            value: function spy(e) {
                if (!this.props.keyboardNavigation) {
                    return;
                }
                switch(e.keyCode){
                    case 40:
                        {
                            this.handleKeyMove("down", e);
                            break;
                        }
                    case 38:
                        {
                            this.handleKeyMove("up", e);
                            break;
                        }
                    case 13:
                        {
                            this.handleEnter();
                            break;
                        }
                    case 37:
                        {
                            this.handleSideMove("left");
                            break;
                        }
                    case 39:
                        {
                            this.handleSideMove("right");
                            break;
                        }
                    default:
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, query = _props.query, onEnterSearchMenu = _props.onEnterSearchMenu, onExitSearchMenu = _props.onExitSearchMenu, onRawClick = _props.onRawClick, onItemClick = _props.onItemClick, onSelect = _props.onSelect, results = _props.results, showAllResults = _props.showAllResults, styling = _props.styling, showStoreLogo = _props.showStoreLogo;
                var t = this.context.t;
                var selected = this.state.selected;
                return /*#__PURE__*/ react.createElement("div", {
                    className: "pj-ui-search" // Shop search has dependency on this className
                    ,
                    onMouseEnter: onEnterSearchMenu,
                    onMouseLeave: onExitSearchMenu,
                    onTouchStart: onEnterSearchMenu,
                    onTouchEnd: onExitSearchMenu
                }, /*#__PURE__*/ react.createElement("div", null, styling === "rich" && showAllResults && /*#__PURE__*/ react.createElement(ShowAllSelectable, {
                    id: -1,
                    selected: selected
                }, /*#__PURE__*/ react.createElement(show_all, {
                    query: query,
                    styling: styling
                })), results.map(function(group) {
                    return /*#__PURE__*/ react.createElement("div", {
                        key: group.name
                    }, group.name === "products" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, styling === "rich" && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("search", "relevant-products.title", {
                        query: query
                    })), /*#__PURE__*/ react.createElement(ProductListBox, {
                        className: "pj-ui-search--products",
                        simple: styling === "simple",
                        role: "listbox"
                    }, group.hits.map(function(product) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: product.selectionId,
                            id: product.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(item, {
                            type: product.type,
                            item: product.item,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            styling: styling,
                            query: query,
                            onSelect: onSelect
                        })));
                    }))), group.name === "categories" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, styling === "rich" && /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("search", "relevant-categories.title", {
                        query: query
                    })), /*#__PURE__*/ react.createElement(CategoryListBox, {
                        role: "listbox",
                        className: "pj-ui-search--categories",
                        simple: styling === "simple"
                    }, group.hits.map(function(category) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: category.selectionId,
                            id: category.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement(item, {
                            type: category.type,
                            item: category.item,
                            styling: styling,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            callToActionText: styling === "simple" ? t("search", "quick-search.category-call-to-action") : null,
                            mode: "row",
                            query: query,
                            onSelect: onSelect
                        }));
                    }))), group.name === "stores" && group.hits.length > 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(ProductListBox, {
                        className: "pj-ui-search--products",
                        simple: styling === "simple",
                        role: "listbox"
                    }, group.hits.map(function(store) {
                        return /*#__PURE__*/ react.createElement(selectable, {
                            key: store.selectionId,
                            id: store.selectionId,
                            selected: selected
                        }, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(item, {
                            type: store.type,
                            item: store.item,
                            onClick: onItemClick,
                            onRawClick: onRawClick,
                            styling: styling,
                            query: query,
                            onSelect: onSelect,
                            showStoreLogo: showStoreLogo
                        })));
                    }))), Boolean(!group.hits.length) && /*#__PURE__*/ react.createElement(NoResults, null, /*#__PURE__*/ react.createElement("span", null, t("search", "no-search-results.title", {
                        query: query
                    }))));
                }), styling === "simple" && showAllResults && /*#__PURE__*/ react.createElement(ShowAllSelectable, {
                    id: -1,
                    selected: selected
                }, /*#__PURE__*/ react.createElement(show_all, {
                    query: query,
                    styling: styling
                }))));
            }
        }
    ]);
    return SearchPage;
}(react.PureComponent);
SearchPage.propTypes = {
    query: (prop_types_default()).string.isRequired,
    results: (prop_types_default()).array.isRequired,
    onSelect: (prop_types_default()).func,
    onEnterSearchMenu: (prop_types_default()).func,
    onExitSearchMenu: (prop_types_default()).func,
    showAllResults: (prop_types_default()).bool,
    keyboardNavigation: (prop_types_default()).bool,
    styling: prop_types_default().oneOf([
        "simple",
        "rich"
    ]),
    onRawClick: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func,
    history: (prop_types_default()).object.isRequired
};
SearchPage.defaultProps = {
    onSelect: undefined,
    onEnterSearchMenu: function() {},
    onExitSearchMenu: function() {},
    showAllResults: false,
    keyboardNavigation: false,
    styling: "rich",
    onRawClick: function() {},
    onItemClick: function() {}
};
/* harmony default export */ const render = ((0,react_router/* withRouter */.EN)(SearchPage));
SearchPage.contextType = app_context/* AppContext */.Il;

// EXTERNAL MODULE: ./src/components/spinner/index.ts + 2 modules
var spinner = __webpack_require__(80054);
;// CONCATENATED MODULE: ./src/components/search/components/loader.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function loader_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function loader_templateObject() {
    var data = loader_taggedTemplateLiteral([
        "\n  animation: ",
        " 0.5s ease-out 1.5s 1 normal forwards;\n  opacity: 0;\n"
    ]);
    loader_templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var FadeIn = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FadeIn",
    componentId: "sc-0-0"
})(loader_templateObject(), base/* animations.fadeInKeyframes */.sF.fadeInKeyframes);
var Loader = function(props) {
    return /*#__PURE__*/ react.createElement(FadeIn, null, /*#__PURE__*/ react.createElement(spinner/* Spinner */.$, _extends({}, props)));
};
/* harmony default export */ const loader = (Loader);

;// CONCATENATED MODULE: ./src/components/search/search.js





var Search = function(param) {
    var query = param.query, options = param.options, showAllResults = param.showAllResults, keyboardNavigation = param.keyboardNavigation, onSelect = param.onSelect, styling = param.styling, onItemClick = param.onItemClick, onRawClick = param.onRawClick, onEnter = param.onEnter, onExit = param.onExit, onSearchResultFound = param.onSearchResultFound, disableScrollToTop = param.disableScrollToTop, inputMinLength = param.inputMinLength, showStoreLogo = param.showStoreLogo;
    if (query.length < inputMinLength) {
        return null;
    }
    var queryOptions = options;
    return /*#__PURE__*/ react.createElement(container, {
        query: query,
        queryOptions: queryOptions,
        disableScrollToTop: disableScrollToTop,
        onSearchResultFound: onSearchResultFound,
        renderLoader: function() {
            return /*#__PURE__*/ react.createElement(loader, {
                isActive: true
            });
        },
        render: function(results) {
            return /*#__PURE__*/ react.createElement(render, {
                showAllResults: showAllResults,
                keyboardNavigation: keyboardNavigation,
                results: results,
                query: query,
                onSelect: onSelect,
                styling: styling,
                onItemClick: onItemClick,
                onRawClick: onRawClick,
                onEnterSearchMenu: onEnter,
                onExitSearchMenu: onExit,
                showStoreLogo: showStoreLogo
            });
        }
    });
};
Search.propTypes = {
    query: (prop_types_default()).string,
    showAllResults: (prop_types_default()).bool,
    keyboardNavigation: (prop_types_default()).bool,
    options: (prop_types_default()).object,
    onSelect: (prop_types_default()).func,
    onRawClick: (prop_types_default()).func,
    onItemClick: (prop_types_default()).func,
    styling: (prop_types_default()).string,
    onEnter: (prop_types_default()).func,
    onExit: (prop_types_default()).func,
    onSearchResultFound: (prop_types_default()).func,
    disableScrollToTop: (prop_types_default()).bool,
    inputMinLength: (prop_types_default()).number,
    showStoreLogo: (prop_types_default()).bool
};
Search.defaultProps = {
    query: "",
    keyboardNavigation: true,
    showAllResults: true,
    options: {
        groups: [
            {
                limit: 3,
                name: "categories",
                modes: [
                    {
                        name: "brand_category",
                        params: {
                            fq: "row_type:category OR row_type:brand_category OR row_type:virtual_category OR row_type:brand_virtual_category"
                        }
                    }
                ]
            },
            {
                limit: 10,
                name: "products",
                modes: [
                    "product",
                    "raw_sorted",
                    "raw"
                ]
            }
        ]
    },
    onSelect: undefined,
    styling: undefined,
    onRawClick: function() {},
    onItemClick: function() {},
    onEnter: function() {},
    onExit: function() {},
    onSearchResultFound: function() {},
    disableScrollToTop: false,
    inputMinLength: 2,
    showStoreLogo: false
};
/* harmony default export */ const search = (Search);


/***/ }),

/***/ 59827:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Wf": () => (/* binding */ DAILY_DEALS_ID)
/* harmony export */ });
/* unused harmony exports BLACK_FRIDAY_ID, CHRISTMAS_SALE_ID, CYBER_MONDAY_ID, BLACK_FRIDAY_WEEKEND_ID, BACK_TO_SCHOOL_ID, JANUARY_SALE_ID */
var BLACK_FRIDAY_ID = 2;
var CHRISTMAS_SALE_ID = 3;
var DAILY_DEALS_ID = 4;
var CYBER_MONDAY_ID = 6;
var BLACK_FRIDAY_WEEKEND_ID = 7;
var BACK_TO_SCHOOL_ID = 9;
var JANUARY_SALE_ID = 12;


/***/ }),

/***/ 60445:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ campaign)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/campaign/queries/useCampaignPageQuery.ts
var useCampaignPageQuery = __webpack_require__(91854);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/types.ts
var CampaignStateEnum;
(function(CampaignStateEnum) {
    CampaignStateEnum["ENDED"] = "ENDED";
    CampaignStateEnum["ACTIVE"] = "ACTIVE";
    CampaignStateEnum["UPCOMING"] = "UPCOMING";
})(CampaignStateEnum || (CampaignStateEnum = {}));
var SortDirectionEnum;
(function(SortDirectionEnum) {
    SortDirectionEnum[SortDirectionEnum["Ascending"] = 0] = "Ascending";
    SortDirectionEnum[SortDirectionEnum["Descending"] = 1] = "Descending";
})(SortDirectionEnum || (SortDirectionEnum = {}));
var SortOptionValueEnum;
(function(SortOptionValueEnum) {
    SortOptionValueEnum["PRODUCT_POPULARITY_TOTAL"] = "popularity";
    SortOptionValueEnum["PRICE_OFFER_ASC"] = "priceLowest";
    SortOptionValueEnum["PRICE_OFFER_DESC"] = "priceHighest";
    SortOptionValueEnum["PRODUCT_USER_REVIEWS_RATING_DESC"] = "rating";
    SortOptionValueEnum["PRICE_DIFF_PERCENTAGE_DESC"] = "dealValue";
    SortOptionValueEnum["DEAL_UPDATE_TIME"] = "dealUpdateTime";
})(SortOptionValueEnum || (SortOptionValueEnum = {}));
var types_PriceRange;
(function(PriceRange) {
    PriceRange["FROM_0_TO_200"] = "FROM_0_TO_200";
    PriceRange["FROM_200_TO_1000"] = "FROM_200_TO_1000";
    PriceRange["FROM_1000_TO_ALL"] = "FROM_1000_TO_ALL";
})(types_PriceRange || (types_PriceRange = {}));
var types_PriceDropPercent;
(function(PriceDropPercent) {
    PriceDropPercent["PERCENT_50"] = "PERCENT_50";
    PriceDropPercent["PERCENT_25"] = "PERCENT_25";
    PriceDropPercent["PERCENT_10"] = "PERCENT_10";
    PriceDropPercent["PERCENT_5"] = "PERCENT_5";
})(types_PriceDropPercent || (types_PriceDropPercent = {}));

;// CONCATENATED MODULE: ./src/areas/campaign-v2/utils.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

var getFilterText = function(key, t, extras) {
    switch(key){
        case PriceRange.FROM_0_TO_200:
            return t("campaigns", "filter.up-to-value", extras);
        case PriceRange.FROM_200_TO_1000:
            return t("campaigns", "filter.from-to-value", extras);
        case PriceRange.FROM_1000_TO_ALL:
            return t("campaigns", "filter.more-than-value", extras);
        case PriceDropPercent.PERCENT_50:
            return t("campaigns", "filter.percent-or-more", {
                percent: "50%"
            });
        case PriceDropPercent.PERCENT_25:
            return t("campaigns", "filter.percent-or-more", {
                percent: "25%"
            });
        case PriceDropPercent.PERCENT_10:
            return t("campaigns", "filter.percent-or-more", {
                percent: "10%"
            });
        case PriceDropPercent.PERCENT_5:
            return t("campaigns", "filter.percent-or-more", {
                percent: "5%"
            });
        case "dealsEndingSoon":
            return t("campaigns", "filter.ending-soon");
        default:
            return "";
    }
};
var getPriceDropText = function(priceDrop) {
    switch(priceDrop){
        case types_PriceDropPercent.PERCENT_5:
            return 5;
        case types_PriceDropPercent.PERCENT_10:
            return 10;
        case types_PriceDropPercent.PERCENT_25:
            return 25;
        case types_PriceDropPercent.PERCENT_50:
            return 50;
        default:
            return null;
    }
};
var updateUrlQuery = function(campaignState) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15;
    var query = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.query) && [
        "query",
        campaignState.filters.query
    ];
    var price = ((ref1 = campaignState.filters) === null || ref1 === void 0 ? void 0 : ref1.priceRangeCustom) && [
        "price",
        "".concat((ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.from, "-").concat((ref4 = campaignState.filters) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.priceRangeCustom) === null || ref5 === void 0 ? void 0 : ref5.to)
    ];
    var priceDrop = ((ref6 = campaignState.filters) === null || ref6 === void 0 ? void 0 : ref6.priceDropPercent) && [
        "price-drop",
        getPriceDropText((ref7 = campaignState.filters) === null || ref7 === void 0 ? void 0 : ref7.priceDropPercent)
    ];
    var brands = ((ref8 = campaignState.filters) === null || ref8 === void 0 ? void 0 : ref8.brands) && ((ref9 = campaignState.filters) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.brands) === null || ref10 === void 0 ? void 0 : ref10.length) > 0 && [
        "brands",
        (ref11 = campaignState.filters) === null || ref11 === void 0 ? void 0 : ref11.brands.join(",")
    ];
    var categories = ((ref12 = campaignState.filters) === null || ref12 === void 0 ? void 0 : ref12.categories) && ((ref13 = campaignState.filters) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.categories) === null || ref14 === void 0 ? void 0 : ref14.length) > 0 && [
        "categories",
        (ref15 = campaignState.filters) === null || ref15 === void 0 ? void 0 : ref15.categories.join(",")
    ];
    var sort = campaignState.sortType && [
        "sort",
        campaignState.sortType
    ];
    var page = campaignState.page && [
        "page",
        campaignState.page
    ];
    var queryToSet = [
        query,
        price,
        priceDrop,
        brands,
        categories,
        sort,
        page
    ].filter(function(q) {
        return q;
    });
    var urlQuery = new URLSearchParams(queryToSet);
    window.history.replaceState(null, "", "?".concat(urlQuery.toString()));
};
var getFilterAndSortFromQuery = function() {
    var ref, ref1;
    var getPriceDropEnum = function(priceDropValue) {
        switch(priceDropValue){
            case "5":
                return types_PriceDropPercent.PERCENT_5;
            case "10":
                return types_PriceDropPercent.PERCENT_10;
            case "25":
                return types_PriceDropPercent.PERCENT_25;
            case "50":
                return types_PriceDropPercent.PERCENT_50;
            default:
                return types_PriceDropPercent.PERCENT_10;
        }
    };
    var getPriceRangeCustom = function(range) {
        if (!range) {
            return null;
        }
        var priceObj = range.split("-");
        return {
            from: priceObj[0] || "",
            to: priceObj[1] || ""
        };
    };
    var filterFromQuery = new URL(window.location.href).searchParams;
    var query = {
        query: filterFromQuery.get("query")
    };
    var priceDrop = {
        PriceDropPercent: getPriceDropEnum(filterFromQuery.get("price-drop"))
    };
    var priceRangeCustom = {
        priceRangeCustom: getPriceRangeCustom(filterFromQuery.get("price"))
    };
    var endingSoon = {
        dealsEndingSoon: !!filterFromQuery.get("ending-soon")
    };
    var brands = {
        brands: (ref = filterFromQuery.get("brands")) === null || ref === void 0 ? void 0 : ref.split(",")
    };
    var categories = {
        categories: (ref1 = filterFromQuery.get("categories")) === null || ref1 === void 0 ? void 0 : ref1.split(",")
    };
    var filterToSet = _objectSpread({}, query, endingSoon, priceDrop, priceRangeCustom, brands, categories);
    var sortToReturn = filterFromQuery.get("sort") || "";
    var pageToReturn = Number(filterFromQuery.get("page")) || undefined;
    var filtersToReturn = Object.fromEntries(Object.entries(filterToSet).filter(function(param) {
        var _param = _slicedToArray(param, 2), _ = _param[0], v = _param[1];
        return v;
    }));
    return {
        filters: filtersToReturn,
        sortType: sortToReturn,
        page: pageToReturn
    };
};
var getFiltersForBff = function(filters) {
    var filtersToReturn = [];
    Object.keys(filters).forEach(function(filterKey) {
        switch(filterKey){
            case "query":
                filtersToReturn.push({
                    key: "query",
                    value: filters.query || ""
                });
                break;
            case "priceRangeCustom":
                var ref, ref1;
                filtersToReturn.push({
                    key: "price",
                    value: "".concat((ref = filters.priceRangeCustom) === null || ref === void 0 ? void 0 : ref.from, "-").concat((ref1 = filters.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.to)
                });
                break;
            case "priceDropPercent":
                var ref2;
                filtersToReturn.push({
                    key: "pricedrop",
                    value: filters.priceDropPercent && ((ref2 = getPriceDropText(filters.priceDropPercent)) === null || ref2 === void 0 ? void 0 : ref2.toString()) || ""
                });
                break;
            case "brands":
                var ref3;
                filtersToReturn.push({
                    key: "brands",
                    value: ((ref3 = filters.brands) === null || ref3 === void 0 ? void 0 : ref3.join("|")) || ""
                });
                break;
            case "categories":
                var ref4;
                filtersToReturn.push({
                    key: "categories",
                    value: ((ref4 = filters.categories) === null || ref4 === void 0 ? void 0 : ref4.join("|")) || ""
                });
                break;
            default:
                break;
        }
    });
    return filtersToReturn;
};

// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(76493);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(70202);
// EXTERNAL MODULE: ./src/client/data-layer.ts
var data_layer = __webpack_require__(81384);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/tracking.ts

/**
 * Tracks a change in the campaign sort order.
 */ var trackSortOrderChange = function(order) {
    (0,data_layer/* pushEvent */.A)("campaignSortOrderChange", {
        order: order
    });
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/sort/utils.ts

var getSortOptions = function(t) {
    return [
        {
            title: t("campaigns", "sort.latest-deals"),
            value: SortOptionValueEnum.DEAL_UPDATE_TIME
        },
        {
            title: t("campaigns", "sort.product.popularity.total"),
            value: SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL
        },
        {
            title: t("campaigns", "sort.price.offer|asc"),
            value: SortOptionValueEnum.PRICE_OFFER_ASC
        },
        {
            title: t("campaigns", "sort.price.offer|desc"),
            value: SortOptionValueEnum.PRICE_OFFER_DESC
        },
        {
            title: t("campaigns", "sort.product.user_reviews.rating|desc"),
            value: SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC
        },
        {
            title: t("campaigns", "sort.price.diff_percentage|desc"),
            value: SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC
        }
    ];
}; /*
export const getSortOptions = (t: TranslateFunc) => [
  {
    title: t('campaigns', `sort.${SortOptionValueEnum.RANK_DESC}`),
    value: SortOptionValueEnum.RANK_DESC,
  },
  {
    title: t('campaigns', `sort.${SortOptionValueEnum.PRODUCT_NAME_KEYWORD}`),
    value: SortOptionValueEnum.PRODUCT_NAME_KEYWORD,
  },
  {
    title: t(
      'campaigns',
      `sort.${SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL}`
    ),
    value: SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL,
  },
  {
    title: t('campaigns', `sort.${SortOptionValueEnum.PRICE_OFFER_ASC}`),
    value: SortOptionValueEnum.PRICE_OFFER_ASC,
  },
  {
    title: t('campaigns', `sort.${SortOptionValueEnum.PRICE_OFFER_DESC}`),
    value: SortOptionValueEnum.PRICE_OFFER_DESC,
  },
  {
    title: t(
      'campaigns',
      `sort.${SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC}`
    ),
    value: SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC,
  },
  {
    title: t(
      'campaigns',
      `sort.${SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC}`
    ),
    value: SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC,
  },
];
*/ 

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(87838);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/sort/index.tsx
function sort_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function sort_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function sort_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function sort_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function sort_slicedToArray(arr, i) {
    return sort_arrayWithHoles(arr) || sort_iterableToArrayLimit(arr, i) || sort_unsupportedIterableToArray(arr, i) || sort_nonIterableRest();
}
function sort_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return sort_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return sort_arrayLikeToArray(o, minLen);
}








var DEFAULT_SORT = SortOptionValueEnum.DEAL_UPDATE_TIME;
var Sort = function() {
    var ref = sort_slicedToArray((0,react.useState)(DEFAULT_SORT), 2), currentSorting = ref[0], setCurrentSorting = ref[1];
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref1 = useCampaignContext(), setCampaignState = ref1.setCampaignState, campaignState = ref1.campaignState;
    (0,react.useEffect)(function() {
        if (campaignState.sortType && currentSorting !== campaignState.sortType) setCurrentSorting(campaignState.sortType);
    }, [
        campaignState
    ]);
    var sortOptions = getSortOptions(t);
    var handleSortChange = function(option) {
        if (option.value) {
            setCampaignState({
                sortType: option.value
            });
            trackSortOrderChange(option.value);
        }
    };
    return /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.ML, {
        defaultSelected: sortOptions.find(function(option) {
            return option.value === currentSorting;
        }),
        alignment: ui/* Direction.Right */.Nm.Right,
        options: sortOptions,
        onFilterChange: handleSortChange
    });
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/campaign-context.tsx
function campaign_context_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function campaign_context_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function campaign_context_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function campaign_context_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function campaign_context_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function campaign_context_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            campaign_context_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function campaign_context_slicedToArray(arr, i) {
    return campaign_context_arrayWithHoles(arr) || campaign_context_iterableToArrayLimit(arr, i) || campaign_context_unsupportedIterableToArray(arr, i) || campaign_context_nonIterableRest();
}
function campaign_context_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return campaign_context_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return campaign_context_arrayLikeToArray(o, minLen);
}








var initState = {
    sortType: DEFAULT_SORT,
    page: 1,
    fetching: true,
    loaded: false,
    filters: {
        priceDropPercent: types_PriceDropPercent.PERCENT_10
    }
};
var AppCtx = /*#__PURE__*/ (0,react.createContext)({
    campaignState: initState,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setCampaignState: function() {}
});
var useCampaignContext = function() {
    return (0,react.useContext)(AppCtx);
};
var CampaignStateProvider = function(param) {
    var children = param.children;
    var ref = campaign_context_slicedToArray((0,react.useState)(initState), 2), campaignState = ref[0], updateCampaignState = ref[1];
    var market = (0,app_context/* useAppContext */.bp)().market;
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var page = campaignState.page || 0;
    var ref1 = (0,useCampaignPageQuery/* useCampaignPageQuery */.K)(_objectSpreadProps(campaign_context_objectSpread({}, route === null || route === void 0 ? void 0 : route.variables), {
        filters: getFiltersForBff(campaignState.filters || {}),
        sortType: campaignState.sortType,
        page: page > 0 ? page - 1 : 0,
        getDealsProducts: Boolean(market.code !== "nz"),
        filtersV2: getFiltersForBff(campaignState.filters || {})
    })), isLoading = ref1.isLoading, isSuccess = ref1.isSuccess, data = ref1.data, fetchStatus = ref1.fetchStatus;
    (0,react.useEffect)(function() {
        var filtersToSet = getFilterAndSortFromQuery();
        var sort = filtersToSet.sortType || DEFAULT_SORT;
        setCampaignState(_objectSpreadProps(campaign_context_objectSpread({}, filtersToSet), {
            sortType: sort,
            loaded: true
        }));
    }, []);
    (0,react.useEffect)(function() {
        if (fetchStatus === "idle") {
            updateCampaignState(_objectSpreadProps(campaign_context_objectSpread({}, campaignState), {
                campaignData: data,
                fetching: false
            }));
        }
    }, [
        fetchStatus
    ]);
    var setCampaignState = function(newState) {
        var merge = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var newFilters = campaign_context_objectSpread({}, campaignState.filters, newState.filters);
        var updatedState = _objectSpreadProps(campaign_context_objectSpread({}, campaignState, newState, merge ? {
            filters: newFilters
        } : {}), {
            fetching: true
        });
        updateUrlQuery(updatedState);
        updateCampaignState(updatedState);
    };
    var contextValue = (0,react.useMemo)(function() {
        return {
            campaignState: campaignState,
            setCampaignState: setCampaignState
        };
    }, [
        campaignState
    ]);
    var renderChildren = function() {
        if (!campaignState.loaded || isLoading) {
            return /*#__PURE__*/ react.createElement(loader/* default */.Z, null);
        }
        if (!isSuccess) {
            return /*#__PURE__*/ react.createElement("div", null, "Error *sadface*");
        }
        return children;
    };
    return /*#__PURE__*/ react.createElement(AppCtx.Provider, {
        value: contextValue
    }, renderChildren());
};

// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/input/variants.js
var variants = __webpack_require__(40236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  padding: ",
        ";\n  padding-top: 0;\n  display: flex;\n  align-self: flex-start;\n  flex-direction: column;\n  width: ",
        ";\n\n  > hr {\n    border: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n    width: 100%;\n    margin: ",
        " 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  input {\n    width: 85px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  width: 120px;\n  margin: ",
        " 0;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin: ",
        " 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  height: 50px;\n  align-items: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  padding-left: ",
        ";\n  padding-top: ",
        ";\n  margin-top: ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  max-height: 450px;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}





var FILTERS_WIDTH = "260px";
var FiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "FiltersWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), design_tokens.measurements.spacing100, design_tokens.measurements.spacing050, FILTERS_WIDTH, design_tokens.measurements.spacing100, base/* media.mediumDown */.BC.mediumDown(_templateObject()));
var PriceRangeForm = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceRangeForm",
    componentId: "sc-0-1"
})(_templateObject2());
var PriceRangeInput = (0,styled_components_browser_esm["default"])(variants/* Input */.II).withConfig({
    displayName: "PriceRangeInput",
    componentId: "sc-0-2"
})(_templateObject3(), design_tokens.measurements.spacing050);
var FilterInput = (0,styled_components_browser_esm["default"])(variants/* Input */.II).withConfig({
    displayName: "FilterInput",
    componentId: "sc-0-3"
})(_templateObject4(), design_tokens.measurements.spacing050);
var Divider = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Divider",
    componentId: "sc-0-4"
})(_templateObject5(), design_tokens.measurements.spacing050);
var RangeWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RangeWrapper",
    componentId: "sc-0-5"
})(_templateObject6());
var LetterStyle = (0,styled_components_browser_esm["default"])(text_variants/* TitleSmallText */.QV).withConfig({
    displayName: "LetterStyle",
    componentId: "sc-0-6"
})(_templateObject7(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, design_tokens.measurements.spacing050);
var ScrollableList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ScrollableList",
    componentId: "sc-0-7"
})(_templateObject8());
var CheckBoxList = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CheckBoxList",
    componentId: "sc-0-8"
})(_templateObject9());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var button_variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(99572);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(58676);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/dropdown-up/index.js
var dropdown_up = __webpack_require__(50036);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/dropdown-down/index.js
var dropdown_down = __webpack_require__(10423);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/filters/checkbox-list-filter.tsx
function checkbox_list_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function checkbox_list_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return checkbox_list_filter_arrayLikeToArray(arr);
}
function checkbox_list_filter_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function checkbox_list_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function checkbox_list_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function checkbox_list_filter_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            checkbox_list_filter_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function checkbox_list_filter_slicedToArray(arr, i) {
    return checkbox_list_filter_arrayWithHoles(arr) || checkbox_list_filter_iterableToArrayLimit(arr, i) || checkbox_list_filter_unsupportedIterableToArray(arr, i) || checkbox_list_filter_nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || checkbox_list_filter_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function checkbox_list_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return checkbox_list_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return checkbox_list_filter_arrayLikeToArray(o, minLen);
}










var CheckBoxListFilter = function(param) {
    var title = param.title, list = param.list, listName = param.listName, _amountOfTopFilters = param.amountOfTopFilters, amountOfTopFilters = _amountOfTopFilters === void 0 ? 10 : _amountOfTopFilters;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = checkbox_list_filter_slicedToArray((0,react.useState)(""), 2), searchString = ref[0], setSearchString = ref[1];
    var ref1 = checkbox_list_filter_slicedToArray((0,react.useState)(false), 2), showAll = ref1[0], setShowAll = ref1[1];
    var ref2 = useCampaignContext(), campaignState = ref2.campaignState, setCampaignState = ref2.setCampaignState;
    var currentList = campaignState.filters && campaignState.filters[listName] || [];
    var getCheckbox = function(item) {
        /*#__PURE__*/ return react.createElement(checkbox_variants/* Checkbox */.XZ, {
            key: "".concat(item.key, "_item"),
            onChange: function() {
                if (currentList.includes(item.key)) {
                    currentList.splice(currentList.indexOf(item.key), 1);
                } else {
                    currentList.push(item.key);
                }
                var filterToSet = checkbox_list_filter_objectSpread({}, campaignState.filters);
                filterToSet[listName] = currentList;
                setCampaignState({
                    filters: filterToSet
                });
            },
            checked: currentList === null || currentList === void 0 ? void 0 : currentList.includes(item.key),
            text: "".concat(item.name, " (").concat(item.count, ")")
        });
    };
    var getTopFilters = function() {
        return _toConsumableArray(list || []).splice(0, amountOfTopFilters).map(function(item) {
            return getCheckbox(item);
        });
    };
    var getCompleteList = function() {
        var filteredList = list === null || list === void 0 ? void 0 : list.filter(function(item) {
            if (searchString === "") {
                return true;
            }
            return item.name.toLowerCase().indexOf(searchString) >= 0;
        });
        if (!filteredList) {
            return null;
        }
        var letterToPrint;
        return filteredList.slice(0, 100).sort(function(a, b) {
            return a.name.localeCompare(b.name);
        }).map(function(item) {
            var firstLetter = item.name[0];
            var letter = null;
            if (firstLetter !== letterToPrint) {
                letterToPrint = firstLetter;
                letter = /*#__PURE__*/ react.createElement(LetterStyle, null, letterToPrint);
            }
            return /*#__PURE__*/ react.createElement(CheckBoxList, {
                key: item.key
            }, letter, getCheckbox(item));
        });
    };
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants/* TitleSmallText */.QV, null, title), getTopFilters(), list && list.length >= amountOfTopFilters && /*#__PURE__*/ react.createElement(button_variants/* TextButton */.Av, {
        onClick: function() {
            return setShowAll(!showAll);
        }
    }, !showAll ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(button_variants/* ButtonText */.oD, null, t("common", "button.show-more")), /*#__PURE__*/ react.createElement(button_variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(dropdown_down/* IconDropdownDown */.Q, null))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(button_variants/* ButtonText */.oD, null, t("common", "button.show-less")), /*#__PURE__*/ react.createElement(button_variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(dropdown_up/* IconDropdownUp */.Q, null)))), showAll && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(FilterInput, {
        icon: magnifier/* IconMagnifier */.j,
        onChangeHandler: function(value) {
            return setSearchString(value || "");
        },
        placeHolder: t("search", "search.button")
    }), /*#__PURE__*/ react.createElement(ScrollableList, null, getCompleteList())));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/radiobutton/index.js
var radiobutton = __webpack_require__(39234);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/filters/price-drop-filter.tsx






var PriceDropFilter = function() {
    var ref, ref1, ref2, ref3;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref4 = useCampaignContext(), campaignState = ref4.campaignState, setCampaignState = ref4.setCampaignState;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants/* TitleSmallText */.QV, null, t("campaigns", "filter.price-drop-title")), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.percent-or-more", {
            percent: "50"
        }),
        onClickHandler: function(e) {
            return setCampaignState({
                filters: {
                    priceDropPercent: e
                }
            });
        },
        selectedValue: (ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.priceDropPercent,
        value: types_PriceDropPercent.PERCENT_50
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.percent-or-more", {
            percent: "25"
        }),
        onClickHandler: function(e) {
            return setCampaignState({
                filters: {
                    priceDropPercent: e
                }
            });
        },
        selectedValue: (ref1 = campaignState.filters) === null || ref1 === void 0 ? void 0 : ref1.priceDropPercent,
        value: types_PriceDropPercent.PERCENT_25
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.percent-or-more", {
            percent: "10"
        }),
        onClickHandler: function(e) {
            return setCampaignState({
                filters: {
                    priceDropPercent: e
                }
            });
        },
        selectedValue: (ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : ref2.priceDropPercent,
        value: types_PriceDropPercent.PERCENT_10
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.percent-or-more", {
            percent: "5"
        }),
        onClickHandler: function(e) {
            return setCampaignState({
                filters: {
                    priceDropPercent: e
                }
            });
        },
        selectedValue: (ref3 = campaignState.filters) === null || ref3 === void 0 ? void 0 : ref3.priceDropPercent,
        value: types_PriceDropPercent.PERCENT_5
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/range/index.js
var range = __webpack_require__(46469);
// EXTERNAL MODULE: ./src/components/currency/index.tsx + 2 modules
var currency = __webpack_require__(7846);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/filters/price-range-filter.tsx
function price_range_filter_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function price_range_filter_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function price_range_filter_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return price_range_filter_arrayLikeToArray(arr);
}
function price_range_filter_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function price_range_filter_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function price_range_filter_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_range_filter_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function price_range_filter_slicedToArray(arr, i) {
    return price_range_filter_arrayWithHoles(arr) || price_range_filter_iterableToArrayLimit(arr, i) || price_range_filter_unsupportedIterableToArray(arr, i) || price_range_filter_nonIterableRest();
}
function price_range_filter_toConsumableArray(arr) {
    return price_range_filter_arrayWithoutHoles(arr) || price_range_filter_iterableToArray(arr) || price_range_filter_unsupportedIterableToArray(arr) || price_range_filter_nonIterableSpread();
}
function price_range_filter_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return price_range_filter_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return price_range_filter_arrayLikeToArray(o, minLen);
}









var PriceRangeFilter = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var MAX_VALUE = 10000;
    var ref6 = (0,app_context/* useAppContext */.bp)(), t = ref6.t, market = ref6.market;
    var ref7 = useCampaignContext(), campaignState = ref7.campaignState, setCampaignState = ref7.setCampaignState;
    var ref8 = price_range_filter_slicedToArray((0,react.useState)({
        min: 0,
        max: 1
    }), 2), minMaxSliderValue = ref8[0], setMinMaxSliderValue = ref8[1];
    var ref9 = price_range_filter_slicedToArray((0,react.useState)([
        0,
        MAX_VALUE
    ]), 2), rangeSliderValues = ref9[0], setRangeSliderValues = ref9[1];
    var ref10 = price_range_filter_slicedToArray((0,react.useState)((0,currency/* formatCurrency */.xG)(0, market.code, false)), 2), fromPriceValue = ref10[0], setFromPriceValue = ref10[1];
    var ref11 = price_range_filter_slicedToArray((0,react.useState)((0,currency/* formatCurrency */.xG)(MAX_VALUE, market.code, false)), 2), toPriceValue = ref11[0], setToPriceValue = ref11[1];
    var getMinMax = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var min = Math.floor(((ref2 = price_range_filter_toConsumableArray(((ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.priceHistorgram) || []).shift()) === null || ref2 === void 0 ? void 0 : ref2.min) || 0);
        var max = ((ref5 = price_range_filter_toConsumableArray(((ref3 = campaignState.campaignData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.deals) === null || ref4 === void 0 ? void 0 : ref4.priceHistorgram) || []).pop()) === null || ref5 === void 0 ? void 0 : ref5.max) || MAX_VALUE;
        return {
            min: min,
            max: max
        };
    };
    (0,react.useEffect)(function() {
        var ref;
        var minMax = getMinMax();
        setMinMaxSliderValue(minMax);
        if (!((ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.priceRangeCustom)) {
            setRangeSliderValues([
                minMax.min,
                minMax.max
            ]);
        }
    }, [
        (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.priceHistorgram
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3, ref4;
        var minMax = getMinMax();
        var from = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.from) || minMax.min;
        var to = ((ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.to) || minMax.max;
        if ((ref4 = campaignState.filters) === null || ref4 === void 0 ? void 0 : ref4.priceRange) {
            var ref5;
            switch((ref5 = campaignState.filters) === null || ref5 === void 0 ? void 0 : ref5.priceRange){
                case types_PriceRange.FROM_0_TO_200:
                    from = 0;
                    to = 200;
                    break;
                case types_PriceRange.FROM_200_TO_1000:
                    from = 200;
                    to = 1000;
                    break;
                case types_PriceRange.FROM_1000_TO_ALL:
                    from = 1000;
                    to = minMaxSliderValue.max;
                    break;
                default:
                    break;
            }
        }
        if (from !== rangeSliderValues[0] || to !== rangeSliderValues[1]) {
            setRangeSliderValues([
                from,
                to
            ]);
        }
    }, [
        (ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : ref2.priceRange
    ]);
    (0,react.useEffect)(function() {
        setFromPriceValue((0,currency/* formatCurrency */.xG)(rangeSliderValues[0], market.code, false));
        setToPriceValue((0,currency/* formatCurrency */.xG)(rangeSliderValues[1], market.code, false));
    }, [
        rangeSliderValues
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants/* TitleSmallText */.QV, null, t("campaigns", "filter.price")), /*#__PURE__*/ react.createElement(PriceRangeForm, null, /*#__PURE__*/ react.createElement(PriceRangeInput, {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChangeHandler: function() {},
        onBlur: function(e) {
            var ref, ref1, ref2, ref3;
            var value = e.target.value;
            var rangeValue = value && parseInt(value.replace(/\D/g, ""), 10) || minMaxSliderValue.min;
            var toValue = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.to) || minMaxSliderValue.max;
            if (rangeValue < minMaxSliderValue.min) {
                rangeValue = minMaxSliderValue.min;
            }
            if (rangeValue > minMaxSliderValue.max) {
                rangeValue = minMaxSliderValue.max;
            }
            setFromPriceValue((0,currency/* formatCurrency */.xG)((ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.from, market.code, false));
            setRangeSliderValues([
                rangeValue,
                toValue
            ]);
            setCampaignState({
                filters: {
                    priceRange: undefined,
                    priceRangeCustom: {
                        from: rangeValue,
                        to: toValue
                    }
                }
            });
        },
        onFocus: function() {
            var ref, ref1, ref2;
            setFromPriceValue(((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.from) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "");
        },
        value: fromPriceValue || ""
    }), /*#__PURE__*/ react.createElement(Divider, null, "-"), /*#__PURE__*/ react.createElement(PriceRangeInput, {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChangeHandler: function() {},
        onBlur: function(e) {
            var ref, ref1, ref2, ref3;
            var value = e.target.value;
            var rangeValue = value && parseInt(value.replace(/\D/g, ""), 10) || minMaxSliderValue.max;
            var fromValue = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : ref1.from) || minMaxSliderValue.min;
            if (rangeValue < minMaxSliderValue.min) {
                rangeValue = minMaxSliderValue.min;
            }
            if (rangeValue > minMaxSliderValue.max) {
                rangeValue = minMaxSliderValue.max;
            }
            setToPriceValue((0,currency/* formatCurrency */.xG)((ref2 = campaignState.filters) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.priceRangeCustom) === null || ref3 === void 0 ? void 0 : ref3.to, market.code, false));
            setRangeSliderValues([
                fromValue,
                rangeValue
            ]);
            setCampaignState({
                filters: {
                    priceRange: undefined,
                    priceRangeCustom: {
                        from: fromValue,
                        to: rangeValue
                    }
                }
            });
        },
        onFocus: function() {
            var ref, ref1, ref2;
            setToPriceValue(((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.priceRangeCustom) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.to) === null || ref2 === void 0 ? void 0 : ref2.toString()) || "");
        },
        value: toPriceValue || ""
    })), /*#__PURE__*/ react.createElement(range/* RangeSlider */.U, {
        domain: [
            minMaxSliderValue.min,
            minMaxSliderValue.max
        ],
        tickValues: [],
        step: 1,
        values: rangeSliderValues,
        onChange: function(e) {
            setRangeSliderValues([
                e[0],
                e[1]
            ]);
        },
        onBlur: function(e) {
            setCampaignState({
                filters: {
                    priceRange: undefined,
                    priceRangeCustom: {
                        from: e[0],
                        to: e[1]
                    }
                }
            });
        }
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.up-to-value", {
            value: (0,currency/* formatCurrency */.xG)(200, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            setCampaignState({
                filters: {
                    priceRange: e,
                    priceRangeCustom: {
                        from: 0,
                        to: 200
                    }
                }
            });
            setRangeSliderValues([
                0,
                200
            ]);
        },
        selectedValue: (ref3 = campaignState.filters) === null || ref3 === void 0 ? void 0 : ref3.priceRange,
        value: types_PriceRange.FROM_0_TO_200
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.from-to-value", {
            from: (0,currency/* formatCurrency */.xG)(200, market.code, false) || "",
            to: (0,currency/* formatCurrency */.xG)(1000, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            setCampaignState({
                filters: {
                    priceRange: e,
                    priceRangeCustom: {
                        from: 200,
                        to: 1000
                    }
                }
            });
            setRangeSliderValues([
                200,
                1000
            ]);
        },
        selectedValue: (ref4 = campaignState.filters) === null || ref4 === void 0 ? void 0 : ref4.priceRange,
        value: types_PriceRange.FROM_200_TO_1000
    }), /*#__PURE__*/ react.createElement(radiobutton/* RadioButton */.E, {
        text: t("campaigns", "filter.more-than-value", {
            value: (0,currency/* formatCurrency */.xG)(1000, market.code, false) || ""
        }),
        name: "pricerange",
        onClickHandler: function(e) {
            setCampaignState({
                filters: {
                    priceRange: e,
                    priceRangeCustom: {
                        from: 1000,
                        to: MAX_VALUE
                    }
                }
            });
            setRangeSliderValues([
                1000,
                MAX_VALUE
            ]);
        },
        selectedValue: (ref5 = campaignState.filters) === null || ref5 === void 0 ? void 0 : ref5.priceRange,
        value: types_PriceRange.FROM_1000_TO_ALL
    }));
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/filters/index.ts




;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/filter-panel/filters-panel.tsx






var FilterPanel = function() {
    var ref, ref1, ref2, ref3;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var campaignState = useCampaignContext().campaignState;
    return /*#__PURE__*/ react.createElement(FiltersWrapper, null, /*#__PURE__*/ react.createElement(text_variants/* H3Text */.I7, null, t("campaigns", "filter.title")), /*#__PURE__*/ react.createElement(PriceDropFilter, null), /*#__PURE__*/ react.createElement("hr", null), /*#__PURE__*/ react.createElement(PriceRangeFilter, null), /*#__PURE__*/ react.createElement("hr", null), /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
        title: t("campaigns", "filter.brand-title"),
        listName: "brands",
        list: (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.brandsAggregations,
        amountOfTopFilters: 5
    }), /*#__PURE__*/ react.createElement("hr", null), /*#__PURE__*/ react.createElement(CheckBoxListFilter, {
        title: t("campaigns", "filter.category-title"),
        listName: "categories",
        list: (ref2 = campaignState.campaignData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.deals) === null || ref3 === void 0 ? void 0 : ref3.categoryAggregations,
        amountOfTopFilters: 10
    }));
};

// EXTERNAL MODULE: ./src/areas/campaign-v2/components/campaign-card/campaign-card-context.tsx
var campaign_card_context = __webpack_require__(90477);
// EXTERNAL MODULE: ./src/components/product-card-new/product-card-context.tsx
var product_card_context = __webpack_require__(52416);
// EXTERNAL MODULE: ./src/components/placeholder/index.tsx + 1 modules
var placeholder = __webpack_require__(49624);
// EXTERNAL MODULE: ./src/areas/campaign-v2/components/campaign-card/index.tsx + 10 modules
var campaign_card = __webpack_require__(54436);
// EXTERNAL MODULE: ./src/components/applied-filters/index.tsx + 3 modules
var applied_filters = __webpack_require__(10655);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/content/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n\n  > h3 {\n    margin: 0;\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    grid-template-columns: repeat(",
        ", minmax(0, 1fr));\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(",
        ", minmax(0, 1fr));\n  gap: ",
        ";\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "grid-column: 1/3;"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  padding: ",
        ";\n  gap: ",
        ";\n  border-radius: ",
        ";\n\n  grid-row: 2;\n  grid-column: 1/4;\n  ",
        "\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var GRID_COLUMNS_DESKTOP = 3;
var GRID_COLUMNS_MOBILE = 2;
var StyledContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledContent",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledHeaderTitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeaderTitle",
    componentId: "sc-0-1"
})(styles_templateObject1());
var StyledProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledProducts",
    componentId: "sc-0-2"
})(styles_templateObject3(), GRID_COLUMNS_DESKTOP, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(styles_templateObject2(), GRID_COLUMNS_MOBILE));
var ActiveFiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ActiveFiltersWrapper",
    componentId: "sc-0-3"
})(styles_templateObject5(), base/* media.smallOnly */.BC.smallOnly(styles_templateObject4()));
var DealsInfoText = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DealsInfoText",
    componentId: "sc-0-4"
})(styles_templateObject7(), light_theme_colors.base100, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(styles_templateObject6()));

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/content/active-filters.tsx
function active_filters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function active_filters_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return active_filters_arrayLikeToArray(arr);
}
function active_filters_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function active_filters_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function active_filters_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function active_filters_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            active_filters_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function active_filters_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function active_filters_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        active_filters_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function active_filters_toConsumableArray(arr) {
    return active_filters_arrayWithoutHoles(arr) || active_filters_iterableToArray(arr) || active_filters_unsupportedIterableToArray(arr) || active_filters_nonIterableSpread();
}
function active_filters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return active_filters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return active_filters_arrayLikeToArray(o, minLen);
}






var ActiveFilters = function() {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = useCampaignContext(), campaignState = ref.campaignState, setCampaignState = ref.setCampaignState;
    if (!campaignState.filters) {
        return null;
    }
    var updateFilterFromActive = function(newFilters) {
        setCampaignState({
            filters: newFilters
        }, false);
    };
    var clearFilter = function(filter) {
        var alteredFilters = active_filters_objectSpread({}, campaignState.filters);
        delete alteredFilters[filter.key];
        if (filter.key === "priceRangeCustom") {
            delete alteredFilters.priceRange;
        }
        if (filter.key.includes("brands::")) {
            var ref;
            var brandValue = filter.key.split("::")[1];
            alteredFilters.brands = (ref = alteredFilters.brands) === null || ref === void 0 ? void 0 : ref.filter(function(brand) {
                return brand !== brandValue;
            });
        }
        if (filter.key.includes("categories::")) {
            var ref1;
            var categoryValue = filter.key.split("::")[1];
            alteredFilters.categories = (ref1 = alteredFilters.categories) === null || ref1 === void 0 ? void 0 : ref1.filter(function(category) {
                return category !== categoryValue;
            });
        }
        updateFilterFromActive(alteredFilters);
    };
    var filters = Object.keys(campaignState.filters).map(function(filterKey) {
        if (!campaignState.filters) {
            return null;
        }
        var value = campaignState.filters[filterKey];
        var buttonText = "";
        switch(value){
            case types_PriceRange.FROM_0_TO_200:
            case types_PriceRange.FROM_200_TO_1000:
            case types_PriceRange.FROM_1000_TO_ALL:
            case types_PriceDropPercent.PERCENT_50:
            case types_PriceDropPercent.PERCENT_25:
            case types_PriceDropPercent.PERCENT_10:
            case types_PriceDropPercent.PERCENT_5:
                return null;
            default:
                break;
        }
        switch(filterKey){
            case "dealsEndingSoon":
                buttonText = value && t("campaigns", "filter.ending-soon");
                break;
            case "priceRangeCustom":
                buttonText = "".concat(value.from, " - ").concat(value.to);
                break;
            default:
                break;
        }
        return {
            value: buttonText,
            key: filterKey
        };
    }).filter(function(filter) {
        return !!(filter === null || filter === void 0 ? void 0 : filter.value);
    });
    var arrayToFilter = function(keyValue, array) {
        return array.map(function(item) {
            var name = item;
            if (keyValue === "categories") {
                var ref, ref1, ref2;
                name = ((ref2 = (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.categoryAggregations.find(function(c) {
                    return c.key === item;
                })) === null || ref2 === void 0 ? void 0 : ref2.name) || "";
            }
            if (keyValue === "brands") {
                var ref3, ref4, ref5;
                name = ((ref5 = (ref3 = campaignState.campaignData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.deals) === null || ref4 === void 0 ? void 0 : ref4.brandsAggregations.find(function(c) {
                    return c.key === item;
                })) === null || ref5 === void 0 ? void 0 : ref5.name) || "";
            }
            return {
                value: name,
                key: "".concat(keyValue, "::").concat(item)
            };
        });
    };
    var mergedFilters = active_filters_toConsumableArray(filters).concat(active_filters_toConsumableArray(arrayToFilter("brands", campaignState.filters.brands || [])), active_filters_toConsumableArray(arrayToFilter("categories", campaignState.filters.categories || [])));
    var filterFormat = function(data) {
        var filter = data.filter;
        return {
            value: filter.value,
            key: filter.key
        };
    };
    return /*#__PURE__*/ react.createElement(ActiveFiltersWrapper, null, /*#__PURE__*/ react.createElement(applied_filters/* AppliedFilters */.M, {
        filters: mergedFilters,
        filterFormatFn: filterFormat,
        onClearFilter: function(filter) {
            return clearFilter(filter);
        },
        onClearAll: function() {
            return setCampaignState(active_filters_objectSpreadProps(active_filters_objectSpread({}, campaignState), {
                filters: initState.filters
            }), false);
        },
        wrap: true
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(21932);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/double-chevron-left/index.js
var double_chevron_left = __webpack_require__(37961);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(64325);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/pagination/styles.ts
function pagination_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function pagination_styles_templateObject() {
    var data = pagination_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: ",
        ";\n  padding: ",
        ";\n"
    ]);
    pagination_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledPagination = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "StyledPagination",
    componentId: "sc-0-0"
})(pagination_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/pagination/index.tsx
function pagination_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function pagination_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function pagination_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function pagination_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function pagination_slicedToArray(arr, i) {
    return pagination_arrayWithHoles(arr) || pagination_iterableToArrayLimit(arr, i) || pagination_unsupportedIterableToArray(arr, i) || pagination_nonIterableRest();
}
function pagination_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return pagination_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return pagination_arrayLikeToArray(o, minLen);
}









var DEFAULT_PAGE = 1;
var Pagination = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref2 = useCampaignContext(), campaignState = ref2.campaignState, setCampaignState = ref2.setCampaignState;
    var ref3 = pagination_slicedToArray((0,react.useState)(DEFAULT_PAGE), 2), currentPage = ref3[0], setCurrentPage = ref3[1];
    var getCurrentPageFromUrl = function(id) {
        var searchParams = new URLSearchParams(window.location.search);
        var qs = searchParams.get(id) || "";
        return qs;
    };
    (0,react.useEffect)(function() {
        var currentPageFromUrl = getCurrentPageFromUrl("page");
        var pageNumber = parseInt(currentPageFromUrl, 10);
        var cleanPageNumber = pageNumber <= 0 ? DEFAULT_PAGE : pageNumber;
        if (cleanPageNumber) {
            setCurrentPage(cleanPageNumber);
        }
    }, []);
    var addStickyOffset = (0,react.useCallback)(function() {
        if (window.innerWidth < 640) {
            return 50;
        }
        return 70;
    }, []);
    var numOfDeals = ((ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.dealsProducts.length) || 0;
    if (numOfDeals < 21) {
        return null;
    }
    var handlePageChange = function(page) {
        setCurrentPage(page);
        setCampaignState({
            page: page
        });
    };
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
        to: "campaignHeader",
        shouldScroll: function(param) {
            var tagName = param.tagName;
            return tagName === "BUTTON";
        },
        animate: false,
        calculateOffset: addStickyOffset
    }, /*#__PURE__*/ react.createElement(StyledPagination, null, currentPage > 2 ? /*#__PURE__*/ react.createElement(button_variants/* OutlinedButton */.Uc, {
        onClick: function() {
            return handlePageChange(1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(double_chevron_left/* IconDoubleChevronLeft */.E, null)) : null, currentPage > 1 ? /*#__PURE__*/ react.createElement(button_variants/* OutlinedButton */.Uc, {
        onClick: function() {
            return handlePageChange(currentPage - 1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(chevron_left/* IconChevronLeft */.e, null)) : null, /*#__PURE__*/ react.createElement("span", null, t("common", "pagination.page-number", {
        number: currentPage
    })), /*#__PURE__*/ react.createElement(button_variants/* OutlinedButton */.Uc, {
        onClick: function() {
            return handlePageChange(currentPage + 1);
        },
        onlyIcon: true
    }, /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, null))));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/offer-list-empty-message/info-message.tsx
var info_message = __webpack_require__(80082);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(11235);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(81509);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/content/content.tsx
function content_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function content_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            content_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function content_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function content_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        content_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}















var ADS_LAYOUT = content_defineProperty({}, types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 5
    },
    dubbelpanorama1: {
        show: false,
        row: 8
    },
    dubbelpanorama2: {
        show: true,
        row: 5
    }
});
var Content = function() {
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref1 = useCampaignContext(), campaignState = ref1.campaignState, setCampaignState = ref1.setCampaignState;
    var deals = (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : ref.deals;
    var handleReset = function() {
        setCampaignState(content_objectSpreadProps(content_objectSpread({}, campaignState), {
            filters: initState.filters
        }), false);
    };
    var renderContent = function() {
        var ref, ref1;
        if (!campaignState.fetching && !(deals === null || deals === void 0 ? void 0 : (ref = deals.dealsProducts) === null || ref === void 0 ? void 0 : ref.length)) {
            return /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement(info_message/* InfoMessage */.$, {
                message: {
                    text: t("filter", "empty-message.no-filter-match"),
                    link: // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/anchor-is-valid
                    /*#__PURE__*/ react.createElement("a", {
                        onClick: function() {
                            return handleReset();
                        }
                    }, t("filter", "button.clear-filters"))
                }
            }));
        }
        return /*#__PURE__*/ react.createElement(react.Fragment, null, campaignState.fetching ? /*#__PURE__*/ react.createElement(placeholder/* Placeholder */.V, {
            color: placeholder/* ColorsEnum.WHITE */.C.WHITE,
            height: 450,
            amount: 12,
            rows: 8
        }) : /*#__PURE__*/ react.createElement(StyledProducts, null, deals === null || deals === void 0 ? void 0 : (ref1 = deals.dealsProducts) === null || ref1 === void 0 ? void 0 : ref1.map(function(product, i) {
            return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
                key: i,
                diffPercentage: product.priceDrop,
                product: content_objectSpreadProps(content_objectSpread({}, product), {
                    category: {
                        name: product.categoryName
                    },
                    media: {
                        first: product.logo
                    },
                    store: {
                        id: product.storeId,
                        name: product.storeName
                    }
                })
            }, /*#__PURE__*/ react.createElement(campaign_card_context/* CampaignCardContextContainer */.O, _extends({}, product), /*#__PURE__*/ react.createElement(campaign_card/* CampaignCard */.p, null)));
        }), /*#__PURE__*/ react.createElement(DealsInfoText, null, /*#__PURE__*/ react.createElement(text_variants/* BodySmallText */.oI, null, t("campaigns", "campaign.deals-info"))), /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
            offersLength: (deals === null || deals === void 0 ? void 0 : deals.dealsProducts.length) || 0,
            layout: types/* LayoutMode.GRID */.X.GRID,
            layoutConfig: ADS_LAYOUT,
            scaleBase: "deals-grid",
            async: true
        })), /*#__PURE__*/ react.createElement(Pagination, null));
    };
    return /*#__PURE__*/ react.createElement(StyledContent, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(StyledHeaderTitle, null, /*#__PURE__*/ react.createElement(text_variants/* H3Text */.I7, null, t("campaigns", "products.title")), (deals === null || deals === void 0 ? void 0 : deals.dealsProducts) && deals.dealsProducts.length > 0 && /*#__PURE__*/ react.createElement(Sort, null)), /*#__PURE__*/ react.createElement(ActiveFilters, null)), renderContent());
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(58079);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-breadcrumbs/styles.ts
function campaign_breadcrumbs_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_breadcrumbs_styles_templateObject() {
    var data = campaign_breadcrumbs_styles_taggedTemplateLiteral([
        "\n  margin: ",
        " 10px;\n"
    ]);
    campaign_breadcrumbs_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledBreadcrumbs = (0,styled_components_browser_esm["default"])(breadcrumbs/* Breadcrumbs */.O).withConfig({
    displayName: "StyledBreadcrumbs",
    componentId: "sc-0-0"
})(campaign_breadcrumbs_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-breadcrumbs/index.tsx






var CampaignBreadcrumbs = function(props) {
    var ref;
    var article = props.article;
    var campaignState = useCampaignContext().campaignState;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var campaignBasePath = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.base;
    });
    return /*#__PURE__*/ react.createElement(StyledBreadcrumbs, null, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), campaignBasePath && /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: campaignBasePath
    }, t("campaigns", "themes.breadcrumb")), ((ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : ref.campaign) && /*#__PURE__*/ react.createElement("span", null, campaignState.campaignData.campaign.name), article && /*#__PURE__*/ react.createElement("span", null, article.title));
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-header/components/search-input/index.tsx
function search_input_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function search_input_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function search_input_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function search_input_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function search_input_slicedToArray(arr, i) {
    return search_input_arrayWithHoles(arr) || search_input_iterableToArrayLimit(arr, i) || search_input_unsupportedIterableToArray(arr, i) || search_input_nonIterableRest();
}
function search_input_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return search_input_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return search_input_arrayLikeToArray(o, minLen);
}





var timer;
var SearchInput = function(param) {
    var handleSearch = param.handleSearch, _delay = param.delay, delay = _delay === void 0 ? 1000 : _delay, onClear = param.onClear, _value = param.value, value = _value === void 0 ? "" : _value;
    var ref;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var campaignState = useCampaignContext().campaignState;
    var ref1 = search_input_slicedToArray((0,react.useState)(value), 2), searchString = ref1[0], setSearchString = ref1[1];
    var ref2 = search_input_slicedToArray((0,react.useState)(value), 2), lastValue = ref2[0], setLastValue = ref2[1];
    (0,react.useEffect)(function() {
        clearTimeout(timer);
        if (searchString === lastValue) {
            return;
        }
        if (!searchString) {
            if (onClear) {
                onClear();
            }
            setLastValue(searchString);
            handleSearch(searchString);
            return;
        }
        timer = setTimeout(function() {
            setLastValue(searchString);
            handleSearch(searchString);
        }, delay);
        // eslint-disable-next-line consistent-return
        return function() {
            clearTimeout(timer);
        };
    }, [
        searchString
    ]);
    var handleChange = function(inputValue) {
        if (searchString !== inputValue) {
            setSearchString(inputValue || "");
        }
    };
    return /*#__PURE__*/ react.createElement(variants/* Input */.II, {
        icon: magnifier/* IconMagnifier */.j,
        clearable: true,
        onChangeHandler: function(e) {
            return handleChange(e);
        },
        value: (ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.query,
        placeHolder: t("campaigns", "search.placeholder")
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/filter/index.js
var filter = __webpack_require__(47548);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/modal/index.js
var modal = __webpack_require__(48134);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-header/components/popular-filters/styles.ts
function popular_filters_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function popular_filters_styles_templateObject() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  overflow: auto;\n  padding: 1px;\n  gap: ",
        ";\n\n  > button {\n    flex-shrink: 0;\n  }\n"
    ]);
    popular_filters_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject1() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    popular_filters_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function popular_filters_styles_templateObject2() {
    var data = popular_filters_styles_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    popular_filters_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledPopularFilters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPopularFilters",
    componentId: "sc-0-0"
})(popular_filters_styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledFilterModalButton = (0,styled_components_browser_esm["default"])(ui_button/* Button */.zx).withConfig({
    displayName: "StyledFilterModalButton",
    componentId: "sc-0-1"
})(popular_filters_styles_templateObject2(), base/* media.largeUp */.BC.largeUp(popular_filters_styles_templateObject1()));

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-header/components/popular-filters/index.tsx
function popular_filters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function popular_filters_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function popular_filters_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function popular_filters_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function popular_filters_slicedToArray(arr, i) {
    return popular_filters_arrayWithHoles(arr) || popular_filters_iterableToArrayLimit(arr, i) || popular_filters_unsupportedIterableToArray(arr, i) || popular_filters_nonIterableRest();
}
function popular_filters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return popular_filters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return popular_filters_arrayLikeToArray(o, minLen);
}









var PopularFilters = function() {
    var ref, ref1, ref2, ref3, ref4;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref5 = useCampaignContext(), campaignState = ref5.campaignState, setCampaignState = ref5.setCampaignState;
    var ref6 = popular_filters_slicedToArray((0,react.useState)(false), 2), isFilterModalOpen = ref6[0], setIsFilterModalOpen = ref6[1];
    var popularCategoryFilters = (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : (ref1 = ref.deals) === null || ref1 === void 0 ? void 0 : ref1.categoryAggregations.filter(function(category) {
        var ref, ref1;
        return category.name && !((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.categories) === null || ref1 === void 0 ? void 0 : ref1.includes(category.key));
    }).slice(0, 5);
    var popularBrandsFilters = (ref2 = campaignState.campaignData) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.deals) === null || ref3 === void 0 ? void 0 : ref3.brandsAggregations.filter(function(brand) {
        var ref, ref1;
        return brand.name && !((ref = campaignState.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.brands) === null || ref1 === void 0 ? void 0 : ref1.includes(brand.key));
    }).slice(0, 5);
    var getAlterValues = function() {
        var brands = (popularBrandsFilters === null || popularBrandsFilters === void 0 ? void 0 : popularBrandsFilters.map(function(filter) {
            return {
                key: filter.key,
                name: filter.name,
                type: "brand"
            };
        })) || [];
        var categories = (popularCategoryFilters === null || popularCategoryFilters === void 0 ? void 0 : popularCategoryFilters.map(function(filter) {
            return {
                key: filter.key,
                name: filter.name,
                type: "category"
            };
        })) || [];
        var length = Math.min(brands.length, categories.length);
        var result = [];
        // eslint-disable-next-line no-plusplus
        for(var i = 0; i < length; i++){
            result.push(brands[i], categories[i]);
        }
        return result;
    };
    var updateFilter = function(filter) {
        var ref, ref1;
        var oldCategories = ((ref = campaignState.filters) === null || ref === void 0 ? void 0 : ref.categories) || [];
        var oldBrands = ((ref1 = campaignState.filters) === null || ref1 === void 0 ? void 0 : ref1.brands) || [];
        if (oldCategories.includes(filter.key) || oldBrands.includes(filter.key)) {
            return;
        }
        var newFilter = {
            categories: oldCategories,
            brands: oldBrands
        };
        switch(filter.type){
            case "category":
                newFilter.categories.push(filter.key);
                break;
            case "brand":
                newFilter.brands.push(filter.key);
                break;
            default:
                return;
        }
        setCampaignState({
            filters: newFilter
        });
    };
    return /*#__PURE__*/ react.createElement(StyledPopularFilters, null, /*#__PURE__*/ react.createElement(modal/* Modal */.u_, {
        isOpen: isFilterModalOpen,
        onRequestClose: function() {
            return setIsFilterModalOpen(false);
        },
        title: t("campaigns", "filter.title")
    }, /*#__PURE__*/ react.createElement(modal/* ModalBody */.fe, null, /*#__PURE__*/ react.createElement(FilterPanel, null))), /*#__PURE__*/ react.createElement(StyledFilterModalButton, {
        onClick: function() {
            return setIsFilterModalOpen(true);
        }
    }, /*#__PURE__*/ react.createElement(ui_button/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(filter/* IconFilter */.w, null))), (ref4 = getAlterValues()) === null || ref4 === void 0 ? void 0 : ref4.map(function(filter, i) {
        return /*#__PURE__*/ react.createElement(button_variants/* OutlinedButton */.Uc, {
            key: i,
            onClick: function() {
                return updateFilter(filter);
            }
        }, filter.name);
    }));
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-header/styles.ts
function campaign_header_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_header_styles_templateObject() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  row-gap: ",
        ";\n  margin: ",
        " 10px;\n"
    ]);
    campaign_header_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject1() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  column-gap: ",
        ";\n"
    ]);
    campaign_header_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject2() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n  "
    ]);
    campaign_header_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject3() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  max-height: ",
        ";\n\n  ",
        "\n"
    ]);
    campaign_header_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject4() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n    flex: 1;\n    column-gap: 0;\n  "
    ]);
    campaign_header_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject5() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  column-gap: ",
        ";\n  row-gap: ",
        ";\n  flex-wrap: wrap;\n\n  ",
        "\n"
    ]);
    campaign_header_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject6() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n    line-height: ",
        ";\n  "
    ]);
    campaign_header_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function campaign_header_styles_templateObject7() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  flex: 0 1 auto;\n  margin: 0;\n\n  ",
        "\n"
    ]);
    campaign_header_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = campaign_header_styles_taggedTemplateLiteral([
        "\n  max-width: 500px;\n\n  > .input {\n    width: 100%;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_DESKTOP = "39px";
var CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE = "35px";
var StyledHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledHeader",
    componentId: "sc-0-0"
})(campaign_header_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150);
var StyledTitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleWrapper",
    componentId: "sc-0-1"
})(campaign_header_styles_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledImage = styled_components_browser_esm["default"].img.withConfig({
    displayName: "StyledImage",
    componentId: "sc-0-2"
})(campaign_header_styles_templateObject3(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_DESKTOP, base/* media.smallOnly */.BC.smallOnly(campaign_header_styles_templateObject2(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE));
var StyledTitleInner = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTitleInner",
    componentId: "sc-0-3"
})(campaign_header_styles_templateObject5(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.smallOnly */.BC.smallOnly(campaign_header_styles_templateObject4()));
var StyledTitle = (0,styled_components_browser_esm["default"])(text_variants/* H1Text */.di).withConfig({
    displayName: "StyledTitle",
    componentId: "sc-0-4"
})(campaign_header_styles_templateObject7(), base/* media.smallOnly */.BC.smallOnly(campaign_header_styles_templateObject6(), CAMPAIGN_HEADER_IMAGE_MAX_HEIGHT_MOBILE));
var StyledSearchContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSearchContainer",
    componentId: "sc-0-5"
})(styles_templateObject8());

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-header/index.tsx





// import { KnowHowText } from './components/know-how-text';


// import { DAILY_DEALS_ID } from 'src/globals/helpers/campaign/campaign-ids';

var CampaignHeader = function() {
    var ref, ref1, ref2, ref3;
    var renderMode = (0,app_context/* useAppContext */.bp)().renderMode;
    var ref4 = useCampaignContext(), campaignState = ref4.campaignState, setCampaignState = ref4.setCampaignState;
    if (!((ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : ref.campaign)) return null;
    var campaign = campaignState.campaignData.campaign;
    var campaignImage = ((ref1 = campaign.banners) === null || ref1 === void 0 ? void 0 : ref1.length) ? campaign.banners[0] : null;
    return /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "campaignHeader"
    }, renderMode !== "native" && /*#__PURE__*/ react.createElement(CampaignBreadcrumbs, null), /*#__PURE__*/ react.createElement(StyledHeader, null, /*#__PURE__*/ react.createElement(StyledTitleWrapper, null, (campaignImage === null || campaignImage === void 0 ? void 0 : campaignImage.imageUrl) && /*#__PURE__*/ react.createElement(StyledImage, {
        src: campaignImage.imageUrl,
        alt: (ref2 = campaign.title) === null || ref2 === void 0 ? void 0 : ref2.page
    }), /*#__PURE__*/ react.createElement(StyledTitleInner, {
        "data-test": "HeaderText"
    }, /*#__PURE__*/ react.createElement(StyledTitle, null, (ref3 = campaign.facetted) === null || ref3 === void 0 ? void 0 : ref3.title))), /*#__PURE__*/ react.createElement(StyledSearchContainer, null, /*#__PURE__*/ react.createElement(SearchInput, {
        handleSearch: function(value) {
            return setCampaignState({
                filters: {
                    query: value
                }
            });
        }
    })), /*#__PURE__*/ react.createElement(PopularFilters, null)));
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/index.ts





// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-inactive/index.js + 9 modules
var campaign_inactive = __webpack_require__(76291);
// EXTERNAL MODULE: ./src/components/campaign-deals/index.ts
var campaign_deals = __webpack_require__(85222);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.js
var campaign_ids = __webpack_require__(59827);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(1603);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/styles.ts
function campaign_v2_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_v2_styles_templateObject() {
    var data = campaign_v2_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  column-gap: ",
        ";\n"
    ]);
    campaign_v2_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_v2_styles_templateObject1() {
    var data = campaign_v2_styles_taggedTemplateLiteral([
        "\n  padding: ",
        " ",
        ";\n"
    ]);
    campaign_v2_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}




var StyledSection = (0,styled_components_browser_esm["default"])(list_variants/* Column */.sg).withConfig({
    displayName: "StyledSection",
    componentId: "sc-0-0"
})(campaign_v2_styles_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var StyledOngoingCampaignsInfo = (0,styled_components_browser_esm["default"])(campaign_group/* default */.Z).withConfig({
    displayName: "StyledOngoingCampaignsInfo",
    componentId: "sc-0-1"
})(campaign_v2_styles_templateObject1(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-wrapper.tsx












var CampaignWrapper = function() {
    var ref, ref1;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var campaignState = useCampaignContext().campaignState;
    var campaign = (ref = campaignState.campaignData) === null || ref === void 0 ? void 0 : ref.campaign;
    var campaigns = (ref1 = campaignState.campaignData) === null || ref1 === void 0 ? void 0 : ref1.campaigns;
    var isActiveCampaign = (campaign === null || campaign === void 0 ? void 0 : campaign.state) === CampaignStateEnum.ACTIVE;
    var activeCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== (campaign === null || campaign === void 0 ? void 0 : campaign.id) && (item === null || item === void 0 ? void 0 : item.state) === CampaignStateEnum.ACTIVE;
    });
    var dailyDeals = activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.find(function(c) {
        return (c === null || c === void 0 ? void 0 : c.id) === campaign_ids/* DAILY_DEALS_ID */.Wf;
    });
    if (!campaign) {
        return null;
    }
    return isActiveCampaign ? /*#__PURE__*/ react.createElement(page/* PageSection */.NP, {
        noPad: "top",
        recessed: true
    }, /*#__PURE__*/ react.createElement(StyledSection, null, /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(FilterPanel, null))), /*#__PURE__*/ react.createElement(Content, null))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(campaign_inactive/* default */.Z, {
        targetDate: (campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start) ? Number((campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start)) : undefined,
        campaign: campaign,
        dailyDeals: dailyDeals,
        // router={router}
        campaignDeals: campaign_deals/* default */.Z
    }), /*#__PURE__*/ react.createElement(StyledOngoingCampaignsInfo, {
        title: t("campaigns", "themes.ongoing-campaigns"),
        campaigns: activeCampaigns
    }));
};

// EXTERNAL MODULE: ./src/areas/product/components/price-list/ads/mobile-top-ad.tsx
var mobile_top_ad = __webpack_require__(81744);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/campaign.tsx






var CampaignPageComponent = function() {
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, /*#__PURE__*/ react.createElement(mobile_top_ad/* MobileTopAd */.b, null), /*#__PURE__*/ react.createElement(CampaignStateProvider, null, /*#__PURE__*/ react.createElement(CampaignHeader, null), /*#__PURE__*/ react.createElement(CampaignWrapper, null)));
};
/* harmony default export */ const campaign = (CampaignPageComponent);


/***/ }),

/***/ 90477:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": () => (/* binding */ CampaignCardContextContainer),
/* harmony export */   "q": () => (/* binding */ useCampaignCardContext)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

var initialValue = {
    categoryName: "",
    featured: false,
    handleCardOnClick: undefined,
    handleClickOut: undefined,
    logo: undefined,
    memberPrice: undefined,
    name: "",
    offerLink: "",
    originalPrice: undefined,
    previousPrice: undefined,
    previousPriceText: undefined,
    price: 0,
    priceDrop: 0,
    priceExpires: undefined,
    priceId: undefined,
    priceUpdateTime: "",
    productId: 0,
    productLink: "",
    productRating: undefined,
    productRatingCount: 0,
    stockStatus: "in_stock",
    storeCount: 0,
    storeId: 0,
    storeName: ""
};
var CampaignCardContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(initialValue);
var useCampaignCardContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(CampaignCardContext);
};
var CampaignCardContextContainer = function(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CampaignCardContext.Provider, {
        value: props
    }, props.children);
};


/***/ }),

/***/ 54436:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": () => (/* binding */ CampaignCard)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/areas/campaign-v2/components/campaign-card/campaign-card-context.tsx
var campaign_card_context = __webpack_require__(90477);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/product-card-new/components/grid/grid-card-header.tsx
var grid_card_header = __webpack_require__(69338);
// EXTERNAL MODULE: ./src/components/product-card-new/product-card-context.tsx
var product_card_context = __webpack_require__(52416);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/badge/index.js
var badge = __webpack_require__(67360);
// EXTERNAL MODULE: ./src/components/offer/price/offer-price/price-data.ts + 1 modules
var price_data = __webpack_require__(56452);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-content/badges/index.tsx





var Badges = function() {
    var ref = (0,campaign_card_context/* useCampaignCardContext */.q)(), memberPrice = ref.memberPrice, originalPrice = ref.originalPrice, priceExpires = ref.priceExpires;
    var ref1 = (0,app_context/* useAppContext */.bp)(), market = ref1.market, t = ref1.t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, memberPrice && /*#__PURE__*/ react.createElement(badge/* Badge */.Ct, {
        color: "YELLOW",
        size: badge/* BadgeSize.SMALL */.OD.SMALL,
        text: t("product", "promotions.members-price")
    }), !memberPrice && originalPrice && /*#__PURE__*/ react.createElement(badge/* Badge */.Ct, {
        color: "YELLOW",
        size: badge/* BadgeSize.SMALL */.OD.SMALL,
        text: priceExpires ? t("campaigns", "campaign-card.sale-badge-end-date", {
            date: (0,price_data/* parseUTCDate */.kT)(priceExpires, market.localeStandard)
        }) : t("campaigns", "campaign-card.sale")
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/question-outlined/index.js
var question_outlined = __webpack_require__(73005);
// EXTERNAL MODULE: ./src/components/currency/index.tsx + 2 modules
var currency = __webpack_require__(7846);
// EXTERNAL MODULE: ./src/components/offer/price/price-text.tsx
var price_text = __webpack_require__(12941);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/tooltip/index.js
var tooltip = __webpack_require__(64478);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-content/prices/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: baseline;\n  gap: ",
        ";\n  white-space: nowrap;\n\n  > * {\n    flex: 0 1 auto;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-decoration: line-through;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-self: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  gap: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}




var StyledPrice = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPrice",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledSecondaryPrice = (0,styled_components_browser_esm["default"])(price_text/* PriceText */.X).withConfig({
    displayName: "StyledSecondaryPrice",
    componentId: "sc-0-1"
})(_templateObject1());
var StyledIconTooltip = (0,styled_components_browser_esm["default"])(tooltip/* Tooltip */.u).withConfig({
    displayName: "StyledIconTooltip",
    componentId: "sc-0-2"
})(_templateObject2());
var StyledSecondaryPriceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSecondaryPriceWrapper",
    componentId: "sc-0-3"
})(_templateObject3(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-content/prices/index.tsx









var Prices = function() {
    var ref = (0,campaign_card_context/* useCampaignCardContext */.q)(), memberPrice = ref.memberPrice, originalPrice = ref.originalPrice, previousPriceText = ref.previousPriceText, price = ref.price, priceDrop = ref.priceDrop;
    if (!price) return null;
    var priceDropDecimal = priceDrop / 100;
    var previousPrice = price ? price / (1 - priceDropDecimal) : undefined;
    return /*#__PURE__*/ react.createElement(list_variants/* Column */.sg, {
        gap: 0
    }, /*#__PURE__*/ react.createElement(StyledPrice, null, /*#__PURE__*/ react.createElement(price_text/* PriceText */.X, {
        color: priceDrop ? variants/* FontColor.NEGATIVE */.rx.NEGATIVE : variants/* FontColor.DARK */.rx.DARK
    }, /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: memberPrice !== null && memberPrice !== void 0 ? memberPrice : price
    })), /*#__PURE__*/ react.createElement(StyledSecondaryPriceWrapper, null, originalPrice || previousPrice ? /*#__PURE__*/ react.createElement(StyledSecondaryPrice, {
        emphasis: variants/* FontEmphasis.MEDIUM */.tu.MEDIUM,
        scale: variants/* FontScale.S */.FE.S,
        weight: variants/* FontWeight.NORMAL */.U9.NORMAL
    }, originalPrice ? /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: originalPrice
    }) : /*#__PURE__*/ react.createElement(currency/* Currency */.F, {
        price: previousPrice
    })) : null, previousPriceText && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(StyledIconTooltip, {
        title: previousPriceText
    }, /*#__PURE__*/ react.createElement(question_outlined/* IconQuestionOutlined */.n, {
        size: 14
    }))), /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement("div", null, "*"))))));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(2262);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-content/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n  && {\n    justify-content: space-between;\n    padding-top: 0;\n    padding-bottom: ",
        ";\n    gap: ",
        ";\n  }\n"
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  > :not(:last-child) {\n    margin-bottom: ",
        ";\n  }\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var StyledCardContent = (0,styled_components_browser_esm["default"])(card/* CardContent */.aY).withConfig({
    displayName: "StyledCardContent",
    componentId: "sc-0-0"
})(styles_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var StyledFirstSection = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFirstSection",
    componentId: "sc-0-1"
})(styles_templateObject1(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var StyledStoreWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledStoreWrapper",
    componentId: "sc-0-2"
})(styles_templateObject2());

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-content/index.tsx









var CampaignCardContent = function(props) {
    var className = props.className;
    var ref = (0,campaign_card_context/* useCampaignCardContext */.q)(), featured = ref.featured, previousPriceText = ref.previousPriceText, productRating = ref.productRating, productRatingCount = ref.productRatingCount;
    var ref1 = (0,product_card_context/* useProductCardContext */.I)(), _product = ref1.product, category = _product.category, name = _product.name, store = _product.store;
    return /*#__PURE__*/ react.createElement(StyledCardContent, {
        className: className
    }, /*#__PURE__*/ react.createElement(StyledFirstSection, null, (category === null || category === void 0 ? void 0 : category.name) && /*#__PURE__*/ react.createElement(variants/* CaptionText */.HB, {
        behavior: variants/* Behavior.OnelineEllipsis */.cg.OnelineEllipsis,
        emphasis: variants/* FontEmphasis.MEDIUM */.tu.MEDIUM
    }, category.name), /*#__PURE__*/ react.createElement(variants/* TitleSmallText */.QV, {
        behavior: variants/* Behavior.TwolineEllipsis */.cg.TwolineEllipsis,
        containerProps: {
            "data-test": "ProductName"
        }
    }, name), productRating && productRating > 0 ? /*#__PURE__*/ react.createElement(rating/* default */.Z, {
        rate: productRating,
        count: productRatingCount,
        showCounterAs: "number"
    }) : null), /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Badges, null), /*#__PURE__*/ react.createElement(Prices, null), /*#__PURE__*/ react.createElement(StyledStoreWrapper, null, /*#__PURE__*/ react.createElement(variants/* CaptionStrongText */.LH, {
        emphasis: featured ? variants/* FontEmphasis.HIGH */.tu.HIGH : variants/* FontEmphasis.LOW */.tu.LOW
    }, store === null || store === void 0 ? void 0 : store.name), previousPriceText && /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(variants/* CaptionText */.HB, null, "* ", previousPriceText)))));
};

// EXTERNAL MODULE: ./src/components/product-card-new/components/new-click-out-button.tsx
var new_click_out_button = __webpack_require__(50271);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-footer/styles.ts
function campaign_card_footer_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_card_footer_styles_templateObject() {
    var data = campaign_card_footer_styles_taggedTemplateLiteral([
        "\n  && {\n    padding-top: 0;\n    justify-content: end;\n    gap: ",
        ";\n  }\n"
    ]);
    campaign_card_footer_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_card_footer_styles_templateObject1() {
    var data = campaign_card_footer_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  width: 100%;\n"
    ]);
    campaign_card_footer_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_card_footer_styles_templateObject2() {
    var data = campaign_card_footer_styles_taggedTemplateLiteral([
        "\n  && {\n    text-decoration: underline;\n\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    campaign_card_footer_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}




var StyledFooter = (0,styled_components_browser_esm["default"])(card/* CardContent */.aY).withConfig({
    displayName: "StyledFooter",
    componentId: "sc-0-0"
})(campaign_card_footer_styles_templateObject(), base/* layout.measurements.spacing075 */.bK.measurements.spacing075);
var StyledStoreCountLink = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledStoreCountLink",
    componentId: "sc-0-1"
})(campaign_card_footer_styles_templateObject1());
var StyledLink = (0,styled_components_browser_esm["default"])(variants/* CaptionText */.HB).withConfig({
    displayName: "StyledLink",
    componentId: "sc-0-2"
})(campaign_card_footer_styles_templateObject2(), function(p) {
    return p.theme.text.callToAction;
});

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-footer/store-count-link.tsx






var StoreCountLink = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t;
    var ref1 = (0,campaign_card_context/* useCampaignCardContext */.q)(), handleCardOnClick = ref1.handleCardOnClick, productLink = ref1.productLink, storeCount = ref1.storeCount;
    return productLink && storeCount ? /*#__PURE__*/ react.createElement(StyledStoreCountLink, null, /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: productLink,
        onClick: handleCardOnClick,
        isExternal: renderMode === "native"
    }, /*#__PURE__*/ react.createElement(StyledLink, {
        color: variants/* FontColor.DARK */.rx.DARK,
        emphasis: variants/* FontEmphasis.MEDIUM */.tu.MEDIUM
    }, storeCount === 1 ? t("campaigns", "campaign-card.compare-prices") : t("campaigns", "campaign-card.compare-prices-from-shops", {
        count: storeCount
    })))) : null;
};

;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/campaign-card-footer/index.tsx






var CampaignCardFooter = function() {
    var ref = (0,campaign_card_context/* useCampaignCardContext */.q)(), featured = ref.featured, handleClickOut = ref.handleClickOut, offerLink = ref.offerLink;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(StyledFooter, null, featured ? /*#__PURE__*/ react.createElement(react.Fragment, null, offerLink && /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        href: offerLink,
        external: true,
        onClick: handleClickOut,
        text: t("product", "kwlp.visit-shop")
    }), /*#__PURE__*/ react.createElement(StoreCountLink, null)) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(new_click_out_button/* NewClickOutButton */.I, {
        external: true,
        href: null,
        text: t("product", "kwlp.visit-shop")
    }), /*#__PURE__*/ react.createElement(StoreCountLink, null)));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(88849);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/index.js
var design_tokens = __webpack_require__(43220);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+design-tokens@10.0.0/node_modules/@prisjakt/design-tokens/light-theme-colors.js
var light_theme_colors = __webpack_require__(24774);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/styles.ts
function campaign_card_styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function campaign_card_styles_templateObject() {
    var data = campaign_card_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n  background-color: ",
        ";\n"
    ]);
    campaign_card_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function campaign_card_styles_templateObject1() {
    var data = campaign_card_styles_taggedTemplateLiteral([
        "\n  height: 100%;\n  cursor: pointer;\n"
    ]);
    campaign_card_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function campaign_card_styles_templateObject2() {
    var data = campaign_card_styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  z-index: 3;\n\n  > button {\n    background-color: ",
        ";\n\n    &:hover {\n      background-color: ",
        ";\n    }\n  }\n\n  > .Floater {\n    left: unset;\n    right: 0;\n  }\n"
    ]);
    campaign_card_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = campaign_card_styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  white-space: nowrap;\n  cursor: pointer;\n  padding: ",
        ";\n  gap: ",
        ";\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}





var StyledCard = (0,styled_components_browser_esm["default"])(card/* Card */.Zb).withConfig({
    displayName: "StyledCard",
    componentId: "sc-0-0"
})(campaign_card_styles_templateObject(), function(p) {
    return p.theme.bg.primary;
});
var StyledCardActionArea = (0,styled_components_browser_esm["default"])(card/* CardActionArea */.MU).withConfig({
    displayName: "StyledCardActionArea",
    componentId: "sc-0-1"
})(campaign_card_styles_templateObject1());
var CardDropDown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "CardDropDown",
    componentId: "sc-0-2"
})(campaign_card_styles_templateObject2(), design_tokens.measurements.spacing075, design_tokens.measurements.spacing075, light_theme_colors.staticBase0, light_theme_colors.staticBase200);
var DropDownItem = styled_components_browser_esm["default"].button.withConfig({
    displayName: "DropDownItem",
    componentId: "sc-0-3"
})(styles_templateObject3(), design_tokens.measurements.spacing050, design_tokens.measurements.spacing050, light_theme_colors.staticBase200, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/notification-outlined/index.js
var notification_outlined = __webpack_require__(24823);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/flag-outlined/index.js
var flag_outlined = __webpack_require__(92826);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/heart-outlined/index.js
var heart_outlined = __webpack_require__(56698);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/menu-kebab/index.js
var menu_kebab = __webpack_require__(2794);
// EXTERNAL MODULE: ./src/areas/product/components/price-list/price-row/components/report-modal/index.tsx
var report_modal = __webpack_require__(65361);
// EXTERNAL MODULE: ./src/components/action-buttons/add-to-list/add-to-list-wrapper.tsx
var add_to_list_wrapper = __webpack_require__(95925);
// EXTERNAL MODULE: ./src/components/action-buttons/alert/alert-modal.tsx
var alert_modal = __webpack_require__(75927);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/components/card-dropdown/card-dropdown.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}













var CampaignCardDropDown = function() {
    var ref = (0,app_context/* useAppContext */.bp)(), renderMode = ref.renderMode, t = ref.t;
    var ref1 = (0,campaign_card_context/* useCampaignCardContext */.q)(), featured = ref1.featured, logo = ref1.logo, name = ref1.name, price = ref1.price, priceId = ref1.priceId, productId = ref1.productId, stockStatus = ref1.stockStatus, storeId = ref1.storeId, storeName = ref1.storeName;
    var ref2 = _slicedToArray((0,react.useState)(false), 2), reportModalIsOpen = ref2[0], setReportModalIsOpen = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)(false), 2), alertModalIsOpen = ref3[0], setAlertModalIsOpen = ref3[1];
    var nativeRenderMode = renderMode === "native";
    var openReportModal = (0,react.useCallback)(function(e) {
        e.preventDefault();
        e.stopPropagation();
        setReportModalIsOpen(true);
    }, [
        setReportModalIsOpen
    ]);
    var closeReportModal = (0,react.useCallback)(function() {
        return setReportModalIsOpen(false);
    }, [
        setReportModalIsOpen
    ]);
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(report_modal/* ReportModal */.y, {
        isOpen: reportModalIsOpen,
        closeModal: closeReportModal,
        priceId: String(priceId),
        priceValue: price,
        productName: name,
        productImage: logo,
        stockStatus: stockStatus,
        store: {
            id: storeId,
            name: storeName
        },
        isFeatured: featured
    }), /*#__PURE__*/ react.createElement(alert_modal/* AlertModal */.V, {
        closeModal: function() {
            return setAlertModalIsOpen(false);
        },
        isOpen: alertModalIsOpen,
        productId: productId
    }), /*#__PURE__*/ react.createElement(CardDropDown, {
        elevation: ui_button/* ButtonElevation.LOW */.Gi.LOW
    }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
        onlyIcon: true,
        type: ui_button/* ButtonType.OUTLINED */.L$.OUTLINED
    }, /*#__PURE__*/ react.createElement(menu_kebab/* IconMenuKebab */.Q, null)), /*#__PURE__*/ react.createElement(add_to_list_wrapper/* AddToListModalsWrapper */.w, {
        productId: productId,
        productName: name
    }, function(onListClick) {
        return /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, null, !nativeRenderMode && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(DropDownItem, {
            onClick: onListClick
        }, /*#__PURE__*/ react.createElement(heart_outlined/* IconHeartOutlined */.G, null), /*#__PURE__*/ react.createElement("span", null, t("lists", "list.save-to-new-list"))), /*#__PURE__*/ react.createElement(DropDownItem, {
            onClick: function() {
                return setAlertModalIsOpen(true);
            }
        }, /*#__PURE__*/ react.createElement(notification_outlined/* IconNotificationOutlined */.F, null), /*#__PURE__*/ react.createElement("span", null, t("alerts", "alert-form.create-button")))), /*#__PURE__*/ react.createElement(DropDownItem, {
            onClick: openReportModal
        }, /*#__PURE__*/ react.createElement(flag_outlined/* IconFlagOutlined */.b, null), /*#__PURE__*/ react.createElement("span", null, t("feedback", "dialog.prompt-button"))));
    })));
};

// EXTERNAL MODULE: ./src/components/product-card-new/components/deal-badge.tsx
var deal_badge = __webpack_require__(24938);
;// CONCATENATED MODULE: ./src/areas/campaign-v2/components/campaign-card/index.tsx










var CampaignCard = function(props) {
    var className = props.className;
    var ref = (0,campaign_card_context/* useCampaignCardContext */.q)(), handleCardOnClick = ref.handleCardOnClick, productLink = ref.productLink;
    var renderMode = (0,app_context/* useAppContext */.bp)().renderMode;
    var MARGIN_REM = 0.75;
    return /*#__PURE__*/ react.createElement(StyledCard, {
        className: className,
        paddingRem: MARGIN_REM
    }, /*#__PURE__*/ react.createElement(CampaignCardDropDown, null), /*#__PURE__*/ react.createElement(StyledCardActionArea, {
        container: clickable/* Clickable */.P,
        containerProps: {
            isExternal: renderMode === "native",
            onClick: handleCardOnClick,
            to: productLink
        }
    }, /*#__PURE__*/ react.createElement(deal_badge/* DealBadge */.H, null), /*#__PURE__*/ react.createElement(grid_card_header/* GridCardHeader */.S, {
        marginRem: MARGIN_REM
    }), /*#__PURE__*/ react.createElement(CampaignCardContent, null)), /*#__PURE__*/ react.createElement(CampaignCardFooter, null));
};


/***/ }),

/***/ 59273:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ campaign)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/querystring@0.2.1/node_modules/querystring/index.js
var querystring = __webpack_require__(97150);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/error-boundary/index.tsx + 1 modules
var error_boundary = __webpack_require__(51558);
// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var actions = __webpack_require__(46205);
// EXTERNAL MODULE: ./src/areas/campaign/components/deals/index.tsx + 2 modules
var deals = __webpack_require__(35014);
// EXTERNAL MODULE: ./src/components/collapsible/index.tsx + 1 modules
var collapsible = __webpack_require__(39509);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(64325);
// EXTERNAL MODULE: ./src/areas/campaign/components/banner/index.js
var banner = __webpack_require__(1793);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var ads = __webpack_require__(68748);
// EXTERNAL MODULE: ./src/components/viewport/context.tsx
var context = __webpack_require__(70477);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-header/styles.ts
var styles = __webpack_require__(81700);
;// CONCATENATED MODULE: ./src/areas/campaign/components/campaign-header/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var CampaignHeader = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref3.renderMode, t = ref3.t;
    var ref4 = (0,context/* useViewportContext */.Ak)(), isMobile = ref4.isMobile, isTablet = ref4.isTablet;
    var shouldCollapseDescription = isMobile || isTablet;
    var ref5 = _slicedToArray((0,react.useState)(shouldCollapseDescription), 2), descriptionCollapsed = ref5[0], setDescriptionCollapsed = ref5[1];
    var expandDescription = (0,react.useCallback)(function() {
        return setDescriptionCollapsed(false);
    }, []);
    var isCollapsed = shouldCollapseDescription && descriptionCollapsed;
    var ref6;
    return props.campaign ? /*#__PURE__*/ react.createElement(styles/* Header */.h4, null, /*#__PURE__*/ react.createElement(styles/* Container */.W2, null, /*#__PURE__*/ react.createElement(styles/* LogoAndText */.eH, null, /*#__PURE__*/ react.createElement(styles/* Logo */.TR, null, /*#__PURE__*/ react.createElement(banner/* default */.Z, {
        banners: props.campaign.banners,
        type: "banner_logo_big",
        alt: (ref = props.campaign.title) === null || ref === void 0 ? void 0 : ref.page
    })), /*#__PURE__*/ react.createElement(styles/* Content */.VY, null, /*#__PURE__*/ react.createElement(styles/* Title */.Dx, {
        "data-test": "CampaignHeaderTitle"
    }, (ref1 = props.campaign.facetted) === null || ref1 === void 0 ? void 0 : ref1.title), /*#__PURE__*/ react.createElement(collapsible/* Collapsible */.z, {
        collapsed: isCollapsed,
        expandText: t("symbols", "symbol.expand"),
        onExpand: expandDescription
    }, /*#__PURE__*/ react.createElement("p", {
        "data-test": "CampaignHeaderDescription",
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: (ref6 = (ref2 = props.campaign.facetted) === null || ref2 === void 0 ? void 0 : ref2.description) !== null && ref6 !== void 0 ? ref6 : ""
        }
    })))), renderMode === "desktop" && /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        format: "insider_1",
        placement: "small_insider_1",
        min: 640,
        max: 10000
    })), /*#__PURE__*/ react.createElement(styles/* Ads */.fi, null, /*#__PURE__*/ react.createElement(components_scroll/* ScrollElement */.xL, {
        name: "CampaignHeaderAd"
    }, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        format: "panorama_1",
        placement: "dubbelpanorama1",
        min: 0,
        max: 639
    })))) : null;
};
/* harmony default export */ const campaign_header = (CampaignHeader);

// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-inactive/index.js + 9 modules
var campaign_inactive = __webpack_require__(76291);
// EXTERNAL MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx + 1 modules
var breadcrumb = __webpack_require__(94410);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-articles/index.js + 1 modules
var campaign_articles = __webpack_require__(27774);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.js
var campaign_ids = __webpack_require__(59827);
;// CONCATENATED MODULE: ./src/areas/campaign/constants.ts
var RANGE_OPTIONS = [
    {
        key: "price",
        field: "price.offer",
        translation: "filter.price",
        showBars: false
    },
    {
        key: "productRating",
        field: "product.user_reviews.rating",
        translation: "filter.product-rating",
        showBars: true
    },
    {
        key: "storeRating",
        field: "store.user_reviews.rating",
        translation: "filter.store-rating",
        showBars: true
    }
];
var DEFAULT_VISIBLE_STORES = 5;
var FILTER_TYPE_MAP = {
    category: "list",
    price: "range",
    productRating: "range",
    storeRating: "range",
    stores: "list"
}; // Our Babel version doesn't support this yet 🤡
 // } satisfies Record<string, FilterTypes>;

;// CONCATENATED MODULE: ./src/areas/campaign/utils.ts
function utils_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return utils_arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || utils_unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function utils_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return utils_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return utils_arrayLikeToArray(o, minLen);
}


var buildRouter = function(location) {
    var qs = querystring.decode(location.search.substr(1));
    var router = {
        qs: qs,
        offset: qs.offset ? parseInt(qs.offset, 10) : 0,
        query: qs.query ? qs.query : "",
        sort: qs.sort,
        filterRanges: {},
        categories: qs.category ? qs.category.split("|") : [],
        stores: qs.stores ? qs.stores.split("|") : [],
        maxStores: parseInt(qs.max_stores, 10) || DEFAULT_VISIBLE_STORES
    };
    RANGE_OPTIONS.forEach(function(option) {
        router.filterRanges[option.key] = "";
        if (qs[option.key]) {
            var range = qs[option.key].split("-");
            if (range.length === 2) {
                router.filterRanges[option.key] = {
                    from: Number(range[0]),
                    to: Number(range[1])
                };
            }
        }
    });
    return router;
};
var findTreeNode = function(value, parents, tree) {
    if (!tree) return null;
    // Check all direct children
    var foundNode = tree.find(function(node) {
        return (node === null || node === void 0 ? void 0 : node.id) === value;
    });
    if (foundNode) {
        foundNode.parents = parents;
        return foundNode;
    }
    // Do recursive search if it wasn't found in the direct children
    tree.some(function(node) {
        if ((node === null || node === void 0 ? void 0 : node.children) && (node === null || node === void 0 ? void 0 : node.children.length) > 0) {
            // Add the current node id to the parents
            foundNode = findTreeNode(value, _toConsumableArray(parents !== null && parents !== void 0 ? parents : []).concat(_toConsumableArray(node.id ? [
                node.id
            ] : [])), node.children);
            if (foundNode) return true;
        }
        return false;
    });
    // Return result, will contain the node if found, otherwise false
    return foundNode;
};
var getSelectedFilters = function(router, stores, categoryTree, t) {
    var selectedFilters = [];
    // Add the filtered categories
    router.categories.forEach(function(id) {
        var node = findTreeNode(id, [], categoryTree);
        if ((node === null || node === void 0 ? void 0 : node.id) && node.name) {
            selectedFilters.push({
                id: node.id,
                name: node.name,
                type: "category",
                isGrouped: true
            });
        }
    });
    router.stores.forEach(function(id) {
        var store = stores.filter(function(x) {
            return x.id === id;
        });
        if (store.length > 0) {
            selectedFilters.push({
                id: store[0].id,
                name: store[0].name,
                type: "stores",
                isGrouped: true
            });
        }
    });
    // Add the filter ranges
    RANGE_OPTIONS.forEach(function(option) {
        if (router.filterRanges[option.key]) {
            var name = "".concat(t("campaigns", option.translation), ": ").concat(router.filterRanges[option.key].from, " - ").concat(router.filterRanges[option.key].to);
            selectedFilters.push({
                id: "".concat(router.filterRanges[option.key].from, "-").concat(router.filterRanges[option.key].to),
                name: name,
                type: option.key,
                isGrouped: false
            });
        }
    });
    return selectedFilters;
};
var adjustGroupedUrlParams = function(currentValues, newValue, keep, categoryTree) {
    var values = currentValues.split("|");
    var index = values.indexOf(newValue);
    // Exclude the value if it is found in the current key, add it otherwise
    if (index !== -1 && !keep) {
        values.splice(index, 1);
    } else {
        values.push(newValue);
    }
    // Only unique values
    values = _toConsumableArray(new Set(values));
    // Check if the new value was added
    if (values.includes(newValue)) {
        var node = findTreeNode(newValue, [], categoryTree);
        // Deselect any found parents
        if (node && node.parents && node.parents.length > 0) {
            values = values.filter(function(value) {
                var ref;
                return !((ref = node.parents) === null || ref === void 0 ? void 0 : ref.includes(value));
            });
        }
        // Deselct any found children
        if (node && node.children && node.children.length > 0) {
            if (values && values.length > 0) {
                values = values.filter(function(value) {
                    return value === newValue || !findTreeNode(value, [], node.children);
                });
            }
        }
    }
    return values.join("|");
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/index.js
var ui_button = __webpack_require__(75063);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./src/ui/block/index.ts
var block = __webpack_require__(51665);
// EXTERNAL MODULE: ./src/areas/campaign/query.js
var query = __webpack_require__(83151);
// EXTERNAL MODULE: ./src/areas/campaign/components/data/use-with-elastic.tsx
var use_with_elastic = __webpack_require__(24405);
;// CONCATENATED MODULE: ./src/areas/campaign/components/aggregations/index.tsx
function aggregations_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function aggregations_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function aggregations_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function aggregations_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function aggregations_slicedToArray(arr, i) {
    return aggregations_arrayWithHoles(arr) || aggregations_iterableToArrayLimit(arr, i) || aggregations_unsupportedIterableToArray(arr, i) || aggregations_nonIterableRest();
}
function aggregations_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return aggregations_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return aggregations_arrayLikeToArray(o, minLen);
}



var RATING_INTERVAL_SIZE = 2;
var createRatingFilter = function(field, selectedCategories, selectedStores) {
    return {
        filter: {
            bool: {
                must: [
                    {
                        range: _defineProperty({}, field, {
                            gt: 1
                        })
                    },
                    selectedCategories.length && {
                        terms: {
                            "product.category.path.id": selectedCategories
                        }
                    },
                    selectedStores.length && {
                        terms: {
                            "store.id": selectedStores
                        }
                    }
                ].filter(function(x) {
                    return x;
                })
            }
        },
        aggs: {
            bars: {
                histogram: {
                    field: field,
                    interval: RATING_INTERVAL_SIZE,
                    extended_bounds: {
                        min: 0,
                        max: 10
                    }
                }
            }
        }
    };
};
var aggregationFields = function(param) {
    var visibleCategories = param.visibleCategories, selectedCategories = param.selectedCategories, selectedStores = param.selectedStores, maxStores = param.maxStores;
    return {
        stores: {
            filter: {
                bool: {
                    must: [
                        selectedCategories.length && {
                            terms: {
                                "product.category.path.id": selectedCategories
                            }
                        }
                    ].filter(function(x) {
                        return x;
                    })
                }
            },
            aggs: {
                current: {
                    terms: {
                        field: "store.id",
                        size: maxStores
                    },
                    aggs: {
                        top_hits: {
                            top_hits: {
                                _source: [
                                    "store.id",
                                    "store.name"
                                ],
                                size: 1
                            }
                        }
                    }
                }
            }
        },
        category: {
            filter: {
                bool: {
                    must: [
                        {
                            terms: {
                                "product.category.path.id": visibleCategories
                            }
                        },
                        selectedStores.length && {
                            terms: {
                                "store.id": selectedStores
                            }
                        }
                    ].filter(function(x) {
                        return x;
                    })
                }
            },
            aggs: {
                current: {
                    terms: {
                        field: "product.category.path.id",
                        include: visibleCategories,
                        size: visibleCategories.length
                    }
                }
            }
        },
        prices: {
            filter: {
                bool: {
                    must: [
                        selectedCategories.length && {
                            terms: {
                                "product.category.path.id": selectedCategories
                            }
                        },
                        selectedStores.length && {
                            terms: {
                                "store.id": selectedStores
                            }
                        }
                    ].filter(function(x) {
                        return x;
                    })
                }
            },
            aggs: {
                max_price: {
                    max: {
                        field: "price.offer"
                    }
                },
                min_price: {
                    min: {
                        field: "price.offer"
                    }
                }
            }
        },
        store_rating: createRatingFilter("store.user_reviews.rating", selectedCategories, selectedStores),
        product_rating: createRatingFilter("product.user_reviews.rating", selectedCategories, selectedStores)
    };
};
var getVisibleCategories = function(tree, expanded) {
    var selected = [];
    var pusher = function(child) {
        selected.push(child.id);
        if (child.children && expanded.includes(child.id)) {
            child.children.forEach(pusher);
        }
    };
    tree.forEach(pusher);
    return selected;
};
var buildQuery = function(props) {
    var router = props.router;
    var levelOne = getVisibleCategories(props.categoryTree, props.expandedCategories);
    var aggs = aggregationFields({
        selectedCategories: props.router.categories,
        visibleCategories: getVisibleCategories(props.categoryTree, levelOne),
        selectedStores: props.router.stores,
        maxStores: props.router.maxStores
    });
    var body = {
        size: 0,
        aggs: aggs,
        query: {
            bool: {
                must: []
            }
        }
    };
    if (router.query) {
        body.query.bool.must.push((0,query/* default */.Z)(router.query));
    }
    return body;
};
var Aggregations = function(props) {
    var ref = aggregations_slicedToArray((0,react.useState)(), 2), responseData = ref[0], setResponseData = ref[1];
    var ref1 = aggregations_slicedToArray((0,react.useState)(buildQuery(props)), 2), currentQuery = ref1[0], setCurrentQuery = ref1[1];
    var fetchResponse = (0,use_with_elastic/* useElasticFetch */.Z)({
        query: currentQuery,
        campaignId: props.campaignId,
        timeout: 500
    });
    (0,react.useEffect)(function() {
        setCurrentQuery(buildQuery(props));
    }, [
        props.router
    ]);
    (0,react.useEffect)(function() {
        if (fetchResponse.fetching || responseData === fetchResponse.data) {
            return;
        }
        props.onSuccess(fetchResponse.data);
        setResponseData(fetchResponse.data);
    }, [
        fetchResponse
    ]);
    if (!responseData) {
        return null;
    }
    return props.render(responseData);
};

// EXTERNAL MODULE: ./src/areas/campaign/components/search/index.js + 1 modules
var search = __webpack_require__(82346);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/areas/campaign/components/popular/index.js



var Popular = function(props) {
    var items = props.filterPaths.map(function(item) {
        return /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            onClick: function(e) {
                e.preventDefault();
                props.onChange({
                    search: item.path,
                    title: item.title
                });
            },
            title: item.title,
            key: item.title,
            to: props.location.pathname + item.path
        }, item.title);
    });
    return /*#__PURE__*/ react.createElement("span", null, items);
};
var func = (prop_types_default()).func, arrayOf = (prop_types_default()).arrayOf, shape = (prop_types_default()).shape, string = (prop_types_default()).string;
Popular.propTypes = {
    onChange: func.isRequired,
    filterPaths: arrayOf(shape({
        title: string.isRequired,
        path: string.isRequired
    })).isRequired,
    location: shape({
        pathname: string
    }).isRequired
};
/* harmony default export */ const popular = (Popular);

// EXTERNAL MODULE: ./src/components/filters/index.ts + 18 modules
var filters = __webpack_require__(11498);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(5492);
;// CONCATENATED MODULE: ./src/areas/campaign/components/categories/index.js
function categories_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}





var mapCategories = function(categories, counters) {
    return categories.filter(function(item) {
        return counters[item.id];
    }).map(function(item) {
        var category = {
            id: item.id,
            name: item.name,
            products: counters[item.id] || 0
        };
        if (item.children) {
            category.children = mapCategories(item.children, counters);
        }
        return category;
    });
};
var findCategory = function(items, selected) {
    if (!selected.parents || selected.parents.length === 0) {
        return items.find(function(item) {
            return item.id === selected.value;
        });
    }
    return selected.parents.map(function(p) {
        return p.id;
    }).reverse().concat(selected.value).reduce(function(itemTree, curr) {
        var match = itemTree.find(function(node) {
            return node.id === curr;
        });
        if (match.id === selected.value) {
            return match;
        }
        return match.children;
    }, items);
};
var Categories = function(props) {
    var aggregation = props.aggregations || [];
    var counters = aggregation.reduce(function(all, curr) {
        return Object.assign(all, categories_defineProperty({}, curr.key, curr.doc_count));
    }, {});
    var categoryTree = props.categoryTree || [];
    var items = mapCategories(categoryTree, counters);
    return /*#__PURE__*/ react.createElement("span", null, items.length !== 0 && /*#__PURE__*/ react.createElement(filters/* List */.aV, {
        id: "category",
        values: items,
        selected: props.selected,
        onChange: function(selected) {
            props.onChange(selected, findCategory(items, selected));
        },
        expanded: props.expanded,
        onExpand: props.onExpand,
        autoSelectChildren: false
    }), items.length === 0 && /*#__PURE__*/ react.createElement(text_variants/* BodySmallText */.oI, {
        container: "p"
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "category.no-items")));
};
var categories_func = (prop_types_default()).func, object = (prop_types_default()).object, categories_arrayOf = (prop_types_default()).arrayOf, categories_string = (prop_types_default()).string, number = (prop_types_default()).number, array = (prop_types_default()).array, categories_shape = (prop_types_default()).shape;
Categories.propTypes = {
    onChange: categories_func.isRequired,
    currentState: object,
    aggregations: categories_arrayOf(categories_shape({
        key: categories_string,
        doc_count: number
    })),
    selected: categories_arrayOf(categories_string).isRequired,
    expanded: categories_arrayOf(categories_string).isRequired,
    onExpand: categories_func.isRequired,
    categoryTree: array,
    data: object,
    campaignId: number.isRequired
};
Categories.defaultProps = {
    aggregations: [],
    categoryTree: undefined,
    data: undefined,
    currentState: {
        selected: []
    }
};
/* harmony default export */ const categories = (Categories);

// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/areas/campaign/components/stores/index.js






var Stores = function(props) {
    var stores = props.stores, hasMore = props.hasMore;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!stores) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("span", null, stores.length > 0 && /*#__PURE__*/ react.createElement("span", null, /*#__PURE__*/ react.createElement(filters/* List */.aV, {
        id: "store",
        values: stores,
        selected: props.selected,
        onChange: function(selected) {
            props.onChange(selected);
        }
    }), hasMore && /*#__PURE__*/ react.createElement(components_button/* Button */.z, {
        variant: "text",
        color: "link",
        onClick: function() {
            props.onMoreChanged(!props.showingMore);
        }
    }, t("filter", props.showingMore ? "properties.quantity-show-less" : "properties.quantity-show-more"))), stores.length === 0 && /*#__PURE__*/ react.createElement("p", null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "store.no-items")));
};
var stores_arrayOf = (prop_types_default()).arrayOf, stores_func = (prop_types_default()).func, stores_number = (prop_types_default()).number, stores_object = (prop_types_default()).object, stores_shape = (prop_types_default()).shape, stores_string = (prop_types_default()).string, bool = (prop_types_default()).bool;
Stores.propTypes = {
    campaignId: stores_number.isRequired,
    data: stores_object,
    onChange: stores_func.isRequired,
    selected: stores_arrayOf(stores_string).isRequired,
    hasMore: bool.isRequired,
    showingMore: bool.isRequired,
    onMoreChanged: stores_func.isRequired,
    stores: stores_arrayOf(stores_shape({
        id: stores_string.isRequired,
        name: stores_string.isRequired,
        products: stores_number.isRequired
    }))
};
Stores.defaultProps = {
    data: null,
    stores: []
};
var mapStores = function(aggregations) {
    return aggregations && aggregations.stores && aggregations.stores.current && aggregations.stores.current.buckets && aggregations.stores.current.buckets.map(function(store) {
        return {
            id: "".concat(store.top_hits.hits.hits[0]._source.store.id),
            name: store.top_hits.hits.hits[0]._source.store.name,
            products: store.top_hits.hits.total
        };
    }) || [];
};
/* harmony default export */ const stores = (/*#__PURE__*/(0,react.memo)(Stores));

// EXTERNAL MODULE: ./src/components/tag/index.tsx + 1 modules
var tag = __webpack_require__(78653);
;// CONCATENATED MODULE: ./src/areas/campaign/components/tag-cloud/index.js





var getTag = function(item, onChange, isClearTag) {
    return /*#__PURE__*/ react.createElement(tag/* Tag */.V, {
        key: item.name,
        onClick: onChange,
        value: item.name,
        type: isClearTag ? "clear" : "default"
    });
};
var TagCloud = function(param) {
    var selected = param.selected, selectionsCount = param.selectionsCount, onChange = param.onChange, onClear = param.onClear;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, selectionsCount > 0 && selected.map(function(item) {
        return getTag(item, function() {
            return onChange({
                id: item.type,
                value: item.id,
                isGrouped: item.isGrouped
            });
        });
    }), selectionsCount > 1 && /*#__PURE__*/ react.createElement(react.Fragment, null, getTag({
        id: "0",
        type: "clear",
        name: t("campaigns", "filter.clear-button")
    }, onClear, true)));
};
var tag_cloud_shape = (prop_types_default()).shape, tag_cloud_arrayOf = (prop_types_default()).arrayOf, tag_cloud_string = (prop_types_default()).string, tag_cloud_func = (prop_types_default()).func, tag_cloud_number = (prop_types_default()).number, tag_cloud_bool = (prop_types_default()).bool;
TagCloud.propTypes = {
    selectionsCount: tag_cloud_number.isRequired,
    selected: tag_cloud_arrayOf(tag_cloud_shape({
        id: tag_cloud_string,
        name: tag_cloud_string,
        isGrouped: tag_cloud_bool.isRequired
    })).isRequired,
    onChange: tag_cloud_func.isRequired,
    onClear: tag_cloud_func.isRequired
};
/* harmony default export */ const tag_cloud = ((0,es/* connect */.$j)(function(state) {
    return state.areas.campaign;
})(/*#__PURE__*/ (0,react.memo)(TagCloud)));

;// CONCATENATED MODULE: ./src/areas/campaign/components/filters/ranges.js
function ranges_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function ranges_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return ranges_arrayLikeToArray(arr);
}
function ranges_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ranges_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function ranges_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ranges_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ranges_toConsumableArray(arr) {
    return ranges_arrayWithoutHoles(arr) || ranges_iterableToArray(arr) || ranges_unsupportedIterableToArray(arr) || ranges_nonIterableSpread();
}
function ranges_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return ranges_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ranges_arrayLikeToArray(o, minLen);
}
var _Math;




var MIN_RANGE_SIZE = 1;
var convertRating = function(rate) {
    return rate / 2;
};
var getPriceRangeData = function(data) {
    var min = data.aggregations.prices.min_price.value || 0;
    var max = data.aggregations.prices.max_price.value || 100;
    // Separate the min and max value if the difference is less than the given threshold
    if (max - min < MIN_RANGE_SIZE) {
        max += MIN_RANGE_SIZE * 3;
        if (min > 0) {
            min -= 1;
        }
    }
    min = Math.floor(min);
    max = Math.ceil(max);
    return {
        values: [
            {
                from: min,
                to: Math.round(max / 2),
                products: 0
            },
            {
                from: Math.round(max / 2),
                to: max,
                products: 0
            }
        ],
        min_value: min,
        max_value: max,
        max_matching_products: data.hits.total
    };
};
var getRatingRangeData = function(ratings) {
    return {
        values: ratings.map(function(agg, i, aggs) {
            return {
                from: aggs[i - 1] ? convertRating(aggs[i - 1].key) : 0,
                to: convertRating(agg.key),
                products: agg.doc_count
            };
        }).filter(function(rating) {
            return rating.from !== rating.to;
        }),
        min_value: 0,
        max_value: 5,
        max_matching_products: (_Math = Math).max.apply(_Math, ranges_toConsumableArray(ratings.map(function(r) {
            return r.doc_count;
        })))
    };
};
var getRangeData = function(data, field) {
    switch(field){
        case "storeRating":
            {
                return getRatingRangeData(data.aggregations.store_rating.bars.buckets);
            }
        case "productRating":
            {
                return getRatingRangeData(data.aggregations.product_rating.bars.buckets);
            }
        case "price":
            {
                return getPriceRangeData(data);
            }
        default:
            {
                return null;
            }
    }
};
var Ranges = function(props) {
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    if (!props.data) return null;
    var router = props.router, onChange = props.onChange, rangeOptions = props.rangeOptions;
    var filterRanges = _objectSpread({
        price: {
            from: props.data.aggregations.prices.min_price.value,
            to: props.data.aggregations.prices.max_price.value
        }
    }, router.filterRanges);
    var ranges = rangeOptions.map(function(option) {
        var title = t("campaigns", option.translation);
        return /*#__PURE__*/ react.createElement("span", {
            key: option.key
        }, /*#__PURE__*/ react.createElement("h6", null, title), /*#__PURE__*/ react.createElement(filters/* SingleRange */.BR, {
            id: option.key,
            key: option.key,
            type: "decimal",
            showBars: option.showBars,
            values: getRangeData(props.data, option.key),
            selected: filterRanges[option.key],
            onChange: function(selected) {
                var value = "";
                if (selected.value) {
                    // Move the slider to the closest 0.5
                    var valueFrom = Math.round(selected.value.from * 2) / 2;
                    var valueTo = Math.round(selected.value.to * 2) / 2;
                    value = "".concat(valueFrom, "-").concat(valueTo);
                }
                onChange({
                    id: option.key,
                    value: value,
                    keep: selected.value,
                    title: title
                });
            }
        }));
    });
    return /*#__PURE__*/ react.createElement("span", null, ranges);
};
var ranges_string = (prop_types_default()).string, ranges_func = (prop_types_default()).func, ranges_object = (prop_types_default()).object, ranges_shape = (prop_types_default()).shape, ranges_arrayOf = (prop_types_default()).arrayOf, ranges_bool = (prop_types_default()).bool, ranges_number = (prop_types_default()).number;
Ranges.propTypes = {
    data: ranges_object,
    router: ranges_shape({
        location: ranges_shape({
            pathname: ranges_string,
            search: ranges_string
        })
    }).isRequired,
    rangeOptions: ranges_arrayOf(ranges_shape({
        key: ranges_string,
        field: ranges_string,
        translation: ranges_string,
        showBars: ranges_bool
    })).isRequired,
    onChange: ranges_func.isRequired,
    campaignId: ranges_number.isRequired
};
Ranges.defaultProps = {
    data: undefined
};
/* harmony default export */ const ranges = (/*#__PURE__*/(0,react.memo)(Ranges));

// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var filter = __webpack_require__(18894);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(40300);
;// CONCATENATED MODULE: ./src/areas/campaign/components/filters/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 1 0%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 auto;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n        display: block;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    display: none;\n    position: fixed;\n    overflow: scroll;\n    top: 0;\n    bottom: 0;\n    background: white;\n    left: 0;\n    right: 0;\n    z-index: ",
        ";\n    padding: 0;\n\n    h2 {\n      display: none;\n    }\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    h6 {\n      font-size: 14px;\n      font-weight: 600;\n      padding: 0;\n      margin: 0;\n      margin-bottom: 10px;\n    }\n\n    ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    margin: 0;\n    padding-top: 120px;\n    padding-bottom: 60px;\n    border-bottom: none;\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid ",
        ";\n  &:last-child {\n    border-bottom: 0;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    border-bottom: 1px solid ",
        ";\n    position: fixed;\n    z-index: 10; /* To cover UI elements with abs position (ex. range slider) */\n    top: 0;\n    left: 0;\n    width: 100%;\n    background-color: ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  h4 {\n    text-align: left;\n    padding: 0 ",
        ";\n    margin-bottom: 0;\n    height: 40px;\n    line-height: 40px;\n    flex: auto;\n    button {\n      height: 40px;\n      width: 40px;\n      float: right;\n      cursor: pointer;\n    }\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    z-index: 10; /* To cover UI elements with abs position (ex. range slider) */\n    width: 100%;\n    padding: ",
        ";\n\n    button {\n      flex: auto;\n    }\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    margin-top: ",
        ";\n    margin-bottom: ",
        ";\n\n    h6 {\n      text-align: left;\n      font-size: ",
        ";\n    }\n    a {\n      display: inline-block;\n      margin-right: 15px;\n      margin-bottom: 2px;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n  background-color: ",
        ";\n\n  a {\n    display: block;\n    margin-right: ",
        ";\n    margin-bottom: ",
        ";\n    text-decoration: underline;\n  }\n\n  ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n        display: block;\n      "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 100%;\n    display: none;\n\n    ",
        "\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    max-width: 220px;\n    padding-right: ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n    display: inline-block;\n    margin-right: ",
        ";\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        ";\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: wrap;\n    margin-top: ",
        ";\n    padding-bottom: ",
        ";\n    width: 100%;\n\n    &:empty{\n      display: none;\n    }\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-top: ",
        ";\n\n  & > * {\n    margin-right: ",
        ";\n    margin-bottom: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}



var flexStyle = (0,styled_components_browser_esm.css)(_templateObject1(), base/* media.largeUp */.BC.largeUp(_templateObject()));
var dividerStyle = (0,styled_components_browser_esm.css)(_templateObject3(), base/* layout.measurements.spacing200 */.bK.measurements.spacing200, base/* media.mediumDown */.BC.mediumDown(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledFilters = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilters",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), base/* media.mediumDown */.BC.mediumDown(_templateObject5(), zindex/* zindex.menu.filter */.Y.menu.filter, props.$show && (0,styled_components_browser_esm.css)(_templateObject4())));
});
var StyledFilter = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilter",
    componentId: "sc-0-1"
})(_templateObject8(), function(p) {
    return p.theme.lines.secondary;
}, base/* media.mediumDown */.BC.mediumDown(_templateObject7()));
var StyledFilterContent = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilterContent",
    componentId: "sc-0-2"
})(_templateObject10(), base/* media.mediumDown */.BC.mediumDown(_templateObject9(), base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem, base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem));
var StyledFiltersHeader = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFiltersHeader",
    componentId: "sc-0-3"
})(_templateObject12(), base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem, base/* media.mediumDown */.BC.mediumDown(_templateObject11(), function(p) {
    return p.theme.lines.primary;
}, function(p) {
    return p.theme.bg.primary;
}));
var StyledFiltersButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFiltersButton",
    componentId: "sc-0-4"
})(_templateObject14(), base/* media.mediumDown */.BC.mediumDown(_templateObject13(), base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem));
var StyledFiltersPopular = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFiltersPopular",
    componentId: "sc-0-5"
})(_templateObject16(), base/* layout.margins.wrapper.desktop.rem */.bK.margins.wrapper.desktop.rem, base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem, base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem, function(props) {
    return props.theme.colors.base100;
}, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject15(), base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem, base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem, base/* layout.margins.component.mobile.rem */.bK.margins.component.mobile.rem, base/* layout.measurements.fontSizeNormal */.bK.measurements.fontSizeNormal));
var StyledFiltersWrapper = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledFiltersWrapper",
    componentId: "sc-0-6"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject19(), flexStyle, (0,base/* remCalc */.vR)(11), base/* media.mediumDown */.BC.mediumDown(_templateObject18(), props.$show && (0,styled_components_browser_esm.css)(_templateObject17())));
});
var StyledFilterRanges = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilterRanges",
    componentId: "sc-0-7"
})(_templateObject20(), dividerStyle);
var StyledFilterShowButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledFilterShowButton",
    componentId: "sc-0-8"
})(_templateObject22(), base/* media.mediumDown */.BC.mediumDown(_templateObject21(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var StyledSearch = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledSearch",
    componentId: "sc-0-9"
})(_templateObject23(), base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var StyledTags = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledTags",
    componentId: "sc-0-10"
})(_templateObject25(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* media.mediumDown */.BC.mediumDown(_templateObject24(), base/* layout.margins.wrapper.mobile.rem */.bK.margins.wrapper.mobile.rem, base/* layout.measurements.spacing050 */.bK.measurements.spacing050));

;// CONCATENATED MODULE: ./src/areas/campaign/components/filters/index.tsx
function filters_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function filters_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function filters_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function filters_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function filters_slicedToArray(arr, i) {
    return filters_arrayWithHoles(arr) || filters_iterableToArrayLimit(arr, i) || filters_unsupportedIterableToArray(arr, i) || filters_nonIterableRest();
}
function filters_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return filters_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return filters_arrayLikeToArray(o, minLen);
}




















var CampaignFilters = function(props) {
    var buildRouter = props.buildRouter, campaign = props.campaign, categoryTree = props.categoryTree, clearFilter = props.clearFilter, executeSearch = props.executeSearch, router = props.router, selectedFilters = props.selectedFilters, setShowFilter = props.setShowFilter, setStores = props.setStores, showFilter = props.showFilter, updateUrlParams = props.updateUrlParams;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var ref = filters_slicedToArray((0,react.useState)([]), 2), expanded = ref[0], setExpanded = ref[1];
    var history = (0,react_router_dom/* useHistory */.k6)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var popularCampaignFilterPaths = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.popularCampaignFilterPaths;
    });
    var filterLayout = "campaign-filter";
    var selectionsCount = selectedFilters.length;
    if (!(campaign === null || campaign === void 0 ? void 0 : campaign.id)) return null;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(block/* MediumDown */.H5, null, /*#__PURE__*/ react.createElement(StyledTags, null, /*#__PURE__*/ react.createElement(StyledFilterShowButton, {
        "data-test": "FilterShowButton"
    }, /*#__PURE__*/ react.createElement(variants/* OutlinedButton */.Uc, {
        onClick: function() {
            return setShowFilter(true);
        },
        size: ui_button/* ButtonSize.SMALL */.qE.SMALL
    }, t("campaigns", "filter.show-button"))), selectionsCount > 0 && /*#__PURE__*/ react.createElement(tag_cloud, {
        selectionsCount: selectionsCount,
        selected: selectedFilters,
        onChange: function(item) {
            (0,filter/* trackFilterRemoveEvent */.YD)({
                value: item.value,
                scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                property: item.id,
                layout: filterLayout,
                type: FILTER_TYPE_MAP[item.id],
                campaign: campaign.name
            });
            updateUrlParams({
                key: item.id,
                value: item.value,
                isGrouped: item.isGrouped
            });
        },
        onClear: function() {
            clearFilter(true);
        }
    }))), /*#__PURE__*/ react.createElement(StyledFiltersWrapper, {
        $show: showFilter
    }, /*#__PURE__*/ react.createElement(StyledFilters, {
        $show: showFilter
    }, /*#__PURE__*/ react.createElement(StyledFilter, null, /*#__PURE__*/ react.createElement(StyledFilterContent, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, null, t("campaigns", "filter.title")), /*#__PURE__*/ react.createElement(block/* DesktopOnly */.NZ, null, /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(StyledSearch, {
        "data-test": "CampaignFilterSearch"
    }, /*#__PURE__*/ react.createElement(search/* default */.Z, {
        query: router.query,
        onSearch: function(item) {
            (0,filter/* trackFilterSelectEvent */.f9)({
                value: item.value,
                scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                property: "campaign-name-search",
                layout: filterLayout,
                type: "campaign-name-search",
                campaign: campaign.name
            });
            updateUrlParams({
                key: item.id,
                value: item.value
            });
        }
    })), /*#__PURE__*/ react.createElement(StyledTags, {
        "data-test": "CampaignSelectedFilterTags"
    }, selectionsCount > 0 && /*#__PURE__*/ react.createElement(tag_cloud, {
        selectionsCount: selectionsCount,
        selected: selectedFilters,
        onChange: function(item) {
            (0,filter/* trackFilterRemoveEvent */.YD)({
                value: item.value,
                scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                property: item.id,
                layout: filterLayout,
                type: FILTER_TYPE_MAP[item.id],
                campaign: campaign.name
            });
            updateUrlParams({
                key: item.id,
                value: item.value,
                isGrouped: item.isGrouped
            });
        },
        onClear: function() {
            clearFilter(true);
        }
    })))), /*#__PURE__*/ react.createElement(StyledFiltersPopular, {
        "data-test": "CampaignFiltersPopular"
    }, /*#__PURE__*/ react.createElement("h6", null, t("campaigns", "popular-filters.title")), popularCampaignFilterPaths ? /*#__PURE__*/ react.createElement(popular, {
        filterPaths: popularCampaignFilterPaths,
        location: history.location,
        onChange: function(item) {
            (0,filter/* trackFilterSelectEvent */.f9)({
                value: item.title,
                scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                property: "popular-deals-link",
                layout: filterLayout,
                type: "popular-deals",
                campaign: campaign.name
            });
            var routerParams = buildRouter(item);
            dispatch((0,actions/* campaignPopularQuery */.DO)(routerParams, popularCampaignFilterPaths === null || popularCampaignFilterPaths === void 0 ? void 0 : popularCampaignFilterPaths.find(function(filter) {
                return filter.path === item.search;
            })));
            setShowFilter(false);
            executeSearch(item.search);
        }
    }) : null), /*#__PURE__*/ react.createElement(Aggregations, {
        campaignId: campaign.id,
        router: router,
        categoryTree: categoryTree,
        expandedCategories: expanded,
        onSuccess: function(data) {
            setStores(mapStores(data.aggregations));
        },
        render: function(data) {
            var ref, ref1, ref2, ref3, ref4, ref5;
            var storeItems = data && mapStores(data.aggregations);
            if (!campaign.id) return null;
            return /*#__PURE__*/ react.createElement("div", {
                "data-test": "CampaignCategories"
            }, /*#__PURE__*/ react.createElement("h6", null, t("campaigns", "category.title")), /*#__PURE__*/ react.createElement(categories, {
                campaignId: campaign.id,
                aggregations: data === null || data === void 0 ? void 0 : (ref = data.aggregations) === null || ref === void 0 ? void 0 : (ref1 = ref.category) === null || ref1 === void 0 ? void 0 : ref1.current.buckets,
                onChange: function(item, category) {
                    if (item.checked) {
                        (0,filter/* trackFilterSelectEvent */.f9)({
                            value: category.id,
                            scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                            property: "category",
                            layout: filterLayout,
                            type: "list",
                            campaign: campaign.name
                        });
                    } else {
                        (0,filter/* trackFilterRemoveEvent */.YD)({
                            value: category.id,
                            scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                            property: "category",
                            layout: filterLayout,
                            type: "list",
                            campaign: campaign.name
                        });
                    }
                    updateUrlParams({
                        key: "category",
                        value: item.value,
                        isGrouped: true
                    });
                    dispatch((0,actions/* campaignCategoryFilter */.KL)(category));
                },
                categoryTree: categoryTree,
                selected: router.categories,
                expanded: expanded,
                onExpand: function(e, id) {
                    e.preventDefault();
                    setExpanded(function(prevState) {
                        return prevState.includes(id) ? prevState.filter(function(item) {
                            return item !== id;
                        }) : prevState.concat([
                            id
                        ]);
                    });
                }
            }), /*#__PURE__*/ react.createElement(StyledFilterRanges, null, /*#__PURE__*/ react.createElement(ranges, {
                campaignId: campaign.id,
                data: data,
                router: router,
                rangeOptions: RANGE_OPTIONS,
                onChange: function(item) {
                    (0,filter/* trackFilterSelectEvent */.f9)({
                        value: "".concat(item.keep.from, " - ").concat(item.keep.to),
                        scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                        property: item.id,
                        layout: filterLayout,
                        type: "range",
                        campaign: campaign.name
                    });
                    updateUrlParams({
                        key: item.id,
                        value: item.value,
                        keep: item.keep
                    });
                    dispatch((0,actions/* campaignsRangeFilter */.mV)(item));
                }
            })), /*#__PURE__*/ react.createElement("h6", null, t("campaigns", "store.title")), /*#__PURE__*/ react.createElement(stores, {
                campaignId: campaign.id,
                stores: storeItems,
                hasMore: Boolean(data && ((ref2 = data.aggregations) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.stores) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.current) === null || ref4 === void 0 ? void 0 : ref4.sum_other_doc_count) && ((ref5 = data.aggregations.stores.current) === null || ref5 === void 0 ? void 0 : ref5.sum_other_doc_count) > 0),
                showingMore: Boolean(storeItems && storeItems.length > DEFAULT_VISIBLE_STORES),
                onChange: function(item) {
                    if (item.selected) {
                        (0,filter/* trackFilterSelectEvent */.f9)({
                            value: item.value,
                            scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                            property: item.id,
                            layout: filterLayout,
                            type: "list",
                            campaign: campaign.name
                        });
                    } else {
                        (0,filter/* trackFilterRemoveEvent */.YD)({
                            value: item.value,
                            scope: filter/* FilterScope.CAMPAIGN */.ri.CAMPAIGN,
                            property: item.id,
                            layout: filterLayout,
                            type: "list",
                            campaign: campaign.name
                        });
                    }
                    updateUrlParams({
                        key: "stores",
                        value: item.value,
                        isGrouped: true
                    });
                },
                onMoreChanged: function(showMore) {
                    if (showMore) {
                        updateUrlParams({
                            key: "max_stores",
                            value: 100
                        });
                    } else {
                        updateUrlParams({
                            key: "max_stores",
                            value: DEFAULT_VISIBLE_STORES
                        });
                    }
                },
                selected: router.stores
            }));
        }
    }))), /*#__PURE__*/ react.createElement(StyledFiltersHeader, null, /*#__PURE__*/ react.createElement("h4", null, t("campaigns", "filter.title"), /*#__PURE__*/ react.createElement("button", {
        type: "button",
        onClick: function() {
            return setShowFilter(false);
        }
    }, /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null))), /*#__PURE__*/ react.createElement(StyledFiltersButton, {
        "data-test": "FiltersButton"
    }, /*#__PURE__*/ react.createElement(ui_button/* Button */.zx, {
        type: selectionsCount === 0 ? ui_button/* ButtonType.OUTLINED */.L$.OUTLINED : ui_button/* ButtonType.PRIMARY */.L$.PRIMARY,
        onClick: function() {
            return setShowFilter(false);
        }
    }, t("campaigns", "filter.apply-button")))))));
};

// EXTERNAL MODULE: ./src/hooks/use-matched-route.ts
var use_matched_route = __webpack_require__(76493);
// EXTERNAL MODULE: ./src/areas/campaign/queries/useCampaignPageQuery.ts
var useCampaignPageQuery = __webpack_require__(91854);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./src/areas/campaign/styles.ts
var campaign_styles = __webpack_require__(63593);
;// CONCATENATED MODULE: ./src/areas/campaign/campaign.tsx
function campaign_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function campaign_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function campaign_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function campaign_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function campaign_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function campaign_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            campaign_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function campaign_slicedToArray(arr, i) {
    return campaign_arrayWithHoles(arr) || campaign_iterableToArrayLimit(arr, i) || campaign_unsupportedIterableToArray(arr, i) || campaign_nonIterableRest();
}
function campaign_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return campaign_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return campaign_arrayLikeToArray(o, minLen);
}





















var CampaignPageLoader = function() {
    var route = (0,use_matched_route/* useMatchedRoute */.M)();
    var ref = (0,useCampaignPageQuery/* useCampaignPageQuery */.K)(route === null || route === void 0 ? void 0 : route.variables), isLoading = ref.isLoading, isSuccess = ref.isSuccess, data = ref.data;
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data ? /*#__PURE__*/ react.createElement(CampaignPageComponent, {
        campaign: data.campaign,
        categoryTree: data.categoryTree,
        campaigns: data.campaigns,
        campaignDeals: data.campaignDeals
    }) : null);
};
var CampaignPageComponent = function(param) {
    var campaign = param.campaign, categoryTree = param.categoryTree, campaigns = param.campaigns, campaignDeals = param.campaignDeals;
    var ref;
    var ref1 = (0,app_context/* useAppContext */.bp)(), renderMode = ref1.renderMode, t = ref1.t;
    var history = (0,react_router_dom/* useHistory */.k6)();
    var location = (0,react_router_dom/* useLocation */.TH)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = campaign_slicedToArray((0,react.useState)(false), 2), showFilter = ref2[0], setShowFilter = ref2[1];
    var ref3 = campaign_slicedToArray((0,react.useState)(buildRouter(location)), 2), router = ref3[0], setRouter = ref3[1];
    var ref4 = campaign_slicedToArray((0,react.useState)([]), 2), stores = ref4[0], setStores = ref4[1];
    var selectedFilters = getSelectedFilters(router, stores, categoryTree, t);
    var featuredArticle = (campaign === null || campaign === void 0 ? void 0 : campaign.articles) ? campaign === null || campaign === void 0 ? void 0 : campaign.articles.find(function(item) {
        return item === null || item === void 0 ? void 0 : item.featured;
    }) : null;
    var activeCampaign = (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "ACTIVE";
    var activeCampaigns = campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== (campaign === null || campaign === void 0 ? void 0 : campaign.id) && (item === null || item === void 0 ? void 0 : item.state) === "ACTIVE";
    });
    var dailyDeals = activeCampaigns === null || activeCampaigns === void 0 ? void 0 : activeCampaigns.find(function(c) {
        return (c === null || c === void 0 ? void 0 : c.id) === campaign_ids/* DAILY_DEALS_ID */.Wf;
    });
    var afterUpdateParams = function(url, routerParams) {
        history.replace(url);
        dispatch((0,actions/* campaignQuery */.Bp)(routerParams));
    };
    (0,react.useEffect)(function() {
        // Send initial query form url
        dispatch((0,actions/* campaignQuery */.Bp)(router));
    }, []);
    var updateUrlParams = function(item) {
        var key = item.key, value = item.value, isGrouped = item.isGrouped, keep = item.keep, _deleteOffset = item.deleteOffset, deleteOffset = _deleteOffset === void 0 ? true : _deleteOffset;
        var qs = router.qs;
        var qsKey = qs[key];
        var newValue = value;
        if (qsKey && isGrouped) {
            newValue = adjustGroupedUrlParams(qsKey, String(newValue), Boolean(keep), categoryTree);
        } else if (qs[key] && newValue === qs[key] && !keep) {
            // The value was found in the query string and is equal to the given value, delete it
            newValue = undefined;
            delete qs[key];
        }
        // Remove all filter ranges if the query is changed
        if (key === "query") {
            Object.keys(router.filterRanges).forEach(function(filterKey) {
                delete qs[filterKey];
            });
            // Sort on relevance if the query string isn't empty
            qs.sort = newValue ? "relevance" : "product.popularity.total";
        }
        var newParams = qs;
        if (newValue) {
            newParams = _objectSpreadProps(campaign_objectSpread({}, newParams), campaign_defineProperty({}, key, String(newValue)));
        } else {
            // Remove the key if no value exists
            delete qs[key];
        }
        if (deleteOffset) {
            // Remove any potential offset if the url params are updated
            delete newParams.offset;
        }
        var search = Object.keys(newParams).length > 0 ? "?".concat(querystring.encode(newParams)) : "";
        executeSearch(search);
    };
    var executeSearch = function(search) {
        var url = history.location.pathname + search;
        var routerParams = buildRouter({
            pathname: history.location.pathname,
            search: search
        });
        setRouter(routerParams);
        afterUpdateParams(url, routerParams);
    };
    var clearFilter = function(keepSort) {
        executeSearch(keepSort ? "?".concat(querystring.encode({
            sort: router.sort
        })) : "");
    };
    if (!(campaign === null || campaign === void 0 ? void 0 : campaign.id)) return null;
    return /*#__PURE__*/ react.createElement(campaign_styles/* StyledCampaign */.GC, null, renderMode !== "native" && /*#__PURE__*/ react.createElement(breadcrumb/* default */.Z, null), /*#__PURE__*/ react.createElement(campaign_header, {
        campaign: campaign
    }), activeCampaign ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(campaign_styles/* StyledGutterWrapper */.bi, null, /*#__PURE__*/ react.createElement(campaign_styles/* StyledProductWrapper */.UH, null, /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(CampaignFilters, {
        buildRouter: buildRouter,
        campaign: campaign,
        categoryTree: categoryTree,
        clearFilter: clearFilter,
        executeSearch: executeSearch,
        router: router,
        selectedFilters: selectedFilters,
        setShowFilter: setShowFilter,
        setStores: setStores,
        showFilter: showFilter,
        updateUrlParams: updateUrlParams
    })), /*#__PURE__*/ react.createElement(campaign_styles/* StyledProducts */.Ki, null, /*#__PURE__*/ react.createElement(deals/* Deals */.Y, {
        campaignId: campaign.id,
        campaignName: campaign.name,
        router: router,
        rangeOptions: RANGE_OPTIONS,
        onChange: function(item) {
            return updateUrlParams({
                key: item.id,
                value: item.value,
                deleteOffset: item.deleteOffset
            });
        },
        onClear: function() {
            clearFilter(false);
        }
    })))), !(campaign === null || campaign === void 0 ? void 0 : (ref = campaign.facetted) === null || ref === void 0 ? void 0 : ref.isFacetted) && /*#__PURE__*/ react.createElement(error_boundary/* default */.Z, {
        onError: function() {
            return null;
        }
    }, /*#__PURE__*/ react.createElement(campaign_articles/* default */.Z, {
        featuredArticle: featuredArticle,
        articles: campaign === null || campaign === void 0 ? void 0 : campaign.articles,
        campaignName: campaign.name
    }))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(campaign_inactive/* default */.Z, {
        targetDate: (campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start) ? Number((campaign === null || campaign === void 0 ? void 0 : campaign.countdown) || (campaign === null || campaign === void 0 ? void 0 : campaign.start)) : undefined,
        campaign: campaign,
        dailyDeals: dailyDeals,
        router: router,
        campaignDeals: campaignDeals
    }), /*#__PURE__*/ react.createElement(campaign_styles/* StyledCampaignGrouping */.h3, {
        title: t("campaigns", "themes.ongoing-campaigns"),
        campaigns: activeCampaigns
    })));
};
/* harmony default export */ const campaign = (CampaignPageLoader);


/***/ }),

/***/ 94410:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ breadcrumb)
});

// UNUSED EXPORTS: CampaignBreadcrumb

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/breadcrumbs/index.js
var breadcrumbs = __webpack_require__(58079);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin: ",
        " 0 ",
        "\n    ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var BreadCrumbWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BreadCrumbWrapper",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
;// CONCATENATED MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var CampaignBreadcrumb = function(props) {
    var campaign = props.campaign;
    var t = (0,app_context/* useAppContext */.bp)().t;
    var base = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.campaign.base;
    });
    var getBreadcrumbPath = function() {
        var path = _toConsumableArray(base ? [
            {
                id: "campaigns",
                name: t("campaigns", "themes.breadcrumb"),
                pathName: base
            }
        ] : []);
        if (campaign) {
            if (base) {
                path.push({
                    id: "".concat(campaign.id),
                    name: campaign.name || "",
                    pathName: "".concat(base, "/").concat(campaign.slug)
                });
            }
            if (props.article) {
                path.push({
                    id: "".concat(props.article.id),
                    name: props.article.title,
                    pathName: props.article.pathName
                });
            }
        }
        return path;
    };
    var paths = getBreadcrumbPath();
    return /*#__PURE__*/ react.createElement(BreadCrumbWrapper, null, /*#__PURE__*/ react.createElement(breadcrumbs/* Breadcrumbs */.O, {
        containerProps: {
            onClick: function(nextPage) {
                (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.BREADCRUMB */.U.BREADCRUMB,
                    nextPage: nextPage
                });
            }
        }
    }, /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
        to: "/"
    }, t("common", "breadcrumb.home")), paths.map(function(crumb, index) {
        return paths.length - 1 === index ? /*#__PURE__*/ react.createElement("span", {
            key: crumb.id
        }, crumb.name) : /*#__PURE__*/ react.createElement(react_router_dom/* Link */.rU, {
            key: crumb.id,
            to: crumb.pathName
        }, crumb.name);
    })));
};
/* harmony default export */ const breadcrumb = (CampaignBreadcrumb);


/***/ }),

/***/ 81700:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "TR": () => (/* binding */ Logo),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "W2": () => (/* binding */ Container),
/* harmony export */   "eH": () => (/* binding */ LogoAndText),
/* harmony export */   "fi": () => (/* binding */ Ads),
/* harmony export */   "h4": () => (/* binding */ Header)
/* harmony export */ });
/* unused harmony export PeakIndex */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    display: block;\n    padding: ",
        " 0;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  padding: ",
        " ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    .legacy & {\n      width: 65%;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: 0;\n    width: 100%;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    padding: 0 20px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 5;\n  min-height: 164px;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    & img {\n      max-width: 65px;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: center;\n  & img {\n    max-width: 150px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  text-align: left;\n  color: #000;\n  & strong {\n    font-weight: inherit;\n    color: #d00;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    .legacy & {\n      padding-right: 30px;\n    }\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    padding-left: 20px;\n    & h1 {\n      font-size: ",
        ";\n    }\n    & p {\n      font-weight: ",
        ";\n    }\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n  padding-left: 30px;\n  flex-grow: 1;\n\n  & h1 {\n    font-weight: normal;\n    font-size: ",
        ";\n  }\n\n  & p {\n    color: ",
        ";\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-wrap: nowrap;\n    min-width: 100%;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  margin-bottom: ",
        ";\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 100%;\n    width: 100%;\n    padding-left: 0;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 200px;\n  width: 200px;\n  padding-left: 30px;\n  margin-bottom: ",
        ";\n  &:empty {\n    display: none;\n  }\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}


var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Header",
    componentId: "sc-0-0"
})(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing250 */ .bK.measurements.spacing250, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var Container = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject2()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject3()));
var Logo = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Logo",
    componentId: "sc-0-2"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5()));
var Title = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].h1.withConfig({
    displayName: "Title",
    componentId: "sc-0-3"
})(_templateObject7());
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-4"
})(_templateObject10(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(22), function(props) {
    return props.theme.text.secondary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject8()), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject9(), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(18), (0,src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .remCalc */ .vR)(13)));
var LogoAndText = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "LogoAndText",
    componentId: "sc-0-5"
})(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject11()));
var PeakIndex = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "PeakIndex",
    componentId: "sc-0-6"
})(_templateObject14(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject13()));
var Ads = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Ads",
    componentId: "sc-0-7"
})(_templateObject15());


/***/ }),

/***/ 24405:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useElasticFetch)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var __generator = undefined && undefined.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};


var defaultResponse = {
    data: {},
    fetching: true,
    error: null
};
var useElasticFetch = function(param) {
    var query = param.query, campaignId = param.campaignId, _timeout = param.timeout, timeout = _timeout === void 0 ? 500 : _timeout;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(defaultResponse), 2), response = ref[0], setResponse = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), initFetched = ref1[0], setInitFetched = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), 2), currentQuery = ref2[0], setCurrentQuery = ref2[1];
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .useAppContext */ .bp)().market;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (JSON.stringify(query) === JSON.stringify(currentQuery)) {
            return;
        }
        setCurrentQuery(query);
        if (!initFetched) {
            apiFetch();
            setInitFetched(true);
            return;
        }
        var timer = setTimeout(function() {
            apiFetch();
        }, timeout);
        // eslint-disable-next-line consistent-return
        return function() {
            return clearTimeout(timer);
        };
    }, [
        query
    ]);
    var apiFetch = function() {
        var _ref = _asyncToGenerator(function() {
            var searchUrl, options, request, jsonResponse, e;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setResponse(defaultResponse);
                        searchUrl = "".concat(market.campaignsBaseUrl, "/campaign-").concat(market.code, "-").concat(campaignId, "-deals/_search");
                        options = {
                            body: JSON.stringify(query),
                            method: "POST"
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            fetch(searchUrl, options)
                        ];
                    case 2:
                        request = _state.sent();
                        return [
                            4,
                            request.json()
                        ];
                    case 3:
                        jsonResponse = _state.sent();
                        setResponse({
                            data: jsonResponse,
                            fetching: false,
                            error: null
                        });
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e = _state.sent();
                        setResponse({
                            data: {},
                            fetching: false,
                            error: e.toString()
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function apiFetch() {
            return _ref.apply(this, arguments);
        };
    }();
    return response;
};


/***/ }),

/***/ 35014:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": () => (/* binding */ Deals)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@5.2.1_react@18.1.0/node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(86177);
// EXTERNAL MODULE: ./node_modules/.pnpm/query-string-for-all@6.8.3/node_modules/query-string-for-all/dist/index.js
var dist = __webpack_require__(25932);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/viewport/index.tsx
var viewport = __webpack_require__(49583);
// EXTERNAL MODULE: ./src/areas/campaign-v2/components/campaign-card/campaign-card-context.tsx
var campaign_card_context = __webpack_require__(90477);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(87838);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/hideable/index.js
var hideable = __webpack_require__(25411);
// EXTERNAL MODULE: ./src/components/number-pagination/index.tsx + 3 modules
var number_pagination = __webpack_require__(24843);
// EXTERNAL MODULE: ./src/components/scroll/index.ts + 2 modules
var components_scroll = __webpack_require__(64325);
// EXTERNAL MODULE: ./src/areas/campaign-v2/components/campaign-card/index.tsx + 10 modules
var campaign_card = __webpack_require__(54436);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./src/areas/product-collection/components/ads/index.tsx + 1 modules
var ads = __webpack_require__(81509);
// EXTERNAL MODULE: ./src/components/filter-dropdown/index.tsx + 1 modules
var filter_dropdown = __webpack_require__(70202);
// EXTERNAL MODULE: ./src/components/products-header/index.tsx + 2 modules
var products_header = __webpack_require__(69447);
// EXTERNAL MODULE: ./src/components/placeholder/index.tsx + 1 modules
var placeholder = __webpack_require__(49624);
// EXTERNAL MODULE: ./src/areas/campaign/query.js
var campaign_query = __webpack_require__(83151);
// EXTERNAL MODULE: ./src/areas/campaign/actions/index.js
var actions = __webpack_require__(46205);
// EXTERNAL MODULE: ./src/areas/campaign/tracking.js
var tracking = __webpack_require__(72862);
// EXTERNAL MODULE: ./src/areas/campaign/components/search/index.js + 1 modules
var components_search = __webpack_require__(82346);
// EXTERNAL MODULE: ./src/areas/campaign/components/data/use-with-elastic.tsx
var use_with_elastic = __webpack_require__(24405);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/areas/product-collection/components/offers-grid/index.tsx
var offers_grid = __webpack_require__(82094);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var components_ads = __webpack_require__(68748);
;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  width: 100%;\n  a {\n    display: block;\n    margin-top: 1rem;\n    text-decoration: underline;\n  }\n\n  ul {\n    padding-left: 40px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  div:empty,\n  a:empty {\n    height: 0;\n    padding: 0 !important;\n    border-bottom: 0 !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    justify-content: center;\n    color: ",
        ";\n    padding: ",
        " ",
        " ",
        " ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      display: block;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  width: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " && {\n        width: 100%;\n        order: 9;\n\n        @media screen and (max-width: 1023px) {\n          order: 11;\n        }\n        @media screen and (max-width: 824px) {\n          order: 9;\n        }\n        @media screen and (max-width: 340px) {\n          > iframe {\n            margin-left: ",
        ";\n            margin-right: ",
        ";\n          }\n        }\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " && {\n        max-width: 100%;\n        order: 9;\n\n        @media screen and (max-width: 1023px) {\n          order: 11;\n        }\n        @media screen and (max-width: 822px) {\n          order: 9;\n        }\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: 5px;\n  margin-bottom: 5px;\n\n  &:empty {\n    display: none;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      grid-template-columns: repeat(auto-fill, minmax(auto, calc(",
        " - ",
        ")))\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var compensateForPadding = base/* layout.gridColumnGutter.small.value */.bK.gridColumnGutter.small.value / 2;
var Empty = styled_components_browser_esm["default"].section.withConfig({
    displayName: "Empty",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.margins.component.desktop.rem */.bK.margins.component.desktop.rem);
var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Container",
    componentId: "sc-0-1"
})(_templateObject1());
var ProductCount = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductCount",
    componentId: "sc-0-2"
})(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2(), function(p) {
    return p.theme.colors.base600;
}, (0,base/* remCalc */.vR)(5), (0,base/* remCalc */.vR)(0), (0,base/* remCalc */.vR)(10), (0,base/* remCalc */.vR)(0)));
var SearchField = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchField",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.show && (0,styled_components_browser_esm.css)(_templateObject4());
});
var Panel = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Panel",
    componentId: "sc-0-4"
})(_templateObject6());
var Ad = (0,styled_components_browser_esm["default"])(components_ads/* default */.Z).withConfig({
    displayName: "",
    componentId: "sc-0-5"
})(_templateObject9(), function(props) {
    return props.mobilePosition && (0,styled_components_browser_esm.css)(_templateObject7(), Panel, compensateForPadding, compensateForPadding);
}, function(props) {
    return props.panoramaPosition && (0,styled_components_browser_esm.css)(_templateObject8(), Panel);
});
var ITEMS_DESKTOP = 3;
var SIZE_DESKTOP = "".concat(100 / ITEMS_DESKTOP, "%");
var GAP_DESKTOP = 1;
var GUTTER_DESKTOP = "(".concat(GAP_DESKTOP * (ITEMS_DESKTOP - 1), "rem / ").concat(ITEMS_DESKTOP, ")");
var DealsGrid = (0,styled_components_browser_esm["default"])(offers_grid/* OffersGrid */.u).withConfig({
    displayName: "DealsGrid",
    componentId: "sc-0-6"
})(_templateObject11(), base/* media.largeUp */.BC.largeUp(_templateObject10(), SIZE_DESKTOP, GUTTER_DESKTOP));

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/magnifier/index.js
var magnifier = __webpack_require__(58676);
// EXTERNAL MODULE: ./src/areas/product/actions/product.ts + 1 modules
var actions_product = __webpack_require__(9450);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking_tracking = __webpack_require__(42779);
// EXTERNAL MODULE: ./src/globals/tracking/conversion.ts
var conversion = __webpack_require__(77660);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(11235);
;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/types.ts
var SortOptionValueEnum;
(function(SortOptionValueEnum) {
    SortOptionValueEnum["RANK_DESC"] = "rank|desc";
    SortOptionValueEnum["PRODUCT_NAME_KEYWORD"] = "product.name.keyword";
    SortOptionValueEnum["PRODUCT_POPULARITY_TOTAL"] = "product.popularity.total";
    SortOptionValueEnum["PRICE_OFFER_ASC"] = "price.offer|asc";
    SortOptionValueEnum["PRICE_OFFER_DESC"] = "price.offer|desc";
    SortOptionValueEnum["PRODUCT_USER_REVIEWS_RATING_DESC"] = "product.user_reviews.rating|desc";
    SortOptionValueEnum["PRICE_DIFF_PERCENTAGE_DESC"] = "price.diff_percentage|desc";
    SortOptionValueEnum["RELEVANCE"] = "relevance";
})(SortOptionValueEnum || (SortOptionValueEnum = {}));

// EXTERNAL MODULE: ./src/globals/tracking/filter.ts
var filter = __webpack_require__(18894);
// EXTERNAL MODULE: ./src/components/product-card-new/product-card-context.tsx
var product_card_context = __webpack_require__(52416);
;// CONCATENATED MODULE: ./src/areas/campaign/components/deals/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
































var DEFAULT_SIZE = 24;
var DEFAULT_SORT = SortOptionValueEnum.RANK_DESC;
var RATING_OPTION_KEYS = [
    "productRating",
    "storeRating"
];
var ADS_LAYOUT = _defineProperty({}, types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 3
    },
    dubbelpanorama1: {
        show: false,
        row: 8
    },
    dubbelpanorama2: {
        show: true,
        row: 4
    }
});
var buildProductProps = function(_source, renderMode, market) {
    var ref;
    var link = market.useClassicUrls && market.domain ? _source.product.web_uri.split(market.domain)[1] // [<siteDomain>, '/product.php?p=xyz']
     : _source.product.semantic_id;
    if (renderMode === "desktop" && market.domain) {
        link = _source.product.web_uri.split(market.domain)[1];
    }
    if (renderMode === "native") {
        link = _source.product.web_uri;
    }
    var product = {
        id: _source.product.id,
        name: _source.product.name,
        rating: (_source.product.user_reviews.rating || 0) / 2,
        count: _source.product.user_reviews.count,
        price: (ref = _source.price) === null || ref === void 0 ? void 0 : ref.offer,
        link: link,
        mode: "grid",
        category: {
            name: _source.product.category.name
        },
        image: _source.product.media.product_images.first ? _source.product.media.product_images.first[280] : null,
        stockStatus: _source.product.stock_status
    };
    return product;
};
var Deals = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var onChange = props.onChange, onClear = props.onClear, router = props.router, _size = props.size, size = _size === void 0 ? DEFAULT_SIZE : _size, _showPagination = props.showPagination, showPagination = _showPagination === void 0 ? true : _showPagination, _showProductsHeader = props.showProductsHeader, showProductsHeader = _showProductsHeader === void 0 ? true : _showProductsHeader, campaignId = props.campaignId, campaignName = props.campaignName;
    var ref8 = (0,react.useContext)(app_context/* AppContext */.Il), market = ref8.market, renderMode = ref8.renderMode, t = ref8.t;
    var ref9 = (0,react.useContext)(viewport/* ViewportContext */.R), isMobile = ref9.isMobile, isTablet = ref9.isTablet;
    var search = (0,react_router/* useLocation */.TH)().search;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref10 = _slicedToArray((0,react.useState)(false), 2), showSearchField = ref10[0], setShowSearchField = ref10[1];
    var ref11 = _slicedToArray((0,react.useState)({}), 2), currentQuery = ref11[0], setCurrentQuery = ref11[1];
    var ref12 = _slicedToArray((0,react.useState)(""), 2), lastSearchQuery = ref12[0], setLastSearchQuery = ref12[1];
    var ref13 = (0,use_with_elastic/* useElasticFetch */.Z)({
        query: currentQuery,
        // eslint-disable-next-line object-shorthand
        campaignId: campaignId,
        timeout: router.query === lastSearchQuery ? 0 : 500
    }), fetching = ref13.fetching, data = ref13.data;
    (0,react.useEffect)(function() {
        setCurrentQuery(buildQuery(null, props));
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        var routerQuery = router.query || "";
        if (routerQuery === lastSearchQuery) {
            return;
        }
        setLastSearchQuery(routerQuery);
    }, [
        data
    ]);
    var sortOptions = [
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.RANK_DESC)),
            value: SortOptionValueEnum.RANK_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_NAME_KEYWORD)),
            value: SortOptionValueEnum.PRODUCT_NAME_KEYWORD
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL)),
            value: SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_OFFER_ASC)),
            value: SortOptionValueEnum.PRICE_OFFER_ASC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_OFFER_DESC)),
            value: SortOptionValueEnum.PRICE_OFFER_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC)),
            value: SortOptionValueEnum.PRODUCT_USER_REVIEWS_RATING_DESC
        },
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC)),
            value: SortOptionValueEnum.PRICE_DIFF_PERCENTAGE_DESC
        }
    ].concat(_toConsumableArray(router.sort === SortOptionValueEnum.RELEVANCE ? [
        {
            title: t("campaigns", "sort.".concat(SortOptionValueEnum.RELEVANCE)),
            value: SortOptionValueEnum.RELEVANCE
        }
    ] : []));
    var addStickyOffset = (0,react.useCallback)(function() {
        if (window.innerWidth < 640) {
            return 50;
        }
        return 70;
    }, []);
    var generatePaginationUrl = (0,react.useCallback)(function(pageNumber) {
        return "?".concat(dist_default().stringify(_objectSpreadProps(_objectSpread({}, dist_default().parse(search.substring(1))), {
            offset: pageNumber > 1 ? (pageNumber - 1) * size : undefined
        })));
    }, [
        search,
        size
    ]);
    var currentSort = ((ref = sortOptions.find(function(item) {
        return router.sort === item.value;
    })) === null || ref === void 0 ? void 0 : ref.value) || DEFAULT_SORT;
    var currentPage = typeof router.offset === "number" && typeof size === "number" ? Math.floor(router.offset / size) + 1 : 1;
    var handleSortChange = function(option) {
        if (option.value) {
            var ref = _slicedToArray(option.value.split("|"), 1), property = ref[0];
            (0,tracking/* trackSortOrderChange */.Od)(option.value);
            (0,filter/* trackSortingSelectEvent */.Em)({
                property: property,
                scope: filter/* SortingScope.CAMPAIGN */.ge.CAMPAIGN,
                campaign: campaignName,
                value: option.value
            });
            onChange({
                id: "sort",
                value: option.value
            });
        }
    };
    var productsCountText = ((ref1 = data.hits) === null || ref1 === void 0 ? void 0 : ref1.total) && ((ref2 = data.hits) === null || ref2 === void 0 ? void 0 : ref2.total) > 0 ? t("campaigns", "deals.n-products-subtitle", {
        n: data.hits.total
    }) : undefined;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, showProductsHeader && /*#__PURE__*/ react.createElement(products_header/* ProductsHeader */.i, {
        displayOptions: isMobile || isTablet ? /*#__PURE__*/ react.createElement("button", {
            "data-test": "ShowSearchButton",
            type: "button",
            onClick: function() {
                return setShowSearchField(function(state) {
                    return !state;
                });
            }
        }, /*#__PURE__*/ react.createElement(magnifier/* IconMagnifier */.j, {
            size: 27,
            color: "maybeBlue700"
        })) : null,
        sortOptions: /*#__PURE__*/ react.createElement(filter_dropdown/* FilterDropdown */.ML, {
            defaultSelected: sortOptions.find(function(option) {
                return option.value === currentSort;
            }),
            title: isMobile || isTablet ? "" : t("common", "sort.title"),
            options: sortOptions,
            onFilterChange: handleSortChange
        }),
        subtitle: isMobile || isTablet ? undefined : productsCountText,
        title: isMobile || isTablet ? undefined : t("campaigns", "products.title")
    }, isMobile || isTablet ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(hideable/* Hideable */.Kc, {
        collapse: ui/* Axis.Y */.RD.Y,
        visible: showSearchField,
        renderWhenHidden: true
    }, /*#__PURE__*/ react.createElement(SearchField, {
        show: showSearchField,
        "data-test": "SearchField"
    }, /*#__PURE__*/ react.createElement(components_search/* default */.Z, {
        query: router.query,
        onSearch: function(item) {
            return onChange(item);
        }
    }))), /*#__PURE__*/ react.createElement(ProductCount, {
        "data-test": "ProductCount"
    }, productsCountText)) : null), !fetching && (!((ref3 = data.hits) === null || ref3 === void 0 ? void 0 : ref3.hits) || data.hits.hits.length === 0) && /*#__PURE__*/ react.createElement(Empty, null, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "item.no-results.md"), /*#__PURE__*/ react.createElement(variants/* PrimaryButton */.KM, {
        onClick: onClear
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "campaigns"
    }, "link.view-all"))), ((ref4 = data.hits) === null || ref4 === void 0 ? void 0 : ref4.hits.length) ? /*#__PURE__*/ react.createElement(DealsGrid, {
        className: "deals-grid",
        offers: (ref5 = data.hits) === null || ref5 === void 0 ? void 0 : ref5.hits.map(function(param, index) {
            var _source = param._source, _id = param._id;
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
            var product = buildProductProps(_source, renderMode, market);
            var price = _source.price;
            var gridCardProps = {
                categoryName: product.category.name,
                featured: !!((ref = _source.store) === null || ref === void 0 ? void 0 : ref.featured),
                priceDrop: Math.round(((ref1 = _source.price) === null || ref1 === void 0 ? void 0 : ref1.diff_percentage) || 0),
                offerLink: _source.external_uri.replace("&api_client=1", "&api_client=1331"),
                logo: product.image || "",
                productLink: product.link,
                name: product.name,
                handleCardOnClick: function() {
                    dispatch((0,actions/* campaignItemClick */.d6)(_source));
                    (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
                        nextPage: product.link,
                        index: index
                    });
                },
                handleClickOut: function() {
                    dispatch((0,actions_product/* productPriceClick */.Po)(product.id, typeof product.price === "string" ? parseInt(product.price, 10) : product.price, true, "", false, "Deals"));
                    if (price) {
                        (0,conversion/* trackOfferClickWithRevenue */.Rx)({
                            scope: conversion/* TrackClickScope.CAMPAIGN_LIST_ITEM */.b8.CAMPAIGN_LIST_ITEM,
                            offerId: String(price === null || price === void 0 ? void 0 : price.id),
                            productId: product.id
                        });
                    }
                },
                priceId: (ref2 = _source.price) === null || ref2 === void 0 ? void 0 : ref2.id,
                price: typeof product.price === "string" ? parseInt(product.price, 10) : product.price,
                previousPrice: typeof (price === null || price === void 0 ? void 0 : (ref3 = price.display) === null || ref3 === void 0 ? void 0 : ref3.previousPrice) === "string" ? parseInt(price === null || price === void 0 ? void 0 : (ref4 = price.display) === null || ref4 === void 0 ? void 0 : ref4.previousPrice, 10) : null,
                previousPriceText: (price === null || price === void 0 ? void 0 : price.days_ago_compare) ? t("campaigns", "deals.price-n-days-ago", {
                    /* The date that days_ago_compare is based on is taken from just after midnight,

                                so from a user perspective it makes more sense to say that the comparison is
                                with the price from the day *before* that. A bit confusing, but that's how
                                it seems to work... */ count: price.days_ago_compare + 1
                }) : undefined,
                productRating: product.rating,
                productRatingCount: product.count,
                stockStatus: product.stockStatus,
                storeId: ((ref5 = _source.store) === null || ref5 === void 0 ? void 0 : ref5.id) || 0,
                storeName: ((ref6 = _source.store) === null || ref6 === void 0 ? void 0 : ref6.name) || "",
                storeCount: ((ref7 = _source.product.price) === null || ref7 === void 0 ? void 0 : ref7.count_regular) || 0,
                priceUpdateTime: "",
                productId: product.id
            };
            return /*#__PURE__*/ react.createElement(product_card_context/* ProductCardContextContainer */.h, {
                key: _id,
                diffPercentage: Math.round(((ref8 = _source.price) === null || ref8 === void 0 ? void 0 : ref8.diff_percentage) || 0),
                onClick: function() {
                    dispatch((0,actions/* campaignItemClick */.d6)(_source));
                    (0,tracking_tracking/* trackInternalNavigationClick */.p)({
                        scope: tracking_tracking/* InternalNavigationScope.CAMPAIGN_PRODUCT_CARD */.U.CAMPAIGN_PRODUCT_CARD,
                        nextPage: product.link,
                        index: index
                    });
                },
                product: _objectSpreadProps(_objectSpread({}, product), {
                    store: _source.store ? {
                        id: _source.store.id,
                        name: _source.store.name,
                        hasLogo: !!_source.store.logo,
                        featured: !!_source.store.featured
                    } : undefined,
                    media: {
                        first: product.image
                    }
                })
            }, /*#__PURE__*/ react.createElement(campaign_card_context/* CampaignCardContextContainer */.O, _extends({}, gridCardProps), /*#__PURE__*/ react.createElement(campaign_card/* CampaignCard */.p, null)));
        })
    }, /*#__PURE__*/ react.createElement(ads/* Ads */.f, {
        offersLength: ((ref6 = data.hits) === null || ref6 === void 0 ? void 0 : ref6.hits.length) || 0,
        layout: types/* LayoutMode.GRID */.X.GRID,
        layoutConfig: ADS_LAYOUT,
        scaleBase: "deals-grid",
        async: true
    })) : null, fetching && /*#__PURE__*/ react.createElement(placeholder/* Placeholder */.V, {
        height: 450,
        amount: 12,
        rows: 8
    }), showPagination && /*#__PURE__*/ react.createElement(components_scroll/* ScrollLink */.Rv, {
        to: "CampaignHeaderAd",
        shouldScroll: function(param) {
            var tagName = param.tagName;
            return tagName === "A";
        },
        animate: false,
        calculateOffset: addStickyOffset
    }, /*#__PURE__*/ react.createElement(number_pagination/* NumberPagination */.O, {
        currentPage: currentPage,
        totalPages: Math.ceil((((ref7 = data.hits) === null || ref7 === void 0 ? void 0 : ref7.total) || 0) / size),
        linkToPage: generatePaginationUrl,
        onClick: function(item) {
            onChange({
                id: "offset",
                value: item.pageNumber > 1 ? (item.pageNumber - 1) * size : 0,
                deleteOffset: false
            });
        }
    })));
};
var buildQuery = function(state, props) {
    var ref = _slicedToArray((props.router.sort || DEFAULT_SORT).split("|"), 2), sort = ref[0], order = ref[1];
    var offset = props.router.offset || 0;
    var _router = props.router, categories = _router.categories, query = _router.query, filterRanges = _router.filterRanges;
    var size = props.size;
    var stores = props.router.stores;
    if (props.stores && props.stores.length) {
        // Stores can come both from the url or as props. Props have the higher priority atm in order to prevent weird behavior.
        stores = props.stores;
    }
    var body = {
        _source: {
            include: [
                "price.display.*",
                "price.diff_percentage",
                "price.days_ago_compare",
                "price.id",
                "price.offer",
                "price.offer_incl_shipping",
                "product.id",
                "product.semantic_id",
                "product.web_uri",
                "product.mobile_web_uri",
                "product.name",
                "product.media",
                "product.price.count",
                "product.price.count_regular",
                "product.statistics.sparklines",
                "product.category.name",
                "product.user_reviews.rating",
                "product.user_reviews.count",
                "product.stock_status",
                "brand.logo",
                "brand.name",
                "store.name",
                "store.id",
                "store.logo",
                "store.featured",
                "external_uri"
            ]
        },
        from: offset,
        size: size || DEFAULT_SIZE
    };
    var selectionGroups = [];
    // Use the score first if the current sort is relevance
    body.sort = sort === SortOptionValueEnum.RELEVANCE ? [
        "_score"
    ] : [
        _defineProperty({}, sort, {
            order: order || "asc",
            unmapped_type: sort === SortOptionValueEnum.PRODUCT_NAME_KEYWORD ? "keyword" : "long"
        }),
        "_score"
    ];
    if (sort === DEFAULT_SORT.split("|")[0]) {
        body.sort.push(_defineProperty({}, SortOptionValueEnum.PRODUCT_POPULARITY_TOTAL, {
            unmapped_type: "long"
        }));
    }
    if (categories === null || categories === void 0 ? void 0 : categories.length) {
        selectionGroups.push({
            bool: {
                should: categories.map(function(value) {
                    return {
                        term: {
                            "product.category.path.id": value
                        }
                    };
                })
            }
        });
    }
    if (stores) {
        selectionGroups.push({
            bool: {
                should: stores.map(function(value) {
                    return {
                        term: {
                            "store.id": value
                        }
                    };
                })
            }
        });
    }
    body.query = {
        bool: {
            must: selectionGroups
        }
    };
    body.query.bool.filter = {
        bool: {
            must: []
        }
    };
    props.rangeOptions.forEach(function(option) {
        if (filterRanges && option.key && filterRanges[option.key]) {
            var filter = {
                range: {}
            };
            if (option.field) filter.range[option.field] = {
                gte: RATING_OPTION_KEYS.includes(option.key) ? filterRanges[option.key].from * 2 // Ratings are between 1-10
                 : filterRanges[option.key].from,
                lte: RATING_OPTION_KEYS.includes(option.key) ? filterRanges[option.key].to * 2 // Ratings are between 1-10
                 : filterRanges[option.key].to
            };
            if (body.query.bool.filter) body.query.bool.filter.bool.must.push(filter);
        }
    });
    if (query) {
        body.query.bool.must = body.query.bool.must.concat((0,campaign_query/* default */.Z)(query));
    }
    return body;
};


/***/ }),

/***/ 88267:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ themes)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/campaign/themes-query.graphql
var themes_query_graphql = __webpack_require__(55299);
var themes_query_graphql_default = /*#__PURE__*/__webpack_require__.n(themes_query_graphql);
// EXTERNAL MODULE: ./src/hooks/use-page-query.ts
var use_page_query = __webpack_require__(72518);
;// CONCATENATED MODULE: ./src/areas/campaign/queries/useThemesPageQuery.ts


function useThemesPageQuery() {
    return (0,use_page_query/* usePageQuery */.v)({
        query: (themes_query_graphql_default()),
        routeName: "themes"
    });
}

// EXTERNAL MODULE: ./src/components/page/index.ts + 7 modules
var page = __webpack_require__(42575);
// EXTERNAL MODULE: ./src/components/loader/index.tsx + 1 modules
var loader = __webpack_require__(56743);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var variants = __webpack_require__(79514);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/panel/index.js
var panel = __webpack_require__(39233);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    width: 100%;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  width: 300px;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



var ColumnWithGutter = (0,styled_components_browser_esm["default"])(variants/* Column */.sg).withConfig({
    displayName: "ColumnWithGutter",
    componentId: "sc-0-0"
})(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CampaignGraphic = styled_components_browser_esm["default"].img.withConfig({
    displayName: "CampaignGraphic",
    componentId: "sc-0-1"
})(_templateObject2(), base/* media.smallOnly */.BC.smallOnly(_templateObject1()));

// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-header/styles.ts
var styles = __webpack_require__(81700);
// EXTERNAL MODULE: ./src/areas/campaign/components/breadcrumb/index.tsx + 1 modules
var breadcrumb = __webpack_require__(94410);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/globals/helpers/campaign/campaign-ids.js
var campaign_ids = __webpack_require__(59827);
// EXTERNAL MODULE: ./src/areas/campaign/components/link/index.js + 1 modules
var components_link = __webpack_require__(93927);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/list-item.js









var formatDates = function(campaign, translationCode, timeZone) {
    var start = new Date(parseInt(campaign.start, 10));
    var end = new Date(parseInt(campaign.end, 10));
    var locale = translationCode.replace("_", "-").toLowerCase();
    var localeOptions = {
        month: "long",
        day: "numeric",
        timeZone: timeZone
    };
    var startDate = start.toLocaleString(locale, localeOptions);
    var endDate = end.toLocaleString(locale, localeOptions);
    return startDate === endDate ? startDate : "".concat(startDate, " - ").concat(endDate);
};
var ThemeListItem = function(param) {
    var campaign = param.campaign, translation = param.translation, timezone = param.timezone;
    return campaign ? /*#__PURE__*/ react.createElement(variants/* Row */.X2, {
        gap: 1,
        style: {
            flexWrap: "wrap"
        }
    }, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        linkContent: /*#__PURE__*/ react.createElement(CampaignGraphic, {
            src: campaign.media.images.featured,
            alt: campaign.title.short
        }),
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                nextPage: campaign.web_uri.responsive
            });
        }
    }), /*#__PURE__*/ react.createElement(variants/* Column */.sg, null, /*#__PURE__*/ react.createElement(components_link/* default */.Z, {
        campaign: campaign,
        linkContent: /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(text_variants/* H3Text */.I7, null, campaign.title.short), /*#__PURE__*/ react.createElement(text_variants/* BodyMediumText */.J$, {
            container: "p"
        }, campaign.description.short)),
        onClick: function() {
            return (0,tracking/* trackInternalNavigationClick */.p)({
                scope: tracking/* InternalNavigationScope.CAMPAIGN_GO_TO */.U.CAMPAIGN_GO_TO,
                nextPage: campaign.web_uri.responsive
            });
        }
    }), campaign.id !== campaign_ids/* DAILY_DEALS_ID */.Wf && /*#__PURE__*/ react.createElement(text_variants/* BodyMediumText */.J$, {
        container: "p"
    }, formatDates(campaign, translation, timezone)))) : null;
};
var shape = (prop_types_default()).shape, string = (prop_types_default()).string;
ThemeListItem.propTypes = {
    campaign: shape({
        title: shape({
            short: string
        }),
        description: shape({
            short: string
        })
    }).isRequired,
    translation: string.isRequired,
    timezone: string.isRequired
};
/* harmony default export */ const list_item = ((0,es/* connect */.$j)(function(state) {
    return {
        translation: state.areas.campaign.translation,
        timezone: state.areas.campaign.timezone
    };
})(ThemeListItem));

;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/component.tsx









var validCampaignTypes = [
    "OFFER"
];
var Themes = function(param) {
    var campaigns = param.campaigns;
    var ref = (0,app_context/* useAppContext */.bp)(), t = ref.t, market = ref.market;
    var _type, _type1;
    var getCampaigns = function(ongoing) {
        return campaigns === null || campaigns === void 0 ? void 0 : campaigns.filter(function(campaign) {
            return ongoing ? (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "ACTIVE" && validCampaignTypes.indexOf((_type = campaign.type) !== null && _type !== void 0 ? _type : "") >= 0 : (campaign === null || campaign === void 0 ? void 0 : campaign.state) === "UPCOMING" && validCampaignTypes.indexOf((_type1 = campaign.type) !== null && _type1 !== void 0 ? _type1 : "") >= 0;
        });
    };
    var ongoingCampaigns = getCampaigns(true);
    var upcomingCampaigns = getCampaigns(false);
    var imageHeaderSource = "".concat(market.cdn, "/g/campaigns/themes/campaigns-logo.png");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(breadcrumb/* default */.Z, null), /*#__PURE__*/ react.createElement(styles/* Header */.h4, null, /*#__PURE__*/ react.createElement(styles/* Container */.W2, null, /*#__PURE__*/ react.createElement(styles/* Logo */.TR, null, /*#__PURE__*/ react.createElement("img", {
        src: imageHeaderSource,
        alt: t("campaigns", "themes.title")
    })), /*#__PURE__*/ react.createElement(styles/* Content */.VY, null, /*#__PURE__*/ react.createElement(styles/* Title */.Dx, null, t("campaigns", "themes.title")), /*#__PURE__*/ react.createElement(text_variants/* BodyMediumText */.J$, {
        container: "p"
    }, t("campaigns", "themes.description"))))), /*#__PURE__*/ react.createElement(ColumnWithGutter, null, /*#__PURE__*/ react.createElement(variants/* Column */.sg, {
        gap: 4
    }, (ongoingCampaigns === null || ongoingCampaigns === void 0 ? void 0 : ongoingCampaigns.length) !== 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2"
    }, t("campaigns", "themes.ongoing-campaigns"))), /*#__PURE__*/ react.createElement(variants/* Column */.sg, {
        gap: 2
    }, ongoingCampaigns === null || ongoingCampaigns === void 0 ? void 0 : ongoingCampaigns.map(function(campaign) {
        return campaign && /*#__PURE__*/ react.createElement(list_item, {
            key: campaign.name,
            campaign: campaign
        });
    }))), (upcomingCampaigns === null || upcomingCampaigns === void 0 ? void 0 : upcomingCampaigns.length) !== 0 && /*#__PURE__*/ react.createElement(panel/* Panel */.s_, null, /*#__PURE__*/ react.createElement(panel/* PanelHeader */.V9, null, /*#__PURE__*/ react.createElement(panel/* PanelTitle */.pY, {
        container: "h2"
    }, t("campaigns", "themes.upcoming-campaigns"))), /*#__PURE__*/ react.createElement(variants/* Column */.sg, {
        gap: 2
    }, upcomingCampaigns.filter(function(campaign) {
        return (campaign === null || campaign === void 0 ? void 0 : campaign.type) === "OFFER";
    }).map(function(campaign) {
        return campaign && /*#__PURE__*/ react.createElement(list_item, {
            key: campaign.name,
            campaign: campaign
        });
    }))))));
};

;// CONCATENATED MODULE: ./src/areas/campaign/components/themes/index.tsx





var ThemesLoader = function() {
    var ref = useThemesPageQuery(), isLoading = ref.isLoading, isSuccess = ref.isSuccess, data = ref.data;
    if (!isLoading && !isSuccess) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(page/* PageContent */.JH, {
        withAds: true
    }, isLoading ? /*#__PURE__*/ react.createElement(loader/* default */.Z, null) : null, isSuccess && data.campaigns ? /*#__PURE__*/ react.createElement(Themes, {
        campaigns: data.campaigns
    }) : null);
};
/* harmony default export */ const themes = (ThemesLoader);


/***/ }),

/***/ 91854:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": () => (/* binding */ useCampaignPageQuery)
/* harmony export */ });
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41170);
/* harmony import */ var _query_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_query_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var src_hooks_use_page_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72518);


function useCampaignPageQuery(variables) {
    return (0,src_hooks_use_page_query__WEBPACK_IMPORTED_MODULE_1__/* .usePageQuery */ .v)({
        query: (_query_graphql__WEBPACK_IMPORTED_MODULE_0___default()),
        routeName: "campaign",
        variables: variables
    });
}


/***/ }),

/***/ 63593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GC": () => (/* binding */ StyledCampaign),
/* harmony export */   "Ki": () => (/* binding */ StyledProducts),
/* harmony export */   "UH": () => (/* binding */ StyledProductWrapper),
/* harmony export */   "W2": () => (/* binding */ gutterStyle),
/* harmony export */   "XX": () => (/* binding */ flexStyle),
/* harmony export */   "bi": () => (/* binding */ StyledGutterWrapper),
/* harmony export */   "h3": () => (/* binding */ StyledCampaignGrouping),
/* harmony export */   "hg": () => (/* binding */ dividerStyle)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var _components_campaign_group__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1603);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 1 0%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n  flex: 1 1 auto;\n\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  padding-left: ",
        ";\n  padding-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  padding-top: ",
        ";\n  padding-bottom: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}



var flexStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject1(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject()));
var gutterStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var dividerStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject3(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var StyledGutterWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledGutterWrapper",
    componentId: "sc-0-0"
})(_templateObject5(), flexStyle, gutterStyle);
var StyledCampaign = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].section.attrs({
    "data-test": "CampaignSection"
}).withConfig({
    displayName: "StyledCampaign",
    componentId: "sc-0-1"
})(_templateObject6(), function(p) {
    return p.theme.colors.base0;
});
var StyledProductWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "StyledProductWrapper",
    componentId: "sc-0-2"
})(_templateObject7());
var StyledProducts = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].section.withConfig({
    displayName: "StyledProducts",
    componentId: "sc-0-3"
})(_templateObject8(), flexStyle);
var StyledCampaignGrouping = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_components_campaign_group__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    displayName: "StyledCampaignGrouping",
    componentId: "sc-0-4"
})(_templateObject9(), gutterStyle, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);


/***/ }),

/***/ 32853:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ expert_avatar)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/user-avatar/index.tsx + 1 modules
var user_avatar = __webpack_require__(40142);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
;// CONCATENATED MODULE: ./src/components/prisjakt-icon/index.tsx


var PrisjaktIcon = function(param) {
    var className = param.className, _size = param.size, size = _size === void 0 ? 32 : _size, _color = param.color, color = _color === void 0 ? base/* brandColors.expert */.D2.expert : _color;
    return /*#__PURE__*/ react.createElement("svg", {
        className: className,
        width: size,
        height: size,
        viewBox: "0 0 40 40"
    }, /*#__PURE__*/ react.createElement("g", {
        fill: "none"
    }, /*#__PURE__*/ react.createElement("circle", {
        cx: "20",
        cy: "20",
        r: "20",
        fill: "#FFF"
    }), /*#__PURE__*/ react.createElement("path", {
        fill: color,
        d: "M19.984 0C31.03-.008 39.992 8.939 40 19.984 40.008 31.03 31.061 39.992 20.016 40 8.97 40.008.008 31.061 0 20.016V20C0 8.958 8.944.005 19.984 0zm8.7 7.728a15.03 15.03 0 00-17.388-.009l-1.98-1.98a17.878 17.878 0 00-3.55 3.55l1.976 1.976a15.06 15.06 0 00-.016 17.442l-1.968 1.97a17.937 17.937 0 003.548 3.55l1.965-1.967a15.029 15.029 0 0017.44-.009l1.966 1.965.44-.342a17.902 17.902 0 002.76-2.768l.343-.443-1.967-1.968A14.987 14.987 0 0035.02 20l-.005-.407a14.983 14.983 0 00-2.78-8.31l1.975-1.977a17.907 17.907 0 00-3.55-3.556zm-8.689 1.72c5.833.006 10.557 4.739 10.552 10.572-.005 5.833-4.738 10.557-10.571 10.551C14.142 30.566 9.418 25.833 9.424 20l.005-.336A10.562 10.562 0 0119.995 9.448zm-.017 5.535l-.265.007A5.014 5.014 0 0014.967 20a5.02 5.02 0 005.022 5.019 5.017 5.017 0 00-.01-10.036h-.001z"
    })));
};
/* harmony default export */ const prisjakt_icon = (PrisjaktIcon);

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  height: fit-content;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ExpertAvatar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-0"
})(_templateObject());
var ExpertIcon = (0,styled_components_browser_esm["default"])(prisjakt_icon).attrs({
    color: base/* brandColors.expert */.D2.expert
}).withConfig({
    displayName: "ExpertIcon",
    componentId: "sc-0-1"
})(_templateObject1());

;// CONCATENATED MODULE: ./src/areas/expert/components/expert-avatar/index.tsx





var expert_avatar_ExpertAvatar = function(param) {
    var avatar = param.avatar, className = param.className, displayName = param.displayName, link = param.link, size = param.size, hideExpertIcon = param.hideExpertIcon;
    var ref = (0,react.useContext)(app_context/* AppContext */.Il), renderMode = ref.renderMode, linkTo = ref.linkTo;
    var children = /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(user_avatar/* UserAvatar */.Y, {
        size: size,
        avatar: avatar,
        displayName: displayName
    }), !hideExpertIcon && /*#__PURE__*/ react.createElement(ExpertIcon, {
        size: size / 3
    }));
    return /*#__PURE__*/ react.createElement(ExpertAvatar, {
        className: className
    }, link ? /*#__PURE__*/ react.createElement(clickable/* Clickable */.P, {
        to: linkTo("expertProfile", {
            semantic_id: link || ""
        }, renderMode === "native" ? {
            view: "native"
        } : undefined)
    }, children) : children);
};
/* harmony default export */ const expert_avatar = (expert_avatar_ExpertAvatar);


/***/ }),

/***/ 69620:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": () => (/* binding */ Title),
/* harmony export */   "Gh": () => (/* binding */ FilterContainer),
/* harmony export */   "QE": () => (/* binding */ Subtitle),
/* harmony export */   "VY": () => (/* binding */ Content),
/* harmony export */   "YE": () => (/* binding */ Sidebar),
/* harmony export */   "ck": () => (/* binding */ Item),
/* harmony export */   "d2": () => (/* binding */ Article),
/* harmony export */   "h4": () => (/* binding */ Header),
/* harmony export */   "im": () => (/* binding */ Wrapper),
/* harmony export */   "iz": () => (/* binding */ Divider),
/* harmony export */   "jQ": () => (/* binding */ MediaImage),
/* harmony export */   "ll": () => (/* binding */ CardTitle),
/* harmony export */   "or": () => (/* binding */ Main),
/* harmony export */   "pU": () => (/* binding */ Media),
/* harmony export */   "zB": () => (/* binding */ MediaWrapper)
/* harmony export */ });
/* unused harmony exports AVATAR_SIZE, Info, ContentType, ExpertAvatar */
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var _prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5492);
/* harmony import */ var _components_expert_avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32853);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  a {\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    grid-template-columns: minmax(0, 1fr);\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n\n  ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  padding: ",
        ";\n  padding-top: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0 ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  &&,\n  > * {\n    font-size: ",
        ";\n    font-weight: 700;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      padding: 0;\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          display: none;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n\n      ",
        "\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    padding: 0 ",
        ";\n    flex-shrink: 0;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    padding-bottom: ",
        ";\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  grid-auto-flow: row;\n  padding: ",
        " 0;\n  row-gap: ",
        ";\n  height: max-content;\n\n  h1 {\n    margin: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n\n      &:not(:first-of-type) {\n        margin-top: ",
        ";\n      }\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        ";\n    display: grid;\n    grid-auto-flow: row;\n    row-gap: ",
        ";\n    order: 2;\n    margin-top: ",
        ";\n\n    a:not([class]) {\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n        text-decoration: underline;\n      }\n    }\n\n    ",
        ";\n\n    > h2,\n    > h3,\n    > *:last-child {\n      margin-bottom: 0;\n    }\n  "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-auto-flow: column;\n  align-items: center;\n  justify-content: start;\n  column-gap: ",
        ";\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: ",
        "px;\n    "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n  "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n      border-radius: 8px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 16px;\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  width: 100%;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n  grid-area: 1 / 1 / 4 / 2;\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    margin: ",
        " 0;\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  margin: ",
        " 0;\n\n  ",
        "\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  overflow-x: auto;\n  padding: 2px;\n\n  > button {\n    flex-shrink: 0;\n    margin-bottom: ",
        ";\n\n    :not(:last-child) {\n      margin-right: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}




var AVATAR_SIZE = 32;
var CardTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .TitleMediumText */ .tC).withConfig({
    displayName: "CardTitle",
    componentId: "sc-0-0"
})(_templateObject());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject2(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject1()));
var Main = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].main.withConfig({
    displayName: "Main",
    componentId: "sc-0-2"
})(_templateObject3());
var Article = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].article.withConfig({
    displayName: "Article",
    componentId: "sc-0-3"
})(_templateObject4(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Item = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Item",
    componentId: "sc-0-4"
})(_templateObject5(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100);
var Title = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .TitleMediumText */ .tC).withConfig({
    displayName: "Title",
    componentId: "sc-0-5"
})(_templateObject6(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium);
var Sidebar = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].aside.withConfig({
    displayName: "Sidebar",
    componentId: "sc-0-6"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject8(), p.viewport === "desktop" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7())), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.largeUp */ .BC.largeUp(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.viewport === "mobile" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9())));
});
var Header = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].header.withConfig({
    displayName: "Header",
    componentId: "sc-0-7"
})(_templateObject13(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject12(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050));
var _marginTop;
var Content = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Content",
    componentId: "sc-0-8"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject15(), p.fontSize || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeMedium */ .bK.measurements.fontSizeMedium, p.rowGap || src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, (_marginTop = p.marginTop) !== null && _marginTop !== void 0 ? _marginTop : src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.callToAction, p.theme.text.callToActionHover, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject14(), p.order || 2, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
});
var Info = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Info",
    componentId: "sc-0-9"
})(_templateObject16(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);
var Subtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_text_variants__WEBPACK_IMPORTED_MODULE_2__/* .TitleMediumText */ .tC).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-10"
})(_templateObject17());
var MediaWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MediaWrapper",
    componentId: "sc-0-11"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject19(), props.maxWidth && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), props.maxWidth));
});
var Media = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Media",
    componentId: "sc-0-12"
})(_templateObject20());
var MediaImage = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].img.withConfig({
    displayName: "MediaImage",
    componentId: "sc-0-13"
})(_templateObject22(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.smallOnly */ .BC.smallOnly(_templateObject21()));
var ContentType = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "ContentType",
    componentId: "sc-0-14"
})(_templateObject23(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, function(p) {
    return p.theme.text.secondary;
});
var ExpertAvatar = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_components_expert_avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    displayName: "ExpertAvatar",
    componentId: "sc-0-15"
})(_templateObject24());
var Divider = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].hr.withConfig({
    displayName: "Divider",
    componentId: "sc-0-16"
})(_templateObject26(), function(p) {
    return p.theme.colors.base200;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing300 */ .bK.measurements.spacing300, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject25(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200));
var FilterContainer = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "FilterContainer",
    componentId: "sc-0-17"
})(_templateObject27(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 32851:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": () => (/* binding */ ProductAlertForm)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/form-serialize@0.7.2/node_modules/form-serialize/index.js
var form_serialize = __webpack_require__(96712);
var form_serialize_default = /*#__PURE__*/__webpack_require__.n(form_serialize);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/currency/index.tsx + 2 modules
var currency = __webpack_require__(7846);
// EXTERNAL MODULE: ./src/components/translate/index.ts + 3 modules
var translate = __webpack_require__(88557);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/checkbox/variants.js
var checkbox_variants = __webpack_require__(99572);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/trash/index.js
var trash = __webpack_require__(27042);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var text_variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/dropdown/index.js
var dropdown = __webpack_require__(88849);
// EXTERNAL MODULE: ./src/areas/account/helpers/index.ts
var helpers = __webpack_require__(31127);
// EXTERNAL MODULE: ./src/areas/sidebar/actions/alert.js
var actions_alert = __webpack_require__(84130);
// EXTERNAL MODULE: ./src/components/render-context/ctx-link.tsx
var ctx_link = __webpack_require__(20785);
// EXTERNAL MODULE: ./src/components/review-form/components/multi-radio/index.tsx
var multi_radio = __webpack_require__(13673);
// EXTERNAL MODULE: ./src/hooks/use-is-authenticated.ts
var use_is_authenticated = __webpack_require__(96328);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/types.ts
var types = __webpack_require__(82878);
// EXTERNAL MODULE: ./src/areas/product-alert/components/product-alert-form/email-hint-styles.ts
var email_hint_styles = __webpack_require__(52306);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    .pj-ui-text-input {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  .pj-ui-text-input {\n    margin-right: 1rem;\n    &--input {\n      height: 45px;\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: ",
        ";\n  align-items: center;\n  margin-top: ",
        ";\n\n  p {\n    margin: 0;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  .pj-ui-input {\n  margin-bottom: 1rem;\n  }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  gap: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 auto;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  margin-top: ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  width: ",
        "px;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  color: ",
        ";\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  margin-right: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}







var EmailInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EmailInput",
    componentId: "sc-0-0"
})(_templateObject1(), base/* media.smallOnly */.BC.smallOnly(_templateObject()), function(p) {
    return p.error && "\n    .pj-ui-input--input {\n      border-color: ".concat(p.theme.colors.negative700, ";\n    }\n  ");
});
var RatingWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RatingWrapper",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var AlertForm = styled_components_browser_esm["default"].form.withConfig({
    displayName: "AlertForm",
    componentId: "sc-0-2"
})(_templateObject4(), base/* media.smallOnly */.BC.smallOnly(_templateObject3()));
var PriceBelowWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceBelowWrapper",
    componentId: "sc-0-3"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var NumberInput = (0,styled_components_browser_esm["default"])(inputs/* NumberInput */.Y2).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "NumberInput",
    componentId: "sc-0-4"
})(_templateObject6());
var TextInput = (0,styled_components_browser_esm["default"])(inputs/* TextInput */.oi).attrs({
    variant: "rounded"
}).withConfig({
    displayName: "TextInput",
    componentId: "sc-0-5"
})(_templateObject7());
var PriceStepWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepWrapper",
    componentId: "sc-0-6"
})(_templateObject8(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var INPUT_WIDTH = 77;
var PriceStepInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "PriceStepInput",
    componentId: "sc-0-7"
})(_templateObject9(), INPUT_WIDTH, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var ShopsFilterWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopsFilterWrapper",
    componentId: "sc-0-8"
})(_templateObject10(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing100 */.bK.measurements.spacing100);
var ShopPreferenceWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ShopPreferenceWrapper",
    componentId: "sc-0-9"
})(_templateObject11(), base/* layout.measurements.spacing125 */.bK.measurements.spacing125, base/* layout.measurements.spacing125 */.bK.measurements.spacing125);
var ShopSettingsLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ShopSettingsLink",
    componentId: "sc-0-10"
})(_templateObject12(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, function(p) {
    return p.theme.text.callToAction;
}, function(p) {
    return p.theme.text.callToActionHover;
});
var ShopPreferenceDropdown = (0,styled_components_browser_esm["default"])(dropdown/* Dropdown */.Lt).withConfig({
    displayName: "ShopPreferenceDropdown",
    componentId: "sc-0-11"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var CheckboxNotify = (0,styled_components_browser_esm["default"])(checkbox_variants/* Checkbox */.XZ).withConfig({
    displayName: "CheckboxNotify",
    componentId: "sc-0-12"
})(_templateObject14(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025);
var RemoveButton = (0,styled_components_browser_esm["default"])(variants/* TextButton */.Av).withConfig({
    displayName: "RemoveButton",
    componentId: "sc-0-13"
})(_templateObject15(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SubmitButtonWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SubmitButtonWrapper",
    componentId: "sc-0-14"
})(_templateObject16());
var CancelButton = (0,styled_components_browser_esm["default"])(variants/* TextButton */.Av).withConfig({
    displayName: "CancelButton",
    componentId: "sc-0-15"
})(_templateObject17(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SaveAlertButton = (0,styled_components_browser_esm["default"])(variants/* PrimaryButton */.KM).withConfig({
    displayName: "SaveAlertButton",
    componentId: "sc-0-16"
})(_templateObject18());

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/index.js
var ui = __webpack_require__(87838);
// EXTERNAL MODULE: ./src/components/dropdown-item/index.ts + 1 modules
var dropdown_item = __webpack_require__(29908);
;// CONCATENATED MODULE: ./src/areas/product-alert/components/product-alert-form/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





















var getDefaultPriceThreshold = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    return regularPrice ? (regularPrice - minimumStepValue).toFixed(numberOfDecimals) : "0";
};
var getDefaultPriceStep = function(regularPrice) {
    var minimumStepValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.1, numberOfDecimals = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var minDefaultPriceStep = minimumStepValue * 10;
    // Returns the largest value of 1% of regularPrice or minDefaultPriceStep
    return regularPrice ? Math.max(regularPrice * 0.01, minDefaultPriceStep).toFixed(numberOfDecimals) : String(minDefaultPriceStep);
};
var numberOfStoresAboveRating = function(prices, rating) {
    if (!prices) {
        return -1;
    }
    return prices.filter(function(price) {
        var ref, ref1;
        return Number(price === null || price === void 0 ? void 0 : (ref = price.store) === null || ref === void 0 ? void 0 : (ref1 = ref.userReviewSummary) === null || ref1 === void 0 ? void 0 : ref1.rating) > rating;
    }).length;
};
var ProductAlertForm = /*#__PURE__*/ (0,react.memo)(function(props) {
    var ref, ref1, ref2;
    var productAlertFormData = props.productAlertFormData, onClose = props.onClose, onCreate = props.onCreate, privacyPolicyUri = props.privacyPolicyUri, error = props.error, _isEdit = props.isEdit, isEdit = _isEdit === void 0 ? true : _isEdit, shouldAutoFocus = props.shouldAutoFocus, disabled = props.disabled, _showRemoveButton = props.showRemoveButton, showRemoveButton = _showRemoveButton === void 0 ? true : _showRemoveButton;
    var ref3 = (0,app_context/* useAppContext */.bp)(), market = ref3.market, t = ref3.t;
    var product = productAlertFormData.product;
    var userProductAlerts = (0,es/* useSelector */.v9)(function(state) {
        return state.areas.sidebar.alerts.products;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var emailInput = (0,react.useRef)(null);
    var isAuthenticated = (0,use_is_authenticated/* useIsAuthenticated */.k)();
    var _code = currency/* MarketSettings */.Gr[market.code], minimumStepValue = _code.minimumStepValue, numberOfDecimals = _code.numberOfDecimals;
    var ref4 = _slicedToArray((0,react.useState)(new Set()), 2), errors = ref4[0], setErrors = ref4[1];
    var ref5 = _slicedToArray((0,react.useState)(""), 2), email = ref5[0], setEmail = ref5[1];
    var ref6 = _slicedToArray((0,react.useState)(false), 2), hasSubmitted = ref6[0], setHasSubmitted = ref6[1];
    var ref7 = _slicedToArray((0,react.useState)(((product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) || 0) / 2), 2), chosenStoreGradeThreshold = ref7[0], setChosenStoreGradeThreshold = ref7[1];
    var ref8 = _slicedToArray((0,react.useState)(function() {
        var ref;
        return (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceThreshold) ? String(product.alert.priceThreshold) : getDefaultPriceThreshold(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceThreshold = ref8[0], setPriceThreshold = ref8[1];
    var ref9 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref1 = product.alert) === null || ref1 === void 0 ? void 0 : ref1.alertType) !== types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS), 2), onlyAlertIfInStock = ref9[0], setOnlyAlertIfInStock = ref9[1];
    var ref10 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : (ref2 = product.alert) === null || ref2 === void 0 ? void 0 : ref2.storePreference) || types/* ShopPreference.NONE */.lc.NONE), 2), shopPreference = ref10[0], setShopPreference = ref10[1];
    // Default to true
    var ref11 = _slicedToArray((0,react.useState)((product === null || product === void 0 ? void 0 : product.alert) ? !!product.alert.priceStep : true), 2), priceStepCheckbox = ref11[0], setPriceStepCheckbox = ref11[1];
    var ref12 = _slicedToArray((0,react.useState)(function() {
        var ref;
        if (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.priceStep) {
            return String(product.alert.priceStep);
        }
        return getDefaultPriceStep(product === null || product === void 0 ? void 0 : product.priceSummary.regular, minimumStepValue, numberOfDecimals);
    }), 2), priceStep = ref12[0], setPriceStep = ref12[1];
    (0,react.useEffect)(function() {
        if (emailInput.current && shouldAutoFocus) {
            emailInput.current.focus();
        }
        return function cleanup() {
            dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        };
    }, [
        dispatch,
        shouldAutoFocus
    ]);
    var clearErrors = function() {
        return setErrors(new Set());
    };
    var addError = function(newError) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            return draftErrors.add(newError);
        });
    };
    var removeError = function(errorToRemove) {
        setErrors(function(prevErrors) {
            var draftErrors = new Set(prevErrors);
            draftErrors.delete(errorToRemove);
            return draftErrors;
        });
    };
    (0,react.useEffect)(function() {
        if (!error) {
            return;
        }
        switch(error){
            case types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID:
            case types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE:
                {
                    addError(error);
                    break;
                }
            default:
                {
                    addError(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN);
                }
        }
    }, [
        error
    ]);
    var handlePriceThresholdChange = function(event) {
        setPriceThreshold(event.target.value);
        if (!event.target.value || Number(event.target.value) < 0) {
            addError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        } else {
            removeError(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW);
        }
    };
    var handlePriceStepChange = function(event) {
        setPriceStep(event.target.value);
    };
    var handleOnlyAlertIfInStockChange = function() {
        return setOnlyAlertIfInStock(function(state) {
            return !state;
        });
    };
    var handlePriceStepCheckboxChange = function() {
        return setPriceStepCheckbox(function(state) {
            return !state;
        });
    };
    var handleEmailChange = function(event) {
        /* The error state is duplicated, between Redux and local state. This is due
    to the fact that we are using sagas to make the create alert request.
    The problem, apart from duplication, is that the error messages outlive the
    form since they are stored in redux. So the error handling in this form
    needs to be improved/simplified. But for now the code below is required to
    fix the issue with the email error messages not disappearing even though the
    user corrects the email.
    */ if ((0,helpers/* isValidEmail */.vV)(event.target.value)) {
            removeError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        } else if (hasSubmitted) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
        }
        dispatch((0,actions_alert/* removeAlertError */.TI)(undefined));
        removeError(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE);
        setEmail(event.target.value);
    };
    var saveAlert = (0,react.useCallback)(function(event) {
        event.preventDefault();
        setHasSubmitted(true);
        var ref = form_serialize_default()(event.target, {
            hash: true
        }), _rating = ref.rating, rating = _rating === void 0 ? 0 : _rating;
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!product) {
            return;
        }
        clearErrors();
        if (!isAuthenticated && !(0,helpers/* isValidEmail */.vV)(email)) {
            addError(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID);
            if (shouldAutoFocus && emailInput.current) {
                emailInput.current.focus();
                emailInput.current.select();
            }
            return;
        }
        if (Number(priceThreshold) < 0 || Number(priceStep) < 0) {
            return;
        }
        var graphQLAlert = {
            type: onlyAlertIfInStock ? types/* AlertTypes.IN_STOCK_PRICE_DROPS */.d_.IN_STOCK_PRICE_DROPS : types/* AlertTypes.PRICE_DROPS */.d_.PRICE_DROPS,
            priceThreshold: Number(priceThreshold)
        };
        var priceStepValue = priceStepCheckbox ? Number(priceStep) : undefined;
        onCreate(_objectSpread({
            alertId: userAlert && userAlert.alertId,
            productId: product.id,
            email: !isAuthenticated ? email : undefined,
            priceStep: priceStepValue,
            storePreference: shopPreference === types/* ShopPreference.NONE */.lc.NONE ? undefined : shopPreference,
            storeGradeThreshold: rating ? Number(rating) * 2 : undefined
        }, graphQLAlert));
    }, [
        email,
        onCreate,
        onlyAlertIfInStock,
        priceStep,
        priceStepCheckbox,
        priceThreshold,
        shopPreference,
        product,
        shouldAutoFocus,
        userProductAlerts,
        isAuthenticated
    ]);
    var removeAlert = function() {
        var userAlert = userProductAlerts.find(function(alert) {
            return alert.productId === (product === null || product === void 0 ? void 0 : product.id);
        });
        if (!(userAlert === null || userAlert === void 0 ? void 0 : userAlert.alertId)) return;
        dispatch((0,actions_alert/* removeAlertRequest */.s$)(userAlert.alertId, product === null || product === void 0 ? void 0 : product.id));
        if (onClose) onClose();
    };
    var shopPreferenceOptions = [
        {
            name: t("alerts", "alerts.shop-preference-none"),
            value: types/* ShopPreference.NONE */.lc.NONE
        },
        {
            name: t("alerts", "alerts.shop-preference-exclude-disliked"),
            value: types/* ShopPreference.EXCLUDE_DISLIKED */.lc.EXCLUDE_DISLIKED
        },
        {
            name: t("alerts", "alerts.shop-preference-liked"),
            value: types/* ShopPreference.LIKED */.lc.LIKED
        }
    ];
    var renderTypeOptions = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(PriceBelowWrapper, null, /*#__PURE__*/ react.createElement(text_variants/* BodySmallText */.oI, {
            emphasis: text_variants/* FontEmphasis.MEDIUM */.tu.MEDIUM
        }, t("alerts", "type.price-below")), /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceThreshold",
            ariaLabel: t("alerts", "alert-form.price-limit"),
            warning: errors.has(types/* Errors.ERROR_THRESHOLD_TOO_LOW */.D1.ERROR_THRESHOLD_TOO_LOW),
            value: priceThreshold,
            onChange: handlePriceThresholdChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0,
            "data-testid": "price-threshold-number-input"
        })), /*#__PURE__*/ react.createElement(PriceStepWrapper, null, /*#__PURE__*/ react.createElement(checkbox_variants/* CheckboxSwitch */.K_, {
            text: t("alerts", "alert-form.price-step-checkbox"),
            onChange: handlePriceStepCheckboxChange,
            checked: priceStepCheckbox
        }), /*#__PURE__*/ react.createElement(PriceStepInput, null, /*#__PURE__*/ react.createElement(NumberInput, {
            name: "priceStep",
            ariaLabel: t("alerts", "alert-form.price-interval"),
            "data-testid": "price-step-number-input",
            disabled: !priceStepCheckbox,
            warning: Number(priceStep) < 0,
            value: priceStep,
            onChange: handlePriceStepChange,
            step: minimumStepValue,
            max: (product === null || product === void 0 ? void 0 : product.priceSummary.regular) ? Number((product.priceSummary.regular - minimumStepValue).toFixed(numberOfDecimals)) : undefined,
            min: 0
        })))), /*#__PURE__*/ react.createElement(CheckboxNotify, {
            name: "onlyAlertIfInStock",
            checked: onlyAlertIfInStock,
            text: t("alerts", "alert-form.only-notify-in-stock"),
            onChange: handleOnlyAlertIfInStockChange
        }), /*#__PURE__*/ react.createElement(ShopsFilterWrapper, null, /*#__PURE__*/ react.createElement(text_variants/* BodySmallText */.oI, {
            emphasis: text_variants/* FontEmphasis.MEDIUM */.tu.MEDIUM
        }, t("alerts", "alert-form.shops-with-higher-rating")), /*#__PURE__*/ react.createElement(RatingWrapper, null, /*#__PURE__*/ react.createElement(multi_radio/* default */.ZP, {
            currentValue: (product === null || product === void 0 ? void 0 : (ref = product.alert) === null || ref === void 0 ? void 0 : ref.storeGradeThreshold) ? product.alert.storeGradeThreshold / 2 : null,
            disabledOptions: [
                5
            ],
            name: "rating",
            onClick: function(e) {
                setChosenStoreGradeThreshold(Number(e.target.value));
            },
            options: [
                1,
                2,
                3,
                4,
                5
            ],
            optionValues: [
                t("reviews", "rating.terrible"),
                t("reviews", "rating.bad"),
                t("reviews", "rating.ok"),
                t("reviews", "rating.good"),
                t("reviews", "rating.excellent")
            ],
            required: true,
            size: "small",
            variant: multi_radio/* Variants.rate */.tr.rate
        }), /*#__PURE__*/ react.createElement("p", null, (product === null || product === void 0 ? void 0 : product.prices) ? t("alerts", "alert-form.n-stores", {
            n: numberOfStoresAboveRating(product === null || product === void 0 ? void 0 : (ref1 = product.prices) === null || ref1 === void 0 ? void 0 : ref1.nodes, chosenStoreGradeThreshold)
        }) : null)), isAuthenticated && /*#__PURE__*/ react.createElement(ShopPreferenceWrapper, null, /*#__PURE__*/ react.createElement(text_variants/* BodySmallText */.oI, {
            emphasis: text_variants/* FontEmphasis.MEDIUM */.tu.MEDIUM
        }, t("alerts", "alert-form.filter-shops")), /*#__PURE__*/ react.createElement(ShopPreferenceDropdown, {
            closeOnItemClick: true
        }, /*#__PURE__*/ react.createElement(dropdown/* DropdownToggle */.Z_, {
            showActiveIcon: true,
            type: variants/* ButtonType.TEXT */.L$.TEXT,
            disabled: !isAuthenticated,
            containerProps: {
                "data-testid": "ShopPreferenceSelector"
            }
        }, (ref2 = shopPreferenceOptions.find(function(row) {
            return row.value === shopPreference;
        })) === null || ref2 === void 0 ? void 0 : ref2.name), /*#__PURE__*/ react.createElement(dropdown/* DropdownContent */.Nv, {
            placement: ui/* Direction.Up */.Nm.Up
        }, shopPreferenceOptions.map(function(option) {
            return /*#__PURE__*/ react.createElement(dropdown_item/* DropdownItem */.h, {
                "data-test": "DropdownOption",
                containerProps: {
                    "data-testid": option.value
                },
                key: option.value,
                disabled: shopPreference === option.value,
                onClick: function() {
                    return setShopPreference(option.value);
                }
            }, option.name);
        }))), /*#__PURE__*/ react.createElement(ShopSettingsLink, {
            to: "/account/profile/shop-preference"
        }, t("alerts", "alert-form.shops-settings")))));
    };
    return /*#__PURE__*/ react.createElement(AlertForm, {
        method: "post",
        onSubmit: saveAlert,
        noValidate: true
    }, renderTypeOptions(), /*#__PURE__*/ react.createElement(EmailInput, {
        error: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, !isAuthenticated && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(TextInput, {
        type: "email",
        name: "email",
        inputRef: emailInput,
        defaultValue: email,
        onChange: handleEmailChange,
        placeholder: t("alerts", "alert-form.email-placeholder"),
        tabIndex: 0,
        autoFocus: shouldAutoFocus,
        // Do not send this element to CUX (cux.io)
        "data-cux-exclude": true
    }), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        visible: errors.has(types/* Errors.ERROR_EMAIL_IN_USE */.D1.ERROR_EMAIL_IN_USE)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.email-in-use-error"), "\xa0", /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: "/login"
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.login-error"))), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_EMAIL_INVALID */.D1.ERROR_EMAIL_INVALID)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.invalid-email-error")), /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        error: true,
        visible: errors.has(types/* Errors.ERROR_UNKNOWN */.D1.ERROR_UNKNOWN)
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "alerts"
    }, "alert-form.unknown-error")), privacyPolicyUri && /*#__PURE__*/ react.createElement(email_hint_styles/* EmailHint */.T, {
        visible: true,
        discreetLink: true
    }, /*#__PURE__*/ react.createElement(ctx_link/* CtxLink */.b, {
        to: privacyPolicyUri
    }, /*#__PURE__*/ react.createElement(translate/* Translate */.v, {
        domain: "product"
    }, "alert.how-your-email-is-used"))))), isEdit && showRemoveButton && /*#__PURE__*/ react.createElement(RemoveButton, {
        onClick: removeAlert
    }, /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(trash/* IconTrash */.I, null)), /*#__PURE__*/ react.createElement(variants/* ButtonText */.oD, null, t("product", "alert.delete-button"))), /*#__PURE__*/ react.createElement(SubmitButtonWrapper, null, isEdit && onClose && product && /*#__PURE__*/ react.createElement(CancelButton, {
        onClick: onClose
    }, t("alerts", "alert-form.cancel-button")), /*#__PURE__*/ react.createElement(SaveAlertButton, {
        disabled: disabled || errors.size > 0,
        containerProps: {
            "data-testid": "CreateAlertButton",
            "data-test": "CreateAlertButton"
        },
        htmlType: "submit",
        fullWidth: true
    }, t("alerts", "alert-form.create-button"))));
});


/***/ }),

/***/ 81509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": () => (/* binding */ Ads)
});

// UNUSED EXPORTS: Advert

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/ads/index.tsx
var ads = __webpack_require__(68748);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/ads/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        " display:none; "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        " display:none; "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    list-style: none;\n    grid-row: ",
        ";\n    grid-column: 1 / -1;\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var Advert = styled_components_browser_esm["default"].li.withConfig({
    displayName: "Advert",
    componentId: "sc-0-0"
})(function(p) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), p.row || "0", p.$display === "mobile" && (0,styled_components_browser_esm.css)(_templateObject1(), base/* media.mediumUp */.BC.mediumUp(_templateObject())), p.$display === "desktop" && (0,styled_components_browser_esm.css)(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2())));
});

// EXTERNAL MODULE: ./src/components/layout-buttons/types.ts
var types = __webpack_require__(11235);
;// CONCATENATED MODULE: ./src/areas/product-collection/components/ads/index.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}




var _obj;
var DEFAULT_LAYOUT_CONFIG = (_obj = {}, _defineProperty(_obj, types/* LayoutMode.GRID */.X.GRID, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _defineProperty(_obj, types/* LayoutMode.LIST */.X.LIST, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _defineProperty(_obj, types/* LayoutMode.COMPACT_LIST */.X.COMPACT_LIST, {
    panorama_extra: {
        show: true,
        row: 2
    },
    dubbelpanorama1: {
        show: true,
        row: 2
    },
    dubbelpanorama2: {
        show: true,
        row: 8
    }
}), _obj);
var Ads = function(param) {
    var offersLength = param.offersLength, layout = param.layout, layoutConfig = param.layoutConfig, scaleBase = param.scaleBase, async = param.async;
    return /*#__PURE__*/ react.createElement(react.Fragment, null, offersLength > 4 && /*#__PURE__*/ react.createElement(ads_Advert, {
        scalable: true,
        scaleBase: scaleBase && ".".concat(scaleBase),
        scaleOrigin: "left center",
        placement: "panorama_extra",
        format: "panorama_1_wde",
        min: 0,
        max: 10000,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async
    }), offersLength > 2 && /*#__PURE__*/ react.createElement(ads_Advert, {
        placement: "dubbelpanorama1",
        format: "panorama_1",
        min: 0,
        max: 860,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async
    }), offersLength > 18 && /*#__PURE__*/ react.createElement(ads_Advert, {
        placement: "dubbelpanorama2",
        format: "panorama_2",
        min: 0,
        max: 860,
        triggerPoint: 100,
        layout: layout,
        layoutConfig: layoutConfig,
        async: async
    }));
};
var getDisplay = function(placement) {
    switch(placement){
        case "panorama_extra":
            return "desktop";
        case "dubbelpanorama1":
        case "dubbelpanorama2":
            return "mobile";
        default:
            return "";
    }
};
var ads_Advert = function(param) {
    var format = param.format, min = param.min, max = param.max, placement = param.placement, _scalable = param.scalable, scalable = _scalable === void 0 ? false : _scalable, scaleBase = param.scaleBase, scaleOrigin = param.scaleOrigin, triggerPoint = param.triggerPoint, layout = param.layout, _layoutConfig = param.layoutConfig, layoutConfig = _layoutConfig === void 0 ? {} : _layoutConfig, async = param.async;
    var display = getDisplay(placement);
    var config = _objectSpread({}, DEFAULT_LAYOUT_CONFIG, layoutConfig);
    var placementConfig = config[layout][placement];
    if (!placementConfig.show) {
        return null;
    }
    return /*#__PURE__*/ react.createElement(Advert, {
        row: placementConfig.row,
        key: placement,
        $display: display
    }, /*#__PURE__*/ react.createElement(ads/* default */.Z, {
        scalable: scalable,
        scaleBase: scaleBase,
        scaleOrigin: scaleOrigin,
        placement: placement,
        format: format,
        min: min,
        max: max,
        triggerPoint: triggerPoint,
        async: async
    }));
};



/***/ }),

/***/ 82094:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53231);


var OffersGrid = function(param) {
    var children = param.children, className = param.className, offers = param.offers, isExtraWide = param.isExtraWide, isOffers = param.isOffers;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGrid */ .u5, {
        "data-test": isOffers ? "OfferGrid" : "ProductGrid",
        className: className,
        isExtraWide: isExtraWide
    }, children, offers && react__WEBPACK_IMPORTED_MODULE_0__.Children.map(offers, function(child, index) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_1__/* .OffersGridItem */ .EA, {
            "data-test": isOffers ? "OfferGridCard" : "ProductGridCard",
            style: {
                order: index
            }
        }, child);
    }));
};


/***/ }),

/***/ 53231:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EA": () => (/* binding */ OffersGridItem),
/* harmony export */   "cq": () => (/* binding */ ITEMS),
/* harmony export */   "u5": () => (/* binding */ OffersGrid)
/* harmony export */ });
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(33399);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10297);
/* harmony import */ var src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8663);
/* eslint-disable no-nested-ternary */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n          grid-gap: ",
        "rem;\n          grid-template-columns: repeat(\n            auto-fill,\n            minmax(auto, calc(",
        " - ",
        "))\n          );\n        "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    @supports (grid-template-columns: repeat(auto-fill, minmax(auto, 50%))) {\n      display: grid;\n      flex: 1 0 auto;\n      list-style: none;\n\n      ",
        "\n      ",
        "\n    }\n\n    /* Fallback to flex if grid-template-columns is not supported */\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}



// We need to cover ALL breakpoints here since we use '`${breakpoint}Only`'
// If we left out xxl for example, then >1600px would look very weird as it wouldn't be covered by any breakpoint
// (This only works because the smallest and largest breakpoints are open in their respective direction)
var ITEMS = {
    small: 2,
    medium: 3,
    large: 4,
    xlarge: 4,
    xxlarge: 4
};
var GAPS = {
    small: 0.5,
    medium: 1,
    large: 1,
    xlarge: 1,
    xxlarge: 1
};
// These are calculated for each render
var SIZES = {};
var GUTTERS = {};
/**
 * Certain experiments require a different grid layout, which is passed as props
 * Here we determine how many items to show depending on the passed props
 */ function getItemsForExperiments(param) {
    var isExtraWide = param.isExtraWide;
    if (isExtraWide) {
        return {
            large: 4,
            xlarge: 5,
            xxlarge: 6
        };
    }
    return {
        large: 4,
        xlarge: 4,
        xxlarge: 4
    };
}
var OffersGrid = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].ul.withConfig({
    displayName: "OffersGrid",
    componentId: "sc-0-0"
})(function(props) {
    // We need to mutate the object here because src/areas/product-collection/components/products/layout-grid/layout-grid.tsx relies on the current layout configuration, and that depends on getItemsForExperiment
    // We don't want to implement the same logic twice, therefore we need to access this object from somewhere else
    Object.assign(ITEMS, getItemsForExperiments(props));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // I'm not really happy with the current solution, but if we dynamically change ITEMS.large etc. for each render, then we also need to recalculate (gutter) sizes for each render
        // eslint-disable-next-line no-restricted-syntax, guard-for-in
        for(var _iterator = src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames */ .PS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var bp = _step.value;
            SIZES[bp] = "".concat(100 / ITEMS[bp], "%");
            GUTTERS[bp] = "".concat(GAPS[bp] * (ITEMS[bp] - 1), "rem / ").concat(ITEMS[bp]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__.css)(_templateObject1(), /* This only works because smallOnly and xxlargeOnly have no boundaries in each unset direction i.e. everything larger than xxlarge is considered xxlarge */ null, src_components_base_styles_variables__WEBPACK_IMPORTED_MODULE_2__/* .breakpointNames.map */ .PS.map(function(breakpoint) {
        return src_components_base__WEBPACK_IMPORTED_MODULE_0__/* .media */ .BC["".concat(breakpoint, "Only")](_templateObject(), GAPS[breakpoint], SIZES[breakpoint], GUTTERS[breakpoint]);
    }));
});
var OffersGridItem = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].li.withConfig({
    displayName: "OffersGridItem",
    componentId: "sc-0-1"
})(_templateObject2());


/***/ }),

/***/ 95925:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": () => (/* binding */ AddToListModalsWrapper)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3732);
/* harmony import */ var _viewport__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49583);
/* harmony import */ var src_areas_product_components_product_header_components_action_buttons_list_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76486);
/* harmony import */ var _modal_login_promo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25629);
/* harmony import */ var src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9086);
/* harmony import */ var _hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96328);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}







var AddToListModalsWrapper = function(param) {
    var children = param.children, productId = param.productId, productName = param.productName;
    var ref;
    var isDesktop = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(_viewport__WEBPACK_IMPORTED_MODULE_2__/* .ViewportContext */ .R).isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), showLoginPromo = ref1[0], setLoginPromoState = ref1[1];
    var toggleLoginPromo = function(e) {
        if (e) {
            e.stopPropagation();
            e.preventDefault();
        }
        setLoginPromoState(!showLoginPromo);
    };
    // Highlights the heart if the product was recently added to a list.
    // Kind of an ugly hack; should be fixed once we can get this information
    // from GraphQL.
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), addedToList = ref2[0], setAddedToListState = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), 2), listOpen = ref3[0], setListOpen = ref3[1];
    var me = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.account.me;
    });
    var isAuthenticated = (0,_hooks_use_is_authenticated__WEBPACK_IMPORTED_MODULE_6__/* .useIsAuthenticated */ .k)();
    var deletedLists = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.deletedLists;
    });
    var selectedList = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        return state.areas.sidebar.selectedList;
    });
    var latestLists = me === null || me === void 0 ? void 0 : (ref = me.lists) === null || ref === void 0 ? void 0 : ref.nodes.filter(function(list) {
        return deletedLists[list.id] !== true;
    }).filter(function(list) {
        return !list.inventory;
    }).sort(function(a) {
        return a.id === selectedList ? 1 : 0;
    });
    var addToMyProducts = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addItemToMyProductsRequest */ ["if"])(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var addToList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(listId) {
        if (listId) dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .selectList */ .Fz)(listId));
        dispatch((0,src_areas_sidebar_actions_lists__WEBPACK_IMPORTED_MODULE_5__/* .addListItemRequest */ .hg)(productId, productName, isDesktop));
        setAddedToListState(true);
    }, [
        dispatch,
        isDesktop,
        productId,
        productName
    ]);
    var handleOnClick = function() {
        return isAuthenticated ? function() {
            return !latestLists || latestLists.length === 0 ? addToList() : setListOpen(true);
        } : toggleLoginPromo;
    };
    if (!productId) return null;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, showLoginPromo && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_modal_login_promo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isOpen: showLoginPromo,
        onRequestClose: toggleLoginPromo
    }), listOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_areas_product_components_product_header_components_action_buttons_list_modal__WEBPACK_IMPORTED_MODULE_3__/* .ListModal */ .a, {
        addToList: addToList,
        addToMyProducts: addToMyProducts,
        isOpen: listOpen,
        closeModal: function() {
            return setListOpen(false);
        },
        lists: latestLists,
        isDesktop: Boolean(isDesktop)
    }), children(handleOnClick(), addedToList));
};


/***/ }),

/***/ 75927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": () => (/* binding */ AlertModal)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13923);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66431);
/* harmony import */ var src_components_modal_v2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4915);
/* harmony import */ var _prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48134);





var ProductAlertModalContent = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)({
    resolved: {},
    chunkName: function chunkName() {
        return "extra";
    },
    isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
            return false;
        }
        if (true) {
            return !!__webpack_require__.m[key];
        }
        return false;
    },
    importAsync: function() {
        return __webpack_require__.e(/* import() | extra */ 737).then(__webpack_require__.bind(__webpack_require__, 78062));
    },
    requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function(resolved) {
            _this.resolved[key] = true;
            return resolved;
        });
    },
    requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (true) {
            return __webpack_require__(id);
        }
        return eval("module.require")(id);
    },
    resolve: function resolve() {
        if (true) {
            return /*require.resolve*/(78062);
        }
        return eval("require.resolve")("../../../areas/product-alert/components/product-alert-modal-content");
    }
});
var AlertModal = function(props) {
    var ref, ref1;
    var market = (0,src_components_app_context__WEBPACK_IMPORTED_MODULE_2__/* .useAppContext */ .bp)().market;
    var closeModal = props.closeModal, isOpen = props.isOpen, productId = props.productId;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, isOpen && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(src_components_modal_v2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        isOpen: isOpen,
        onRequestClose: closeModal
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_modal__WEBPACK_IMPORTED_MODULE_4__/* .ModalBody */ .fe, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ProductAlertModalContent, {
        productId: productId,
        hideModal: closeModal,
        privacyPolicyUri: market === null || market === void 0 ? void 0 : (ref = market.privacySettings) === null || ref === void 0 ? void 0 : (ref1 = ref.responsive) === null || ref1 === void 0 ? void 0 : ref1.privacyUrl
    }))));
};


/***/ }),

/***/ 10655:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* binding */ applied_filters_AppliedFilters)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/button/variants.js
var variants = __webpack_require__(71406);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/index.js
var ui_text = __webpack_require__(65532);
;// CONCATENATED MODULE: ./src/components/applied-filters/applied-filter.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  min-width: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var AppliedFilter = function(param) {
    var title = param.title, value = param.value, onClick = param.onClick;
    var t = (0,app_context/* useAppContext */.bp)().t;
    return /*#__PURE__*/ react.createElement(AppliedFilterButton, {
        onClick: onClick,
        containerProps: {
            "data-test": "AppliedFilter"
        },
        style: {}
    }, /*#__PURE__*/ react.createElement(variants/* ButtonText */.oD, {
        behavior: ui_text/* Behavior.OnelineEllipsis */.cg.OnelineEllipsis
    }, title ? t("filter", "applied-filter.filter-with-name", {
        name: title,
        value: value
    }) : value), /*#__PURE__*/ react.createElement(variants/* ButtonIcon */.Ei, null, /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null)));
};
var AppliedFilterButton = (0,styled_components_browser_esm["default"])(variants/* TagButton */.D_).withConfig({
    displayName: "AppliedFilterButton",
    componentId: "sc-0-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/applied-filters/clear-button.tsx



var ClearButton = function(param) {
    var onClick = param.onClick, className = param.className;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(variants/* TextButton */.Av, {
        className: className,
        onClick: onClick,
        size: variants/* ButtonSize.SMALL */.qE.SMALL,
        containerProps: {
            "data-test": "FeaturedFilterClear"
        }
    }, t("filter", "button.clear-filter"));
};

// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/list/variants.js
var list_variants = __webpack_require__(79514);
;// CONCATENATED MODULE: ./src/components/applied-filters/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-top: 0;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: ",
        ";\n  align-items: center;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  white-space: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var AppliedFilters = (0,styled_components_browser_esm["default"])(list_variants/* Row */.X2).withConfig({
    displayName: "AppliedFilters",
    componentId: "sc-0-0"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.$wrap && "flex-wrap: wrap;";
}, base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var AppliedFiltersTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "AppliedFiltersTitle",
    componentId: "sc-0-1"
})(_templateObject2());
var AppliedFiltersWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "AppliedFiltersWrapper",
    componentId: "sc-0-2"
})(_templateObject3(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);

;// CONCATENATED MODULE: ./src/components/applied-filters/index.tsx





var applied_filters_AppliedFilters = function(props) {
    var t = (0,app_context/* useAppContext */.bp)().t;
    var formattedFilters = props.filters.map(function(filter) {
        return {
            filter: filter,
            formatted: props.filterFormatFn({
                filter: filter,
                t: t
            })
        };
    });
    if (!(formattedFilters === null || formattedFilters === void 0 ? void 0 : formattedFilters.length)) return null;
    return /*#__PURE__*/ react.createElement(AppliedFiltersWrapper, {
        "data-test": "AppliedFiltersWrapper"
    }, /*#__PURE__*/ react.createElement(AppliedFilters, {
        $wrap: props.wrap,
        gap: 0.5
    }, formattedFilters.map(function(param) {
        var filter = param.filter, formatted = param.formatted;
        return /*#__PURE__*/ react.createElement(AppliedFilter, {
            key: formatted.key,
            title: formatted.title,
            value: formatted.value,
            onClick: function() {
                return props.onClearFilter(filter);
            }
        });
    }), /*#__PURE__*/ react.createElement(ClearButton, {
        onClick: props.onClearAll
    })));
};


/***/ }),

/***/ 39509:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": () => (/* binding */ Collapsible)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/collapsible/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 3em;\n      overflow: hidden;\n      /* Fade out towards the bottom */\n      &::after {\n        content: '';\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 2em;\n        background: linear-gradient(\n          to bottom,\n          rgba(255, 255, 255, 0),\n          rgba(255, 255, 255, 0.8)\n        );\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  background: transparent;\n  color: transparent;\n  cursor: pointer;\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  transition: background-color ",
        ";\n  width: 100%;\n  z-index: 1;\n\n  &:focus {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var CollapsibleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "CollapsibleWrapper",
    componentId: "sc-0-0"
})(_templateObject1(), function(param) {
    var collapsed = param.collapsed;
    return collapsed && (0,styled_components_browser_esm.css)(_templateObject());
});
var ExpandButton = styled_components_browser_esm["default"].button.attrs({
    type: "button"
}).withConfig({
    displayName: "ExpandButton",
    componentId: "sc-0-1"
})(_templateObject2(), base/* layout.animations.buttonTransition */.bK.animations.buttonTransition, function(p) {
    return base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(p.theme.colors.maybeBlue700, "0.5");
});

;// CONCATENATED MODULE: ./src/components/collapsible/index.tsx


var Collapsible = function(param) {
    var children = param.children, collapsed = param.collapsed, expandText = param.expandText, onExpand = param.onExpand, className = param.className;
    return /*#__PURE__*/ react.createElement(CollapsibleWrapper, {
        collapsed: collapsed,
        className: className
    }, children, collapsed && /*#__PURE__*/ react.createElement(ExpandButton, {
        onClick: onExpand
    }, expandText));
};


/***/ }),

/***/ 29908:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* reexport */ DropdownItem)
});

// UNUSED EXPORTS: SharedListItemStyles

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/dropdown-item/dropdown-item.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: ",
        " ",
        ";\n  cursor: pointer;\n  width: 100%;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n\n  svg {\n    margin-right: ",
        ";\n  }\n\n  &:hover {\n    background: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var SharedListItemStyles = (0,styled_components_browser_esm.css)(_templateObject(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.measurements.spacing075 */.bK.measurements.spacing075, base/* layout.measurements.spacing050 */.bK.measurements.spacing050, function(p) {
    return p.theme.dropdowns.secondary.hoverBackground;
});
var DropdownItem = (0,styled_components_browser_esm["default"])(clickable/* Clickable */.P).withConfig({
    displayName: "DropdownItem",
    componentId: "sc-0-0"
})(_templateObject1(), SharedListItemStyles);

;// CONCATENATED MODULE: ./src/components/dropdown-item/index.ts



/***/ }),

/***/ 66103:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": () => (/* binding */ FeaturedArticle)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/areas/campaign/components/campaign-group/index.js + 1 modules
var campaign_group = __webpack_require__(1603);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/card/index.js
var card = __webpack_require__(2262);
;// CONCATENATED MODULE: ./src/components/featured-article/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    margin-right: ",
        ";\n    padding-right: ",
        ";\n    flex: 1 0 70%;\n      max-width: 70%;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1 0 640px;\n    max-width: 640px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-bottom: ",
        ";\n  flex: 1 0 100%;\n  max-width: 100%;\n  margin-right: 0;\n  padding-right: 0;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n    flex: 1;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      flex: 1 0 100%;\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 0 100%;\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  > * {\n    margin-bottom: 1rem;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  min-height: 185px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var StyledArticle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-0"
})(_templateObject2(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300, base/* media.mediumUp */.BC.mediumUp(_templateObject(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.measurements.spacing150 */.bK.measurements.spacing150), base/* media.largeUp */.BC.largeUp(_templateObject1()));
var RelatedArticleContainer = styled_components_browser_esm["default"].section.withConfig({
    displayName: "RelatedArticleContainer",
    componentId: "sc-0-1"
})(_templateObject5(), base/* media.mediumUp */.BC.mediumUp(_templateObject3()), function(p) {
    return p.fullWidth && (0,styled_components_browser_esm.css)(_templateObject4());
});
var StyledFeaturedArticle = styled_components_browser_esm["default"].section.withConfig({
    displayName: "StyledFeaturedArticle",
    componentId: "sc-0-2"
})(_templateObject6(), base/* layout.measurements.spacing300 */.bK.measurements.spacing300);
var RelatedArticleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedArticleWrapper",
    componentId: "sc-0-3"
})(_templateObject7());
var StyledCardMedia = (0,styled_components_browser_esm["default"])(card/* CardMedia */.ZB).withConfig({
    displayName: "StyledCardMedia",
    componentId: "sc-0-4"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/article/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n    margin-bottom: 1.2rem;\n  "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.6rem;\n  line-height: 1.4;\n  margin: 0 0 1rem;\n\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n    h4 {margin-bottom: 1.4rem;}\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  color: ",
        ";\n\n  figure {\n    margin-bottom: 1rem;\n    img {\n      display: block;\n      margin: 0 auto;\n      max-width: 100%;\n    }\n    figcaption {\n      color: ",
        ";\n      text-align: right;\n    }\n  }\n  ",
        " {\n    font-size: 1.6rem;\n  }\n  h2 {\n    font-size: 1.3rem;\n  }\n  h3 {\n    font-size: 1.15rem;\n  }\n  h4 {\n    margin-bottom: 1rem;\n  }\n  ol,\n  ul {\n    list-style-position: inside;\n    line-height: 1.6;\n  }\n  p {\n    line-height: 1.6;\n  }\n  a {\n    color: ",
        ";\n    text-decoration: underline;\n  }\n  .caption {\n    text-align: right;\n  }\n\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n  font-size: 1.15rem;\n  font-weight: 600;\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var StyledArticleHeading = styled_components_browser_esm["default"].h1.withConfig({
    displayName: "StyledArticleHeading",
    componentId: "sc-0-0"
})(styles_templateObject1(), base/* media.largeUp */.BC.largeUp(styles_templateObject()));
var styles_StyledArticle = styled_components_browser_esm["default"].article.withConfig({
    displayName: "StyledArticle",
    componentId: "sc-0-1"
})(styles_templateObject3(), function(p) {
    return p.theme.text.primary;
}, function(p) {
    return p.theme.text.secondary;
}, StyledArticleHeading, function(p) {
    return p.theme.text.linkExternal;
}, base/* media.largeUp */.BC.largeUp(styles_templateObject2()));
var Preamble = styled_components_browser_esm["default"].p.withConfig({
    displayName: "Preamble",
    componentId: "sc-0-2"
})(styles_templateObject4());

;// CONCATENATED MODULE: ./src/components/article/article-heading.tsx


var ArticleHeading = function(param) {
    var title = param.title, _embedded = param.embedded, embedded = _embedded === void 0 ? false : _embedded;
    return embedded ? /*#__PURE__*/ react.createElement(StyledArticleHeading, {
        as: "h2"
    }, title) : /*#__PURE__*/ react.createElement(StyledArticleHeading, null, title);
};

// EXTERNAL MODULE: ./src/components/lazy/index.tsx
var lazy = __webpack_require__(88270);
;// CONCATENATED MODULE: ./src/components/article/article.tsx
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var Article = function(_param) {
    var _embedded = _param.embedded, embedded = _embedded === void 0 ? true : _embedded, props = _objectWithoutProperties(_param, [
        "embedded"
    ]);
    return /*#__PURE__*/ react.createElement(styles_StyledArticle, null, props.imageUrl && /*#__PURE__*/ react.createElement("figure", null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        src: props.imageUrl,
        alt: props.imageCaption || ""
    })), props.imageCaption && /*#__PURE__*/ react.createElement("figcaption", null, props.imageCaption)), /*#__PURE__*/ react.createElement(ArticleHeading, {
        title: props.title,
        embedded: embedded
    }), props.preamble && /*#__PURE__*/ react.createElement(Preamble, null, props.preamble), props.body && /*#__PURE__*/ react.createElement("div", {
        dangerouslySetInnerHTML: {
            __html: props.body
        }
    }), props.byline && /*#__PURE__*/ react.createElement("span", null, props.byline));
};

// EXTERNAL MODULE: ./src/components/clickable/index.tsx + 1 modules
var clickable = __webpack_require__(87172);
// EXTERNAL MODULE: ./src/areas/expert/styles.ts
var styles = __webpack_require__(69620);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/globals/tracking/tracking.ts
var tracking = __webpack_require__(42779);
;// CONCATENATED MODULE: ./src/components/featured-article/related-article.tsx








var RelatedArticle = function(param) {
    var article = param.article, _preambleMaxLength = param.preambleMaxLength, preambleMaxLength = _preambleMaxLength === void 0 ? 80 : _preambleMaxLength;
    return /*#__PURE__*/ react.createElement(card/* Card */.Zb, null, /*#__PURE__*/ react.createElement(card/* CardActionArea */.MU, {
        container: clickable/* Clickable */.P,
        containerProps: {
            to: article.pathName,
            onClick: function() {
                return (0,tracking/* trackInternalNavigationClick */.p)({
                    scope: tracking/* InternalNavigationScope.RELATED_ARTICLE */.U.RELATED_ARTICLE,
                    nextPage: article.pathName
                });
            }
        }
    }, article.imageUrl && /*#__PURE__*/ react.createElement(StyledCardMedia, null, /*#__PURE__*/ react.createElement(lazy/* Lazy */.o, {
        loadOnIdle: true
    }, /*#__PURE__*/ react.createElement("img", {
        alt: article.title,
        src: article.imageUrl,
        height: 124
    }))), /*#__PURE__*/ react.createElement(card/* CardContent */.aY, null, /*#__PURE__*/ react.createElement(styles/* CardTitle */.ll, null, article.title), article.preamble && /*#__PURE__*/ react.createElement(variants/* BodySmallText */.oI, {
        container: "p"
    }, formatPreamble(article.preamble, preambleMaxLength)))));
};
function formatPreamble(str, maxLength) {
    return str && str.length > maxLength ? "".concat(str.substr(0, str.substr(0, maxLength).lastIndexOf(" ")).trim(), "\xa0…") : str;
}

;// CONCATENATED MODULE: ./src/components/featured-article/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var FeaturedArticle = function(param) {
    var article = param.article, _embedded = param.embedded, embedded = _embedded === void 0 ? true : _embedded, _related = param.related, related = _related === void 0 ? [] : _related;
    var articleId = article ? article.id : null;
    var relatedArticles = (article && article.related && article.related.articles ? related.concat(article.related.articles) : related).filter(Boolean).filter(function(item) {
        return (item === null || item === void 0 ? void 0 : item.id) !== articleId;
    }).sort(function(a, b) {
        return new Date((b === null || b === void 0 ? void 0 : b.publishedAt) || "1971-1-1").getTime() - new Date((a === null || a === void 0 ? void 0 : a.publishedAt) || "1971-1-1").getTime();
    });
    return /*#__PURE__*/ react.createElement(StyledFeaturedArticle, null, !!article && /*#__PURE__*/ react.createElement(StyledArticle, null, /*#__PURE__*/ react.createElement(Article, _extends({}, article, {
        embedded: embedded
    }))), /*#__PURE__*/ react.createElement(RelatedArticleContainer, {
        fullWidth: !article
    }, /*#__PURE__*/ react.createElement(RelatedArticleWrapper, null, relatedArticles.map(function(item) {
        return /*#__PURE__*/ react.createElement(RelatedArticle, {
            key: item.id,
            article: item
        });
    })), article && article.related && article.related.campaign && /*#__PURE__*/ react.createElement(campaign_group/* default */.Z, {
        campaigns: [
            article.related.campaign
        ]
    })));
};


/***/ }),

/***/ 11498:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kg": () => (/* reexport */ dual_range),
  "aV": () => (/* reexport */ list),
  "Y8": () => (/* reexport */ filters_radio),
  "BR": () => (/* reexport */ single_range)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-tools@1.7.2/node_modules/styled-tools/dist/es/index.js + 7 modules
var es = __webpack_require__(55703);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-up/index.js
var chevron_up = __webpack_require__(65451);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-down/index.js
var chevron_down = __webpack_require__(46503);
;// CONCATENATED MODULE: ./src/components/filters/styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  outline: 0;\n  opacity: 0;\n  position: absolute;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      box-shadow: 0 0 0 1px ",
        ";\n      border: 5px solid ",
        ";\n      color: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 2px;\n  margin-top: 2px;\n  margin-right: 10px;\n  width: 16px;\n  height: 16px;\n  border-radius: 100%;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      font-weight: 600;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 2.6rem;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  padding-right: ",
        "px;\n  color: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: 5px;\n  margin-right: 5px;\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: ",
        ";\n  flex-wrap: wrap;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  display: block;\n  user-select: none;\n  position: relative;\n  padding-left: ",
        ";\n  font-weight: ",
        ";\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  padding-top: 8px;\n  padding-bottom: 8px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      border: 1px solid ",
        ";\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n  display: flex;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-grow: 1;\n  color: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  word-break: break-word;\n  word-wrap: break-word;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  align-self: center;\n  color: ",
        ";\n  margin-left: 5px;\n  margin-right: 5px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  margin-left: auto;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: rgba(",
        ", 0.4);\n      &:hover,\n      &:active,\n      &:focus {\n        background-color: rgba(",
        ", 0.4);\n      }\n    "
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  cursor: pointer;\n  width: ",
        "rem;\n  height: ",
        "rem;\n  padding: 0;\n  text-align: center;\n\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}




var listSidePadding = "0.6rem";
/* stylelint-disable property-no-vendor-prefix */ var HiddenInput = styled_components_browser_esm["default"].input.withConfig({
    displayName: "HiddenInput",
    componentId: "sc-0-0"
})(_templateObject());
/* stylelint-enable property-no-vendor-prefix */ var listSideHeight = 2.6; // rem
var RadioButton = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RadioButton",
    componentId: "sc-0-1"
})(_templateObject2(), function(props) {
    return props.theme.colors.base0;
}, function(props) {
    return props.theme.colors.base300;
}, function(props) {
    return props.checked && (0,styled_components_browser_esm.css)(_templateObject1(), props.theme.colors.base0, props.theme.colors.base300, props.theme.colors.maybeBlue700, props.theme.colors.base700);
});
var Label = styled_components_browser_esm["default"].label.withConfig({
    displayName: "Label",
    componentId: "sc-0-2"
})(_templateObject4(), (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, 20, 0), function(props) {
    return props.theme.colors.base600;
}, function(props) {
    return props.theme.colors.base100;
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3());
});
var Counter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Counter",
    componentId: "sc-0-3"
})(_templateObject5(), function(props) {
    return props.theme.colors.base500;
});
var Layout = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Layout",
    componentId: "sc-0-4"
})(_templateObject6(), (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, "flex", "block"));
var ListItem = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ListItem",
    componentId: "sc-0-5"
})(_templateObject7(), listSidePadding, (0,es/* ifProp */.fq)("selected", "600", "normal"), function(props) {
    return props.theme.colors.base100;
});
var ListLabel = styled_components_browser_esm["default"].label.withConfig({
    displayName: "ListLabel",
    componentId: "sc-0-6"
})(_templateObject8());
var Checkbox = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Checkbox",
    componentId: "sc-0-7"
})(_templateObject10(), listSidePadding, function(props) {
    return props.theme.colors.white;
}, function(props) {
    return props.theme.colors.base300;
}, function(props) {
    return (props.checked || props.partial) && (0,styled_components_browser_esm.css)(_templateObject9(), props.theme.colors.maybeBlue700, props.theme.colors.maybeBlue700);
});
var ListLabelText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelText",
    componentId: "sc-0-8"
})(_templateObject11(), function(props) {
    return props.theme.colors.base600;
});
var ListLabelName = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelName",
    componentId: "sc-0-9"
})(_templateObject12());
var ListLabelByline = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ListLabelByline",
    componentId: "sc-0-10"
})(_templateObject13(), function(props) {
    return props.theme.colors.base500;
});
var ExpandWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "ExpandWrapper",
    componentId: "sc-0-11"
})(_templateObject14());
var ExpandButton = styled_components_browser_esm["default"].button.withConfig({
    displayName: "ExpandButton",
    componentId: "sc-0-12"
})(_templateObject16(), listSideHeight, listSideHeight / 2, function(props) {
    return props.expanded && (0,styled_components_browser_esm.css)(_templateObject15(), props.theme.colors.base200, props.theme.colors.base200);
});
var ArrowUp = (0,styled_components_browser_esm["default"])(chevron_up/* IconChevronUp */.y).attrs({
    color: "base300"
}).withConfig({
    displayName: "ArrowUp",
    componentId: "sc-0-13"
})(_templateObject17());
var ArrowDown = (0,styled_components_browser_esm["default"])(chevron_down/* IconChevronDown */.C).attrs({
    color: "base300"
}).withConfig({
    displayName: "ArrowDown",
    componentId: "sc-0-14"
})(_templateObject18());

;// CONCATENATED MODULE: ./src/components/filters/radio.js
/* eslint-disable jsx-a11y/label-has-for */ 


var Radio = function(props) {
    var values = props.values, selected = props.selected, layout = props.layout, onChange = props.onChange;
    return /*#__PURE__*/ react.createElement(Layout, {
        layout: layout
    }, values.map(function(value) {
        return /*#__PURE__*/ react.createElement(Label, {
            key: value.id,
            layout: layout
        }, /*#__PURE__*/ react.createElement(HiddenInput, {
            checked: selected === value.id,
            onChange: function(e) {
                onChange({
                    id: value.id,
                    checked: e.currentTarget.checked
                });
            },
            name: props.id,
            type: "radio",
            value: String(value.id)
        }), /*#__PURE__*/ react.createElement(RadioButton, {
            checked: selected === value.id
        }), value.text, value.products !== undefined && /*#__PURE__*/ react.createElement(Counter, null, "(", value.products, ")"));
    }));
};
var string = (prop_types_default()).string, number = (prop_types_default()).number, arrayOf = (prop_types_default()).arrayOf, shape = (prop_types_default()).shape, oneOfType = (prop_types_default()).oneOfType, oneOf = (prop_types_default()).oneOf, bool = (prop_types_default()).bool, func = (prop_types_default()).func;
Radio.propTypes = {
    id: oneOfType([
        string,
        number
    ]).isRequired,
    values: arrayOf(shape({
        id: oneOfType([
            string,
            number,
            bool
        ]),
        text: string,
        products: number
    })).isRequired,
    selected: oneOfType([
        string,
        number,
        bool
    ]),
    onChange: func,
    layout: oneOf([
        "vertical",
        "horizontal"
    ])
};
Radio.defaultProps = {
    selected: null,
    onChange: function() {},
    layout: "vertical"
};
/* harmony default export */ const filters_radio = (Radio);

;// CONCATENATED MODULE: ./src/components/filters/range/constants.js
var KEY_LEFT = "from";
var KEY_RIGHT = "to";
var TYPE_INTEGER = "integer";
var TYPE_DATE_YEAR = "date-year";
var TYPE_DECIMAL = "decimal";

// EXTERNAL MODULE: ./src/components/base/styles/variables.ts
var variables = __webpack_require__(8663);
;// CONCATENATED MODULE: ./src/components/filters/range/styles.js
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      margin-top: 0;\n      margin-bottom: 10px;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n  margin-top: 10px;\n  margin-bottom: 30px;\n  display: flex;\n  flex-flow: ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  margin: 0 20px 15px;\n  margin-top: ",
        ";\n"
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: ",
        "px;\n  margin-top: 5px;\n  display: flex;\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n      width: 100%;\n      height: 100%;\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n  flex: 1;\n  position: relative;\n  padding: 3px 1px 0 1px;\n  height: 100%;\n  text-align: center;\n  display: flex;\n  align-items: flex-end;\n  cursor: pointer;\n\n  ",
        "\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  background-color: ",
        ";\n  width: 100%;\n  max-width: 30px;\n  margin: 0 auto;\n  min-height: ",
        ";\n  transition: height 0.3s ease;\n"
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n  touch-action: pan-y;\n  position: absolute;\n  z-index: 1;\n  display: inline-flex;\n  width: 30px;\n  height: 30px;\n  padding-top: 5px;\n  justify-content: center;\n  cursor: pointer;\n  opacity: ",
        ";\n  left: ",
        "%;\n  transform: translateX(-50%) translateY(-",
        "px);\n  transition: ",
        ";\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        ";\n    "
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n  border-radius: 50%;\n  width: ",
        "px;\n  height: ",
        "px;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  ",
        "\n"
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  height: ",
        "px;\n  background-color: ",
        ";\n"
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ",
        ";\n  display: ",
        ";\n"
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n"
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: relative;\n  font-size: 11px;\n  color: ",
        ";\n  margin-top: ",
        "px;\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = styles_taggedTemplateLiteral([
        "\n      color: ",
        ";\n    "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = styles_taggedTemplateLiteral([
        "\n  position: absolute;\n  text-align: center;\n  transform: translateX(-50%);\n  cursor: pointer;\n  padding: 5px 0;\n  ",
        "\n"
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-color: ",
        ";\n      background-color: ",
        "];\n    "
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 70px;\n  text-align: center;\n  color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 2px;\n  font-size: 12px;\n  ",
        "\n"
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = styles_taggedTemplateLiteral([
        "\n      width: 180px;\n      order: 2;\n    "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = styles_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-self: center;\n  ",
        ";\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}



var lineThickness = 3; // px
var dotSize = 17; // px
var handleColor = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var numberColor = variables/* colors.lightTheme.base600 */.O9.lightTheme.base600;
var numberColorInactive = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textColor = variables/* colors.lightTheme.base600 */.O9.lightTheme.base600;
var textBorder = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textBorderInvalid = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var textBackgroundInvalid = variables/* colors.lightTheme.base500 */.O9.lightTheme.base500;
var barActive = variables/* colors.lightTheme.base700 */.O9.lightTheme.base700;
var barInactive = variables/* colors.lightTheme.base300 */.O9.lightTheme.base300;
var styles_Layout = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Layout",
    componentId: "sc-0-0"
})(styles_templateObject1(), (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, "row", "column"), function(param) {
    var layout = param.layout;
    return layout === "horizontal" && (0,styled_components_browser_esm.css)(styles_templateObject());
});
var SliderWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SliderWrapper",
    componentId: "sc-0-1"
})(styles_templateObject2(), function(param) {
    var showBars = param.showBars;
    return showBars ? "0px" : "15px";
});
var styles_Bars = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Bars",
    componentId: "sc-0-2"
})(styles_templateObject3(), (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, 13, 25));
var styles_Bar = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Bar",
    componentId: "sc-0-3"
})(styles_templateObject5(), function(props) {
    return props.inactive && (0,styled_components_browser_esm.css)(styles_templateObject4(), barInactive);
});
var Filler = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Filler",
    componentId: "sc-0-4"
})(styles_templateObject6(), barActive, function(param) {
    var empty = param.empty;
    return empty ? 0 : "2px";
});
var styles_Handles = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Handles",
    componentId: "sc-0-5"
})(styles_templateObject7());
var styles_Handle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Handle",
    componentId: "sc-0-6"
})(styles_templateObject8(), (0,es/* ifProp */.fq)("invalid", 0.4, 1), (0,es/* ifProp */.fq)({
    direction: "from"
}, 0, 100), dotSize - lineThickness, (0,es/* ifProp */.fq)("dragging", "none", "all 0.2s ease"));
var HandleDot = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HandleDot",
    componentId: "sc-0-7"
})(styles_templateObject10(), dotSize, dotSize, variables/* colors.lightTheme.base0 */.O9.lightTheme.base0, handleColor, function(param) {
    var selected = param.selected, dragging = param.dragging;
    return (selected || dragging) && (0,styled_components_browser_esm.css)(styles_templateObject9(), variables/* colors.lightTheme.base0 */.O9.lightTheme.base0, variables/* colors.lightTheme.maybeBlue700 */.O9.lightTheme.maybeBlue700);
});
var LineWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "LineWrapper",
    componentId: "sc-0-8"
})(styles_templateObject11(), (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, 1, lineThickness), variables/* colors.lightTheme.base300 */.O9.lightTheme.base300);
var styles_Line = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Line",
    componentId: "sc-0-9"
})(styles_templateObject12(), variables/* colors.lightTheme.base700 */.O9.lightTheme.base700, function(param) {
    var invalid = param.invalid;
    return invalid ? "none" : "block";
});
var NumberWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "NumberWrapper",
    componentId: "sc-0-10"
})(styles_templateObject13());
var styles_Number = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Number",
    componentId: "sc-0-11"
})(styles_templateObject14(), numberColor, (0,es/* ifProp */.fq)({
    layout: "horizontal"
}, 3, 6));
var NumberValue = styled_components_browser_esm["default"].button.withConfig({
    displayName: "NumberValue",
    componentId: "sc-0-12"
})(styles_templateObject16(), function(param) {
    var inactive = param.inactive;
    return inactive && (0,styled_components_browser_esm.css)(styles_templateObject15(), numberColorInactive);
});
var Input = styled_components_browser_esm["default"].input.withConfig({
    displayName: "Input",
    componentId: "sc-0-13"
})(styles_templateObject18(), textColor, textBorder, function(param) {
    var invalid = param.invalid;
    return invalid && (0,styled_components_browser_esm.css)(styles_templateObject17(), textBorderInvalid, textBackgroundInvalid);
});
var InputWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "InputWrapper",
    componentId: "sc-0-14"
})(_templateObject20(), function(param) {
    var layout = param.layout;
    return layout === "horizontal" && (0,styled_components_browser_esm.css)(_templateObject19());
});

;// CONCATENATED MODULE: ./src/components/filters/range/bar.js
/* eslint-disable jsx-a11y/no-static-element-interactions */ function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



var Bar = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(Bar, Component);
    var _super = _createSuper(Bar);
    function Bar(props) {
        _classCallCheck(this, Bar);
        var _this;
        _this = _super.call(this, props);
        _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
        return _this;
    }
    _createClass(Bar, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.fillData.fill !== nextProps.fillData.fill) {
                    return true;
                }
                if (this.props.max !== nextProps.max) {
                    return true;
                }
                if (this.props.products !== nextProps.products) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "onChange",
            value: function onChange() {
                this.props.onChange({
                    from: this.props.from,
                    to: this.props.to
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, products = _props.products, max = _props.max, fillData = _props.fillData;
                var fillPercentage = fillData.fill;
                var style = Bar.getHeight(products, max);
                var opacityStyle = {
                    opacity: 1 - fillPercentage
                };
                return /*#__PURE__*/ react.createElement(styles_Bar, {
                    onClick: this.onChange
                }, /*#__PURE__*/ react.createElement(Filler, {
                    style: style,
                    "data-opacity": fillPercentage,
                    empty: !products
                }, /*#__PURE__*/ react.createElement(styles_Bar, {
                    inactive: true,
                    style: opacityStyle
                })));
            }
        }
    ], [
        {
            key: "getHeight",
            value: function getHeight(products, max) {
                return {
                    height: "".concat(100 * (products / max), "%")
                };
            }
        }
    ]);
    return Bar;
}(react.Component);

Bar.propTypes = {
    id: (prop_types_default()).number.isRequired,
    fillData: prop_types_default().shape({
        fill: (prop_types_default()).number,
        from: (prop_types_default()).bool,
        to: (prop_types_default()).bool
    }).isRequired,
    products: (prop_types_default()).number.isRequired,
    max: (prop_types_default()).number.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    to: (prop_types_default()).number.isRequired,
    from: (prop_types_default()).number.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/bars.js
function bars_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function bars_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function bars_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function bars_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) bars_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) bars_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function bars_getPrototypeOf(o) {
    bars_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return bars_getPrototypeOf(o);
}
function bars_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) bars_setPrototypeOf(subClass, superClass);
}
function bars_possibleConstructorReturn(self, call) {
    if (call && (bars_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return bars_assertThisInitialized(self);
}
function bars_setPrototypeOf(o, p) {
    bars_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return bars_setPrototypeOf(o, p);
}
var bars_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function bars_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function bars_createSuper(Derived) {
    var hasNativeReflectConstruct = bars_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = bars_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = bars_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return bars_possibleConstructorReturn(this, result);
    };
}




var Bars = /*#__PURE__*/ function(Component) {
    "use strict";
    bars_inherits(Bars, Component);
    var _super = bars_createSuper(Bars);
    function Bars() {
        bars_classCallCheck(this, Bars);
        return _super.apply(this, arguments);
    }
    bars_createClass(Bars, [
        {
            key: "renderBar",
            value: function renderBar(data, index) {
                var fillData = this.props.getSectionFillData(index);
                return /*#__PURE__*/ react.createElement(Bar, _extends({
                    key: "bar".concat(index),
                    id: index,
                    max: this.props.values.max_matching_products,
                    onChange: this.props.onChange,
                    fillData: fillData
                }, data));
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Bars, {
                    layout: this.props.layout
                }, this.props.values.values.map(this.renderBar, this));
            }
        }
    ]);
    return Bars;
}(react.Component);

Bars.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_value: (prop_types_default()).number,
        min_value: (prop_types_default()).number,
        values: prop_types_default().arrayOf(prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number,
            max: (prop_types_default()).number,
            products: (prop_types_default()).number
        }))
    }).isRequired,
    getSectionFillData: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/line.js
function line_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function line_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function line_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function line_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) line_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) line_defineProperties(Constructor, staticProps);
    return Constructor;
}
function line_getPrototypeOf(o) {
    line_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return line_getPrototypeOf(o);
}
function line_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) line_setPrototypeOf(subClass, superClass);
}
function line_possibleConstructorReturn(self, call) {
    if (call && (line_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return line_assertThisInitialized(self);
}
function line_setPrototypeOf(o, p) {
    line_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return line_setPrototypeOf(o, p);
}
var line_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function line_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function line_createSuper(Derived) {
    var hasNativeReflectConstruct = line_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = line_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = line_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return line_possibleConstructorReturn(this, result);
    };
}



var Line = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    line_inherits(Line, _PureComponent);
    var _super = line_createSuper(Line);
    function Line() {
        line_classCallCheck(this, Line);
        return _super.apply(this, arguments);
    }
    line_createClass(Line, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(LineWrapper, {
                    layout: this.props.layout
                }, /*#__PURE__*/ react.createElement(styles_Line, {
                    invalid: this.props.invalid,
                    style: Line.getFilledStyle(this.props.from, this.props.to)
                }));
            }
        }
    ], [
        {
            key: "getFilledStyle",
            value: function getFilledStyle(from, to) {
                var leftValue = 100 * from;
                var rightValue = 100 - 100 * to;
                return {
                    left: "".concat(leftValue, "%"),
                    right: "".concat(rightValue, "%")
                };
            }
        }
    ]);
    return Line;
}(react.PureComponent);
Line.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    invalid: (prop_types_default()).bool.isRequired,
    from: (prop_types_default()).number.isRequired,
    to: (prop_types_default()).number.isRequired
};
/* harmony default export */ const line = (Line);

;// CONCATENATED MODULE: ./src/components/filters/range/text-input.js
function text_input_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function text_input_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function text_input_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function text_input_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) text_input_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) text_input_defineProperties(Constructor, staticProps);
    return Constructor;
}
function text_input_getPrototypeOf(o) {
    text_input_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return text_input_getPrototypeOf(o);
}
function text_input_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) text_input_setPrototypeOf(subClass, superClass);
}
function text_input_possibleConstructorReturn(self, call) {
    if (call && (text_input_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return text_input_assertThisInitialized(self);
}
function text_input_setPrototypeOf(o, p) {
    text_input_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return text_input_setPrototypeOf(o, p);
}
var text_input_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function text_input_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function text_input_createSuper(Derived) {
    var hasNativeReflectConstruct = text_input_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = text_input_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = text_input_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return text_input_possibleConstructorReturn(this, result);
    };
}



var TextInput = /*#__PURE__*/ function(Component) {
    "use strict";
    text_input_inherits(TextInput, Component);
    var _super = text_input_createSuper(TextInput);
    function TextInput(props) {
        text_input_classCallCheck(this, TextInput);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            tempValue: null,
            valid: true
        };
        _this.handleKeyUp = _this.handleKeyUp.bind(text_input_assertThisInitialized(_this));
        _this.handleBlur = _this.handleBlur.bind(text_input_assertThisInitialized(_this));
        _this.handleChange = _this.handleChange.bind(text_input_assertThisInitialized(_this));
        return _this;
    }
    text_input_createClass(TextInput, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (this.props.selected !== nextProps.selected) {
                    return true;
                }
                if (this.state.tempValue !== nextState.tempValue) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "handleKeyUp",
            value: function handleKeyUp(event) {
                // eslint-disable-next-line default-case
                switch(event.keyCode){
                    case 27:
                        this.resetInput();
                    // fall through
                    case 13:
                        event.target.blur();
                        break;
                }
            }
        },
        {
            key: "resetInput",
            value: function resetInput() {
                this.setState({
                    tempValue: null,
                    valid: true
                });
            }
        },
        {
            key: "handleBlur",
            value: function handleBlur() {
                if (this.state.tempValue === null) {
                    // Dont update filter if value never changed
                    return;
                }
                var newValue = TextInput.validate(this.state.tempValue || this.props.default);
                this.resetInput();
                if (isNaN(newValue)) {
                    return;
                }
                this.props.onChange({
                    id: this.props.id,
                    value: newValue
                });
            }
        },
        {
            key: "handleChange",
            value: function handleChange(event) {
                this.setState({
                    tempValue: event.target.value,
                    valid: !isNaN(TextInput.validate(event.target.value))
                });
            }
        },
        {
            key: "getValue",
            value: function getValue() {
                // Want to be able to erase the entire input field
                if (this.state.tempValue !== null && this.state.tempValue.length === 0) {
                    return "";
                }
                return this.state.tempValue || this.props.selected || this.props.default;
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(Input, {
                    type: "text",
                    invalid: !this.state.valid,
                    value: this.getValue(),
                    onKeyUp: this.handleKeyUp,
                    onBlur: this.handleBlur,
                    onChange: this.handleChange
                });
            }
        }
    ], [
        {
            key: "validate",
            value: function validate(num) {
                return +num.replace(",", ".");
            }
        }
    ]);
    return TextInput;
}(react.Component);

TextInput.propTypes = {
    id: (prop_types_default()).string.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    default: (prop_types_default()).string.isRequired,
    selected: (prop_types_default()).number
};
TextInput.defaultProps = {
    selected: null
};

;// CONCATENATED MODULE: ./src/components/filters/range/text-inputs.js
function text_inputs_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function text_inputs_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function text_inputs_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function text_inputs_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) text_inputs_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) text_inputs_defineProperties(Constructor, staticProps);
    return Constructor;
}
function text_inputs_getPrototypeOf(o) {
    text_inputs_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return text_inputs_getPrototypeOf(o);
}
function text_inputs_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) text_inputs_setPrototypeOf(subClass, superClass);
}
function text_inputs_possibleConstructorReturn(self, call) {
    if (call && (text_inputs_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return text_inputs_assertThisInitialized(self);
}
function text_inputs_setPrototypeOf(o, p) {
    text_inputs_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return text_inputs_setPrototypeOf(o, p);
}
var text_inputs_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function text_inputs_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function text_inputs_createSuper(Derived) {
    var hasNativeReflectConstruct = text_inputs_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = text_inputs_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = text_inputs_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return text_inputs_possibleConstructorReturn(this, result);
    };
}




var TextInputs = /*#__PURE__*/ function(Component) {
    "use strict";
    text_inputs_inherits(TextInputs, Component);
    var _super = text_inputs_createSuper(TextInputs);
    function TextInputs() {
        text_inputs_classCallCheck(this, TextInputs);
        return _super.apply(this, arguments);
    }
    text_inputs_createClass(TextInputs, [
        {
            key: "renderTextInput",
            value: function renderTextInput(key) {
                var defaultValue = this.props.minMax[key];
                var selected = this.props.selected ? this.props.selected[key] : null;
                return /*#__PURE__*/ react.createElement(TextInput, {
                    key: "input-".concat(key, "-").concat(defaultValue),
                    id: key,
                    default: "".concat(defaultValue),
                    selected: selected,
                    onChange: this.props.onChange
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(InputWrapper, {
                    layout: this.props.layout
                }, this.props.keys.map(this.renderTextInput, this));
            }
        }
    ]);
    return TextInputs;
}(react.Component);

TextInputs.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    keys: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    minMax: prop_types_default().shape({
        from: (prop_types_default()).number,
        to: (prop_types_default()).number
    }).isRequired,
    onChange: (prop_types_default()).func.isRequired,
    selected: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    ])
};
TextInputs.defaultProps = {
    selected: {
        from: null,
        to: null
    }
};

// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/throttle.js
var throttle = __webpack_require__(38209);
var throttle_default = /*#__PURE__*/__webpack_require__.n(throttle);
;// CONCATENATED MODULE: ./src/components/filters/range/handle.js
/* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/interactive-supports-focus */ function handle_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function handle_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function handle_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function handle_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) handle_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) handle_defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function handle_getPrototypeOf(o) {
    handle_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return handle_getPrototypeOf(o);
}
function handle_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) handle_setPrototypeOf(subClass, superClass);
}
function handle_possibleConstructorReturn(self, call) {
    if (call && (handle_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return handle_assertThisInitialized(self);
}
function handle_setPrototypeOf(o, p) {
    handle_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return handle_setPrototypeOf(o, p);
}
var handle_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function handle_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function handle_createSuper(Derived) {
    var hasNativeReflectConstruct = handle_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = handle_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = handle_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return handle_possibleConstructorReturn(this, result);
    };
}




var Handle = /*#__PURE__*/ function(Component) {
    "use strict";
    handle_inherits(Handle, Component);
    var _super = handle_createSuper(Handle);
    function Handle(props) {
        handle_classCallCheck(this, Handle);
        var _this;
        _this = _super.call(this, props);
        _defineProperty(handle_assertThisInitialized(_this), "startDrag", function(event) {
            _this.setState({
                dragging: true
            });
            // Prevent default to get rid of the "issue" where the user might select text when dragging
            event.preventDefault();
            var sliderWidth = _this.props.getSliderWidth();
            _this.pixelSize = 100 / sliderWidth;
            _this.initialPointerX = Handle.getPointerX(event);
            _this.currentPointerX = _this.initialPointerX;
            _this.initialPosition = _this.props.positionData.position * 100;
            var throttledDragHelper = throttle_default()(_this.dragPositionHelper, 1000 / 60);
            _this.dragHelper = function(moveEvent) {
                // this is necessary because if the preventDefault is throttled
                // the page will be able to be panned when dragging a handle. (touch only)
                // UPDATE: might not be necessary if touch-action works as advertised.
                moveEvent.preventDefault();
                throttledDragHelper(moveEvent);
            };
            _this.props.startDragging(function() {
                requestAnimationFrame(_this.handleDrag);
                _this.addMoveEventListeners();
                _this.removeEndEventListeners(); // make sure any dangling events are removed before adding new
                _this.addEndEventListeners();
            });
        });
        _defineProperty(handle_assertThisInitialized(_this), "handleDrag", function() {
            if (!_this.props.dragging) {
                return;
            }
            // if no movement, skip calculation, wait for next frame
            if (_this.currentPointerX === _this.prevPointerX) {
                requestAnimationFrame(_this.handleDrag);
                return;
            }
            var deltaX = _this.currentPointerX - _this.initialPointerX;
            var percentageMoved = deltaX * _this.pixelSize;
            var positionPercentage = _this.initialPosition + percentageMoved;
            _this.prevPointerX = _this.currentPointerX;
            _this.props.updateSlider({
                id: _this.props.id,
                position: positionPercentage
            });
            if (_this.props.dragging) {
                requestAnimationFrame(_this.handleDrag);
            }
        });
        _defineProperty(handle_assertThisInitialized(_this), "stopDrag", function() {
            _this.setState({
                dragging: false
            });
            _this.removeMoveEventListeners();
            _this.removeEndEventListeners();
            _this.initialPointerX = null;
            _this.initialPosition = null;
            _this.props.stopDragging();
        });
        _defineProperty(handle_assertThisInitialized(_this), "dragPositionHelper", function(event) {
            _this.currentPointerX = Handle.getPointerX(event);
        });
        _this.state = {
            dragging: false
        };
        return _this;
    }
    handle_createClass(Handle, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.positionData.position !== nextProps.positionData.position) {
                    return true;
                }
                if (this.props.dragging !== nextProps.dragging) {
                    return true;
                }
                return false;
            }
        },
        {
            key: "addMoveEventListeners",
            value: function addMoveEventListeners() {
                var _this = this;
                [
                    "touchmove",
                    "mousemove"
                ].forEach(function(eventName) {
                    document.addEventListener(eventName, _this.dragHelper);
                });
            }
        },
        {
            key: "removeMoveEventListeners",
            value: function removeMoveEventListeners() {
                var _this = this;
                [
                    "touchmove",
                    "mousemove"
                ].forEach(function(eventName) {
                    document.removeEventListener(eventName, _this.dragHelper);
                });
            }
        },
        {
            key: "addEndEventListeners",
            value: function addEndEventListeners() {
                var _this = this;
                [
                    "touchend",
                    "mouseup"
                ].forEach(function(eventName) {
                    document.addEventListener(eventName, _this.stopDrag);
                });
            }
        },
        {
            key: "removeEndEventListeners",
            value: function removeEndEventListeners() {
                var _this = this;
                [
                    "touchend",
                    "mouseup"
                ].forEach(function(eventName) {
                    document.removeEventListener(eventName, _this.stopDrag);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Handle, {
                    direction: this.props.id,
                    onMouseDown: this.startDrag,
                    onTouchStart: this.startDrag,
                    dragging: this.state.dragging,
                    style: {
                        left: "".concat(this.props.positionData.position * 100, "%")
                    }
                }, /*#__PURE__*/ react.createElement(HandleDot, {
                    selected: this.props.selected,
                    dragging: this.state.dragging
                }));
            }
        }
    ], [
        {
            key: "getPointerX",
            value: function getPointerX(event) {
                if (event.clientX) {
                    return event.clientX;
                }
                return event.touches ? event.touches[0].clientX : null;
            }
        }
    ]);
    return Handle;
}(react.Component);

Handle.defaultProps = {
    selected: false
};
Handle.propTypes = {
    id: (prop_types_default()).string.isRequired,
    selected: (prop_types_default()).bool,
    positionData: prop_types_default().shape({
        fill: (prop_types_default()).number,
        position: (prop_types_default()).number,
        section: (prop_types_default()).number
    }).isRequired,
    startDragging: (prop_types_default()).func.isRequired,
    stopDragging: (prop_types_default()).func.isRequired,
    getSliderWidth: (prop_types_default()).func.isRequired,
    updateSlider: (prop_types_default()).func.isRequired,
    dragging: (prop_types_default()).bool.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/handles.js
function handles_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function handles_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function handles_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function handles_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) handles_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) handles_defineProperties(Constructor, staticProps);
    return Constructor;
}
function handles_getPrototypeOf(o) {
    handles_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return handles_getPrototypeOf(o);
}
function handles_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) handles_setPrototypeOf(subClass, superClass);
}
function handles_possibleConstructorReturn(self, call) {
    if (call && (handles_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return handles_assertThisInitialized(self);
}
function handles_setPrototypeOf(o, p) {
    handles_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return handles_setPrototypeOf(o, p);
}
var handles_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function handles_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function handles_createSuper(Derived) {
    var hasNativeReflectConstruct = handles_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = handles_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = handles_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return handles_possibleConstructorReturn(this, result);
    };
}




var Handles = /*#__PURE__*/ function(Component) {
    "use strict";
    handles_inherits(Handles, Component);
    var _super = handles_createSuper(Handles);
    function Handles() {
        handles_classCallCheck(this, Handles);
        return _super.apply(this, arguments);
    }
    handles_createClass(Handles, [
        {
            key: "renderHandle",
            value: function renderHandle(key) {
                return /*#__PURE__*/ react.createElement(Handle, {
                    key: "handle-".concat(key),
                    id: key,
                    selected: this.props.selected && Boolean(this.props.selected[key]),
                    positionData: this.props.positionData[key],
                    startDragging: this.props.startDragging,
                    stopDragging: this.props.stopDragging,
                    getSliderWidth: this.props.getSliderWidth,
                    updateSlider: this.props.updateSlider,
                    dragging: this.props.dragging
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Handles, null, this.props.keys.map(this.renderHandle, this));
            }
        }
    ]);
    return Handles;
}(react.Component);

Handles.defaultProps = {
    selected: {
        from: false,
        to: false
    }
};
Handles.propTypes = {
    keys: prop_types_default().arrayOf((prop_types_default()).string).isRequired,
    selected: prop_types_default().shape({
        from: (prop_types_default()).bool,
        to: (prop_types_default()).bool
    }),
    positionData: prop_types_default().shape({
        from: prop_types_default().shape({
            fill: (prop_types_default()).number,
            position: (prop_types_default()).number,
            section: (prop_types_default()).number
        }),
        to: prop_types_default().shape({
            fill: (prop_types_default()).number,
            position: (prop_types_default()).number,
            section: (prop_types_default()).number
        })
    }).isRequired,
    startDragging: (prop_types_default()).func.isRequired,
    stopDragging: (prop_types_default()).func.isRequired,
    getSliderWidth: (prop_types_default()).func.isRequired,
    updateSlider: (prop_types_default()).func.isRequired,
    dragging: (prop_types_default()).bool.isRequired
};

// EXTERNAL MODULE: ./node_modules/.pnpm/react-dom@18.1.0_react@18.1.0/node_modules/react-dom/index.js
var react_dom = __webpack_require__(19103);
;// CONCATENATED MODULE: ./src/components/filters/range/number.js
function number_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function number_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function number_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function number_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) number_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) number_defineProperties(Constructor, staticProps);
    return Constructor;
}
function number_getPrototypeOf(o) {
    number_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return number_getPrototypeOf(o);
}
function number_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) number_setPrototypeOf(subClass, superClass);
}
function number_possibleConstructorReturn(self, call) {
    if (call && (number_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return number_assertThisInitialized(self);
}
function number_setPrototypeOf(o, p) {
    number_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return number_setPrototypeOf(o, p);
}
var number_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function number_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function number_createSuper(Derived) {
    var hasNativeReflectConstruct = number_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = number_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = number_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return number_possibleConstructorReturn(this, result);
    };
}



var number_Number = /*#__PURE__*/ function(Component) {
    "use strict";
    number_inherits(Number, Component);
    var _super = number_createSuper(Number);
    function Number(props) {
        number_classCallCheck(this, Number);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind(number_assertThisInitialized(_this));
        return _this;
    }
    number_createClass(Number, [
        {
            key: "onClick",
            value: function onClick() {
                this.props.onChange({
                    index: this.props.index,
                    value: this.props.value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(styles_Number, {
                    layout: this.props.layout
                }, /*#__PURE__*/ react.createElement(NumberValue, {
                    inactive: !this.props.selected,
                    onClick: this.onClick
                }, this.props.value));
            }
        }
    ]);
    return Number;
}(react.Component);

number_Number.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    value: (prop_types_default()).number.isRequired,
    onChange: (prop_types_default()).func.isRequired,
    index: (prop_types_default()).number.isRequired,
    selected: (prop_types_default()).bool
};
number_Number.defaultProps = {
    selected: true
};

;// CONCATENATED MODULE: ./src/components/filters/range/numbers.js
function numbers_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function numbers_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function numbers_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function numbers_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) numbers_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) numbers_defineProperties(Constructor, staticProps);
    return Constructor;
}
function numbers_extends() {
    numbers_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return numbers_extends.apply(this, arguments);
}
function numbers_getPrototypeOf(o) {
    numbers_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return numbers_getPrototypeOf(o);
}
function numbers_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) numbers_setPrototypeOf(subClass, superClass);
}
function numbers_possibleConstructorReturn(self, call) {
    if (call && (numbers_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return numbers_assertThisInitialized(self);
}
function numbers_setPrototypeOf(o, p) {
    numbers_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return numbers_setPrototypeOf(o, p);
}
var numbers_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function numbers_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function numbers_createSuper(Derived) {
    var hasNativeReflectConstruct = numbers_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = numbers_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = numbers_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return numbers_possibleConstructorReturn(this, result);
    };
}





var Numbers = /*#__PURE__*/ function(Component) {
    "use strict";
    numbers_inherits(Numbers, Component);
    var _super = numbers_createSuper(Numbers);
    function Numbers(props) {
        numbers_classCallCheck(this, Numbers);
        var _this;
        _this = _super.call(this, props);
        _this.numberRefs = [];
        _this.wrapper = null;
        return _this;
    }
    numbers_createClass(Numbers, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.adjustVisibleNumbers();
            }
        },
        {
            key: "getSectionValues",
            value: function getSectionValues() {
                var _this = this;
                return this.props.sections.reduce(function(values, section, index) {
                    var fillData = _this.props.getSectionFillData(index);
                    if (index === 0) {
                        values.push({
                            value: section.from,
                            index: index,
                            selected: fillData.from
                        });
                    }
                    values.push({
                        value: section.to,
                        index: index + 1,
                        selected: fillData.to
                    });
                    return values;
                }, []);
            }
        },
        {
            /* eslint-disable no-plusplus, react/no-find-dom-node, no-continue, no-constant-condition */ key: "adjustVisibleNumbers",
            value: function adjustVisibleNumbers() {
                if (!this.wrapper) {
                    return;
                }
                var lastVisibleNode = null;
                var selector = "button";
                var length = this.getSectionValues().length;
                if (true) {
                    for(var i = 0; i < length; i++){
                        var numberNode = react_dom.findDOMNode(this.numberRefs["number".concat(i)]);
                        if (!numberNode) {
                            continue;
                        }
                        var currentNode = numberNode.querySelector("".concat(selector));
                        if (!currentNode) {
                            continue;
                        }
                        currentNode.style.display = "block";
                        if (lastVisibleNode === null) {
                            lastVisibleNode = numberNode.querySelector("".concat(selector));
                            continue;
                        }
                        var lastVisibleRect = lastVisibleNode.getBoundingClientRect();
                        var currentRect = currentNode.getBoundingClientRect();
                        var distance = currentRect.left - lastVisibleRect.right;
                        // we need some distance between the numbers,
                        // i.e we do not want to show number too close to each other like 2030, we want 20 30.
                        if (distance < 5) {
                            // numbers are overlapping, hide current node UNLESS current node is the last node.
                            // Because we do want to show the edge numbers they are more important than the others.
                            if (i === length - 1) {
                                currentNode = lastVisibleNode;
                            }
                            currentNode.style.display = "none";
                        } else {
                            lastVisibleNode = currentNode;
                        }
                    }
                    this.visibleNumbersAdjusted = true;
                }
            }
        },
        {
            key: "renderNumber",
            value: function renderNumber(section, index) {
                var _this = this;
                return /*#__PURE__*/ react.createElement(number_Number, numbers_extends({
                    key: "number".concat(index),
                    layout: this.props.layout,
                    ref: function(c) {
                        _this.numberRefs["number".concat(index)] = c;
                    },
                    value: section.value,
                    index: section.index,
                    onChange: this.props.onChange
                }, section));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var sectionValues = this.getSectionValues();
                return /*#__PURE__*/ react.createElement(NumberWrapper, {
                    ref: function(node) {
                        _this.wrapper = node;
                    }
                }, sectionValues.map(this.renderNumber, this));
            }
        }
    ]);
    return Numbers;
}(react.Component);

Numbers.propTypes = {
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ]).isRequired,
    sections: prop_types_default().arrayOf(prop_types_default().shape({
        from: (prop_types_default()).number,
        to: (prop_types_default()).number,
        products: (prop_types_default()).number
    })).isRequired,
    getSectionFillData: (prop_types_default()).func.isRequired,
    onChange: (prop_types_default()).func.isRequired
};

;// CONCATENATED MODULE: ./src/components/filters/range/range.js
function range_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function range_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function range_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function range_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) range_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) range_defineProperties(Constructor, staticProps);
    return Constructor;
}
function range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function range_getPrototypeOf(o) {
    range_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return range_getPrototypeOf(o);
}
function range_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) range_setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function range_possibleConstructorReturn(self, call) {
    if (call && (range_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return range_assertThisInitialized(self);
}
function range_setPrototypeOf(o, p) {
    range_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return range_setPrototypeOf(o, p);
}
var range_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function range_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function range_createSuper(Derived) {
    var hasNativeReflectConstruct = range_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = range_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = range_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return range_possibleConstructorReturn(this, result);
    };
}









var Range = /*#__PURE__*/ function(Component) {
    "use strict";
    range_inherits(Range, Component);
    var _super = range_createSuper(Range);
    function Range(props) {
        range_classCallCheck(this, Range);
        var _this;
        _this = _super.call(this, props);
        range_defineProperty(range_assertThisInitialized(_this), "getSectionFillData", function(index) {
            // | = section, [---] = selection
            var _positionData = _this.state.positionData, from = _positionData.from, to = _positionData.to;
            // whole section inside selection. ie [--|--|--]
            if (index > from.section && index < to.section) {
                return {
                    from: true,
                    to: true,
                    fill: 1
                };
            }
            // section touches from right. ie |-[-|----]
            if (index === from.section && index !== to.section) {
                return {
                    from: from.fill === 0,
                    to: true,
                    fill: 1 - from.fill
                };
            }
            // section touches from left. ie [----|-]-|
            if (index !== from.section && index === to.section) {
                return {
                    from: true,
                    to: to.fill === 1,
                    fill: to.fill
                };
            }
            // whole selection inside section. . ie |-[-]-|
            if (index === from.section && index === to.section) {
                return {
                    from: false,
                    to: false,
                    fill: to.fill - from.fill
                };
            }
            // section outside selection. ie [----]-|--|
            return {
                from: false,
                to: false,
                fill: 0
            };
        });
        range_defineProperty(range_assertThisInitialized(_this), "getSliderWidth", function() {
            var sliderNode = _this.slider;
            return sliderNode.offsetWidth;
        });
        range_defineProperty(range_assertThisInitialized(_this), "startDragging", function(callback) {
            _this.setState({
                dragging: true
            }, callback);
        });
        range_defineProperty(range_assertThisInitialized(_this), "stopDragging", function() {
            _this.setState({
                dragging: false
            }, function() {
                _this.commitChanges(_this.state.selected);
            });
        });
        range_defineProperty(range_assertThisInitialized(_this), "updateValueFromPosition", function(key, positionPercentage) {
            var sectionCount = _this.props.values.values.length;
            var rawValueMapping = positionPercentage / (100 / sectionCount);
            var index = Math.floor(rawValueMapping);
            var fill = parseFloat((rawValueMapping % 1).toFixed(4));
            // make sure inside outer bounds
            var bounds = Range.getSectionBounds(sectionCount);
            if (index < bounds.from.section) {
                index = bounds.from.section;
                fill = bounds.from.fill;
            } else if (index > bounds.to.section) {
                index = bounds.to.section;
                fill = bounds.to.fill;
            }
            var newSelected = _objectSpreadProps(_objectSpread({}, _this.props.selected), range_defineProperty({}, key, Range.getSectionValue(_this.props.values.values[index], fill)));
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "adjustValueForPropertyType", function(value) {
            var step = null;
            var type = _this.props.type;
            switch(type){
                case TYPE_INTEGER:
                case TYPE_DATE_YEAR:
                    step = 1;
                    break;
                case TYPE_DECIMAL:
                default:
                    step = 10;
            }
            return Math.round(value * step) / step;
        });
        range_defineProperty(range_assertThisInitialized(_this), "moveClosestHandle", function(value, index) {
            var _positionData = _this.state.positionData, from = _positionData.from, to = _positionData.to;
            var fromDifference = Math.abs(from.section + from.fill - index);
            var toDifference = Math.abs(to.section + to.fill - index);
            var newSelected = {};
            if (fromDifference < toDifference) {
                newSelected.from = value;
            } else {
                newSelected.to = value;
            }
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "normalizeSelected", function(selected, data) {
            var realMinMax = _this.state.realMinMax;
            var newSelected = _objectSpread({}, realMinMax, selected, data);
            newSelected.from = _this.adjustValueForPropertyType(newSelected.from);
            newSelected.to = _this.adjustValueForPropertyType(newSelected.to);
            if (newSelected.from > newSelected.to) {
                var tempValue = newSelected.from;
                newSelected.from = newSelected.to;
                newSelected.to = tempValue;
            }
            return newSelected;
        });
        range_defineProperty(range_assertThisInitialized(_this), "onChange", function(event) {
            var selected = _this.updateValueFromPosition(event.id, event.position);
            _this.update(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onTextInputChange", function(event) {
            var selected = range_defineProperty({}, event.id, event.value);
            _this.commitChanges(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onBarClick", function(event) {
            _this.commitChanges(event);
        });
        range_defineProperty(range_assertThisInitialized(_this), "onNumberClick", function(event) {
            var selected = _this.moveClosestHandle(event.value, event.index);
            _this.commitChanges(selected);
        });
        range_defineProperty(range_assertThisInitialized(_this), "commitChanges", function(selected) {
            _this.props.onChange(_this.update(selected));
        });
        range_defineProperty(range_assertThisInitialized(_this), "update", function(selected) {
            var newSelected = _this.normalizeSelected(_this.state.selected, selected);
            var positionData = Range.calculatePositionData(_this.props.values, newSelected);
            _this.setState({
                positionData: positionData,
                selected: newSelected
            });
            return newSelected;
        });
        var realMinMax = Range.getRealMinMax(props.values.values);
        var positionData = Range.calculatePositionData(props.values, props.selected);
        _this.state = {
            positionData: positionData,
            realMinMax: realMinMax,
            selected: props.selected,
            dragging: false
        };
        return _this;
    }
    range_createClass(Range, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (!this.props.selected && prevProps.selected !== this.props.selected) {
                    // eslint-disable-next-line
                    this.setState({
                        positionData: Range.calculatePositionData(this.props.values, this.props.selected),
                        selected: this.props.selected
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, showBars = _props.showBars, values = _props.values, layout = _props.layout;
                var _positionData = this.state.positionData, from = _positionData.from, to = _positionData.to;
                var _state = this.state, selected = _state.selected, realMinMax = _state.realMinMax, dragging = _state.dragging;
                var isSelected = {
                    from: selected ? selected.from > realMinMax.from : false,
                    to: selected ? selected.to < realMinMax.to : false
                };
                return /*#__PURE__*/ react.createElement(styles_Layout, {
                    layout: layout
                }, /*#__PURE__*/ react.createElement(TextInputs, {
                    keys: [
                        KEY_LEFT,
                        KEY_RIGHT
                    ],
                    selected: this.state.selected,
                    onChange: this.onTextInputChange,
                    minMax: realMinMax,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(SliderWrapper, {
                    ref: function(c) {
                        _this.slider = c;
                    },
                    showBars: showBars
                }, showBars && /*#__PURE__*/ react.createElement(Bars, {
                    values: values,
                    onChange: this.onBarClick,
                    getSectionFillData: this.getSectionFillData,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(line, {
                    invalid: !this.props.isValid,
                    from: from.position,
                    to: to.position,
                    layout: layout
                }), /*#__PURE__*/ react.createElement(Handles, {
                    keys: [
                        KEY_LEFT,
                        KEY_RIGHT
                    ],
                    selected: isSelected,
                    invalid: !this.props.isValid,
                    positionData: this.state.positionData,
                    updateSlider: this.onChange,
                    startDragging: this.startDragging,
                    stopDragging: this.stopDragging,
                    getSliderWidth: this.getSliderWidth,
                    dragging: dragging
                }), /*#__PURE__*/ react.createElement(Numbers, {
                    sections: values.values,
                    onChange: this.onNumberClick,
                    getSectionFillData: this.getSectionFillData,
                    layout: layout
                })));
            }
        }
    ], [
        {
            key: "getRealMinMax",
            value: /**
   * We can't use props.values.max_values/min_values since they refer to
   * min max for actual products, not what the range contains.
   * @param values
   */ function getRealMinMax(values) {
                var maxIndex = values.length - 1;
                return {
                    from: values[0].from,
                    to: values[maxIndex].to
                };
            }
        },
        {
            key: "getSectionFill",
            value: function getSectionFill(section, value) {
                var range = section.to - section.from;
                var valueInRange = value - section.from;
                return valueInRange / range;
            }
        },
        {
            key: "getSectionValue",
            value: function getSectionValue(section, fill) {
                var range = section.to - section.from;
                return parseFloat((section.from + range * fill).toFixed(4));
            }
        },
        {
            key: "getSectionBounds",
            value: function getSectionBounds(sectionCount) {
                var _obj;
                return _obj = {}, range_defineProperty(_obj, KEY_LEFT, {
                    section: 0,
                    fill: 0,
                    position: 0
                }), range_defineProperty(_obj, KEY_RIGHT, {
                    section: sectionCount - 1,
                    fill: 1,
                    position: 1
                }), _obj;
            }
        },
        {
            key: "findSectionIndexForValue",
            value: function findSectionIndexForValue(sections, value) {
                return sections.findIndex(function(section) {
                    if (section.from <= value && section.to >= value) {
                        return true;
                    }
                    return false;
                });
            }
        },
        {
            key: "calculatePositionData",
            value: function calculatePositionData(values, selected) {
                var sectionCount = values.values.length;
                if (!selected) {
                    return Range.getSectionBounds(sectionCount);
                }
                return [
                    KEY_LEFT,
                    KEY_RIGHT
                ].reduce(function(positionData, key) {
                    var selectValue = selected[key];
                    // get section value is in.
                    var sectionData = {};
                    var section = Range.findSectionIndexForValue(values.values, selectValue);
                    if (section === -1) {
                        // section not found which means selection is out of bound
                        // (e.g. "I want 1tb RAM" is a valid filter even though 1tb RAM does not (yet) exist)
                        sectionData.section = key === KEY_LEFT ? 0 : sectionCount - 1;
                        sectionData.fill = key === KEY_LEFT ? 0 : 1;
                        sectionData.position = key === KEY_LEFT ? 0 : 1;
                    } else {
                        sectionData.section = section;
                        sectionData.fill = Range.getSectionFill(values.values[section], selectValue);
                        sectionData.position = (section + sectionData.fill) / sectionCount;
                    }
                    return _objectSpreadProps(_objectSpread({}, positionData), range_defineProperty({}, key, sectionData));
                }, {});
            }
        }
    ]);
    return Range;
}(react.Component);

Range.propTypes = {
    layout: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_values: (prop_types_default()).number,
        min_values: (prop_types_default()).number,
        values: prop_types_default().arrayOf(prop_types_default().shape([
            prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            })
        ]))
    }).isRequired,
    type: (prop_types_default()).string.isRequired,
    showBars: (prop_types_default()).bool,
    isValid: (prop_types_default()).bool,
    onChange: (prop_types_default()).func.isRequired,
    selected: prop_types_default().oneOfType([
        (prop_types_default()).string,
        prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    ])
};
Range.defaultProps = {
    layout: "vertical",
    showBars: true,
    isValid: true,
    selected: undefined
};

;// CONCATENATED MODULE: ./src/components/filters/dual-range.js
function dual_range_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function dual_range_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function dual_range_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function dual_range_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) dual_range_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) dual_range_defineProperties(Constructor, staticProps);
    return Constructor;
}
function dual_range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dual_range_extends() {
    dual_range_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dual_range_extends.apply(this, arguments);
}
function dual_range_getPrototypeOf(o) {
    dual_range_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return dual_range_getPrototypeOf(o);
}
function dual_range_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) dual_range_setPrototypeOf(subClass, superClass);
}
function dual_range_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dual_range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function dual_range_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dual_range_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dual_range_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function dual_range_possibleConstructorReturn(self, call) {
    if (call && (dual_range_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return dual_range_assertThisInitialized(self);
}
function dual_range_setPrototypeOf(o, p) {
    dual_range_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return dual_range_setPrototypeOf(o, p);
}
var dual_range_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function dual_range_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function dual_range_createSuper(Derived) {
    var hasNativeReflectConstruct = dual_range_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = dual_range_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = dual_range_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return dual_range_possibleConstructorReturn(this, result);
    };
}




var DualRange = /*#__PURE__*/ function(_Component) {
    "use strict";
    dual_range_inherits(DualRange, _Component);
    var _super = dual_range_createSuper(DualRange);
    function DualRange(props) {
        dual_range_classCallCheck(this, DualRange);
        var _this;
        _this = _super.call(this, props);
        var _obj;
        _this.defaultValues = (_obj = {}, dual_range_defineProperty(_obj, KEY_LEFT, null), dual_range_defineProperty(_obj, KEY_RIGHT, null), _obj);
        _this.state = {
            selected: _this.props.selected
        };
        return _this;
    }
    dual_range_createClass(DualRange, [
        {
            key: "getPropsForRange",
            value: function getPropsForRange(key) {
                var values = this.props.values;
                var selected = this.state.selected;
                var newProps = dual_range_objectSpreadProps(dual_range_objectSpread({}, this.props), {
                    values: {
                        min_value: values.min_value,
                        max_value: values.max_value,
                        values: values.values[key]
                    }
                });
                if (selected) {
                    newProps = dual_range_objectSpreadProps(dual_range_objectSpread({}, newProps), {
                        selected: selected[key]
                    });
                }
                return newProps;
            }
        },
        {
            key: "onChange",
            value: function onChange(key, evt) {
                // The API requires us to send in both 'from' and 'to', null values are okay however.
                // This merges the nullified values with the selected and finally the changed value
                var newSelected = dual_range_objectSpreadProps(dual_range_objectSpread({}, this.defaultValues, this.state.selected), dual_range_defineProperty({}, key, evt));
                // If both 'from' and 'to' is null we will make the entire setting null(aka, clear it)
                if (DualRange.selectedIsNull(newSelected)) {
                    newSelected = null;
                }
                this.setState({
                    selected: newSelected
                });
                this.props.onChange({
                    value: newSelected
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(Range, dual_range_extends({}, this.getPropsForRange(KEY_LEFT), {
                    onChange: function(evt) {
                        return _this.onChange(KEY_LEFT, evt);
                    }
                })), /*#__PURE__*/ react.createElement(Range, dual_range_extends({}, this.getPropsForRange(KEY_RIGHT), {
                    onChange: function(evt) {
                        return _this.onChange(KEY_RIGHT, evt);
                    }
                })));
            }
        }
    ], [
        {
            key: "deriveStateFromProps",
            value: function deriveStateFromProps(nextProps) {
                return {
                    selected: nextProps.selected
                };
            }
        },
        {
            key: "selectedIsNull",
            value: function selectedIsNull(selected) {
                return Object.keys(selected).filter(function(index) {
                    return selected[index];
                }).length === 0;
            }
        }
    ]);
    return DualRange;
}(react.Component);
DualRange.propTypes = {
    onChange: (prop_types_default()).func.isRequired,
    values: prop_types_default().shape({
        max_matching_products: (prop_types_default()).number,
        max_values: (prop_types_default()).number,
        min_values: (prop_types_default()).number,
        values: prop_types_default().shape({
            from: prop_types_default().arrayOf(prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            })),
            to: prop_types_default().arrayOf(prop_types_default().shape({
                from: (prop_types_default()).number,
                to: (prop_types_default()).number,
                products: (prop_types_default()).number
            }))
        })
    }).isRequired,
    selected: prop_types_default().shape({
        from: prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        }),
        to: prop_types_default().shape({
            from: (prop_types_default()).number,
            to: (prop_types_default()).number
        })
    }),
    layout: prop_types_default().oneOf([
        "vertical",
        "horizontal"
    ])
};
DualRange.defaultProps = {
    selected: null,
    layout: "vertical"
};
/* harmony default export */ const dual_range = (DualRange);

// EXTERNAL MODULE: ./src/ui/icons/index.ts + 4 modules
var icons = __webpack_require__(31913);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/filters/checkbox.js
function checkbox_assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function checkbox_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function checkbox_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function checkbox_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) checkbox_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) checkbox_defineProperties(Constructor, staticProps);
    return Constructor;
}
function checkbox_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function checkbox_getPrototypeOf(o) {
    checkbox_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return checkbox_getPrototypeOf(o);
}
function checkbox_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) checkbox_setPrototypeOf(subClass, superClass);
}
function checkbox_possibleConstructorReturn(self, call) {
    if (call && (checkbox_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return checkbox_assertThisInitialized(self);
}
function checkbox_setPrototypeOf(o, p) {
    checkbox_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return checkbox_setPrototypeOf(o, p);
}
var checkbox_typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function checkbox_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function checkbox_createSuper(Derived) {
    var hasNativeReflectConstruct = checkbox_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = checkbox_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = checkbox_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return checkbox_possibleConstructorReturn(this, result);
    };
}




var checkbox_Checkbox = /*#__PURE__*/ function(_PureComponent) {
    "use strict";
    checkbox_inherits(Checkbox, _PureComponent);
    var _super = checkbox_createSuper(Checkbox);
    function Checkbox(props) {
        checkbox_classCallCheck(this, Checkbox);
        var _this;
        _this = _super.call(this, props);
        checkbox_defineProperty(checkbox_assertThisInitialized(_this), "handleOnChange", function(e) {
            _this.props.onChange({
                id: _this.props.id,
                value: _this.props.child.id,
                name: _this.props.child.name,
                checked: e.currentTarget.checked,
                children: _this.props.child.children,
                parents: _this.props.parents,
                autoSelectChildren: _this.props.autoSelectChildren
            });
        });
        return _this;
    }
    checkbox_createClass(Checkbox, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ react.createElement(HiddenInput, {
                    checked: this.props.isChecked,
                    onChange: this.handleOnChange,
                    type: "checkbox",
                    value: this.props.child.id
                });
            }
        }
    ]);
    return Checkbox;
}(react.PureComponent);
var checkbox_oneOfType = (prop_types_default()).oneOfType, checkbox_arrayOf = (prop_types_default()).arrayOf, checkbox_string = (prop_types_default()).string, checkbox_bool = (prop_types_default()).bool, checkbox_shape = (prop_types_default()).shape, checkbox_func = (prop_types_default()).func, checkbox_number = (prop_types_default()).number, object = (prop_types_default()).object;
var valueType = {
    id: checkbox_string.isRequired,
    name: checkbox_string.isRequired,
    products: checkbox_number
};
valueType.children = checkbox_arrayOf(checkbox_shape(valueType));
checkbox_Checkbox.propTypes = {
    child: object.isRequired,
    onChange: checkbox_func,
    id: checkbox_oneOfType([
        checkbox_number,
        checkbox_string
    ]).isRequired,
    parents: checkbox_arrayOf(checkbox_shape(valueType)),
    autoSelectChildren: checkbox_bool,
    isChecked: checkbox_bool.isRequired
};
checkbox_Checkbox.defaultProps = {
    parents: [],
    onChange: base/* noop */.ZT,
    autoSelectChildren: true
};
/* harmony default export */ const filters_checkbox = (checkbox_Checkbox);

;// CONCATENATED MODULE: ./src/components/filters/list.js
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function list_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function list_extends() {
    list_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return list_extends.apply(this, arguments);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function list_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            list_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function list_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function list_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        list_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}





var generateFakeId = function(parents, child) {
    return [
        child
    ].concat(_toConsumableArray(parents)).map(function(x) {
        return x.name;
    }).join("/");
};
var isSelected = function(selected, child) {
    if (selected === true) return selected;
    if (selected.includes(child.id)) {
        return true;
    }
    if (child.children && child.children.length) {
        return child.children.reduce(isSelected, selected);
    }
    return selected;
};
function hasSelectedChild(selected, children) {
    if (!children || !selected.length) return false;
    return children.reduce(isSelected, selected) === true;
}
function hasSelectedAllChildren(selected, children) {
    if (!children || !children.length || !selected.length) return false;
    var allSelected = children.filter(function(child) {
        return selected.includes(child.id);
    });
    return allSelected.length === children.length;
}
var List = function(props) {
    var id = props.id, values = props.values, selected = props.selected, selectedParent = props.selectedParent, onChange = props.onChange, parents = props.parents, onExpand = props.onExpand, expanded = props.expanded, autoSelectChildren = props.autoSelectChildren, layout = props.layout;
    return /*#__PURE__*/ react.createElement(Layout, {
        layout: layout
    }, values.map(function(value) {
        // Not all options have an id, so we have to generate one that we can use as an identifier
        var child = list_objectSpreadProps(list_objectSpread({}, value), {
            id: value.id || generateFakeId(parents, value)
        });
        var isSelectable = child.selectable !== false;
        var isChecked = isSelectable && (selectedParent && autoSelectChildren || selected.includes(child.id) || selected.includes(parseInt(child.id, 10)) || hasSelectedAllChildren(selected, child.children));
        var isPartiallyChecked = isSelectable && hasSelectedChild(selected, child.children) && !hasSelectedAllChildren(selected, child.children);
        var isExpanded = expanded.includes(child.id);
        // Prevent the box from being checked if it already is partially checked and shouldn't select children
        if (!autoSelectChildren && isPartiallyChecked) {
            isChecked = false;
        }
        var nonSelectableParentProps = {
            as: "span",
            onClick: function(e) {
                return onExpand(e, child.id);
            }
        };
        return /*#__PURE__*/ react.createElement(ListItem, {
            key: child.id,
            selected: isChecked || isPartiallyChecked,
            "data-test": "ListItem"
        }, /*#__PURE__*/ react.createElement(ListLabel, list_extends({}, isSelectable ? {} : nonSelectableParentProps), isSelectable && /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(filters_checkbox, list_extends({
            child: child,
            isChecked: isChecked
        }, props)), /*#__PURE__*/ react.createElement(Checkbox, {
            checked: isChecked,
            partial: isPartiallyChecked
        }, /*#__PURE__*/ react.createElement(icons/* CheckIcon */.nQ, {
            styling: "neutral-light",
            strokeWidth: "6",
            height: 14,
            left: 1,
            top: 1,
            checked: isChecked,
            partial: isPartiallyChecked
        }))), /*#__PURE__*/ react.createElement(ListLabelText, {
            "data-test": "ListItemLabelText"
        }, /*#__PURE__*/ react.createElement(ListLabelName, null, child.name), /*#__PURE__*/ react.createElement(ListLabelByline, null, "(", child.products, ")")), child.children && Boolean(child.children.length) && /*#__PURE__*/ react.createElement(ExpandWrapper, null, /*#__PURE__*/ react.createElement(ExpandButton, {
            as: isSelectable ? undefined : "span",
            expanded: isExpanded,
            outlined: !isExpanded,
            onClick: isSelectable ? function(e) {
                return onExpand(e, child.id);
            } : undefined
        }, isExpanded ? /*#__PURE__*/ react.createElement(ArrowUp, null) : /*#__PURE__*/ react.createElement(ArrowDown, null)))), child.children && isExpanded && /*#__PURE__*/ react.createElement(List, {
            id: id,
            values: child.children,
            parents: [
                child
            ].concat(_toConsumableArray(parents)),
            onChange: onChange,
            selected: selected,
            selectedParent: isChecked,
            expanded: expanded,
            onExpand: onExpand,
            autoSelectChildren: autoSelectChildren
        }));
    }));
};
var list_oneOfType = (prop_types_default()).oneOfType, list_arrayOf = (prop_types_default()).arrayOf, list_string = (prop_types_default()).string, list_bool = (prop_types_default()).bool, list_shape = (prop_types_default()).shape, list_func = (prop_types_default()).func, list_number = (prop_types_default()).number, list_oneOf = (prop_types_default()).oneOf;
var list_valueType = {
    id: list_string.isRequired,
    name: list_string.isRequired,
    products: list_number
};
list_valueType.children = list_arrayOf(list_shape(list_valueType));
List.propTypes = {
    id: list_oneOfType([
        list_number,
        list_string
    ]).isRequired,
    values: list_arrayOf(list_shape(list_valueType)).isRequired,
    selectedParent: list_bool,
    selected: list_arrayOf(list_string),
    parents: list_arrayOf(list_shape(list_valueType)),
    onChange: list_func,
    onExpand: list_func,
    expanded: list_arrayOf(list_string),
    autoSelectChildren: list_bool,
    layout: list_oneOf([
        "vertical",
        "horizontal"
    ])
};
List.defaultProps = {
    parents: [],
    onChange: function() {},
    selected: [],
    selectedParent: false,
    onExpand: function() {},
    expanded: [],
    autoSelectChildren: true,
    layout: "vertical"
};
/* harmony default export */ const list = (List);

;// CONCATENATED MODULE: ./src/components/filters/single-range.js
function single_range_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_range_extends() {
    single_range_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return single_range_extends.apply(this, arguments);
}
function single_range_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_range_defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var SingleRange = function(props) {
    return /*#__PURE__*/ react.createElement(Range, single_range_extends({}, props, {
        onChange: function(data) {
            return props.onChange({
                value: data
            });
        }
    }));
};
SingleRange.propTypes = single_range_objectSpread({
    onChange: (prop_types_default()).func.isRequired
}, Range.propTypes);
SingleRange.defaultProps = single_range_objectSpread({
    showBars: true,
    isValid: true
}, Range.defaultProps);
/* harmony default export */ const single_range = (SingleRange);

;// CONCATENATED MODULE: ./src/components/filters/index.ts







/***/ }),

/***/ 59857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "r": () => (/* reexport */ Grid)
});

// UNUSED EXPORTS: GridRow

// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n        margin-bottom: ",
        ";\n        margin-right: ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  /* Basic fallback for IE11 */\n\n  display: flex;\n  flex-wrap: wrap;\n  display: grid;\n  grid-template-columns: ",
        ";\n  grid-gap: ",
        ";\n\n  > * {\n    /* grid-gap fallback for IE11 */\n    ",
        "\n\n    @supports (display: grid) {\n      margin-bottom: 0;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

/* stylelint-disable declaration-block-no-duplicate-properties */ var Grid = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Grid",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.columnTemplate || "repeat(".concat(props.columnCount || "auto-fill", ", minmax(").concat(props.columnMinWidth || "auto", ", ").concat(props.columnMaxWidth || "1fr", "))");
}, function(props) {
    return props.gap || "10px";
}, function(props) {
    return props.gap && (0,styled_components_browser_esm.css)(_templateObject(), props.gap, props.gap);
});

// EXTERNAL MODULE: ./node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js
var prop_types = __webpack_require__(40507);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/flexible-grid/grid-row.js
function grid_row_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function grid_row_templateObject() {
    var data = grid_row_taggedTemplateLiteral([
        "\n  grid-column: 1 / -1;\n  grid-row-start: ",
        ";\n\n  /* Fallback for browsers without grid support */\n  flex: 1 0 100%;\n  order: 1;\n"
    ]);
    grid_row_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GridRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "GridRow",
    componentId: "sc-0-0"
})(grid_row_templateObject(), function(props) {
    return props.row;
});
var number = (prop_types_default()).number, node = (prop_types_default()).node;
GridRow.propTypes = {
    children: node,
    row: number
};
GridRow.defaultProps = {
    children: undefined,
    row: 1
};

;// CONCATENATED MODULE: ./src/components/flexible-grid/index.ts





/***/ }),

/***/ 94957:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": () => (/* binding */ ListItem)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83826);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}



var ListItem = function(param) {
    var children = param.children, name = param.name, link = param.link, image = param.image, callToActionText = param.callToActionText, showArrow = param.showArrow, showBackArrow = param.showBackArrow, _onClick = param.onClick, onClick = _onClick === void 0 ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .noop */ .ZT : _onClick, className = param.className, isExternal = param.isExternal, linkAttributes = param.linkAttributes, dataTest = param["data-test"], disabled = param.disabled;
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ListItem */ .HC, _extends({
        onClick: onClick,
        className: className,
        to: link,
        isExternal: isExternal
    }, linkAttributes || {}, {
        "data-test": dataTest,
        disabled: disabled
    }), showBackArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .LeftArrow */ .IT, null), image && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Image */ .Ee, null, image), children, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Name */ .VG, null, name), callToActionText && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .CallToAction */ .Jd, null, callToActionText), showArrow && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RightArrow */ .UV, null));
};


/***/ }),

/***/ 83826:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ee": () => (/* binding */ Image),
/* harmony export */   "HC": () => (/* binding */ ListItem),
/* harmony export */   "IT": () => (/* binding */ LeftArrow),
/* harmony export */   "Jd": () => (/* binding */ CallToAction),
/* harmony export */   "UV": () => (/* binding */ RightArrow),
/* harmony export */   "VG": () => (/* binding */ Name)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var _prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21932);
/* harmony import */ var _prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81736);
/* harmony import */ var src_components_clickable__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87172);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33399);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      cursor: default;\n      opacity: 0.5;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  cursor: pointer;\n  min-height: 48px;\n  padding: ",
        " ",
        ";\n  text-align: left;\n  display: flex;\n  align-items: center;\n\n  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */\n  box-sizing: border-box;\n  width: 100%;\n\n  &:hover,\n  &.focus-visible {\n    background-color: ",
        ";\n    outline: 0;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  flex: 0 1 50%;\n  margin-left: ",
        ";\n  overflow: hidden;\n  text-align: right;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-left: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 0 0 auto;\n  margin-right: ",
        ";\n  path {\n    fill: currentColor;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var padding = src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050;
var ListItem = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_components_clickable__WEBPACK_IMPORTED_MODULE_3__/* .Clickable */ .P).withConfig({
    displayName: "ListItem",
    componentId: "sc-0-0"
})(_templateObject1(), function(props) {
    return props.theme.text.primary;
}, src_components_base__WEBPACK_IMPORTED_MODULE_4__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, padding, function(props) {
    return props.theme.bg.secondary;
}, function(props) {
    return props.disabled && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
});
var Image = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Image",
    componentId: "sc-0-1"
})(_templateObject2(), padding);
var Name = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "Name",
    componentId: "sc-0-2"
})(_templateObject3());
var CallToAction = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].span.withConfig({
    displayName: "CallToAction",
    componentId: "sc-0-3"
})(_templateObject4(), function(props) {
    return props.theme.text.callToAction;
}, padding);
var RightArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_right__WEBPACK_IMPORTED_MODULE_2__/* .IconChevronRight */ .V).attrs({
    size: 20
}).withConfig({
    displayName: "RightArrow",
    componentId: "sc-0-4"
})(_templateObject5(), padding);
var LeftArrow = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(_prisjakt_ui_icon_chevron_left__WEBPACK_IMPORTED_MODULE_1__/* .IconChevronLeft */ .e).attrs({
    size: 20
}).withConfig({
    displayName: "LeftArrow",
    componentId: "sc-0-5"
})(_templateObject6(), padding);


/***/ }),

/***/ 30407:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ modal)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@7.2.0_fxintbam4sfi3slcde3hiy3qty/node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(3732);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-modal@3.8.1_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/react-modal/lib/index.js
var lib = __webpack_require__(92573);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./src/ui/zindex/index.ts
var zindex = __webpack_require__(40300);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/button/index.tsx + 1 modules
var components_button = __webpack_require__(33999);
;// CONCATENATED MODULE: ./src/components/modal/index.styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      max-width: 90vw;\n      padding: ",
        ";\n      margin-top: ",
        "px;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n          padding: ",
        " 0;\n        "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      margin: 0;\n      padding: $padding-wrapper 0;\n\n      ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    padding: ",
        ";\n    background: #fff;\n    border-radius: ",
        ";\n    overflow: hidden;\n    outline: 0;\n    display: flex;\n    flex-flow: row wrap;\n    position: absolute;\n    margin: ",
        "px auto;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n\n    h1 {\n      font-size: 2.2rem;\n    }\n    > h1,\n    > h2,\n    > h3,\n    > h4,\n    > h5,\n    > h6 {\n      &:first-child {\n        margin-top: 0;\n        margin-bottom: 0.5em;\n        line-height: 1.2em;\n      }\n    }\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    padding: 0 ",
        ";\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  width: 100%;\n  padding: 0 ",
        ";\n  max-height: 80vh;\n  overflow-y: auto;\n\n  ",
        ";\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: ",
        ";\n  right: ",
        ";\n  width: 40px;\n  height: 40px;\n  user-select: none;\n  cursor: pointer;\n  border: none;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var Modal = (0,styled_components_browser_esm["default"])((lib_default())).withConfig({
    displayName: "Modal",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* layout.borderRadius */.bK.borderRadius, base/* layout.headerHeight.desktop.value */.bK.headerHeight.desktop.value, base/* media.mediumDown */.BC.mediumDown(_templateObject()), base/* media.smallOnly */.BC.smallOnly(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* layout.headerHeight.mobile.value */.bK.headerHeight.mobile.value / 2), props.$verticalScroll && (0,styled_components_browser_esm.css)(_templateObject3(), base/* media.smallOnly */.BC.smallOnly(_templateObject2(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050)));
});
var Wrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Wrapper",
    componentId: "sc-0-1"
})(_templateObject5());
var Viewport = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Viewport",
    componentId: "sc-0-2"
})(_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject6(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050));
var CloseButton = (0,styled_components_browser_esm["default"])(components_button/* Button */.z).withConfig({
    displayName: "CloseButton",
    componentId: "sc-0-3"
})(_templateObject8(), base/* layout.measurements.spacing025 */.bK.measurements.spacing025, base/* layout.measurements.spacing025 */.bK.measurements.spacing025);

;// CONCATENATED MODULE: ./src/components/modal/modal.tsx







var APP_ROOT_ID = "root";
var MODAL_ROOT_ID = "root-modal";
var getModalRoot = function() {
    return document.getElementById(MODAL_ROOT_ID);
};
var modal_Modal = function(props) {
    react.useEffect(function() {
        lib_default().setAppElement("#".concat(APP_ROOT_ID));
    }, []);
    var children = props.children, className = props.className, dataTest = props.dataTest, id = props.id, _isOpen = props.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen, onRequestClose = props.onRequestClose, _shouldShowCloseIcon = props.shouldShowCloseIcon, shouldShowCloseIcon = _shouldShowCloseIcon === void 0 ? true : _shouldShowCloseIcon, _shouldCloseOnOverlayClick = props.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? true : _shouldCloseOnOverlayClick, _verticalScroll = props.verticalScroll, verticalScroll = _verticalScroll === void 0 ? false : _verticalScroll, _width = props.width, width = _width === void 0 ? "auto" : _width;
    var current = (0,es/* useSelector */.v9)(function(state) {
        return state.modal.current;
    });
    return /*#__PURE__*/ react.createElement(Modal, {
        id: id,
        className: className,
        isOpen: isOpen || !!current && current === id,
        onRequestClose: onRequestClose,
        parentSelector: getModalRoot,
        $verticalScroll: verticalScroll,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        style: {
            content: {
                width: width
            },
            overlay: {
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                height: "100%",
                width: "100%",
                background: base/* colorUtils.setRgbaAlpha */.$n.setRgbaAlpha(base/* colors.lightTheme.base700 */.O9.lightTheme.base700, "0.8"),
                overflow: "auto",
                zIndex: zindex/* zindex.modal */.Y.modal,
                overflowY: "scroll",
                WebkitOverflowScrolling: "touch",
                display: "flex",
                justifyContent: "center"
            }
        }
    }, /*#__PURE__*/ react.createElement(Wrapper, {
        "data-test": dataTest
    }, verticalScroll ? /*#__PURE__*/ react.createElement(Viewport, null, children) : children, shouldShowCloseIcon && /*#__PURE__*/ react.createElement(CloseButton, {
        variant: "icon",
        onClick: function() {
            if (onRequestClose) onRequestClose();
        },
        tabIndex: 0,
        icon: /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, null),
        "data-test": "ModalDialogCloseButton"
    })));
};
/* harmony default export */ const modal = (modal_Modal);


/***/ }),

/***/ 24843:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": () => (/* binding */ NumberPagination)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-items.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function notNull(item) {
    return item !== null;
}
function getPrevPageItem(currentPage, alwaysShowStepButtons) {
    if (currentPage === 1 && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "prev",
        pageNumber: currentPage - 1,
        disabled: currentPage === 1
    };
}
function getFirstPageItem(nearbyPages) {
    var _Math;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    if (firstNearbyPage === 1) {
        return null;
    }
    return {
        type: "first",
        pageNumber: 1,
        indicateOmittedPages: firstNearbyPage > 2 ? "after" : undefined
    };
}
function getNearbyPages(currentPage, totalPages) {
    var from = Math.max(1, Math.min(totalPages - 4, currentPage - 2));
    var to = Math.min(totalPages, Math.max(5, currentPage + 2));
    var pages = [];
    for(var i = from; i <= to; i += 1){
        var page = {
            type: "nearby-page",
            pageNumber: i,
            isCurrent: currentPage === i
        };
        if ([
            from,
            to
        ].includes(i) && !page.isCurrent) {
            page.omitOnSmallDevices = true;
        }
        pages.push(page);
    }
    return pages;
}
var getMidrangePage = function(position, nearbyPages, totalPages) {
    var _Math, _Math1;
    var threshold = 5;
    var firstNearbyPage = (_Math = Math).min.apply(_Math, _toConsumableArray(nearbyPages));
    var lastNearByPage = (_Math1 = Math).max.apply(_Math1, _toConsumableArray(nearbyPages));
    switch(position){
        case "before":
            if (firstNearbyPage < threshold) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.ceil(firstNearbyPage / 2),
                indicateOmittedPages: "after"
            };
        case "after":
            if (lastNearByPage + threshold > totalPages) {
                return null;
            }
            return {
                type: "midrange",
                pageNumber: Math.floor((totalPages - lastNearByPage) / 2) + lastNearByPage,
                indicateOmittedPages: "before"
            };
        default:
            return null;
    }
};
function getLastPageItem(nearbyPages, totalPages) {
    var _Math;
    var lastNearbyPage = (_Math = Math).max.apply(_Math, _toConsumableArray(nearbyPages));
    if (lastNearbyPage === totalPages) {
        return null;
    }
    return {
        type: "last",
        pageNumber: totalPages,
        indicateOmittedPages: lastNearbyPage < totalPages - 1 ? "before" : undefined
    };
}
function getNextPageItem(currentPage, totalPages, alwaysShowStepButtons) {
    if (currentPage === totalPages && !alwaysShowStepButtons) {
        return null;
    }
    return {
        type: "next",
        pageNumber: currentPage + 1,
        disabled: currentPage === totalPages
    };
}
function getPaginationItems(currentPage, totalPages) {
    var ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _alwaysShowStepButtons = ref.alwaysShowStepButtons, alwaysShowStepButtons = _alwaysShowStepButtons === void 0 ? false : _alwaysShowStepButtons;
    if (totalPages <= 1) {
        return [];
    }
    var clampedCurrentPage = Math.max(1, Math.min(totalPages, currentPage));
    var nearbyPages = getNearbyPages(clampedCurrentPage, totalPages);
    var nearbyPageNrs = nearbyPages.map(function(page) {
        return page.pageNumber;
    });
    return [
        getPrevPageItem(clampedCurrentPage, alwaysShowStepButtons),
        getFirstPageItem(nearbyPageNrs),
        getMidrangePage("before", nearbyPageNrs, totalPages)
    ].concat(_toConsumableArray(nearbyPages), [
        getMidrangePage("after", nearbyPageNrs, totalPages),
        getLastPageItem(nearbyPageNrs, totalPages),
        getNextPageItem(clampedCurrentPage, totalPages, alwaysShowStepButtons)
    ]).filter(notNull);
}

// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/number-pagination/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  list-style: none;\n  margin: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: ",
        ";\n      margin-right: ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    margin-right: ",
        ";\n\n    ",
        "\n\n    @media screen and (max-width: 420px) {\n      ",
        "\n\n      @media screen and (max-width: 350px) {\n        margin: 0 ",
        " 0 0;\n      }\n    }\n\n    &:last-child {\n      margin-right: 0;\n    }\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      padding: ",
        ";\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  align-items: center;\n  border-radius: 8px;\n  display: flex;\n  font-weight: 600;\n  height: 30px;\n  justify-content: center;\n  min-width: 30px;\n  padding: ",
        ";\n  transition: all ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  color: ",
        ";\n\n  &:hover,\n  &.focus-visible {\n    background: ",
        ";\n    box-shadow: ",
        ";\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  box-shadow: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  background: ",
        ";\n  color: ",
        ";\n  cursor: default;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}



var measurements = base/* layout.measurements */.bK.measurements, animations = base/* layout.animations */.bK.animations;
var Pagination = styled_components_browser_esm["default"].ul.withConfig({
    displayName: "Pagination",
    componentId: "sc-0-0"
})(_templateObject());
var PaginationListItem = styled_components_browser_esm["default"].li.withConfig({
    displayName: "PaginationListItem",
    componentId: "sc-0-1"
})(function(param) {
    var indicateOmittedPages = param.indicateOmittedPages, omitOnSmallDevices = param.omitOnSmallDevices;
    return (0,styled_components_browser_esm.css)(_templateObject2(), indicateOmittedPages === "before" ? measurements.spacing150 : 0, indicateOmittedPages === "after" ? measurements.spacing150 : measurements.spacing025, base/* media.smallOnly */.BC.smallOnly(_templateObject1(), indicateOmittedPages === "before" ? measurements.spacing050 : 0, indicateOmittedPages === "after" ? measurements.spacing050 : measurements.spacing025), omitOnSmallDevices ? "display: none;" : "", measurements.spacing025);
});
var paginationLinkStyles = (0,styled_components_browser_esm.css)(_templateObject4(), measurements.spacing050, animations.buttonTransition, base/* media.smallOnly */.BC.smallOnly(_templateObject3(), measurements.spacing025));
var PaginationLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "PaginationLink",
    componentId: "sc-0-2"
})(_templateObject5(), paginationLinkStyles, function(props) {
    return props.theme.colors.base800;
}, function(props) {
    return props.theme.colors.base200;
}, function(props) {
    return "transparent 0px 0px ".concat(props.theme.colors.base800, " 0px 0px 0px 1px");
});
var DisabledPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "DisabledPaginationLink",
    componentId: "sc-0-3"
})(_templateObject6(), paginationLinkStyles, function(props) {
    return "inset 0 0 0 1px ".concat(props.theme.lines.primary);
}, function(props) {
    return props.theme.text.quaternary;
}, function(props) {
    return props.theme.bg.secondary;
});
var CurrentPaginationLink = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CurrentPaginationLink",
    componentId: "sc-0-4"
})(_templateObject7(), paginationLinkStyles, function(props) {
    return props.theme.colors.maybeBlue500;
}, function(props) {
    return props.theme.colors.base0;
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-left/index.js
var chevron_left = __webpack_require__(21932);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/chevron-right/index.js
var chevron_right = __webpack_require__(81736);
;// CONCATENATED MODULE: ./src/components/number-pagination/pagination-item.tsx





var PaginationItem = function(param) {
    var item = param.item, linkToPage = param.linkToPage, onClick = param.onClick;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var label = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return /*#__PURE__*/ react.createElement(chevron_left/* IconChevronLeft */.e, null);
            case "next":
                return /*#__PURE__*/ react.createElement(chevron_right/* IconChevronRight */.V, null);
            default:
                return /*#__PURE__*/ react.createElement(react.Fragment, null, item.pageNumber);
        }
    }, [
        item.type,
        item.pageNumber
    ]);
    var ariaLabel = (0,react.useMemo)(function() {
        switch(item.type){
            case "prev":
                return t("symbols", "symbol.show-prev");
            case "next":
                return t("symbols", "symbol.show-next");
            default:
                return t("common", "pagination.page-number", {
                    number: item.pageNumber
                });
        }
    }, [
        item.type,
        item.pageNumber,
        t
    ]);
    var onClickHandler = (0,react.useCallback)(function() {
        return typeof onClick === "function" && onClick(item);
    }, [
        item,
        onClick
    ]);
    if (item.disabled) {
        return /*#__PURE__*/ react.createElement(DisabledPaginationLink, null, label);
    }
    if (item.isCurrent) {
        return /*#__PURE__*/ react.createElement(CurrentPaginationLink, {
            "data-test": "CurrentPaginationLink"
        }, label);
    }
    return /*#__PURE__*/ react.createElement(PaginationLink, {
        to: linkToPage(item.pageNumber),
        "data-test": "PaginationLink",
        "data-test-page": item.pageNumber,
        onClick: onClickHandler,
        "aria-label": ariaLabel
    }, label);
};
/* harmony default export */ const pagination_item = (PaginationItem);

;// CONCATENATED MODULE: ./src/components/number-pagination/index.tsx




var NumberPagination = function(param) {
    var currentPage = param.currentPage, totalPages = param.totalPages, linkToPage = param.linkToPage, onClick = param.onClick, alwaysShowStepButtons = param.alwaysShowStepButtons;
    var paginationItems = (0,react.useMemo)(function() {
        return getPaginationItems(currentPage, totalPages, {
            alwaysShowStepButtons: alwaysShowStepButtons
        });
    }, [
        currentPage,
        totalPages,
        alwaysShowStepButtons
    ]);
    return /*#__PURE__*/ react.createElement(Pagination, {
        "data-test": "Pagination"
    }, paginationItems.map(function(item) {
        return /*#__PURE__*/ react.createElement(PaginationListItem, {
            key: "".concat(item.type, ":").concat(item.pageNumber),
            indicateOmittedPages: item.indicateOmittedPages,
            omitOnSmallDevices: item.omitOnSmallDevices
        }, /*#__PURE__*/ react.createElement(pagination_item, {
            item: item,
            linkToPage: linkToPage,
            onClick: onClick
        }));
    }));
};


/***/ }),

/***/ 49624:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": () => (/* reexport */ ColorsEnum),
  "V": () => (/* binding */ Placeholder)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/placeholder/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n\n  @keyframes gradient {\n    0% {\n      background-position: 100% 50%;\n    }\n    100% {\n      background-position: -100% 50%;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n    min-width: 146px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n      padding-bottom: 10%;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      max-height: 88px;\n      flex-direction: row;\n      flex-wrap: nowrap;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: ",
        ";\n  display: flex;\n  flex-direction: column;\n  padding: 20px;\n  flex-grow: 1;\n  min-width: 200px;\n\n  ",
        "\n  ",
        "\n\n    ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n      align-self: center;\n      height: 100px;\n      width: 100px;\n      margin-bottom: 10px;\n    "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    order: ",
        ";\n    display: flex;\n    height: 50px;\n    width: 50px;\n    background: ",
        ";\n    border-radius: ",
        ";\n\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      margin-left: 12px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      margin-top: 20px;\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n      order: ",
        ";\n    "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(\n        to right,\n        rgba(238, 238, 238, 1) 8%,\n        rgba(238, 238, 238, 0.5) 18%,\n        rgba(238, 238, 238, 1) 33%\n      );\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n      background: linear-gradient(to right, #fff 8%, #ffffff80 18%, #fff 33%);\n    "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        "\n    display: flex;\n    height: 10px;\n    margin: 5px 0;\n    width: 100%;\n    background-size: 300% 300%;\n    animation: gradient 1s linear infinite;\n    border-radius: 30px;\n\n    ",
        "\n\n    ",
        "\n\n    &:nth-of-type(even) {\n      width: 80%;\n    }\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}


var ColorsEnum;
(function(ColorsEnum) {
    ColorsEnum["WHITE"] = "white";
    ColorsEnum["GRAY"] = "gray";
})(ColorsEnum || (ColorsEnum = {}));
var StyledPlaceholder = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledPlaceholder",
    componentId: "sc-0-0"
})(_templateObject());
var StyledDeal = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledDeal",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.height;
}, base/* media.smallOnly */.BC.smallOnly(_templateObject1()), function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject2());
}, function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject3());
});
var StyledMedia = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledMedia",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject6(), props.mediaPosition, props.$color === ColorsEnum.GRAY ? "#eee" : "#fff", base/* layout.borderRadius */.bK.borderRadius, props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject5()));
});
var StyledRows = styled_components_browser_esm["default"].div.withConfig({
    displayName: "StyledRows",
    componentId: "sc-0-3"
})(_templateObject9(), function(props) {
    return props.mode === "row" && (0,styled_components_browser_esm.css)(_templateObject7());
}, function(props) {
    return props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject8());
});
var StyledText = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StyledText",
    componentId: "sc-0-4"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject13(), props.mode === "grid" && (0,styled_components_browser_esm.css)(_templateObject10(), props.rowIndex && props.rowIndex + 1), props.$color === ColorsEnum.GRAY && (0,styled_components_browser_esm.css)(_templateObject11()), props.$color === ColorsEnum.WHITE && (0,styled_components_browser_esm.css)(_templateObject12()));
});

;// CONCATENATED MODULE: ./src/components/placeholder/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var Placeholder = function(param) {
    var className = param.className, _amount = param.amount, amount = _amount === void 0 ? 1 : _amount, _color = param.color, color = _color === void 0 ? ColorsEnum.GRAY : _color, _rows = param.rows, rows = _rows === void 0 ? 5 : _rows, _mode = param.mode, mode = _mode === void 0 ? "grid" : _mode, _height = param.height, height = _height === void 0 ? "auto" : _height, _mediaPosition = param.mediaPosition, mediaPosition = _mediaPosition === void 0 ? 0 : _mediaPosition, _showMedia = param.showMedia, showMedia = _showMedia === void 0 ? true : _showMedia;
    return /*#__PURE__*/ react.createElement(StyledPlaceholder, {
        "data-test": "Placeholder"
    }, _toConsumableArray(new Array(amount)).map(function(e, i) {
        return /*#__PURE__*/ react.createElement(StyledDeal, {
            key: i.toString(),
            mode: mode,
            height: height
        }, showMedia && /*#__PURE__*/ react.createElement(StyledMedia, {
            mediaPosition: mediaPosition,
            mode: mode,
            $color: color
        }), /*#__PURE__*/ react.createElement(StyledRows, {
            mode: mode
        }, _toConsumableArray(new Array(rows)).map(function(row, rowIndex) {
            return /*#__PURE__*/ react.createElement(StyledText, {
                key: rowIndex.toString(),
                rowIndex: rowIndex,
                mode: mode,
                $color: color
            });
        })));
    }));
};



/***/ }),

/***/ 69919:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_row)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/offer/price/price-label/index.tsx + 1 modules
var price_label = __webpack_require__(14596);
// EXTERNAL MODULE: ./src/components/rating/index.tsx + 1 modules
var components_rating = __webpack_require__(29258);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/product-checkbox/index.tsx + 1 modules
var product_checkbox = __webpack_require__(55548);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router-dom@5.3.0_react@18.1.0/node_modules/react-router-dom/esm/react-router-dom.js
var react_router_dom = __webpack_require__(51322);
;// CONCATENATED MODULE: ./src/components/product-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  position: relative;\n  padding: 5px 10px;\n  outline: none;\n\n  :hover::after,\n  :focus::after {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      border-bottom: 1px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        " {\n        padding-left: ",
        "px;\n      }\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "::before {\n        ",
        "\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  line-height: 1.2em;\n  min-height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  .pj-ui-product-core-properties {\n    margin: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 0 0 auto;\n  width: 40px;\n  height: 40px;\n  margin-right: 10px;\n  background: ",
        ";\n  border-radius: ",
        ";\n\n  .pj-ui-product-image {\n    display: block;\n    max-width: 40px;\n    max-height: 40px;\n    width: auto;\n    height: auto;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 100%;\n  margin-right: 3px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  :not(:last-child) {\n    margin-bottom: 1px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-size: 12px;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 5px;\n  max-height: 55px;\n  min-width: 21px;\n  flex: 0 1 55px;\n  margin-left: 10px;\n  text-align: center;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  flex: 1 1 auto;\n  margin-left: 10px;\n  white-space: nowrap;\n  text-align: right;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: flex-end;\n  font-size: 12px;\n  color: ",
        ";\n  fill: ",
        ";\n  align-items: center;\n\n  svg {\n    height: 16px !important;\n    width: 16px !important;\n    margin-left: 2px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  left: ",
        ";\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n\n  ",
        ":hover & {\n    ",
        "\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var ProductLink = (0,styled_components_browser_esm["default"])(react_router_dom/* Link */.rU).withConfig({
    displayName: "ProductLink",
    componentId: "sc-0-0"
})(_templateObject(), base/* styledUtils.overlay */.au.overlay());
var Row = styled_components_browser_esm["default"].div.attrs({
    "data-test": "ProductRow"
}).withConfig({
    displayName: "Row",
    componentId: "sc-0-1"
})(_templateObject4(), function(props) {
    return props.showDivider && (0,styled_components_browser_esm.css)(_templateObject1(), function(p) {
        return p.theme.lines.primary;
    });
}, function(props) {
    return props.selectable && (0,styled_components_browser_esm.css)(_templateObject2(), ProductLink, product_checkbox/* PRODUCT_CHECKBOX_SIZE */.mr + (0,base/* pixelCalc */.A)(base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
}, function(props) {
    return props.selected && (0,styled_components_browser_esm.css)(_templateObject3(), ProductLink, base/* styledUtils.overlay */.au.overlay(props.theme.bg.productCompareLight));
});
var ProductImage = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductImage",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base200;
}, base/* layout.borderRadius */.bK.borderRadius);
var BasicInfo = styled_components_browser_esm["default"].div.withConfig({
    displayName: "BasicInfo",
    componentId: "sc-0-3"
})(_templateObject6());
var ProductName = styled_components_browser_esm["default"].div.withConfig({
    displayName: "ProductName",
    componentId: "sc-0-4"
})(_templateObject7());
var Subtitle = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-5"
})(_templateObject8(), function(p) {
    return p.theme.text.tertiary;
});
var CampaignBadge = styled_components_browser_esm["default"].span.withConfig({
    displayName: "CampaignBadge",
    componentId: "sc-0-6"
})(_templateObject9());
var PriceLabelWrapper = styled_components_browser_esm["default"].span.withConfig({
    displayName: "PriceLabelWrapper",
    componentId: "sc-0-7"
})(_templateObject10());
var StoreCount = styled_components_browser_esm["default"].span.withConfig({
    displayName: "StoreCount",
    componentId: "sc-0-8"
})(_templateObject11(), function(p) {
    return p.theme.text.tertiary;
}, function(p) {
    return p.theme.icons.tertiary;
});
var Gutter = styled_components_browser_esm["default"].span.withConfig({
    displayName: "Gutter",
    componentId: "sc-0-9"
})(_templateObject12());
var SelectBox = (0,styled_components_browser_esm["default"])(product_checkbox/* ProductCheckbox */.WX).withConfig({
    displayName: "SelectBox",
    componentId: "sc-0-10"
})(_templateObject13(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, Row, product_checkbox/* productCheckboxHoverStyle */.lo);

// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/shopping-cart/index.js
var shopping_cart = __webpack_require__(31615);
;// CONCATENATED MODULE: ./src/components/product-row/index.tsx
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}





var ProductRow = function(param) {
    var onClick = param.onClick, linkAttributes = param.linkAttributes, _link = param.link, link = _link === void 0 ? "" : _link, image = param.image, name = param.name, rating = param.rating, subtitle = param.subtitle, campaignBadge = param.campaignBadge, ratingCount = param.ratingCount, _ratingCountTranslation = param.ratingCountTranslation, ratingCountTranslation = _ratingCountTranslation === void 0 ? {
        domain: "product",
        key: "product-card.n-ratings"
    } : _ratingCountTranslation, price = param.price, storesCount = param.storesCount, storesCountText = param.storesCountText, children = param.children, className = param.className, showDivider = param.showDivider, selectable = param.selectable, selected = param.selected, onSelect = param.onSelect, onDeselect = param.onDeselect;
    var onToggle = selected ? onDeselect : onSelect;
    var clickHandler = (0,react.useCallback)(function(e) {
        if (selectable) {
            e.preventDefault();
            onToggle === null || onToggle === void 0 ? void 0 : onToggle();
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    }, [
        selectable,
        onToggle,
        onClick
    ]);
    return /*#__PURE__*/ react.createElement(Row, {
        className: className,
        showDivider: showDivider,
        selectable: selectable,
        selected: selected
    }, /*#__PURE__*/ react.createElement(ProductLink, _extends({
        onClick: clickHandler
    }, linkAttributes || {}, {
        to: link,
        "aria-label": name
    }), image && /*#__PURE__*/ react.createElement(ProductImage, null, image), /*#__PURE__*/ react.createElement(BasicInfo, null, /*#__PURE__*/ react.createElement(ProductName, null, name), rating ? /*#__PURE__*/ react.createElement(components_rating/* default */.Z, {
        hide: rating === null,
        rate: rating,
        showRate: true,
        size: "small",
        count: ratingCount,
        countTranslation: ratingCountTranslation,
        showCounter: true
    }) : null, subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)), campaignBadge && /*#__PURE__*/ react.createElement(CampaignBadge, null, campaignBadge), price && /*#__PURE__*/ react.createElement(PriceLabelWrapper, null, /*#__PURE__*/ react.createElement(price_label/* PriceLabel */.l, {
        value: price
    }), storesCount !== null && /*#__PURE__*/ react.createElement(StoreCount, {
        title: storesCountText
    }, /*#__PURE__*/ react.createElement("span", null, storesCount), " ", /*#__PURE__*/ react.createElement(shopping_cart/* IconShoppingCart */.w, {
        color: "base500"
    })))), children && /*#__PURE__*/ react.createElement(Gutter, null, children), selectable && /*#__PURE__*/ react.createElement(SelectBox, {
        selected: selected,
        onSelect: onSelect,
        onDeselect: onDeselect,
        "aria-label": name
    }));
};
/* harmony default export */ const product_row = (ProductRow);


/***/ }),

/***/ 29014:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ product_search)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./src/components/app-context/index.tsx
var app_context = __webpack_require__(66431);
// EXTERNAL MODULE: ./src/components/search/search.js + 10 modules
var search_search = __webpack_require__(431);
// EXTERNAL MODULE: ./src/components/inputs/index.ts + 10 modules
var inputs = __webpack_require__(4410);
// EXTERNAL MODULE: ./src/components/product-image/index.tsx
var product_image = __webpack_require__(23354);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/product-row/index.tsx + 1 modules
var product_row = __webpack_require__(69919);
;// CONCATENATED MODULE: ./src/components/product-search/components/related-products/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  z-index: 4;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        ";\n  margin-top: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n          top: 37px;\n        "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n      top: 47px;\n\n      ",
        ", ",
        " {\n        padding: 0 ",
        ";\n      }\n\n      ",
        "\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    background: ",
        ";\n    border-radius: 4px;\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: auto;\n\n    ",
        "\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}



var relatedProductsTitleFontSize = (0,base/* remCalc */.vR)(15);
var boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var relatedProductsOverlayStyles = (0,styled_components_browser_esm.css)(_templateObject(), boxShadowStyle);
var RelatedProductsTitle = styled_components_browser_esm["default"].h5.withConfig({
    displayName: "RelatedProductsTitle",
    componentId: "sc-0-0"
})(_templateObject1(), relatedProductsTitleFontSize, base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var RelatedProductsSubTitle = styled_components_browser_esm["default"].p.withConfig({
    displayName: "RelatedProductsSubTitle",
    componentId: "sc-0-1"
})(_templateObject2(), function(p) {
    return p.theme.text.quaternary;
});
var RelatedProducts = styled_components_browser_esm["default"].div.withConfig({
    displayName: "RelatedProducts",
    componentId: "sc-0-2"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject5(), props.theme.colors.base0, props.relatedProductsAsOverlay && (0,styled_components_browser_esm.css)(_templateObject4(), relatedProductsOverlayStyles, RelatedProductsTitle, RelatedProductsSubTitle, base/* layout.measurements.spacing100 */.bK.measurements.spacing100, base/* media.smallOnly */.BC.smallOnly(_templateObject3())));
});
var ProductRow = (0,styled_components_browser_esm["default"])(product_row/* default */.Z).withConfig({
    displayName: "ProductRow",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject8(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject7(), base/* media.mediumDown */.BC.mediumDown(_templateObject6(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100)));
});

;// CONCATENATED MODULE: ./src/components/product-search/components/related-products/index.tsx




var related_products_RelatedProducts = function(param) {
    var relatedProducts = param.relatedProducts, relatedProductsAsOverlay = param.relatedProductsAsOverlay, onSelect = param.onSelect, showNewComparePageLayout = param.showNewComparePageLayout;
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    return /*#__PURE__*/ react.createElement(RelatedProducts, {
        relatedProductsAsOverlay: relatedProductsAsOverlay
    }, /*#__PURE__*/ react.createElement(RelatedProductsTitle, null, t("product", "recommendations.similar-products")), /*#__PURE__*/ react.createElement(RelatedProductsSubTitle, null, t("compare", "related-products.add")), relatedProducts.map(function(relatedProduct) {
        var product = relatedProduct.product;
        if (!product) return null;
        var onClickHandler = function(e) {
            e.preventDefault();
            onSelect(product);
        };
        return /*#__PURE__*/ react.createElement(ProductRow, {
            key: "related-product-".concat(product.id),
            onClick: onClickHandler,
            name: product.name,
            price: product.priceSummary.regular,
            image: product.media.first && /*#__PURE__*/ react.createElement(product_image/* ProductImage */.q, {
                name: product.name,
                src: product.media.first
            }),
            showDivider: true,
            showNewComparePageLayout: showNewComparePageLayout
        });
    }));
};
/* harmony default export */ const related_products = (related_products_RelatedProducts);

;// CONCATENATED MODULE: ./src/components/product-search/styles.ts
function styles_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function styles_templateObject() {
    var data = styles_taggedTemplateLiteral([
        "\n      border-bottom: none;\n      border-radius: 5px 5px 0px 0px;\n    "
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n    border: ",
        "px solid\n      ",
        ";\n    overflow: hidden;\n    border-bottom: ",
        "px solid\n      ",
        ";\n    border-radius: 5px;\n\n    ",
        "\n  "
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = styles_taggedTemplateLiteral([
        "\n        border: 1px solid ",
        ";\n        border-top: none;\n      "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        ";\n        "
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = styles_taggedTemplateLiteral([
        "\n          top: ",
        "px;\n        "
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = styles_taggedTemplateLiteral([
        "\n      position: absolute;\n      left: 0;\n      right: 0;\n      border: none;\n      border-top: none;\n      z-index: 10;\n      box-shadow: ",
        ";\n\n      ",
        "\n\n      ",
        ";\n\n      ",
        ";\n\n      ",
        ";\n    "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = styles_taggedTemplateLiteral([
        "\n      padding: 0 ",
        ";\n    "
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = styles_taggedTemplateLiteral([
        "\n    position: relative;\n    background: ",
        ";\n    border-radius: 0px 0px 5px 5px;\n    overflow: hidden;\n    text-align: left;\n\n    ",
        ";\n\n    .pj-ui-search--products {\n      padding-top: 0;\n    }\n\n    ",
        ";\n  "
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = styles_taggedTemplateLiteral([
        "\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = styles_taggedTemplateLiteral([
        "\n          padding: 0 ",
        ";\n\n          ",
        " {\n            border-bottom: 1px solid ",
        ";\n            border-radius: 5px;\n          }\n\n          ",
        " {\n            border: none;\n            box-shadow: none;\n          }\n        "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = styles_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = styles_taggedTemplateLiteral([
        "\n    width: 100%;\n\n    ",
        "\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}


var searchHeight = base/* layout.searchBar.height.desktop.value */.bK.searchBar.height.desktop.value;
var searchHeightMobile = base/* layout.searchBar.height.mobile.value */.bK.searchBar.height.mobile.value;
var searchBorderWidth = base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth;
var styles_boxShadowStyle = "0px 6px 10px 0px rgba(0, 0, 0, 0.2)";
var SearchInput = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchInput",
    componentId: "sc-0-0"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject1(), base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, base/* layout.searchBar.borderWidth */.bK.searchBar.borderWidth, function(p) {
        return p.theme.colors.maybeBlue700;
    }, props.searchIsOpen && (0,styled_components_browser_esm.css)(styles_templateObject()));
});
var SearchResult = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchResult",
    componentId: "sc-0-1"
})(function(props) {
    return (0,styled_components_browser_esm.css)(styles_templateObject8(), props.theme.colors.base0, props.showFloatingResult && (0,styled_components_browser_esm.css)(styles_templateObject6(), styles_boxShadowStyle, props.searchIsOpen && (0,styled_components_browser_esm.css)(styles_templateObject2(), props.theme.colors.maybeBlue700), base/* media.smallOnly */.BC.smallOnly(styles_templateObject3(), props.showNewComparePageLayout ? "".concat(searchHeightMobile + searchBorderWidth * 2, "px") : "".concat(searchHeightMobile, "px")), base/* media.mediumOnly */.BC.mediumOnly(styles_templateObject4(), searchHeight + searchBorderWidth * 2), base/* media.largeUp */.BC.largeUp(styles_templateObject5(), searchHeight)), base/* media.mediumDown */.BC.mediumDown(styles_templateObject7(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100));
});
var SearchWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "SearchWrapper",
    componentId: "sc-0-2"
})(_templateObject9());
var Search = styled_components_browser_esm["default"].div.withConfig({
    displayName: "Search",
    componentId: "sc-0-3"
})(function(props) {
    return (0,styled_components_browser_esm.css)(_templateObject12(), props.showNewComparePageLayout && (0,styled_components_browser_esm.css)(_templateObject11(), base/* media.mediumDown */.BC.mediumDown(_templateObject10(), base/* layout.measurements.spacing100 */.bK.measurements.spacing100, SearchInput, props.theme.colors.maybeBlue700, SearchResult)));
});

;// CONCATENATED MODULE: ./src/components/product-search/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var INPUT_MIN_LENGTH = 2;
var SEARCH_OPTIONS = {
    groups: [
        {
            limit: 5,
            name: "products",
            modes: [
                "product"
            ]
        }
    ]
};
var ProductSearch = function(param) {
    var _showNewComparePageLayout = param.showNewComparePageLayout, showNewComparePageLayout = _showNewComparePageLayout === void 0 ? false : _showNewComparePageLayout, _relatedProductsAsOverlay = param.relatedProductsAsOverlay, relatedProductsAsOverlay = _relatedProductsAsOverlay === void 0 ? false : _relatedProductsAsOverlay, _showFloatingResult = param.showFloatingResult, showFloatingResult = _showFloatingResult === void 0 ? true : _showFloatingResult, focusOnMount = param.focusOnMount, placeholder = param.placeholder, onSelect = param.onSelect, relatedProducts = param.relatedProducts;
    var searchRef = (0,react.useRef)(null);
    var searchInputRef = (0,react.useRef)(null);
    var t = (0,react.useContext)(app_context/* AppContext */.Il).t;
    var ref = _slicedToArray((0,react.useState)(""), 2), inputValue = ref[0], setInputValueState = ref[1];
    var ref1 = _slicedToArray((0,react.useState)(""), 2), search = ref1[0], setSearchState = ref1[1];
    var ref2 = _slicedToArray((0,react.useState)(false), 2), hasResultsState = ref2[0], setHasResultsState = ref2[1];
    var ref3 = _slicedToArray((0,react.useState)([]), 2), results = ref3[0], setResultsState = ref3[1];
    var resetSearch = function() {
        setSearchState("");
        setHasResultsState(false);
    };
    var handleOnChange = (0,react.useCallback)(function(searchTerm) {
        setSearchState(searchTerm);
        setHasResultsState(false);
    }, []);
    var handleOnFocus = (0,react.useCallback)(function(searchTerm) {
        if (searchTerm.length >= INPUT_MIN_LENGTH) {
            setSearchState(searchTerm);
            setHasResultsState(true);
        }
    }, []);
    var setInputValue = (0,react.useCallback)(function(input) {
        setInputValueState(input);
    }, []);
    var handleOnSelect = (0,react.useCallback)(function(product) {
        setInputValueState("");
        resetSearch();
        return onSelect(product);
    }, [
        onSelect
    ]);
    var handleSearchResultFound = (0,react.useCallback)(function() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        var ref;
        setHasResultsState(true);
        var ref1;
        setResultsState((ref1 = (ref = items[0]) === null || ref === void 0 ? void 0 : ref.hits) !== null && ref1 !== void 0 ? ref1 : []);
    }, []);
    var handleKeyDown = (0,react.useCallback)(function(e) {
        if (e.key === "Escape") {
            resetSearch();
        }
    }, []);
    var handleClickOutside = (0,react.useCallback)(function(e) {
        if (e.target && searchRef.current && !searchRef.current.contains(e.target)) {
            resetSearch();
        }
    }, []);
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("click", handleClickOutside);
        if (focusOnMount && searchInputRef.current) {
            var inputElement = searchInputRef.current.querySelector("input[type=text]");
            if (inputElement) {
                inputElement.focus();
            }
        }
        return function() {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("click", handleClickOutside);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    var searchIsOpen = inputValue.length >= INPUT_MIN_LENGTH && search !== "";
    var hasResults = hasResultsState && search !== "" && results && results.length > 0;
    return /*#__PURE__*/ react.createElement(SearchWrapper, {
        ref: searchRef
    }, /*#__PURE__*/ react.createElement(Search, {
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(SearchInput, {
        ref: searchInputRef,
        searchIsOpen: searchIsOpen
    }, /*#__PURE__*/ react.createElement(inputs/* Search */.ol, {
        key: "search",
        placeholder: placeholder || t("search", "search-products.placeholder"),
        hasResults: hasResults,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        inputValue: inputValue,
        setInputValue: setInputValue
    })), /*#__PURE__*/ react.createElement(SearchResult, {
        searchIsOpen: searchIsOpen,
        showFloatingResult: showFloatingResult,
        showNewComparePageLayout: showNewComparePageLayout
    }, /*#__PURE__*/ react.createElement(search_search/* default */.Z, {
        query: search,
        onSelect: handleOnSelect,
        showAllResults: false,
        keyboardNavigation: false,
        styling: "none",
        disableScrollToTop: true,
        onSearchResultFound: handleSearchResultFound,
        options: SEARCH_OPTIONS,
        inputMinLength: INPUT_MIN_LENGTH
    }))), relatedProducts && Boolean(relatedProducts.length) && !hasResults && Boolean(!searchIsOpen) && /*#__PURE__*/ react.createElement(related_products, {
        relatedProducts: relatedProducts,
        relatedProductsAsOverlay: relatedProductsAsOverlay,
        onSelect: onSelect,
        showNewComparePageLayout: showNewComparePageLayout
    }));
};
/* harmony default export */ const product_search = (ProductSearch);


/***/ }),

/***/ 69447:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": () => (/* binding */ ProductsHeader)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/text/variants.js
var variants = __webpack_require__(5492);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
// EXTERNAL MODULE: ./src/components/tooltip-new/index.ts + 1 modules
var tooltip_new = __webpack_require__(24061);
;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  white-space: nowrap;\n  margin-right: ",
        ";\n  margin-bottom: 0;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      justify-content: space-between;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    width: 100%;\n    grid-column-gap: ",
        ";\n    align-items: center;\n\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-column-gap: ",
        ";\n  align-items: center;\n  grid-auto-flow: column;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n          position: absolute;\n          right: 0;\n        "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  height: 100%;\n  width: ",
        "px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var TitleWrapper = styled_components_browser_esm["default"].div.withConfig({
    displayName: "TitleWrapper",
    componentId: "sc-0-0"
})(_templateObject());
var Title = (0,styled_components_browser_esm["default"])(variants/* H3Text */.I7).withConfig({
    displayName: "Title",
    componentId: "sc-0-1"
})(_templateObject1(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var Subtitle = (0,styled_components_browser_esm["default"])(variants/* CaptionText */.HB).withConfig({
    displayName: "Subtitle",
    componentId: "sc-0-2"
})(_templateObject2());
var HeaderRow = styled_components_browser_esm["default"].div.withConfig({
    displayName: "HeaderRow",
    componentId: "sc-0-3"
})(function() {
    return (0,styled_components_browser_esm.css)(_templateObject4(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050, base/* media.mediumDown */.BC.mediumDown(_templateObject3()));
});
var DisplayOptions = styled_components_browser_esm["default"].div.withConfig({
    displayName: "DisplayOptions",
    componentId: "sc-0-4"
})(_templateObject5(), base/* layout.measurements.spacing050 */.bK.measurements.spacing050);
var SearchInputIcon = styled_components_browser_esm["default"].button.withConfig({
    displayName: "SearchInputIcon",
    componentId: "sc-0-5"
})(_templateObject7(), function(param) {
    var positionAbsolute = param.positionAbsolute;
    return positionAbsolute ? (0,styled_components_browser_esm.css)(_templateObject6()) : "";
}, function(p) {
    return p.iconSize;
}, function(p) {
    return p.theme.icons.callToActionHover;
});
var Tooltip = (0,styled_components_browser_esm["default"])(tooltip_new/* Tooltip */.u).withConfig({
    displayName: "Tooltip",
    componentId: "sc-0-6"
})(_templateObject8());

;// CONCATENATED MODULE: ./src/components/products-header/components/header-row/index.tsx


var header_row_HeaderRow = function(props) {
    var className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title;
    return /*#__PURE__*/ react.createElement(HeaderRow, {
        className: className,
        "data-test": "ProductsHeader"
    }, title || subtitle ? /*#__PURE__*/ react.createElement(TitleWrapper, {
        "data-test": "ProductsHeaderTitleWrapper"
    }, title && /*#__PURE__*/ react.createElement(Title, {
        "data-botify": dataBotify
    }, title), subtitle && /*#__PURE__*/ react.createElement(Subtitle, null, subtitle)) : null, sortOptions !== null && sortOptions !== void 0 ? sortOptions : null, displayOptions ? /*#__PURE__*/ react.createElement(DisplayOptions, null, displayOptions) : null);
};

;// CONCATENATED MODULE: ./src/components/products-header/index.tsx


var ProductsHeader = function(props) {
    var children = props.children, className = props.className, dataBotify = props.dataBotify, displayOptions = props.displayOptions, sortOptions = props.sortOptions, subtitle = props.subtitle, title = props.title;
    return /*#__PURE__*/ react.createElement("div", null, /*#__PURE__*/ react.createElement(header_row_HeaderRow, {
        className: className,
        "data-botify": dataBotify,
        displayOptions: displayOptions,
        sortOptions: sortOptions,
        subtitle: subtitle,
        title: title
    }), children);
};


/***/ }),

/***/ 13673:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "tr": () => (/* binding */ Variants)
/* harmony export */ });
/* unused harmony export Colors */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var src_components_app_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66431);
/* harmony import */ var _styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8176);
/* harmony import */ var _prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4012);
/* eslint-disable jsx-a11y/label-has-associated-control, jsx-a11y/control-has-associated-label */ function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}




var Variants;
(function(Variants) {
    Variants["rate"] = "rate";
    Variants["scale"] = "scale";
    Variants["boolean"] = "boolean";
})(Variants || (Variants = {}));
var Colors;
(function(Colors) {
    Colors["negative"] = "negative";
    Colors["neutral"] = "neutral";
    Colors["positive"] = "positive";
})(Colors || (Colors = {}));
var ratingColorMap = [
    Colors.negative,
    Colors.negative,
    Colors.neutral,
    Colors.positive,
    Colors.positive
];
var MultiRadio = function(param) {
    var currentValue = param.currentValue, disabledOptions = param.disabledOptions, _labels = param.labels, labels = _labels === void 0 ? [] : _labels, name = param.name, onClick = param.onClick, options = param.options, _optionValues = param.optionValues, optionValues = _optionValues === void 0 ? [] : _optionValues, required = param.required, _size = param.size, size = _size === void 0 ? "medium" : _size, variant = param.variant;
    var t = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(src_components_app_context__WEBPACK_IMPORTED_MODULE_1__/* .AppContext */ .Il).t;
    var ref = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? optionValues[currentValue - 1] : undefined), 2), selected = ref[0], setSelected = ref[1];
    var ref1 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue ? ratingColorMap[currentValue - 1] : Colors.neutral), 2), ratingColor = ref1[0], setRatingColor = ref1[1];
    var ref2 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), 2), error = ref2[0], setError = ref2[1];
    var ref3 = _slicedToArray((0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(currentValue), 2), checked = ref3[0], setChecked = ref3[1];
    var getSize = function() {
        switch(size){
            case "small":
                return 20;
            case "medium":
            default:
                return 32;
        }
    };
    var iconSize = getSize();
    var handleChange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (e.target.checkValidity()) {
            setError(null);
        }
        setSelected(e.target.dataset.value);
        setChecked(parseInt(e.target.value, 10));
        if (variant === Variants.rate) {
            var index = Number(e.target.value) - 1;
            setRatingColor(ratingColorMap[index]);
        }
        if (onClick) onClick(e);
    }, [
        onClick,
        variant
    ]);
    var getIsDisabled = function(option) {
        return (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.length) ? (disabledOptions === null || disabledOptions === void 0 ? void 0 : disabledOptions.find(function(item) {
            return item === option;
        })) !== undefined : false;
    };
    var handleInvalidity = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(e) {
        if (error === e.target.name) return;
        setError(e.target.name);
    }, [
        error
    ]);
    if (variant === Variants.rate) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity
        }, options.map(function(option, index) {
            switch(option){
                case 1:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngryIcon */ .u7, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 2:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfiedIcon */ .fV, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 3:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutralIcon */ .cI, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 4:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues[index],
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmilingIcon */ .oX, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                case 5:
                    {
                        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            key: option
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .RadioRating */ .N$, {
                            type: "radio",
                            name: name,
                            id: "".concat(name, ":").concat(option),
                            value: option,
                            "data-value": optionValues.length ? optionValues[index] : undefined,
                            required: required,
                            onChange: handleChange,
                            tabIndex: 0,
                            checked: checked === option,
                            $size: size,
                            disabled: getIsDisabled(option)
                        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                            htmlFor: "".concat(name, ":").concat(option)
                        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughingIcon */ .mv, {
                            showError: error === name,
                            size: iconSize,
                            ariaLabel: "".concat(name, ":").concat(option)
                        })));
                    }
                default:
                    return null;
            }
        }), selected && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .SelectedRating */ .u1, {
            color: ratingColor
        }, selected)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.scale) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            hasSelected: Boolean(optionValues.length),
            showError: error === name
        }, optionValues.length ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Selected */ .Ne, null, selected !== null && selected !== void 0 ? selected : t("reviews", "form.question-nothing-selected")) : null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, options.map(function(option, index) {
            return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                key: option
            }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .ScaleRadio */ .az, {
                type: "radio",
                name: name,
                id: "".concat(name, ":").concat(option),
                value: option,
                "data-value": optionValues.length ? optionValues[index] : undefined,
                required: required,
                onChange: handleChange,
                alignRight: index + 1 === options.length,
                alignLeft: index === 0,
                showError: error === name,
                tabIndex: 0,
                checked: checked === option
            }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
                htmlFor: "".concat(name, ":").concat(option),
                "data-label": labels.length ? labels[index] : null
            }));
        }))), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    if (variant === Variants.boolean) {
        return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .MultiRadio */ .ng, {
            variant: variant,
            onInvalid: handleInvalidity,
            showError: error === name
        }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Inputs */ .kq, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":1"),
            value: "1",
            "data-value": t("reviews", "form.boolean-yes"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 1
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":1")
        }, t("reviews", "form.boolean-yes"))), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":0"),
            value: "0",
            "data-value": t("reviews", "form.boolean-no"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 0
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":0")
        }, t("reviews", "form.boolean-no"))), options.length > 2 ? /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .BooleanRadio */ .qV, {
            type: "radio",
            name: name,
            id: "".concat(name, ":2"),
            value: "2",
            "data-value": t("reviews", "form.boolean-unknown"),
            required: required,
            onChange: handleChange,
            tabIndex: 0,
            checked: checked === 2
        }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("label", {
            htmlFor: "".concat(name, ":2")
        }, t("reviews", "form.boolean-no"))) : null)), error === name && /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_styles__WEBPACK_IMPORTED_MODULE_2__/* .Error */ .jj, null, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_prisjakt_ui_icon_info_filled__WEBPACK_IMPORTED_MODULE_3__/* .IconInfoFilled */ .h, {
            size: 16,
            color: "negative700"
        }), " ", t("reviews", "form.error-radio")));
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (MultiRadio);


/***/ }),

/***/ 8176:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N$": () => (/* binding */ RadioRating),
/* harmony export */   "Ne": () => (/* binding */ Selected),
/* harmony export */   "az": () => (/* binding */ ScaleRadio),
/* harmony export */   "cI": () => (/* binding */ EmoticonNeutralIcon),
/* harmony export */   "fV": () => (/* binding */ EmoticonDissatisfiedIcon),
/* harmony export */   "jj": () => (/* binding */ Error),
/* harmony export */   "kq": () => (/* binding */ Inputs),
/* harmony export */   "mv": () => (/* binding */ EmoticonLaughingIcon),
/* harmony export */   "ng": () => (/* binding */ MultiRadio),
/* harmony export */   "oX": () => (/* binding */ EmoticonSmilingIcon),
/* harmony export */   "qV": () => (/* binding */ BooleanRadio),
/* harmony export */   "u1": () => (/* binding */ SelectedRating),
/* harmony export */   "u7": () => (/* binding */ EmoticonAngryIcon),
/* harmony export */   "uZ": () => (/* binding */ RadioDot)
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10297);
/* harmony import */ var src_components_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33399);
/* harmony import */ var src_ui_icons__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31913);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13673);
/* stylelint-disable */ function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  opacity: 0;\n  position: absolute;\n  pointer-events: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      flex-direction: row;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n          height: ",
        ";\n        "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n            top: ",
        "px;\n          "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      position: relative;\n      height: ",
        ";\n      align-items: flex-start;\n      width: 100%;\n\n      ",
        ";\n\n      ",
        " {\n        width: 100%;\n        justify-content: space-between;\n\n        &::after {\n          content: '';\n          width: 100%;\n          position: absolute;\n          top: ",
        "px;\n          z-index: 1;\n          border-top: 1px solid\n            ",
        ";\n\n          ",
        ";\n        }\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      display: inline-flex;\n      background: #eee;\n      padding: 2px;\n      border-radius: 4px;\n\n      box-shadow: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    margin-left: ",
        ";\n    border-radius: 20px;\n    background: ",
        ";\n    padding: 1px ",
        ";\n    color: ",
        ";\n    line-height: initial;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n  height: 20px;\n  max-height: 20px;\n  font-size: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n  background: #eee;\n  border-radius: 5px;\n  box-shadow: ",
        ";\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n          margin-right: ",
        ";\n        "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      line-height: 0;\n\n      &:not(:last-of-type) {\n        margin-right: ",
        ";\n\n        ",
        "\n      }\n    }\n\n    &:checked + label {\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n\n      ",
        " {\n        background: ",
        ";\n      }\n    }\n\n    &.focus-visible + label {\n      ",
        ",\n      ",
        ",\n    ",
        ",\n    ",
        ",\n    ",
        " {\n        box-shadow: 0 0 0 2px ",
        ";\n      }\n    }\n\n    &:disabled + label {\n      cursor: not-allowed;\n    }\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _taggedTemplateLiteral([
        "\n          right: 0;\n          left: unset;\n          transform: translateX(0);\n          text-align: right;\n        "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _taggedTemplateLiteral([
        "\n          left: 0;\n          transform: translateX(0);\n          text-align: left;\n        "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _taggedTemplateLiteral([
        "\n        width: ",
        "px;\n        height: ",
        "px;\n      "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      z-index: 2;\n      border-radius: ",
        "px;\n      border: 1px solid\n        ",
        ";\n\n      ",
        ";\n\n      position: relative;\n\n      &::after {\n        content: attr(data-label);\n        position: absolute;\n        align-self: center;\n        top: 100%;\n        left: 50%;\n        transform: translateX(-50%);\n        margin-top: ",
        ";\n        color: ",
        ";\n        width: 100px;\n        font-size: ",
        ";\n        text-align: center;\n        white-space: nowrap;\n\n        ",
        ";\n\n        ",
        ";\n      }\n    }\n\n    &:checked + label > ",
        " {\n      width: ",
        "px;\n      height: ",
        "px;\n      background: ",
        ";\n      border-radius: 50%;\n\n      ",
        ";\n    }\n\n    &.focus-visible + label {\n      border: 2px solid ",
        ";\n    }\n  "
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _taggedTemplateLiteral([
        "\n        padding: ",
        " ",
        ";\n      "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _taggedTemplateLiteral([
        "\n    ",
        ";\n\n    & + label {\n      cursor: pointer;\n      padding: ",
        "\n        ",
        ";\n      border-radius: 5px;\n      white-space: nowrap;\n      user-select: none;\n\n      ",
        ";\n    }\n\n    &:checked + label {\n      background: #fff;\n    }\n\n    &.focus-visible + label {\n      box-shadow: 0 0 0 2px ",
        ";\n    }\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: ",
        ";\n  margin-top: ",
        ";\n  color: ",
        ";\n  background: ",
        ";\n\n  svg {\n    margin-right: ",
        ";\n  }\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}




var CHECKBOX_SIZE = {
    DESKTOP: 18,
    MOBILE: 18
};
var disabledInputStyles = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject());
var Inputs = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Inputs",
    componentId: "sc-0-0"
})(_templateObject1());
var RadioDot = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "RadioDot",
    componentId: "sc-0-1"
})(_templateObject2());
var MultiRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "MultiRadio",
    componentId: "sc-0-2"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject8(), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.rate */ .tr.rate && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject3()), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.scale */ .tr.scale && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject6(), p.hasSelected ? "80px" : "60px", src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject4(), p.hasSelected ? "90px" : "70px"), Inputs, CHECKBOX_SIZE.DESKTOP / 2, p.showError ? p.theme.text.negative : p.theme.lines.tertiary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject5(), CHECKBOX_SIZE.MOBILE / 2)), p.variant === ___WEBPACK_IMPORTED_MODULE_3__/* .Variants.boolean */ .tr.boolean && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject7(), p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : "none"));
});
var SelectedRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "SelectedRating",
    componentId: "sc-0-3"
})(function(param) {
    var color = param.color, theme = param.theme;
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject9(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, theme.ratings[color].bg, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, theme.ratings[color].fg);
});
var Selected = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Selected",
    componentId: "sc-0-4"
})(_templateObject10(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025);
var iconStyling = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject11(), function(p) {
    return p.showError ? "0 0 0 1px ".concat(p.theme.text.negative) : 0;
});
var EmoticonAngryIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonAngry */ .Sd).withConfig({
    displayName: "EmoticonAngryIcon",
    componentId: "sc-0-5"
})(_templateObject12(), iconStyling);
var EmoticonDissatisfiedIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonDissatisfied */ ._z).withConfig({
    displayName: "EmoticonDissatisfiedIcon",
    componentId: "sc-0-6"
})(_templateObject13(), iconStyling);
var EmoticonNeutralIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonNeutral */ .sS).withConfig({
    displayName: "EmoticonNeutralIcon",
    componentId: "sc-0-7"
})(_templateObject14(), iconStyling);
var EmoticonSmilingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonSmiling */ .wr).withConfig({
    displayName: "EmoticonSmilingIcon",
    componentId: "sc-0-8"
})(_templateObject15(), iconStyling);
var EmoticonLaughingIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(src_ui_icons__WEBPACK_IMPORTED_MODULE_2__/* .EmoticonLaughing */ .X3).withConfig({
    displayName: "EmoticonLaughingIcon",
    componentId: "sc-0-9"
})(_templateObject16(), iconStyling);
var RadioRating = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "RadioRating",
    componentId: "sc-0-10"
})(function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject18(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, props.$size === "small" && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject17(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050), EmoticonAngryIcon, props.theme.ratings.negative.bg, EmoticonDissatisfiedIcon, props.theme.ratings.negative.bg, EmoticonNeutralIcon, props.theme.ratings.neutral.bg, EmoticonSmilingIcon, props.theme.ratings.positive.bg, EmoticonLaughingIcon, props.theme.ratings.positive.bg, EmoticonAngryIcon, EmoticonDissatisfiedIcon, EmoticonNeutralIcon, EmoticonSmilingIcon, EmoticonLaughingIcon, props.theme.icons.callToAction);
});
var ScaleRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "ScaleRadio",
    componentId: "sc-0-11"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject23(), disabledInputStyles, CHECKBOX_SIZE.DESKTOP, CHECKBOX_SIZE.DESKTOP, p.theme.bg.primary, CHECKBOX_SIZE.DESKTOP, p.showError ? p.theme.text.negative : p.theme.lines.quaternary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject19(), CHECKBOX_SIZE.MOBILE, CHECKBOX_SIZE.MOBILE), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100, p.theme.text.secondary, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.fontSizeSmall */ .bK.measurements.fontSizeSmall, p.alignRight && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject20()), p.alignLeft && (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject21()), RadioDot, CHECKBOX_SIZE.DESKTOP - 6, CHECKBOX_SIZE.DESKTOP - 6, p.theme.lines.highlight, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject22(), CHECKBOX_SIZE.MOBILE - 6, CHECKBOX_SIZE.MOBILE - 6), p.theme.icons.callToAction);
});
var BooleanRadio = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].input.withConfig({
    displayName: "BooleanRadio",
    componentId: "sc-0-12"
})(function(p) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_0__.css)(_templateObject25(), disabledInputStyles, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing025 */ .bK.measurements.spacing025, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing200 */ .bK.measurements.spacing200, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .media.mediumDown */ .BC.mediumDown(_templateObject24(), src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing150 */ .bK.measurements.spacing150), p.theme.icons.callToAction);
});
var Error = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({
    displayName: "Error",
    componentId: "sc-0-13"
})(_templateObject26(), function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing100 */ .bK.measurements.spacing100 : 0;
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050, function(p) {
    return p.theme.text.negative;
}, function(p) {
    return p.background ? src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .colorUtils.setRgbaAlpha */ .$n.setRgbaAlpha(p.theme.text.negative, "0.1") : "none";
}, src_components_base__WEBPACK_IMPORTED_MODULE_1__/* .layout.measurements.spacing050 */ .bK.measurements.spacing050);


/***/ }),

/***/ 78653:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": () => (/* binding */ Tag)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@prisjakt+ui@4.21.0_detyyulmcddbxgwtzoez3crluq/node_modules/@prisjakt/ui/icon/close/index.js
var icon_close = __webpack_require__(47156);
// EXTERNAL MODULE: ./node_modules/.pnpm/styled-components@5.3.5_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10297);
// EXTERNAL MODULE: ./src/components/base/index.js + 8 modules
var base = __webpack_require__(33399);
;// CONCATENATED MODULE: ./src/components/tag/styles.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    min-height: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n      background: ",
        ";\n      padding-right: ",
        ";\n      &:active {\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  cursor: pointer;\n  background: ",
        ";\n  border: 1px solid transparent;\n  border-radius: 5px;\n  padding: ",
        ";\n  word-break: break-word;\n  hyphens: auto;\n  min-height: 35px;\n\n  ",
        "\n\n  &:active {\n    background: ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  margin-right: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n      padding-right: ",
        ";\n      &:active {\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  color: ",
        ";\n  font-weight: 600;\n\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  margin-left: ",
        ";\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var spacing = "4px";
var StyledTag = styled_components_browser_esm["default"].button.withConfig({
    displayName: "StyledTag",
    componentId: "sc-0-0"
})(_templateObject2(), function(p) {
    return p.theme.colors.maybeBlue700;
}, spacing, base/* media.largeUp */.BC.largeUp(_templateObject()), function(p) {
    return p.theme.colors.maybeBlue700;
}, function(p) {
    return p.clear && (0,styled_components_browser_esm.css)(_templateObject1(), p.theme.colors.base600, spacing, p.theme.colors.base700);
});
var TagGroup = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagGroup",
    componentId: "sc-0-1"
})(_templateObject3(), function(p) {
    return p.theme.colors.base0;
}, spacing);
var TagValue = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagValue",
    componentId: "sc-0-2"
})(_templateObject5(), function(p) {
    return p.theme.colors.base0;
}, function(p) {
    return p.clear && (0,styled_components_browser_esm.css)(_templateObject4(), spacing, p.theme.colors.base700);
});
var TagClose = styled_components_browser_esm["default"].span.withConfig({
    displayName: "TagClose",
    componentId: "sc-0-3"
})(_templateObject6(), spacing);

;// CONCATENATED MODULE: ./src/components/tag/index.tsx



var CLEAR = "clear";
var DEFAULT = "default";
var Tag = function(param) {
    var value = param.value, groupName = param.groupName, _type = param.type, type = _type === void 0 ? DEFAULT : _type, _onClick = param.// eslint-disable-next-line @typescript-eslint/no-empty-function
    onClick, onClick = _onClick === void 0 ? function() {} : _onClick;
    var isClear = type === CLEAR;
    return /*#__PURE__*/ react.createElement(StyledTag, {
        type: "button",
        onClick: onClick,
        clear: isClear
    }, groupName && type !== CLEAR && /*#__PURE__*/ react.createElement(TagGroup, null, groupName, ":"), /*#__PURE__*/ react.createElement(TagValue, {
        clear: isClear
    }, value), type !== CLEAR && /*#__PURE__*/ react.createElement(TagClose, null, /*#__PURE__*/ react.createElement(icon_close/* IconClose */.b, {
        size: 16,
        color: "base0"
    })));
};


/***/ }),

/***/ 91190:
/***/ ((module) => {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ })

}]);